import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { loadList, saveList } from "./slice/ExcludeProductsSlice";
import axios, { subscribeShopDataSyncState } from '../modules/api';
import {http, setIsErrorAlert} from '../modules/api';
import $ from 'jquery';
import DatePicker from "react-datepicker";
import { ko } from "date-fns/esm/locale"; // datePicker 한글화
import "react-datepicker/dist/react-datepicker.css";
import SaveDialogV2 from '../modules/dialogs/SaveDialogV2';
import BasicDialogV2 from '../modules/dialogs/BasicDialogV2';
import TitleContentDialogV2 from '../modules/dialogs/TitleContentDialogV2';
import ConfirmDialogV2 from '../modules/dialogs/ConfirmDialogV2';
import SelectBoxV2, {getSelectBoxSelectIdx} from '../modules/common/SelectBoxV2';
import CheckBox from '../modules/common/CheckBox';
import RadioButton from '../modules/common/RadioButton';
import PopupFrame from '../modules/popup/PopupFrame';
import * as StringUtil from '../modules/utils/StringUtil';

import plus_img from '../../resources/img/plus.svg';
import default_plus_img from '../../resources/img/default_plus.svg';
import default_minus_img from '../../resources/img/default_minus.svg';
import x_img from '../../resources/img/x.svg';
import fix_icon from '../../resources/img/fix_icon.svg';
import non_fix_icon from '../../resources/img/non_fix_icon.svg';

import round_loading_bar from '../../resources/img/round_loading_bar.gif';

import ReactGA, { send } from 'react-ga';
import SearchProductPopup from '../modules/popup/SearchProductPopup';
import TextInput from '../modules/common/TextInput';
import Button from '../modules/common/Button';
import ExcludeProductTableMgmt from './component/ExcludeProductTableMgmt';
import EssentialProductTableMgmt from './component/EssentialProductTableMgmt';
import ListOrderChangeBtnBundle from './component/ListOrderChangeBtnBundle';

import MultiSelect from 'react-select';
import {reactSelectStyles} from '../modules/libraries/react-select';
import makeAnimated from 'react-select/animated';
import WarningDialog from '../modules/dialogs/WarningDialog';
import Tooltip from '../modules/common/Tooltip';
import { APIs } from '../modules/apiClient';
import moment from 'moment';
import LazyLoad from 'react-lazyload';
import InputDialogV2 from '../modules/dialogs/InputDialogV2';
import {
    DndContext,
    closestCenter,
    PointerSensor,
    useSensor,
    useSensors
  } from "@dnd-kit/core";
import {
    arrayMove as arraymMoveByDndKit,
    SortableContext,
    useSortable,
    rectSortingStrategy
  } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

// const isTouchDevice = () =>
//     typeof window !== "undefined" &&
//     ("ontouchstart" in window || navigator.maxTouchPoints > 0);
  
// const sensors = isTouchDevice()
// ? [] // 터치를 지원하는 디바이스 → 드래그 비활성화
// : [ { sensor: PointerSensor, options: {} } ]; // PC → 드래그 활성화

const sensors = [
    {
      sensor: PointerSensor,
      options: {
        activationConstraint: {
          delay: 0,
          tolerance: 5,
        },
      },
    },
];

const animatedComponents = makeAnimated();
const _ = require('lodash');

ReactGA.initialize('UA-78553461-8', {
    titleCase: false,
});

let is_test_use = "";
if (document.domain.indexOf("127.0.0.1") >= 0) {
    is_test_use = "Y"
}

let this_location;

// 페이지를 생성하는 경우
let create_rp = false;

let user_id = sessionStorage.getItem("user_id"); // 사용자 ID
let expand_timer = {}; // 왼쪽 영역 접기 펼치기 동작 누적 방지
let load_upper_num = 0; // upper_code(왼쪽 영역) 선택지 전부 불러왔는지 확인
let checkCafe24CategoryRunAPI = false; // 카페24 분류별 진열 API 실행 조회중인 여부 (삭제, 순서변경)
let checkCafe24MainRunAPI = false; // 카페24 메인 진열 API 실행 조회중인 여부

/*------ 상품 선택 수 기본 최대값 ------*/
const nayeol_event_total_item_select_range_category = 1000; // RoboMD 알고리즘 개수 선택 수 (카테고리)
const nayeol_event_total_item_select_range_main = 200; // RoboMD 알고리즘 개수 선택 수 (메인)
const cafe24_main_page_max_product_num = 200; // cafe24 메인진열에서 저장될 수 있는 총 자동 진열할 상품 수 
const flagCafe24BulkConversionProductCount = 100; // cafe24 카테고리 진열에서 대량전환이 되는 상품 개수 (알고리즘 선택)

const cafe24ListExpandRef = React.createRef();
const cafe24ListExpandCheckRef = React.createRef();
const rpTitleRef = React.createRef();
const highlightConnect = React.createRef();
const highlightRanking = React.createRef();
const highlightKeyword = React.createRef();
const highlightPeriod = React.createRef();

const titleContentOverwrite = {
    stepOneTitle: "<br />상품덮어쓰기 선택시 변경전 주의사항",
    stepTwoTitle: "<br />상품덮어쓰기 선택시 두번째 주의사항",
    stepOneContent(src) {
        return "<img id='overwrite1' src='" + src + "' /> <br />" +
            "<br />자동 진열 설정 대로<br />" +
            "상품 자동 선택 수 만큼만 자동으로 분석해서<br />" +
            "<b style='white-space: nowrap'> 기존 상품을 덮어씌워서 선택 수량만 노출됩니다.</b><br />" +
            "동의하시겠습니까?<br /><br />";
    },
    stepTwoContent(src) {
        return `<img id="overwrite2" src="${src}" style="margin-top:5px" alt="Overwrite" />
        <br />
        <br />
        덮어쓰기기능은<br />
        <b>일반상품 단독 사용시에만 설정하기를 권장합니다.</b><br />
        카페24구조상 덮어쓰기 기능을 사용하시면<br />
        추천.신상품 코너가 자동삭제됩니다.<br />
        그래도 적용하시겠습니까?<br />`
    },
}

const basicDialogModifyDisplay = {
    title: `<h2 style="font-size: 16px; font-weight: 500; line-height: 24px; color: #202020; margin-bottom: 8px;">
안녕하세요!<br />
    자동사용을 즐겁게 시작하세요</h2>
    `,
    content(src, title, location, category, autoDay, autoTime) {
        return `<img id='overwrite1' src="${src}" /> <br />
        <b>[${title}]</b> 은<br />
        <b>[${location}]</b> 의 <b>[${category}]</b> 로<br />
        <b>[${autoDay}]</b>일 마다 <b>[${autoTime}]</b>시 에<br />
        <b style="color: #0090FF;" >설정개수로 기존상품을 덮어쓰는 자동진열</b><br />입니다.<br />
        [로보MD]로 즐거운 자동 운영하세요
        `
    }
}

const maxRightTableWidth = "1270px";

const overwriteImageURLs = {}

class RpProductList_nonInstall extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            syncState : "0",
            syncDateFormat : "",
            refresh_data_show_state : false,
            highlightType: "",

            /*-------------- 왼쪽 영역 시작 --------------*/
            is_left_load_first_setting : false, // 왼쪽영역 로딩여부(update에서 돌리기 위함)

            install_yn : "", // 값이 없는 경우(진열 추가 페이지에서 저장전인 경우 / 값이 들어오면 저장 후)
            // 저장 값
            user_seq: "",
            shop_no: "",
            iframe_page_id: "", // 위치
            cafe24_main_display_group : "", // 선택된 카페24 메인 진열 카테고리
            cafe24_category_no : "", // 카페24 카테고리 상품분류 번호
            cafe24_category_no_list : "",  // 카페24 카테고리 상품분류 저장 리스트(대분류, 중분류, 소분류, 세분류)
            cafe24_category_display_group : "1", // 카페24 카테고리 진열 상세 상품분류
            cafe24_category_display_type: "2", // 카페24 카테고리 진열 타입
            iframe_html_id: "", // 페이지 번호
            // => 비어있으면 왼쪽 영역 저장 전.. 저장 후 해당 값을 받아와서 적용
            iframe_html_name: "", // 관리자 진열 제목
            image_type_cd: "", // 이미지 타입 코드

            /* 비설치 페이지로 분리되면서, 저장 및 로드시 값이 넘겨지지만 관리되진 않는 설치/롤링 값 */
            display_name_use_yn : "", // 제목 사용 여부
            display_name: "", // 제목
            display_name_cd: "", // 제목 코드
            display_type: "", // 진열 방식
            link_open_type: "48002", // 링크 열기 방식
            event_cycle: "", // 자동 진열 일정관리 주기
            event_time: "", // 자동 진열 일정관리 시간
            event_type_cd: "", // 디자인
            event_item_price_show_type : "", // 가격 타입
            event_category_select_type: "34002", // 상품 카테고리 종류
            event_category_list: "", // 상품 카테고리
            event_view_cnt: "", // pc 가로 상품 개수
            event_mobile_view_cnt: "", // mobile 가로 상품 개수
            platform_type: "", // pc | modile | pc + mobile (P / M / C)
            auto_rolling_yn: "", // 자동 롤링 기능
            transition_mode: "", // 롤링 방식
            transition_speed: "", // 롤링 속도
            transition_pause: "", // 롤링 이동 텀
            auto_create_yn: "N", // 자동 진열 일정관리

            /* 자동 상품 설정 관련 */
            list_self_select : [], // 직접 지정 리스트
            item_select_type: "", // 상품 선택 알고리즘 : 구 자동 선택 필드(현재는 해당값이 직점 지정이었던 모습으로만 관리)
            event_item_price_filter_yn : "Y", // 판매가 사용 여부 : 구 자동 선택 필드(현재 Y값 필수)
            event_item_min_price: "", // 판매가 최소값 : 구 자동 선택 필드
            event_item_max_price: "", // 판매가 최대값 : 구 자동 선택 필드
            event_item_created_period : "", // 상품 등록일 기준 : 구 자동 선택 필드
            event_item_analysis_period : "", // 상품 분석 기간 : 구 자동 선택 필드
            event_total_item_select_cnt: "", // 상품 선택 수 : 구 자동 선택 필드

            max_item_analysis_list: [
                // {value:"1", title:"알고리즘별 자동 합산"},
                // {value:"1", title:"사용 안함"},
                // {value:"1", title:"자동합산"},
                // {value:"3", title:"알고리즘 상위 배분"},
                // {value:"2", title:"알고리즘별 균등 배분"},
                {value:"3", title:"알고리즘 위부터 총 자동 진열할 상품 수  이하 선정"},
                {value:"2", title:"알고리즘별로 총 자동 진열할 상품 수 를 균등 분배"},
                {value:"1", title:"알고리즘의 상품 수 합산 개수 선정"},
            ],

            max_item_analysis: "3",
            max_item_analysis_value: "10",

            /* 강제 자동 상품 설정 관련 */
            force_category_list_1: [],
            force_category_list_2: [],
            force_category_list_3: [],
            force_category_list_4: [],

            force_select_area_checked: true,
            force_use_yn: "N",
            force_logic : "",
            force_category: {},
            force_auto_remove: "",
            force_analysis_period: "",
            force_select_created_yn: "",
            force_created_period_type: "",
            force_created_period: "",
            force_created_start_date: "",
            force_created_end_date: "",
            force_is_except_invisible_category: "",

            // upper : 왼쪽 영역 선택지 받아오기 //
            item_select_type_list : [], // 상품 선택 알고리즘 목록
            iframe_page_id_list : [], // 위치 목록
            main_category_list : [], // 카페24 메인 진열 카테고리 목록
            image_type_list: [], // 이미지 타입(목록이미지, 상세이미지)
            display_type_list: [], // 진열 방식(나열, 롤링)
            display_name_list : [], // 제목 목록
            event_item_price_show_type_list : [], // 가격 목록
            event_type_list_rolling : [], // 디자인 목록 : 롤링
            event_type_list_nayeol : [], // 디자인 목록 : 나열
            transition_mode_list : [], // 롤링 방식 목록
            transition_pause_list: [], // 롤링 이동 텀 목록
            transition_speed_list: [], // 롤링 속도 목록
            cafe24_category_display_group_list: [{value:1, title:"일반 상품"},{value:2, title:"추천 상품"},{value:3, title:"신상품"}],
            cafe24_product_manage_type_list: [
                {title:"추천 · 일반 · 신상품 동일상품 자동 선택 시 노출제외 " , value: 1},
                {title:"추천 · 일반 · 신상품과 동일상품 자동 선택 시 중복노출" , value: 2},
            ],
            cafe24_category_display_type_list: [{value: 1, title:"상품 덮어쓰기"}, {value:2, title:"상품 상단추가"}],
            event_view_cnt_select : [
                {value:2, title:"2개"},{value:3, title:"3개"},{value:4, title:"4개"},
                {value:5, title:"5개"},{value:6, title:"6개"},{value:7, title:"7개"}],
            event_mobile_view_cnt_select : [{value:1, title:"1개"},{value:2, title:"2개"},{value:3, title:"3개"}],
            event_item_condition_period_list : [
                // {value:0, title:"날짜 무관"},
                {value:"1/D", title:"최근 1일"},{value:"2/D", title:"최근 2일"},{value:"3/D", title:"최근 3일"},{value:"4/D", title:"최근 4일"},{value:"5/D", title:"최근 5일"},{value:"6/D", title:"최근 6일"},
                {value:1, title:"최근 1주"},{value:2, title:"최근 2주"},{value:3, title:"최근 3주"},{value:4, title:"최근 4주"},
                {value:"3/M", title:"최근 3달"},
                {value:"1/Y", title:"최근 1년"},{value:"2/Y", title:"최근 2년"},
            ],
            event_item_analysis_period_list : [
                // {value:0, title:"날짜 무관"},
                {value:"1/D", title:"최근 1일"},{value:"2/D", title:"최근 2일"},{value:"3/D", title:"최근 3일"},{value:"4/D", title:"최근 4일"},{value:"5/D", title:"최근 5일"},{value:"6/D", title:"최근 6일"},
                {value:1, title:"최근 1주"},{value:2, title:"최근 2주"},{value:3, title:"최근 3주"},{value:4, title:"최근 4주"},
                {value:"3/M", title:"최근 3달"},
                {value:"1/Y", title:"최근 1년"},{value:"2/Y", title:"최근 2년"},
            ],
            event_item_created_period_list : [
                {value:0, title:"날짜 무관"},{value:-1, title:"직접 지정"},
                {value:"1/D", title:"최근 1일"},{value:"2/D", title:"최근 2일"},{value:"3/D", title:"최근 3일"},{value:"4/D", title:"최근 4일"},{value:"5/D", title:"최근 5일"},{value:"6/D", title:"최근 6일"},
                {value:"1/W", title:"최근 1주"},{value:"2/W", title:"최근 2주"},{value:"3/W", title:"최근 3주"},{value:"4/W", title:"최근 4주"},{value:"5/W", title:"최근 5주"},{value:"6/W", title:"최근 6주"},
                {value:"8/W", title:"최근 8주"},{value:"9/W", title:"최근 9주"},{value:"10/W", title:"최근 10주"},{value:"11/W", title:"최근 11주"},
                {value:"12/W", title:"최근 12주"},{value:"24/W", title:"최근 24주"},
                {value:"1/M", title:"최근 1달"},{value:"2/M", title:"최근 2달"},{value:"3/M", title:"최근 3달"},{value:"4/M", title:"최근 4달"},{value:"5/M", title:"최근 5달"},{value:"6/M", title:"최근 6달"},
                {value:"7/M", title:"최근 7달"},{value:"8/M", title:"최근 8달"},{value:"9/M", title:"최근 9달"},{value:"10/M", title:"최근 10달"},{value:"11/M", title:"최근 11달"},
                {value:"1/Y", title:"최근 1년"},{value:"2/Y", title:"최근 2년"},{value:"3/Y", title:"최근 3년"},{value:"4/Y", title:"최근 4년"},            
            ],
            event_item_created_period_season_list : [
                {value:"-999", title:"사용 안함"},
                {value:"1/S", title:"모든 봄등록일"},{value:"2/S", title:"모든 초여름등록일"},{value:"3/S", title:"모든 여름등록일"},{value:"4/S", title:"모든 가을등록일 "},{value:"5/S", title:"모든 겨울등록일"},
                {value:"6/S", title:"매년 4계절마다"},{value:"7/S", title:"2년포함 4계절마다"},{value:"8/S", title:"3년포함 4계절마다"},{value:"9/S", title:"4년포함 4계절마다"},{value:"10/S", title:"전체년도 4계절마다"},
                {value:"11/S", title:"매년 여름겨울이 긴 4계절마다"},{value:"12/S", title:"2년포함 여름겨울이 긴 4계절마다"},{value:"13/S", title:"3년포함 여름겨울이 긴 4계절마다"},{value:"14/S", title:"4년포함 여름겨울이 긴 4계절마다"},{value:"15/S", title:"전체년도 여름겨울이 긴 4계절마다"},
                {value:"16/S", title:"봄가을 구분없는 매년 계절별로"},{value:"17/S", title:"간절기를 고려한 장기판매 매년 6계절별로"},{value:"18/S", title:"긴여름을 고려한 장기판매 매년 6계절별로"},{value:"19/S", title:"봄가을을 구분없는 모든 계벌별로"},{value:"20/S", title:"간절기를 고려한 장기판매 모든 6계절별로"},{value:"21/S", title:"긴여름을 고려한 장기판매 모든 6계절별로"},
                {value:"22/S", title:"전체 4계절 선등록 후 노출 기준"},
            ],
            event_cycle_list : [{value:1, title:"1일"},{value:2, title:"2일"},{value:3, title:"3일"},
            {value:5, title:"5일"},{value:7, title:"7일"},{value:14, title:"14일"},{value:30, title:"30일"},],
            use_yn_list : [{text:"사용함", value:"Y"},{text:"사용 안 함", value:"N"}],
            // auto_yn_list : [{text:"자동관리사용", value:"Y"},{text:"수동관리사용", value:"N"}],
            auto_yn_list : [{text:"반복관리", value:"Y"},{text:"수동관리", value:"N"}],
            force_use_yn_list : [{text:"사용함", value:"Y"},{text:"사용 안 함", value:"N"}],
            event_time_list : Array.from({ length: 24 }, (_, i) => ({ value: i, title: `${i}시` })), // (0시 ~ 23시)
            event_time_list_v2 : Array.from({ length: 24 }, (_, i) => ({ value: i + 1, title: `${i + 1}시` })), // (1시 ~ 24시)
            product_color_list : [],

            left_is_modified : false, // 왼쪽 영역 수정 여부
            total_item_select_cnt_range : [], // 상품 선택 수 선택을 위한 리스트

            del_cafe24_main_display_group : false, // 카페24에서 삭제된 메인분류인 경우
            del_cafe24_category_no : false, // 카페24에서 삭제된 카테고리인 경우(카테고리 진열)

            // 카페24 분류별 진열 : 카테고리 상태값
            cafe24_category_list_1:[],
            cafe24_category_list_2:[],
            cafe24_category_list_3:[],
            cafe24_category_list_4:[],

            cafe24_category_no_1: "",
            cafe24_category_no_2: "",
            cafe24_category_no_3: "",
            cafe24_category_no_4: "",

            cafe24_category_full_name: "",

            operateed_yn : "N", // 결제 여부

            first_category_list : "", // 처음 받아온 대카테고리


            /* ---------- 선택된 상품목록 팝업 관련 변수 --------*/

            show_event_product_list_popup : false, // 선택된 상품목록 팝업 보이는 상태 
            show_event_product_list_table_loading_bar : false, // 자동 진열된 상품 목록 로딩 바

            event_order_gubun : "",
            event_order_type : "",

            event_rp_product_list : [], // 자동 진열된 상품 목록
            event_rp_product_list_created: "", // 자동 진열된 상품 목록 도출된 날짜
            event_rp_product_list_yn: "",
            event_product_checked_list : [], // 자동 진열된 상품 목록 체크된 상품 목록
            select_event_order_gubun_type : "org", // 자동 진열된 상품 목록 선택 정렬
            // 자동 진열된 상품 목록 정렬 필터
            select_event_order_gubun_type_list : [{value:"org", title:"선택된 순서대로"},{value:"order_price/desc", title:"총 판매액이 많은 상품이 위로"},
            {value:"order_price/asc", title:"총 판매액이 많은 상품이 아래로"},{value:"price/desc", title:"판매가 높은 상품이 위로"},{value:"price/asc", title:"판매가 높은 상품이 아래로"},
            {value:"order_cnt/desc", title:"판매수 많은 상품이 위로"},{value:"order_cnt/asc", title:"판매수 많은 상품이 아래로"},{value:"hit_cnt/desc", title:"조회 많은 상품이 위로"},
            {value:"hit_cnt/asc", title:"조회 많은 상품이 아래로"},{value:"created_date/desc", title:"최근 등록된 상품이 위로"},{value:"created_date/asc", title:"최근 등록된 상품이 아래로"},
            {value:"updated_date/desc", title:"최근 수정된 상품이 위로"},{value:"updated_date/asc", title:"최근 수정된 상품이 아래로"},{value:"product_name/asc", title:"상품명 가나다순"},
			{value:"product_name/desc", title:"상품명 가나다 역순"}
            ,{value:"cart_cnt/desc", title:"장바구니 많이 담은 상품이 위로"},{value:"cart_cnt/asc", title:"장바구니 많이 담은 상품이 아래로"}
            // {value:"wish_cnt/desc", title:"찜이 많은 상품이 위로"},{value:"wish_cnt/asc", title:"찜이 많은 상품이 아래로"}
            , {value:"quantity/desc", title:"재고 많은 상품이 위로"},
			{value:"quantity/asc", title:"재고 많은 상품이 아래로"},
            ],
            /* ------------ 제외 상품 목록 팝업 관련 변수 ----------- */
            show_exclude_product_list_popup : false, // 제외 상품 목록 팝업 보이는 상태

            /* ------------ 진열 간 상품 중복 제외 설정 팝업 관련 변수 ----------- */

            show_except_setting_popup : false, // 진열 간 상품 중복 제외 설정 팝업 보이는 상태
            rp_event_setting_list: [], // 진열 설정 목록
            except_setting_list: [], // 진열 간 상품 중복 제외 설정 목록
            select_except_rp_setting : "", // 셀렉트박스에 선택된 진열 ex) iframe_page_id+"/"+iframe_html_id
            show_except_product_popup : false, // (제외쪽)진열 상품 목록 보기
            except_product_list: [], // 진열 제외 상품 목록 (상품 보기쪽 목록)
            except_products : {}, // 진열 제외 다중 카테고리 상품 목록 (상품 보기쪽 목록)
            except_event_category_list : [], // 진열 제외 다중 카테고리 목록
            except_select_category : "", // 진열 제외 선택된 다중 카테고리
            except_setting_is_modified : false, // 진열 간 상품 중복 제외 설정 수정 여부
            
            /*-------------- 왼쪽 영역 종료 --------------*/

            // 왼쪽 영역 단일 카테고리 선택시 받아오는 카테고리 값
            rp_category: [
                {category_no:""},
                {category_no:""},
                {category_no:""},
                {category_no:""}
            ],
            // 왼쪽 영역 세팅 받아온 값
            rp_setting: {
                event_category_select_type: "34002",
            },
            
            /* ---------- 오른쪽 영역 관련 변수 --------*/
            cafe24_main_page_over_product : false, // 카페24 메인 진열 상품 목록 저장 가능 개수 초과 여부
            cafe24_main_product_list : [], // 카페24 메인 진열 상품 목록
            rp_check_product_list : [], // 메인 테이블 체크 상품 목록
            cafe24_category_product_list : [], // 카페24 분류별 진열 상품 목록
            cafe24_category_change_order_list : [], // 카페24 분류별 진열 순서 변경 상품 목록
            cafe24_category_before_order_list : [], // 카페24 분류별 진열 순서 변경전 순서 목록

            modified_date: "", // 메인 테이블 상품 수정일
            is_auto : "N", // 자동="Y", 수동(수정)="N"

            cafe24_category_product_display_scope : "", // 카페24 분류별 진열 현재 카테고리가 전체/영역별 중 어떤 것인지

            right_is_modified : false, // 메인 테이블 영역 수정 여부
            category_order_is_modified : false, // 카테고리 순서변경 수정 여부

            main_order_idx:[], // 메인 상품 순서 번호

            show_rp_product_list_table_loading_bar : true,// 상품 목록 로딩 바

            /* ---------- 상품 추가 팝업 관련 변수 --------*/
            show_add_product_popup : false, // 상품 추가 팝업 보이는 상태

            /* ---------- 다이얼로그 관련 변수 --------*/
            save_dialog_show_state : false, // 저장 다이얼로그
            save_dialog_content: "",
            save_dialog_button_list: [],
            basic_dialog_show_state : false, // 기본 다이얼로그
            basic_dialog_content: "",
            basic_dialog_button_list: [],
            title_content_dialog_title: "",
            title_content_dialog_content: "",
            title_content_dialog_button_list: [],
            title_content_dialog_check_box_text: "",
            title_content_dialog_check_box_checked: false,
            confirm_dialog_show_state : false,
            paste_confirm_dialog_show_state : false, // 자동 진열된 상품 목록 적용하기
            confirm_dialog_content: "",
            confirm_dialog_button_list: [],

             /* ---------- 알고리즘 (~중에) ---------- */
             item_condition_list : [],

             /*---------- 데이터 분석 표기 기준 ---------- */
             event_item_analysis_standard_list : [
                {value:"1/D", title:"최근 1일"},{value:"2/D", title:"최근 2일"},{value:"3/D", title:"최근 3일"},{value:"4/D", title:"최근 4일"},{value:"5/D", title:"최근 5일"},{value:"6/D", title:"최근 6일"},
                {value:1, title:"최근 1주"},{value:2, title:"최근 2주"},{value:3, title:"최근 3주"},{value:4, title:"최근 4주"},
                {value:"3/M", title:"최근 3달"},
                {value:"1/Y", title:"최근 1년"},{value:"2/Y", title:"최근 2년"},
            ],
            analysis_standard_value : "4",

            warning_state: false,
            warning_message: "",

            cafe24_product_manage_type: "",

            /* ---------- 카페24 자동진열 사용여부 ---------- */
            is_main_auto_display_use: false,
            is_category_auto_display_use : false,
            
            is_loading_overwrite_product : false,
            is_loading_add_below_product : false,

            /* ---------- 알고리즘 미리보기 종류 ---------- */
            mirroring_type_list : [{text:"미리보기에 상품 덮어쓰기", value:"1"},{text:"미리보기의 하단에 상품 추가하기", value:"2"}],
            mirroring_type : "1",

            /* ---------- 실시간, 예약, 요일 ---------- */
            // 이제부터는 API로 코드 테이블을 조회 하는게 아니라 하드코딩으로 적용.

            // auto_create_type : "A7002", // A7001: 반복 관리, A7002: 수동 관리, A7003: 실시간 관리
            auto_create_type_list : [
                {code_cd: "A7001", code_name: "반복관리"}
                , {code_cd: "A7002", code_name: "수동관리"}
                , {code_cd: "A7003", code_name: "실시간관리"}
            ],
            event_cycle_type : "A8001", // A8001: 일별, A8002: 주별, A8003: 실시간
            event_cycle_type_list : [
                {code_cd: "A8001", code_name: "일별"}
                , {code_cd: "A8002", code_name: "요일별"}
                , {code_cd: "A8003", code_name: "실시간"}
            ],
            
            weekday_use_yn : "",
            weekday_cycle : "1", // 1주, 2주, 3주... 12주
            weekday_cycle_selectbox_list : [
                {code_cd: "1", code_name: "1주"},
                {code_cd: "2", code_name: "2주"},
                {code_cd: "3", code_name: "3주"},
                {code_cd: "4", code_name: "4주"},
                {code_cd: "5", code_name: "5주"},
                {code_cd: "6", code_name: "6주"},
                {code_cd: "7", code_name: "7주"},
                {code_cd: "8", code_name: "8주"},
                {code_cd: "9", code_name: "9주"},
                {code_cd: "10", code_name: "10주"},
                {code_cd: "11", code_name: "11주"},
                {code_cd: "12", code_name: "12주"}
            ],
            weekday_list : "-1,0,1,2,3,4,5,6", // 0,1,2,3... (쉼표 구분자로 여러 요일 선택 가능)
            weekday_selectbox_list : [
                {code_cd: "-1", code_name: "전체"},
                {code_cd: "0", code_name: "월"},
                {code_cd: "1", code_name: "화"},
                {code_cd: "2", code_name: "수"},
                {code_cd: "3", code_name: "목"},
                {code_cd: "4", code_name: "금"},
                {code_cd: "5", code_name: "토"},
                {code_cd: "6", code_name: "일"},
            ],

            // real_time_type : "A9003", // A9001: 30분, A9002: 3시간, A9003: 6시간
            // weekday_radio_list : [
            //     {code_cd: "A9001", code_name: "30분"},
            //     {code_cd: "A9002", code_name: "3시간"},
            //     {code_cd: "A9003", code_name: "6시간"},
            // ],
            real_time_cycle : "720",
            real_time_cycle_selectbox_list_by_basic : [
                {code_cd: "720", code_name: "12시간"},
                {code_cd: "360", code_name: "6시간"}, 
                {code_cd: "180", code_name: "3시간"}, 
            ],
            real_time_cycle_selectbox_list_by_premium : [
                {code_cd: "720", code_name: "12시간"},
                {code_cd: "360", code_name: "6시간"}, 
                {code_cd: "180", code_name: "3시간"}, 
                {code_cd: "120", code_name: "2시간"}, 
                {code_cd: "60", code_name: "1시간"}, 
                {code_cd: "30", code_name: "30분"}, 
            ],

            reservation_use_yn : "N",
            reservation_date : new Date().setDate(new Date().getDate() + 0),
            reservation_hour : "7",

            event_start_date : new Date().setDate(new Date().getDate() + 0),
            // event_start_hour : "7",

            real_time_service_regist_show_state: false,

            real_time_txt_use_yn: "N",
            
            real_time_start_hour: "12",
            real_time_end_hour: "24",
            
            past_order_start_date_type_list : [
                {value:"-1", title:"당일"},
                {value:"1/D", title:"1일 전"},{value:"2/D", title:"2일 전"},{value:"3/D", title:"3일 전"},{value:"4/D", title:"4일 전"},{value:"5/D", title:"5일 전"},{value:"6/D", title:"6일 전"},
                {value:"1/W", title:"1주 전"},{value:"2/W", title:"2주 전"},{value:"3/W", title:"3주 전"},
                {value:"1/M", title:"1달 전"},
                {value:"5/W", title:"5주 전"},{value:"6/W", title:"6주 전"},{value:"7/W", title:"7주 전"},
                {value:"2/M", title:"2달 전"},
                {value:"9/W", title:"9주 전"},{value:"10/W", title:"10주 전"},{value:"11/W", title:"11주 전"},
                {value:"3/M", title:"3달 전"},
                
                {value:"-1/D", title:"1일 후"},{value:"-2/D", title:"2일 후"},{value:"-3/D", title:"3일 후"},{value:"-4/D", title:"4일 후"},{value:"-5/D", title:"5일 후"},{value:"-6/D", title:"6일 후"},
                {value:"-1/W", title:"1주 후"},{value:"-2/W", title:"2주 후"},{value:"-3/W", title:"3주 후"},
                {value:"-1/M", title:"1달 후"},
                {value:"-5/W", title:"5주 후"},{value:"-6/W", title:"6주 후"},{value:"-7/W", title:"7주 후"},
                {value:"-2/M", title:"2달 후"},
                {value:"-9/W", title:"9주 후"},{value:"-10/W", title:"10주 후"},{value:"-11/W", title:"11주 후"},
                {value:"-3/M", title:"3달 후"},
            ],
            past_order_end_date_type_list : [
                {value:"-1", title:"당일"},
                
                {value:"-1/D", title:"1일 전"},{value:"-2/D", title:"2일 전"},{value:"-3/D", title:"3일 전"},{value:"-4/D", title:"4일 전"},{value:"-5/D", title:"5일 전"},{value:"-6/D", title:"6일 전"},
                {value:"-1/W", title:"1주 전"},{value:"-2/W", title:"2주 전"},{value:"-3/W", title:"3주 전"},
                
                {value:"1/D", title:"1일 후"},{value:"2/D", title:"2일 후"},{value:"3/D", title:"3일 후"},{value:"4/D", title:"4일 후"},{value:"5/D", title:"5일 후"},{value:"6/D", title:"6일 후"},
                {value:"1/W", title:"1주 후"},{value:"2/W", title:"2주 후"},{value:"3/W", title:"3주 후"},
                {value:"1/M", title:"1달 후"},
                {value:"5/W", title:"5주 후"},{value:"6/W", title:"6주 후"},{value:"7/W", title:"7주 후"},
                {value:"2/M", title:"2달 후"},
                {value:"9/W", title:"9주 후"},{value:"10/W", title:"10주 후"},{value:"11/W", title:"11주 후"},
                {value:"3/M", title:"3달 후"},
            ],
            past_order_sort_type_list : [
                {value:"1", title:"판매수 많은 순으로"},
                {value:"2", title:"판매액 많은 순으로"},
                {value:"3", title:"판매수 적은 순으로"},
                {value:"4", title:"판매액 적은 순으로"},
            ],

            product_preview_type: 2,
            grid_column_count: 4,

            total_sort_type: 1, 
            total_sort_type_list : [
                {value:"1", title:"1순위부터 우선 진열"},
                {value:"2", title:"모든 순위 상품 선정 후 랜덤진열"},
            ],

            cafe24_sub_category_product_display: "F",

            is_cafe24_show_exception_category : false,
            is_cafe24_show_exception_auto : false,

            self_select_main_category_list: [], // 알고리즘별 선택/제외 메인분류 목록

            self_except_setting_list: [
                /*
                {
                    id: "robomd_cafe24_main_page/robomd_rp_1",
                    iframe_page_id: "robomd_cafe24_main_page",
                    iframe_html_id: "robomd_rp_1",
                    name: "[메인] 추천상품",

                    cafe24_main_display_group: "2",
                    cafe24_category_display_group: "",
                    cafe24_category_no_list: "",

                    event_category_select_type: "34002",

                    except_order_start_no: "",
                    except_order_end_no: ""
                }
                */                
            ], // 알고리즘별 제외 설정 목록
            self_except_event_category_list: [],
            select_self_except_event_category: "",
            self_except_event_category_products: {},
        }
        this.hasFetchedSyncData = createRef()
        this.list_main_board_table_wrap = createRef();
        this.hasFetchedSyncData.current = false;
    }

    componentWillMount() {
        // 무료 체험 기간이 종료되었다면 진열 목록 화면으로 보내기
        this.loadFreeDatePeriod();

        // 새로운 페이지라면, 로딩 프로그레스 안 보이게 처리
        var page_id = StringUtil.getUrlParams("page_id");
        var html_id = StringUtil.getUrlParams("html_id");
        this.setState({
            iframe_page_id : page_id,
            iframe_html_id : html_id,
        });
        if(page_id == null || html_id == null || page_id == "" || html_id == ""){
            create_rp = true;
            this.setState({
                show_rp_product_list_table_loading_bar : false,
            });
        }

        // 페이지 주소값 보관
        this_location = window.location.href;

        if(this.props.location.state && this.props.location.state.highlightType){
            this.setState({highlightType : this.props.location.state.highlightType}, () => {
                if(this.state.highlightType == "except"){
                    this.setState({show_except_setting_popup : true});
                } else if(this.state.highlightType == "add"){
                    this.setState({show_add_product_popup : true});
                }
            });
        }
    }

    componentDidMount() {
        /** 부가서비스 신청 여부 조회 */
        this.loadRegistedService("0100201001"); // operate_yn_0100201001 (3시간 서비스 - 베이직)
        this.loadRegistedService("0100201002"); // operate_yn_0100201002 (30분 서비스 - 프리미엄)

        /** Static image 호출 및 캐싱 */
        this.preloadImage('/img/rollingProduct/guide_overwrite_1.svg', 'overwrite1');
        this.preloadImage('/img/rollingProduct/guide_modify.svg', 'modify');

        const preHandle = async () => {
            /** 카테고리 리스트 (Root Category from RoboMD) */
            await this.loadProductCategory("", "", "first_category_list");
            /** 카테고리 리스트 (Root Category from Cafe24) */
            await this.loadCafe24Category(1,1,"cafe24_category_list_");
            /** 알고리즘별 선택/제외 메인분류 목록 */
            await this.loadSelfSelectMainCategoryList();
            /** 기존 왼쪽 영역 선택지 */
            await this.loadUpperCodeList();
        }
        preHandle();

        this.loadRpEventExceptSettingsToBe();

        this.loadShopSyncStateAndSyncDate();
        this.loadProductColorList();
        // 사이드바 확장/축소 버튼 클릭 시 화면 비율 조정
        $('html').click(function(e) {
            if($(e.target).parents(".pc_left_menu").length > 0 || $(e.target).parents(".pc_left_menu_reduction").length > 0) {
                setTimeout(() => window.dispatchEvent(new Event('resize')), 10);
            }
        });

        $(document).ready(function(){
            $(window).resize(function(){
                list_main_menu_width_change();
            });
            
            // 페이지 로드시 사이드메뉴 펼친상태 / 접힌상태 설정
            function list_expand(){
                if($(window).width() <= 800){
                    //넓이 720이하일 때 사이드메뉴 줄이기
                    $(".list_expand_check").prop("checked",false);
                    $(".list_expand").each(function(){
                        
                        if($(this).hasClass("list_category_expand")){
                            $(this).nextAll(".list_expand_1").first().css({height :"0", overflow:"hidden", borderTop: "0px"});
                        } else{
                            let list_expand_m = $(this).outerHeight();
                            
                            $(this).parent(".list_expand_wrap").css({
                                "height":list_expand_m
                                , "overflow":"hidden"
                            });
                        }

                    });
                }
                else{
                    //넓이 720초과일 때 사이드메뉴 펼치기
                    $(".list_expand_check").prop("checked",true);
                    $(".list_expand").each(function(){
                        $(this).parent(".list_expand_wrap").css({"height":"auto", "overflow":"visible"});
                    });
                }
            }
            setTimeout(list_expand,0);
        
            function list_main_menu_width_change(){
                let window_width= $(window).width();
                let window_height = $(window).height();
                
                let list_expand_outerWidth = $(".list_expand").outerWidth();
                let list_expand_innerWidth = $(".list_expand").innerWidth();
                let list_expand_width = $(".list_expand").width();
                let list_expand_width_padding_all = list_expand_width - list_expand_innerWidth;
                let list_expand_width_padding = list_expand_width_padding_all / 2;

                // window 높이에 따라서 메인테이블의 max-height가 달라지도록 적용(드래그 스크롤을 위한 작업)
                $("#list_admin_main_board").css({"max-height":window_height-360});
                $("#main_table_tbody").css({"max-height":window_height-430});
                
                // 오른쪽 영역 메인테이블 크기 지정하는 부분
                if(window_width < 800){
                    //상품 카테고리의 '직접 지정' 선택 시 하단 선택창 넓이 변경
                    $(".list_side_2_radio_self_select_wrap").css({
                        "width":list_expand_outerWidth,
                        "transform":"translateX("+list_expand_width_padding+"px)"
                    });
                }
                else{
                    // 상품 카테고리의 '직접 지정' 선택 시 하단 선택창 넓이 변경
                    $(".list_side_2_radio_self_select_wrap").css({
                        "width":list_expand_outerWidth,
                        "transform":"translateX("+list_expand_width_padding+"px)"
                    });
                }
            }
            setTimeout(list_main_menu_width_change,0);
        
            // 왼쪽 영역 접기/펼치기 클릭 이벤트
            var list_title_height;
        
            $(".list_expand").on('click',function(e){
                if (e.target.id === 'btn_add_favorite_algorithm') {
                    // 특정 아이디를 가진 버튼을 클릭한 경우 아무 작업도 하지 않고 종료
                    return;
                }

                list_title_height = $(this).outerHeight();

                // expand_timer의 동작을 취소한다 (시간이 300 만큼 지나기 전에 클릭이 또 있었다면, 이전의 timeout동작은 실행되지 않을것이다)
                let object = this;
                let object_id = this.id;
                // 버튼을 연속으로 누르기 전에 열려있었는지 닫혀있었는지에 대한 정보를 담는다
                if(expand_timer[object_id] == null){
                    expand_timer[object_id+"_yn"] = $(object).find(".list_expand_check").is(":checked")? "Y" : "N";
                }
                // 700만큼의 시간이 지나기 전에 여닫기를 다시 눌렀다면 이전에 걸어놨던 setTimeout 동작은 사라진다(연속으로 누른경우 마지막 동작만 실행)
                clearTimeout(expand_timer[object_id]);
                if($(object).find(".list_expand_check").is(":checked")){
                    $(object).find(".list_expand_check").prop('checked',false);
                    expand_timer[object_id] = setTimeout(() => {
                        if($(object).hasClass("list_category_expand")){
                            $(object).nextAll(".list_expand_1").first().css({overflow:"hidden"});
                            $(object).nextAll(".list_expand_1").first().animate({
                                height :"0"
                            },700, () => {
                                $(object).nextAll(".list_expand_1").first().css({ overflow:"hidden", borderTop: "0px"});
                            });
                        } else{
                            $(object).parent(".list_expand_wrap").css({overflow:"hidden"});
                            $(object).parent(".list_expand_wrap").animate({
                                height:list_title_height,
                            },700, () => {
                                $(object).parent(".list_expand_wrap").css({overflow:"hidden"});
                            });
                        }
                        expand_timer[object_id] = null;
                    },300);
                }
                else{
                    $(object).find(".list_expand_check").prop('checked',true);
                    expand_timer[object_id] = setTimeout(() => {
                        // 버튼을 연속으로 누르기전에 닫혀있는 상태일 경우에만 영역을 연다
                        // 이전에 열려있던 상태였는데도 여는 animate를 실행하면 길이가 뚝 잘렸다가 다시 늘어나는 모션을 취하기 때문에 방지한다.
                        if(expand_timer[object_id+"_yn"]!="Y"){
                            if($(object).hasClass("list_category_expand")){
                                // height auto값에 animate를 주는 작업
                                var height = $(object).nextAll(".list_expand_1").first().css('height','auto').height();
                                $(object).nextAll(".list_expand_1").first().css({height :"0", borderTop: "1px solid rgba(0, 0, 0, 0.12)"}); // 크기가 변하기 전 값
                                $(object).nextAll(".list_expand_1").first().animate({height: height+'px'}, 700, () => {
                                    $(object).nextAll(".list_expand_1").first().css({height: 'auto', overflow:"visible"});
                                });
                            } else{
                                // height auto값에 animate를 주는 작업
                                var height = $(object).parent(".list_expand_wrap").css('height','auto').height();
                                $(object).parent(".list_expand_wrap").css('height',list_title_height+'px'); // 크기가 변하기 전 값
                                $(object).parent(".list_expand_wrap").animate({height: height+'px'}, 700, () => {
                                    $(object).parent(".list_expand_wrap").css({height: 'auto', overflow:"visible"});
                                });
                            }
                        }
                        expand_timer[object_id] = null;
                    },300);
                }
            });
        });   
    }

    componentDidUpdate(prevProps, prevState) {

        // 화면 스크롤 고정 : 여러개의 팝업 중 하나라도 보여지는 상태라면 스크롤 고정
        if(this.state.save_dialog_show_state
            || this.state.basic_dialog_show_state
            || this.state.title_content_dialog_show_state
            || this.state.confirm_dialog_show_state
            || this.state.paste_confirm_dialog_show_state
            || this.state.show_event_product_list_popup
            || this.state.show_exclude_product_list_popup
            || this.state.show_except_setting_popup
            || this.state.show_self_except_setting_popup
            || this.state.show_except_product_popup
            || this.state.show_add_product_popup
            || this.state.refresh_data_show_state) {
            document.body.style.overflow = 'hidden'; // 스크롤 고정
        } else {
            document.body.style.overflow = 'auto'; // 스크롤 고정 해제
        }

        /*------------------------- 왼쪽 영역 : 초기 설정 부분 ------------------------*/
        if (this.state.is_left_load_first_setting) {

            this.countTotalItemSelectCntRange(); // 상품 선택 수 계산
            // 상품 선택 수 합계 구하기
            this.SumEventTotalItemSelectCnt();
            // 자동 진열 설정  체크 상태에 맞게 영역 높이(여닫기) 설정
            for(var i=0;i<this.state.list_self_select.length; i++){
                $("#list_select_arrow_"+i).prop("checked",this.state.list_self_select[i].self_select_area_checked);
                this.onClickEventFolderNoneAni(i); // none 애니메이션으로 변경
            }

            $("#list_select_arrow_force").prop("checked", true);
            this.onClickEventFolderNoneAni("force");
            
            this.setState({
                left_is_modified : false,
                is_left_load_first_setting : false
            }, () => {
                // css설정이 끝난 후에 오른쪽 영역의 크기를 제대로 돌리기 위해 resize를 한번 실행한다.
                window.dispatchEvent(new Event('resize'));
            });
        }

        /** cafe24_shops sync_state 1(연동중) 일 경우 최초 렌더링시 다시 sync 호출 */
        // if (prevState.syncState !== this.state.syncState){
        //     if (this.state.syncState === "1" && !this.hasFetchedSyncData.current) {
        //         try {
        //             this.hasFetchedSyncData.current = true
        //             APIs.subscribeShopDataSyncState(new Date().getTime()).then(res => this.callBackSubscribeShopDataSyncState(res))
        //         } catch (error) {
        //             console.log(error)
        //         }
        //     }
        // } 
    }

    componentWillUnmount(e) {
        if (this.preloadLink1) {
            document.head.removeChild(this.preloadLink1);
        }
        if (this.preloadLink2) {
            document.head.removeChild(this.preloadLink2);
        }
    }

    formatTime(minutes) {
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
      
        if (hours > 0 && remainingMinutes > 0) {
          return `${hours}시간 ${remainingMinutes}분`;
        } else if (hours > 0) {
          return `${hours}시간`;
        } else {
          return `${remainingMinutes}분`;
        }
      }

    onChangeTitleContentCheckBox = (e) => {
        this.setState({title_content_dialog_check_box_checked: e.target.checked})
        localStorage.setItem("ignore_popup", e.target.checked ? "Y" : "N")
    }

    preloadImage = async (url, key) => {
        try {
          const response = await fetch(url, {
            cache: 'reload', // 캐시 제어
          });

          if (!response.ok) throw new Error('Front web server error');

          overwriteImageURLs[key] = URL.createObjectURL(await response.blob()); // Blob URL 저장
        } catch (error) {
          console.error('Error fetching image:', error);
        }
      };

    createPreloadLink(attrs) {
        const link = document.createElement('link')
        Object.keys(attrs).forEach(key => {
            link[key] = attrs[key]
        })
        return link
    }

    /** 무료 체험 기간 조회 : 무료체험 기간이 끝났다면 위에 링크를 쳐서 들어오는 것을 막는다 */
    async loadFreeDatePeriod(){
        await APIs.rp.getCheckingFreeDatePeriod()
            .then(res => {
                if (res.data != null && res.data != '') {
                    if(res.data["is_finish"] != 0){
                        alert("사용 기간이 종료 되었습니다");
                        this.props.history.replace({ pathname: `/shop/rp/event/list` })
                    }
                }
            })
            .catch(error => {});
    }

    setGaEvent(action_text) {
        ReactGA.event({
             category: "베스트 서비스 ("+ this.state.rp_setting.iframe_html_name +" 상품 목록)",
             action: action_text,
             label: sessionStorage.getItem("user_id"),
         });
     }

     setPopupGaEvent(action_text) {
        ReactGA.event({
             category: "베스트 서비스 ("+this.state.rp_setting.iframe_html_name +" 상품 추가 팝업)",
             action: action_text,
             label: sessionStorage.getItem("user_id"),
         });
     }

    // 사용자 가이드
    onClickUserGuide(){
        window.open("https://iclave.notion.site/MD-41912c6f69084ba19fab96b903b08999");
    }

    // 기간 연장하기
    onClicExtendPeriod(){
        this.props.history.push(
            {
                pathname: `/shop/qna/form`,
                state: {qna_type_cd: "2104"}
            }	
        )
    }

    // 서비스 상담 안내
    goConsultingPage = () => {
        window.open('/shop/qna/form?qna_type_cd=2109', '_blank');
    }

    /** 왼쪽 영역 기존 설정 불러오기
     * @param {*} reload 다시 로드하는 경우 (초기화, 첫 저장)
     * @param {*} first_save 첫 저장인 경우
    */
    async loadRpEventSetting(reload, first_save) {

        await APIs.rp.getRpEventSetting(this.state.iframe_page_id, this.state.iframe_html_id)
            .then(res => {
                if (res.data.code == "200") {
                    this.setState({
                        rp_setting : res.data["setting"],
                    }, () => {
                        /*------- 왼쪽 영역 값 초기화 ------*/
                        const {rp_setting, product_color_list} = this.state;
                        // 판매가 최대값, 최소값
                        let event_item_min_price = "";
                        if (rp_setting.event_item_min_price != null) {
                            event_item_min_price = rp_setting.event_item_min_price;
                        }
                        let event_item_max_price = "";
                        if (rp_setting.event_item_max_price != null) {
                            event_item_max_price = rp_setting.event_item_max_price;
                        }

                        // 제목 사용 여부
                        const display_name_use_yn = rp_setting.display_name_cd == "33099"? "N" : "Y";
                        // 카페24 메인 진열 - 메인 분류 : 새로 생긴 속성이라 값이 없는것에 대응
                        let cafe24_main_display_group = this.state.cafe24_main_display_group;
                        if(rp_setting.cafe24_main_display_group != null && rp_setting.cafe24_main_display_group != ""){
                            cafe24_main_display_group = rp_setting.cafe24_main_display_group;
                        }
                        // 카페24 카테고리 진열 - 상세 상품분류 : 새로 생긴 속성이라 값이 없는것에 대응
                        let cafe24_category_display_group = this.state.cafe24_category_display_group;
                        if(rp_setting.cafe24_category_display_group != null && rp_setting.cafe24_category_display_group != ""){
                            cafe24_category_display_group = rp_setting.cafe24_category_display_group;
                        }

                        // 카테24 카테고리 진열 - 상품분류 : 새로 생긴 속성이라 값이 없는것에 대응
                        let cafe24_category_no_list = this.state.cafe24_category_no;
                        let cafe24_category_no = this.state.cafe24_category_no;
                        if(rp_setting.cafe24_category_no_list != null && rp_setting.cafe24_category_no_list != ""){
                            cafe24_category_no_list = rp_setting.cafe24_category_no_list;
                            cafe24_category_no = String(cafe24_category_no_list).indexOf(',') == -1 ? cafe24_category_no_list : String(cafe24_category_no_list).split(',')[String(cafe24_category_no_list).split(',').length-1];
                        }
                        // 상품 등록일 기준 : 새로 생긴 속성이라 값이 없는것에 대응
                        let event_item_created_period = "0";
                        if(rp_setting.event_item_created_period != null && rp_setting.event_item_created_period != ""){
                            event_item_created_period = rp_setting.event_item_created_period;
                        }
                        // 알고리즘 분석 기간 : 새로 생긴 속성이라 값이 없는것에 대응
                        let event_item_analysis_period = "4";
                        if(rp_setting.event_item_analysis_period != null && rp_setting.event_item_analysis_period != ""){
                            event_item_analysis_period = rp_setting.event_item_analysis_period;
                        }
                        // 직접 지정 영역 : 고도화 이후 새로 생긴 속성이라 값이 없는것에 대응
                        let force_use_yn = "N";
                        let force_logic = "22001";
                        let force_category_list_1 = JSON.parse(JSON.stringify(this.state.first_category_list));
                        let force_category_list_2 = [];
                        let force_category_list_3 = [];
                        let force_category_list_4 = [];
                        let force_category = {
                            "product_rp_category_no_1": "전체상품",
                        };
                        let force_auto_remove = "";
                        let force_analysis_period = 0;
                        let force_select_created_yn = "N";
                        let force_created_period_type = "";
                        let force_created_period = 0;
                        let force_created_start_date = "";
                        let force_created_end_date = "";
                        let force_is_except_invisible_category = "N";

                        // let auto_create_type = "";
                        // if (rp_setting.auto_create_type) {
                        //     auto_create_type = rp_setting.auto_create_type;
                        // } else if (rp_setting.auto_create_yn == "Y") {
                        //     auto_create_type = "A7001"
                        // } else if (rp_setting.auto_create_yn == "N") {
                        //     auto_create_type = "A7002"
                        // }

                        let event_cycle_type = "A8001";
                        if (rp_setting.event_cycle_type) {
                            event_cycle_type = rp_setting.event_cycle_type;
                        }

                        let weekday_use_yn = "";
                        if (rp_setting.weekday_use_yn) {
                            weekday_use_yn = rp_setting.weekday_use_yn;
                        }

                        let weekday_cycle = "";
                        if (rp_setting.weekday_cycle) {
                            weekday_cycle = rp_setting.weekday_cycle;
                        }

                        let weekday_list = "-1,0,1,2,3,4,5,6";
                        if (rp_setting.weekday_list) {
                            weekday_list = rp_setting.weekday_list;
                        }

                        let real_time_cycle = "720";
                        if (rp_setting.real_time_cycle) {
                            real_time_cycle = rp_setting.real_time_cycle;
                        }

                        let real_time_txt_use_yn = "N";
                        if (rp_setting.real_time_txt_use_yn) {
                            real_time_txt_use_yn = rp_setting.real_time_txt_use_yn;
                        }

                        let reservation_use_yn = "N";
                        if (rp_setting.reservation_use_yn) {
                            reservation_use_yn = rp_setting.reservation_use_yn;
                        }

                        let reservation_date = "";
                        if (rp_setting.reservation_date) {
                            reservation_date = new Date(rp_setting.reservation_date);
                        }

                        let reservation_hour = "7";
                        if (rp_setting.reservation_hour) {
                            reservation_hour = rp_setting.reservation_hour;
                        }

                        let event_start_date = new Date(rp_setting.reg_date);
                        if (rp_setting.event_start_date) {
                            event_start_date = new Date(rp_setting.event_start_date);
                        }

                        // let event_start_hour = "7";
                        // if (rp_setting.event_start_hour) {
                        //     event_start_hour = rp_setting.event_start_hour;
                        // }
                        
                        let real_time_start_hour = "12";
                        if (rp_setting.real_time_start_hour) {
                            real_time_start_hour = rp_setting.real_time_start_hour;
                        }
                        
                        let real_time_end_hour = "24";
                        if (rp_setting.real_time_end_hour) {
                            real_time_end_hour = rp_setting.real_time_end_hour;
                        }
    
                        // 진열 최대 개수
                        let max_item_analysis = this.state.max_item_analysis;
                        let max_item_analysis_value = this.state.max_item_analysis_value;

                        // 최종 상품 순서
                        let total_sort_type = this.state.total_sort_type;
    
                        let list_self_select = this.state.list_self_select;
                        if(res.data["list_self_select"] != null && res.data["list_self_select"] != ""){
                            list_self_select = res.data["list_self_select"];
                            const {first_category_list} = this.state;
                            for(var idx=0;idx<list_self_select.length;idx++){
                                // uuid 부여
                                if (list_self_select[idx].uuid == null) {
                                    list_self_select[idx].uuid = StringUtil.generateUUID();
                                }
                                if (!list_self_select[idx].item_select_type_start_idx) {
                                    list_self_select[idx].item_select_type_start_idx = 1;
                                }
                                // if (list_self_select[idx].detail_filter_expand_check == null) {
                                    // 첫 로드시 닫힘
                                    list_self_select[idx].detail_filter_expand_check = false;
                                // }

                                // null이라는 문자값으로 들어오는것을 방지
                                if(list_self_select[idx].min_hit_cnt == null){ list_self_select[idx].min_hit_cnt = ""; }
                                if(list_self_select[idx].max_hit_cnt == null){ list_self_select[idx].max_hit_cnt = ""; }

                                if(list_self_select[idx].min_cart_cnt == null){ list_self_select[idx].min_cart_cnt = ""; }
                                if(list_self_select[idx].max_cart_cnt == null){ list_self_select[idx].max_cart_cnt = ""; }

                                if(list_self_select[idx].min_price == null){ list_self_select[idx].min_price = ""; }
                                if(list_self_select[idx].max_price == null){ list_self_select[idx].max_price = ""; }

                                if(list_self_select[idx].min_order_cnt == null){ list_self_select[idx].min_order_cnt = ""; }
                                if(list_self_select[idx].max_order_cnt == null){ list_self_select[idx].max_order_cnt = ""; }

                                if(list_self_select[idx].min_order_price == null){ list_self_select[idx].min_order_price = ""; }
                                if(list_self_select[idx].max_order_price == null){ list_self_select[idx].max_order_price = ""; }
                                
                                if(list_self_select[idx].min_review_cnt == null){ list_self_select[idx].min_review_cnt = ""; }
                                if(list_self_select[idx].max_review_cnt == null){ list_self_select[idx].max_review_cnt = ""; }

                                if(list_self_select[idx].min_review_point == null){ list_self_select[idx].min_review_point = ""; }
                                if(list_self_select[idx].max_review_point == null){ list_self_select[idx].max_review_point = ""; }
                            
                                if(list_self_select[idx].min_quantity == null){ list_self_select[idx].min_quantity = ""; }
                                if(list_self_select[idx].max_quantity == null){ list_self_select[idx].max_quantity = ""; }

                                // 상품 선택 수가 빈문자로 들어오는것을 방지 (select 영역)
                                if(list_self_select[idx].cnt == null || list_self_select[idx].cnt == ""){ list_self_select[idx].cnt = 0; }

                                // 카테고리 목록을 불러올 수 없다면 전체선택으로 변경 (전체선택 or 기존 대카테고리 목록값 들어오는 경우[a,b,c] or 오류)
                                if(list_self_select[idx].category == null || list_self_select[idx].category.length == 0){
                                    list_self_select[idx].event_category_list = "";
                                }

                                // 알고리즘 분석 기간이 null이라면
                                if(!list_self_select[idx].event_item_analysis_period && list_self_select[idx].event_item_analysis_period != 0){
                                    list_self_select[idx].event_item_analysis_period = '4';
                                }

                                // 상품 선택일 관련 작업
                                if(list_self_select[idx].event_item_created_period != null && list_self_select[idx]["self_select_created_yn"] == 'Y'){
                                    list_self_select[idx].event_item_created_start_date = list_self_select[idx].event_item_created_start_date != null ? new Date(StringUtil.dateFormater(list_self_select[idx].event_item_created_start_date)) : null;
                                    list_self_select[idx].event_item_created_end_date = list_self_select[idx].event_item_created_end_date != null ? new Date(StringUtil.dateFormater(list_self_select[idx].event_item_created_end_date)) : null;
                                } else{
                                    list_self_select[idx].event_item_created_period = (list_self_select[idx].event_item_created_period != null ? list_self_select[idx].event_item_created_period : "0");
                                    list_self_select[idx].event_item_created_period_type = list_self_select[idx].event_item_created_period_type ? list_self_select[idx].event_item_created_period_type : "W";
                                    list_self_select[idx].event_item_created_start_date = null;
                                    list_self_select[idx].event_item_created_end_date = null;
                                }
                                // 강제설정 날짜 포맷 맞추기
                                list_self_select[idx].force_created_start_date = list_self_select[idx].force_created_start_date != null && list_self_select[idx].force_created_start_date != "" ? new Date(StringUtil.dateFormater(list_self_select[idx].force_created_start_date)) : null;
                                list_self_select[idx].force_created_end_date = list_self_select[idx].force_created_end_date != null && list_self_select[idx].force_created_end_date != "" ? new Date(StringUtil.dateFormater(list_self_select[idx].force_created_end_date)) : null;

                                // 카테고리 목록 및 값
                                list_self_select[idx]["product_rp_category_list_1"] = JSON.parse(JSON.stringify(first_category_list));
                                list_self_select[idx]["product_rp_category_list_2"] = [];
                                list_self_select[idx]["product_rp_category_list_3"] = [];
                                list_self_select[idx]["product_rp_category_list_4"] = [];
    
                                list_self_select[idx]["product_rp_category_no_1"] = list_self_select[idx]["category"].length > 0 ? list_self_select[idx]["category"][0].category_no : "";
                                list_self_select[idx]["product_rp_category_no_2"] = list_self_select[idx]["category"].length > 1 ? list_self_select[idx]["category"][1].category_no : "";
                                list_self_select[idx]["product_rp_category_no_3"] = list_self_select[idx]["category"].length > 2 ? list_self_select[idx]["category"][2].category_no : "";
                                list_self_select[idx]["product_rp_category_no_4"] = list_self_select[idx]["category"].length > 3 ? list_self_select[idx]["category"][3].category_no : "";
                                
                                const event_except_category_list = list_self_select[idx]["event_except_category_list"];
                                
                                // 제외 카테고리 초기화
                                if (
                                    !list_self_select[idx]["product_rp_except_category_no_list"] ||
                                    !Array.isArray(list_self_select[idx]["product_rp_except_category_no_list"]) ||
                                    list_self_select[idx]["product_rp_except_category_no_list"].length === 0
                                ) {
                                    list_self_select[idx]["product_rp_except_category_no_list"] = [{}];
                                }

                                let copy_first_category_list = JSON.parse(JSON.stringify(first_category_list));
                                if (copy_first_category_list != null && copy_first_category_list[0] != null) {
                                    copy_first_category_list[0] = {
                                        category_name: "사용 안함",
                                        category_name_no_format: "사용 안함",
                                        category_no: ""
                                    };
                                }

                                for (let exIdx = 0; exIdx < list_self_select[idx]["product_rp_except_category_no_list"].length; exIdx++) {
                                    const exceptObj = list_self_select[idx]["product_rp_except_category_no_list"][exIdx] || {};

                                    // 응답에 들어있던 product_rp_except_category_list_1~4 는 사용하지 않고 덮어씀
                                    exceptObj["product_rp_except_category_list_1"] = JSON.parse(JSON.stringify(copy_first_category_list));
                                    exceptObj["product_rp_except_category_list_2"] = [];
                                    exceptObj["product_rp_except_category_list_3"] = [];
                                    exceptObj["product_rp_except_category_list_4"] = [];

                                    if (!exceptObj["product_rp_except_category_no_1"]) {
                                        exceptObj["product_rp_except_category_no_1"] = "";
                                    }
                                    if (!exceptObj["product_rp_except_category_no_2"]) {
                                        exceptObj["product_rp_except_category_no_2"] = "";
                                    }
                                    if (!exceptObj["product_rp_except_category_no_3"]) {
                                        exceptObj["product_rp_except_category_no_3"] = "";
                                    }
                                    if (!exceptObj["product_rp_except_category_no_4"]) {
                                        exceptObj["product_rp_except_category_no_4"] = "";
                                    }

                                    list_self_select[idx]["product_rp_except_category_no_list"][exIdx] = exceptObj;
                                }

                                if (!event_except_category_list) {
                                    list_self_select[idx]["event_except_category_list"] = [""];
                                }

                                // 순위별 진열코너 중복 제외 설정
                                if (!Array.isArray(list_self_select[idx]["self_except_setting_list"])) {
                                    list_self_select[idx]["self_except_setting_list"] = [];
                                } else {
                                    list_self_select[idx]["self_except_setting_list"] =
                                        list_self_select[idx]["self_except_setting_list"].map(exceptObj => ({
                                            ...exceptObj,
                                            id: exceptObj.id || (exceptObj.iframe_page_id + "/" + exceptObj.iframe_html_id),
                                            except_order_start_no: exceptObj.except_order_start_no == null ? "" : String(exceptObj.except_order_start_no),
                                            except_order_end_no: exceptObj.except_order_end_no == null ? "" : String(exceptObj.except_order_end_no),
                                        }));
                                }

                                // 선택 메인분류
                                if (list_self_select[idx]["event_main_display_group"] == null) {
                                    list_self_select[idx]["event_main_display_group"] = "";
                                } else {
                                    list_self_select[idx]["event_main_display_group"] = String(list_self_select[idx]["event_main_display_group"]);
                                }

                                // 제외 메인분류
                                if (!Array.isArray(list_self_select[idx]["event_except_main_display_group_list"])) {
                                    list_self_select[idx]["event_except_main_display_group_list"] = [];
                                } else {
                                    list_self_select[idx]["event_except_main_display_group_list"] =
                                        list_self_select[idx]["event_except_main_display_group_list"].map(String);
                                }

                                // 자동 선택 상품 키워드
                                list_self_select[idx]["product_keyword_list"] = list_self_select[idx]["product_keyword_list"] ? list_self_select[idx]["product_keyword_list"] : [""];
                                // 제외 키워드
                                list_self_select[idx]["product_except_keyword_list"] = list_self_select[idx]["product_except_keyword_list"] ? list_self_select[idx]["product_except_keyword_list"] : [""];
    
                                // 여닫기 체크 상태
                                if (!first_save) {
                                    list_self_select[idx]["self_select_area_checked"] = (idx == 0 ? true : false);
                                }
    
                                if (!list_self_select[idx]["event_item_condition_list"] 
                                        || (list_self_select[idx]["event_item_condition_list"] && list_self_select[idx]["event_item_condition_list"].length <= 0)) {
                                    // 알고리즘(~중에)) 초기화
                                    list_self_select[idx]["event_item_condition_list"] = [
                                        "A2999",
                                        "A2999"
                                    ]                                            
                                }
                                // 컬러 목록
                                if(list_self_select[idx].color_seq_list){
                                    let color_seq_list = list_self_select[idx].color_seq_list;
                                    const color_list = product_color_list.filter(obj => color_seq_list.indexOf(obj.color_seq) != -1);
                                    list_self_select[idx].color_list = color_list;
                                    delete list_self_select[idx].color_seq_list;
                                } else{
                                    list_self_select[idx].color_list = [];
                                }

                                if (!list_self_select[idx].past_order_date_use_yn) {
                                    // 과거 판매 상품 사용 여부가 없으나,
                                    if (list_self_select[idx].past_order_start_date_type 
                                        || list_self_select[idx].past_order_end_date_type) {
                                            // 시작일 또는 종료일 둘중 하나가 있는 경우
                                            list_self_select[idx].past_order_date_use_yn = "Y";
                                    } else {
                                        // 시작일과 종료일 둘 다 없는 경우
                                        list_self_select[idx].past_order_date_use_yn = "N";
                                    }
                                }

                                // 과거 판매 시작일 또는 종료일 둘중 하나가 없는 경우 (이전 버전에서 생략으로 선택한 경우)
                                if (!list_self_select[idx].past_order_start_date_type) {
                                    list_self_select[idx].past_order_date_use_yn = "N";
                                }
                                if (!list_self_select[idx].past_order_end_date_type) {
                                    list_self_select[idx].past_order_date_use_yn = "N";
                                }
                                
                                // 과거 알고리즘이 없는 경우 1로 초기화 (기존 설정들)
                                if (!list_self_select[idx].past_order_sort_type) {
                                    list_self_select[idx].past_order_sort_type = "1";
                                }

                                // 진열 최대 개수 없는 경우
                                if (!list_self_select[idx].max_item_analysis) {
                                    list_self_select[idx].max_item_analysis = "1";
                                }
                                if (!list_self_select[idx].max_item_analysis_value) {
                                    list_self_select[idx].max_item_analysis_value = "10";
                                }

                                // 죄종 상품 순서 없는 경우
                                if (!list_self_select[idx].total_sort_type) {
                                    list_self_select[idx].total_sort_type = "1";
                                }
                                
                                // 강제 알고리즘
                                if( list_self_select[idx].force_use_yn ) force_use_yn = list_self_select[idx].force_use_yn;
                                if( list_self_select[idx].force_logic ) force_logic = list_self_select[idx].force_logic;
                                if( list_self_select[idx].force_category ) force_category = list_self_select[idx].force_category;
                                if( list_self_select[idx].force_auto_remove ) force_auto_remove = list_self_select[idx].force_auto_remove;
                                if( list_self_select[idx].force_analysis_period ) force_analysis_period = list_self_select[idx].force_analysis_period;
                                if( list_self_select[idx].force_select_created_yn ) force_select_created_yn = list_self_select[idx].force_select_created_yn;
                                if( list_self_select[idx].force_created_period_type ) force_created_period_type = list_self_select[idx].force_created_period_type;
                                if( list_self_select[idx].force_created_period ) force_created_period = list_self_select[idx].force_created_period;
                                if( list_self_select[idx].force_created_start_date ) force_created_start_date = list_self_select[idx].force_created_start_date;
                                if( list_self_select[idx].force_created_end_date ) force_created_end_date = list_self_select[idx].force_created_end_date;
                                if( list_self_select[idx].force_is_except_invisible_category ) force_is_except_invisible_category = list_self_select[idx].force_is_except_invisible_category;
                                if( list_self_select[idx].max_item_analysis ) max_item_analysis = list_self_select[idx].max_item_analysis;
                                if( list_self_select[idx].max_item_analysis_value ) max_item_analysis_value = list_self_select[idx].max_item_analysis_value;
                                if( list_self_select[idx].total_sort_type ) total_sort_type = list_self_select[idx].total_sort_type;
                        }
                    }
                    this.setState({
                        user_seq : rp_setting.user_seq,
                        shop_no : rp_setting.shop_no,
                        iframe_html_id : rp_setting.iframe_html_id,
                        iframe_page_id : rp_setting.iframe_page_id,
                        cafe24_main_display_group : cafe24_main_display_group,
                        cafe24_category_display_group : cafe24_category_display_group,
                        cafe24_category_display_type: rp_setting.cafe24_category_display_type ? rp_setting.cafe24_category_display_type.toString() : "2",
                        cafe24_product_manage_type: rp_setting.cafe24_product_manage_type ? rp_setting.cafe24_product_manage_type.toString() : "2",
                        cafe24_category_no_list : cafe24_category_no_list,
                        cafe24_category_no : cafe24_category_no,
                        image_type_cd: rp_setting.image_type_cd,
                        link_open_type : rp_setting.link_open_type,
                        display_type : rp_setting.display_type,
                        display_name_use_yn : display_name_use_yn,
                        display_name : rp_setting.display_name,
                        display_name_cd : rp_setting.display_name_cd,
                        platform_type : rp_setting.platform_type,
                        item_select_type : rp_setting.item_select_type,
                        auto_create_yn: rp_setting.auto_create_yn,
                        auto_rolling_yn: rp_setting.auto_rolling_yn,
                        event_category_list: rp_setting.event_category_list,
                        event_category_select_type: rp_setting.event_category_select_type,
                        event_cycle: rp_setting.event_cycle,
                        event_item_created_period : event_item_created_period,
                        event_item_analysis_period : event_item_analysis_period,
                        list_self_select : list_self_select,
                        event_item_price_filter_yn :"Y",
                        event_item_min_price : event_item_min_price,
                        event_item_max_price : event_item_max_price,
                        event_mobile_view_cnt: rp_setting.event_mobile_view_cnt,
                        event_time: rp_setting.event_time,
                        event_total_item_select_cnt: rp_setting.event_total_item_select_cnt,
                        event_type_cd: rp_setting.event_type_cd,
                        event_item_price_show_type : rp_setting.event_item_price_show_type,
                        event_view_cnt: rp_setting.event_view_cnt,
                        iframe_html_name: rp_setting.iframe_html_name,
                        install_yn: rp_setting.install_yn,
                        reg_date: rp_setting.reg_date,
                        transition_mode: rp_setting.transition_mode,
                        transition_pause: rp_setting.transition_pause,
                        transition_speed: rp_setting.transition_speed,
                        operateed_yn : rp_setting.operateed_yn,
                        force_use_yn: force_use_yn,
                        force_logic: force_logic,
                        force_category: force_category,
                        force_category_list_1: force_category_list_1,
                        force_category_list_2: force_category_list_2,
                        force_category_list_3: force_category_list_3,
                        force_category_list_4: force_category_list_4,
                        force_auto_remove: force_auto_remove,
                        force_analysis_period: force_analysis_period,
                        force_select_created_yn: force_select_created_yn,
                        force_created_period_type: force_created_period_type,
                        force_created_period: force_created_period,
                        force_created_start_date: force_created_start_date,
                        force_created_end_date: force_created_end_date,
                        force_is_except_invisible_category: force_is_except_invisible_category,
                        max_item_analysis: max_item_analysis,
                        max_item_analysis_value: max_item_analysis_value,
                        total_sort_type: total_sort_type,
                        
                        // auto_create_type: auto_create_type,
                        event_cycle_type: event_cycle_type,
                        weekday_use_yn: weekday_use_yn,
                        weekday_cycle: weekday_cycle,
                        weekday_list: weekday_list,
                        real_time_cycle: real_time_cycle,
                        real_time_txt_use_yn: real_time_txt_use_yn,
                        reservation_use_yn: reservation_use_yn,
                        reservation_date: reservation_date,
                        reservation_hour: reservation_hour,
                        event_start_date: event_start_date,
                        // event_start_hour: event_start_hour,
                        real_time_start_hour: real_time_start_hour,
                        real_time_end_hour: real_time_end_hour,
                    }, async () => {
                        if(!create_rp && this.state.operateed_yn != "Y") {
                            this.props.history.replace(
                                {
                                    pathname: `/shop/rp/event/cafe24List`,
                                }
                            )
                        }
                        // 이미 설치 되었다면
                        if(this.state.install_yn=="Y"){
                            // 설치값 메뉴 닫기
                            $("#list_side_title_arrow").prop("checked",false);

                            let list_expand_m = $("#install_list_expand").outerHeight();
                            $("#install_list_expand").parent(".list_expand_wrap").css({
                                "height":list_expand_m,
                                "overflow":"hidden"
                            });
                        }
                        if(reload == null || !reload){
                            /** 제외목록 호출 */
                            const asyncCallExceptSettings = async () => {
                                this.loadExcludeProductList();
                                this.loadRpEventExceptSettingsToBe();
                                this.loadRpEventExceptSettingsDone();
                            }

                            await asyncCallExceptSettings()
                            if(this.state.iframe_page_id == "robomd_cafe24_main_page"){
                                /** 먼저 Main 진열 관련 api 동작중인지 체크 후, 알고리즘을 통해 도출된 상품목록이 있는지 본다. */
                                // if (await this.cafe24MainAPIRun(true)) {
                                //     await this.getRpEventResultProducts(this.state.cafe24_main_display_group)
                                // } else {
                                //   this.loadSelfEventProductList()
                                // }
                                await this.cafe24MainAPIRun(true)
                                await this.loadCafe24MainProductList();
                            } else if(this.state.iframe_page_id == "robomd_cafe24_category_page"){
                                /** 먼저 Category 진열 관련 api 동작중인지 체크 후, 알고리즘을 통해 도출된 상품목록이 있는지 본다. */
                                this.cafe24CategoryAPIRun("D",null,null,true);
                                // if (!checkCafe24CategoryRunAPI) {
                                //   await this.getRpEventResultProducts(this.state.cafe24_category_display_group)
                                // }
                            }
                        } else {
                          this.orderIdxReset();
                        }

                        // if(!first_save){
                            let {list_self_select} = this.state;
                            for(let idx=0;idx<list_self_select.length;idx++){
                                // 상품 선택 영역 카테고리 리스트 선택되어 있도록 하는 작업
                                if(list_self_select[idx].category != null && list_self_select[idx].category.length!=0){
                                    for (var idx2 in list_self_select[idx].category) {
                                        const name = "product_rp_category_no_"+(Number(idx2)+1);
                                        this.setState({
                                            [name]: list_self_select[idx].category[idx2].category_no,
                                        });
                                        this.loadProductCategory(list_self_select[idx].category[Number(idx2)].parent_category_no, Number(idx2)+1, "product_rp_category_list_",idx)
                                    }
            
                                    const category_length = list_self_select[idx].category.length;
                                    // 불러온 카테고리의 가장 하위 카테고리는, 다음 카테고리가 전체선택인 채로 저장되었을 수도 있으니 불러온다. (아니면 안불러옴)
                                    if(category_length > 0){
                                        this.loadProductCategory(list_self_select[idx].category[category_length-1].category_no, category_length+1, "product_rp_category_list_",idx);
                                    }
                                }
                            }

                            for (let idx = 0; idx < list_self_select.length; idx++) {
                                // 상품 선택 영역 카테고리 리스트 선택되어 있도록 하는 작업
                                const exceptCategoryNoList = list_self_select[idx].product_rp_except_category_no_list;

                                if (exceptCategoryNoList && exceptCategoryNoList.length > 0) {
                                    for (let exIdx = 0; exIdx < exceptCategoryNoList.length; exIdx++) {
                                        const exceptObj = exceptCategoryNoList[exIdx];

                                        if (!exceptObj) continue;

                                        // 1depth가 선택되어 있으면 2depth 목록 로드
                                        if (exceptObj.product_rp_except_category_no_1) {
                                            this.loadProductCategory(
                                                exceptObj.product_rp_except_category_no_1,
                                                2,
                                                "product_rp_except_category_list_",
                                                idx,
                                                exIdx
                                            );
                                        }

                                        // 2depth가 선택되어 있으면 3depth 목록 로드
                                        if (exceptObj.product_rp_except_category_no_2) {
                                            this.loadProductCategory(
                                                exceptObj.product_rp_except_category_no_2,
                                                3,
                                                "product_rp_except_category_list_",
                                                idx,
                                                exIdx
                                            );
                                        }

                                        // 3depth가 선택되어 있으면 4depth 목록 로드
                                        if (exceptObj.product_rp_except_category_no_3) {
                                            this.loadProductCategory(
                                                exceptObj.product_rp_except_category_no_3,
                                                4,
                                                "product_rp_except_category_list_",
                                                idx,
                                                exIdx
                                            );
                                        }
                                    }
                                }
                            }

                            // 상품 선택 영역 카테고리 리스트 선택되어 있도록 하는 작업
                            let {force_category} = this.state;
                            // if(force_category != null && force_category.length!=0){
                            if (force_category && Object.keys(force_category).length > 0) {    
                                idx = 1;
                                for (var key in force_category) {
                                    if( key === 'event_category_list') continue;
                                    if( force_category[key] == "") continue;
                                    this.loadProductCategory(force_category[key], Number(idx)+1, "force_category_list_", true)
                                    idx++;
                                }
                            }

                            // 카페24 분류값에 맞는 목록 불러오기
                            if(this.state.iframe_page_id == "robomd_cafe24_category_page" && cafe24_category_no_list != null && cafe24_category_no_list!= ""){
                                let cafe24_category_no_list = [];
                                if((String(this.state.cafe24_category_no_list)).indexOf(',') == -1){
                                    cafe24_category_no_list.push(this.state.cafe24_category_no_list); 
                                } else{
                                    cafe24_category_no_list = String(this.state.cafe24_category_no_list).split(',');
                                }

                                for (var idx2 in cafe24_category_no_list) {
                                    const name = "cafe24_category_no_"+(Number(idx2)+1);
                                    this.setState({
                                        [name]: cafe24_category_no_list[idx2],
                                    });
                                    if(idx2 > 0){
                                        this.loadCafe24Category(cafe24_category_no_list[idx2-1], Number(idx2)+1, "cafe24_category_list_")
                                    }
                                }
        
                                const category_length = cafe24_category_no_list.length;
                                // 불러온 카테고리의 가장 하위 카테고리는, 다음 카테고리가 전체선택인 채로 저장되었을 수도 있으니 불러온다. (아니면 안불러옴)
                                if(category_length < 4){
                                    this.loadCafe24Category(cafe24_category_no_list[category_length-1], category_length+1, "cafe24_category_list_");
                                }

                                this.checkCafe24CategorySetting(null, true);
                            }
                        // }

                            this.setState({is_left_load_first_setting : true});

                            // 카페24 자동진열 사용 여부
                            this.loadCategoryAutoLayoutList(this.state.cafe24_category_no, this.state.cafe24_main_display_group, true);
                        });
                    });
                    } else if(res.data.code == "400" || res.data.code == "404" || res.data.code == "500") {
                        alert("접근할 수 없는 진열입니다.")
                        window.location.href = "/shop/rp/event/cafe24List";
                    } else{
                        alert("진열 설정을 불러오는데 실패하였습니다.");
                        window.history.back();
                    }
                })
                .catch(error => {
                    console.error(error);
                    alert("접근할 수 없는 진열입니다.")
                    window.location.href = "/shop/rp/event/cafe24List";
                });
            }

    async loadFixedProductList() {
        await http.get("/rest/shop/rp/event/fixed-product/list?iframe_page_id="+this.state.iframe_page_id+"&iframe_html_id="+this.state.iframe_html_id) 
        .then(res => {
            if (res.data.success == "true" && res.data.list.length > 0) {
                this.setState({ fixed_product_list: res.data.list });
            } else {
                this.setState({ fixed_product_list: [] });
            }

            const { event_rp_product_list } = this.state;
            const fixed_product_no_list = res.data.list.map(item => item.product_no);
            const updated_event_rp_product_list = event_rp_product_list.map(item => ({
                ...item,
                is_fixed: fixed_product_no_list.includes(item.product_no)
            }));
            this.setState({ event_rp_product_list: updated_event_rp_product_list });

        }).catch(error => { 
            console.error(error);
            this.setState({ fixed_product_list: [] });
        });
    }

    // 저장 버튼 onClick={() => this.saveFixedProducts()} 로 사용
    saveFixedProducts = async () => {
        const {
            iframe_page_id,
            iframe_html_id,
            event_rp_product_list
        } = this.state;

        if (!iframe_page_id || !iframe_html_id) {
            alert("iframe_page_id, iframe_html_id가 없습니다.");
            return;
        }

        // 1) 현재 상태에서 is_fixed=true 인 것만 서버 포맷으로 변환
         const fixed_product_list = (event_rp_product_list || [])
        .map((x, idx) => ({ ...x, original_index: idx })) // 원본 인덱스 보존
        .filter(x => x && x.is_fixed)
        .map(x => ({
            product_no: String(x.product_no),
            fixed_no: x.original_index + 1 // 원본 배열에서 몇 번째인지
        }));

        this.setState({ fixed_saving: true });

        try {
            const url = `/rest/shop/rp/event/fixed-product/save`;
            const body = {
                iframe_page_id,
                iframe_html_id,
                fixed_product_list
            };

            const res = await http.post(url, body); // axios 래퍼 사용
            const data = res?.data || {};

            if (data.success) {
                this.setState({ fixed_saving: false });
                // alert("저장되었습니다.");
                // await this.loadFixedProductList();
            } else {
                this.setState({ fixed_saving: false });
                alert(data.message || "저장에 실패했습니다.");
            }
        } catch (err) {
            this.setState({ fixed_saving: false });
            alert("저장 중 오류가 발생했습니다.");
        }
    };


        
    /** 카테고리 리스트를 불러오는 함수
     * @param {*} parentCategory 목록이 바로 포함하는 상위 카테고리 번호
     * @param {*} depth 카테고리 깊이 순서
     * @param {*} key_name 리스트 값이 저장될 이름
     * @param {*} list_self_select_index 직접 지정속 카테고리인 경우 : 선택 기준 순서 번호
    */   
    async loadProductCategory(parentCategory, depth, key_name, list_self_select_index, except_index = null) {
        await APIs.rp.getRoboMDCategory(this.state.user_seq, this.state.shop_no, parentCategory)
            .then(async (res) => {
                const name = key_name + depth;

                let categoryList = res.data.list ? [...res.data.list] : [];
                if (categoryList.length > 0) {
                    categoryList.splice(0, 0, {
                        category_name: "전체상품",
                        category_name_no_format: "전체상품",
                        category_no: "전체상품"
                    });
                }

                if (list_self_select_index != null) {
                    let { list_self_select } = this.state;

                    if (except_index != null) {
                        if (!list_self_select[list_self_select_index].product_rp_except_category_no_list) {
                            list_self_select[list_self_select_index].product_rp_except_category_no_list = [];
                        }
                        if (!list_self_select[list_self_select_index].product_rp_except_category_no_list[except_index]) {
                            list_self_select[list_self_select_index].product_rp_except_category_no_list[except_index] = {};
                        }

                        list_self_select[list_self_select_index]
                            .product_rp_except_category_no_list[except_index][name] = categoryList;
                    } else {
                        list_self_select[list_self_select_index][name] = categoryList;
                    }

                    this.setState({ list_self_select });
                } else {
                    this.setState({ [name]: categoryList });
                }
            })
            .catch(error => {});
    }
    async loadProductExceptCategory(parentCategory, depth, key_name, list_self_select_index, except_category_idx) {
        await APIs.rp.getRoboMDCategory(this.state.user_seq, this.state.shop_no, parentCategory)
            .then(async (res) => {
                var name = key_name+depth;
                if(res.data.list.length > 0){
                    res.data.list.splice(0,0,{category_name : "전체상품", category_name_no_format : "전체상품", category_no : "전체상품"})
                }
                if(list_self_select_index != null){
                    let {list_self_select} = this.state;
                    list_self_select[list_self_select_index]["product_rp_except_category_no_list"][except_category_idx][name] = res.data.list;
                    this.setState({list_self_select : list_self_select});
                } else{
                    this.setState({[name]: res.data.list});
                }
            }).catch(error => {});
    }

    async loadSelfSelectMainCategoryList() {
        await http.get("/rest/shop/mainCategoryList")
            .then(res => {
                const list = res.data && Array.isArray(res.data.list)
                    ? res.data.list
                    : [];

                this.setState({
                    self_select_main_category_list: list
                });
            })
            .catch(error => {
                console.log(error);
                this.setState({
                    self_select_main_category_list: []
                });
            });
    }

    /** 카페24 메인 진열 상품 목록 불러오기 */
    async loadCafe24MainProductList(){
        await APIs.rp.getCafe24MainProductList(this.state.cafe24_main_display_group)
            .then(res => {
                if (res.data.code == "200") {
                    const list = res.data.main_product_list.map((obj, idx) => 
                        obj.fixed_sort ? { ...obj, sequence_no: idx + 1 } : obj
                    );
                
                    this.setState({
                        cafe24_main_product_list: list,
                        // event_rp_product_list: list,
                        show_rp_product_list_table_loading_bar: false,
                        del_cafe24_main_display_group: false,
                        cafe24_main_page_over_product: res.data.main_product_list.length > cafe24_main_page_max_product_num,
                        // 상품수가 최대값을 넘으면 자동 선택이 안되도록 한다
                        auto_create_yn: res.data.main_product_list.length > cafe24_main_page_max_product_num ? "N" : this.state.auto_create_yn,
                    }, () => {
                        // 기존 체크 해제
                        this.setState({ rp_check_product_list: [] });
                        this.orderIdxReset();
                    });
                } else {
                    this.setState({
                        del_cafe24_main_display_group: true,
                    });
                }
            }).catch(error => {});
    }

    /** 카페24 알고리즘 상품목록 저장
     * @param {*} none_dialog 다이얼로그 안내 없이 상품목록을 저장하는 경우
    */
    saveCafe24MainProductList(){
        const product_list = this.state.event_rp_product_list;
        const product_no = [];
        const create_type_cds = [];
        const fixed_sorts = [];
        const fix_product_no = [];
  
        product_list.forEach(({ product_no: pNo, create_type_cd, fixed_sort }) => {
            product_no.push(Number(pNo));
            create_type_cds.push(create_type_cd || "");
            fixed_sorts.push(fixed_sort);
  
            // 고정값이 true인 상품 번호를 추출한다
            if (fixed_sort) {
                fix_product_no.push(Number(pNo));
            }
        });

        /** 자동진열로 이미 뽑힌것을 재등록하는경우, 모든 진열 상품을 삭제하는 경우를 제외하고 상품목록 저장 */
        if (this.state.event_rp_product_list_yn !== "Y" 
        && this.state.event_rp_product_list.length !== 0
        ) {
            this.saveRpEventResultProducts()
            this.saveFixedProducts();
        }
        this.saveDialogSimpleInform("저장 중 입니다.", "N")

        let runAPI = setTimeout(() => {
            // 분류별 진열 API 실행 조회 여부 활성화
            checkCafe24MainRunAPI = true;
            this.cafe24MainAPIRun();
            return false;
        },50000); //50초로 변경해야 함.

        // 에러 알럿 비활성화
        setIsErrorAlert(false);

        APIs.rp.saveCafe24MainProductListV3(
            this.state.cafe24_main_display_group, product_no, fix_product_no, create_type_cds, fixed_sorts, this.state.iframe_page_id, this.state.iframe_html_id, this.getListSelfSelectSend())
            .then((res) => {
                // 에러 알럿 활성화
                setIsErrorAlert(true);

                if (res.data.code == "200") {
                    this.setState({
                        right_is_modified: false,
                        save_dialog_show_state: true,
                        save_dialog_content: "저장됐습니다.",
                        save_dialog_button_list: [
                            {
                                title: "확인",
                                type: "1",
                                event_method: () => {
                                    //팝업 닫기
                                    this.setState({ save_dialog_show_state: false });
                                }
                            }
                        ]
                    });
                } else{
                    if (res.data.code == "cafe24_403") {
                        alert('카페24 메인 상품 저장 권한이 없습니다.\n카페24 앱스토어를 통해 로보MD 앱에 접속 해주시면 권한이 부여됩니다.');
                    } else if (res.data.code == "cafe24_400") {
                        if (res.data.msg == "[Product number] is a required field. (parameter.product_no)") {
                            alert("상품을 1개 이상 등록해주세요.");
                        } else if (res.data.msg.indexOf("Auto") >= 0) {
                            alert("해당 분류는 현재 자동진열 중입니다."
                            +"\n자동진열 중인 분류는 카페24 어드민의 [상품 자동 진열]에서 관리하실 수 있습니다.");
                        } else {
                            alert(res.data.msg);
                        }
                    } else if(res.data.code == "include_delete_product_400"){
                        let msg = res.data["msg"];
                        const remove_product_list = res.data["remove_product_list"];
                        for(var i=0;i<remove_product_list.length;i++){
                            msg += "\n- " + product_list.find((product) => product.product_no == remove_product_list[i])["product_name"];
                        }
                        alert(msg);
                    } else{
                        alert('상품 목록 저장에 실패하였습니다.');
                    }
                    //팝업 닫기
                    this.setState({ save_dialog_show_state: false });
                }
            })
            .catch((error) => {
                // 에러 알럿 활성화
                setIsErrorAlert(true);

                // 50초를 넘겨 API 실행여부를 확인중인 경우
                if(checkCafe24MainRunAPI){
                    return false;
                }
                // 50초 안에 return 받아서 API 실행여부 확인이 필요없는 경우
                clearTimeout(runAPI);

                // alert('상품 목록 저장에 실패하였습니다.');
                //팝업 닫기
                this.setState({ save_dialog_show_state: false });
            });   
      }

    /**
     * 오른쪽 알고리즘 결과 저장하기.
     */
    saveRpEventResultProducts = async (firstSave) => {
        const display_group = this.getPageStatus() == "main" ? this.state.cafe24_main_display_group : this.state.cafe24_category_display_group
        await APIs.rp.saveLatestProductsByAlgorithm(
          this.state.user_seq, 
          this.state.shop_no, 
          this.state.iframe_page_id, 
          this.state.iframe_html_id, 
          display_group, 
          "N", 
          JSON.stringify(this.state.event_rp_product_list))
        .then(res => {
          this.getRpEventResultProducts(display_group, firstSave)
        })
        .catch(err => {
          console.log(err)
        })
    }

    /** 
     * 오른쪽 영역에 보여줄 이전 상품목록. 
     * 수동: 가장 최근에 직접 알고리즘을 통해 도출해낸 상품목록.
     * 자동: 자동 진열간에 뽑힌 상품 목록중 가장 최근 상품목록.
     * */
    getRpEventResultProducts = async (display_group, firstSave) => {
        if (!firstSave) {this.setState({show_rp_product_list_table_loading_bar: true})}
        await APIs.rp.getLatestRpEventResultProducts(this.state.iframe_page_id, this.state.iframe_html_id, display_group)
            .then(res => {
              if (res.data.code == 200) {

                // const products = JSON.parse(res.data.product_list)
                const products = res.data.product_list
                this.setState({
                  event_rp_product_list: products ? products : [],
                  show_rp_product_list_table_loading_bar: false,
                  event_rp_product_list_created: moment.utc(res.data.reg_date).local().format('YYYY년 MM월 DD일 HH시 mm분 ss초'),
                  event_rp_product_list_yn: res.data["auto_yn"],
                }, () => {
                    /** 예약 진열인 경우 추가 후 상품 개수 체크 */
                    if (this.state.event_rp_product_list.length > flagCafe24BulkConversionProductCount && this.state.auto_create_yn == 'N' && this.state.reservation_use_yn == 'Y') {
                        this.setState({
                            reservation_hour: 3,
                        })
                    }
                    if (this.state.iframe_page_id=='robomd_cafe24_main_page' && this.state.event_rp_product_list.length > cafe24_main_page_max_product_num && this.state.auto_create_yn == 'N' && this.state.reservation_use_yn == 'Y') {
                        this.setState({
                            reservation_use_yn: "N",
                        })
                    }
                    if(this.state.iframe_page_id=='robomd_cafe24_category_page' && this.state.event_rp_product_list.length > nayeol_event_total_item_select_range_category && this.state.auto_create_yn == 'N' && this.state.reservation_use_yn == 'Y'){
                        this.setState({
                            reservation_use_yn: "N",
                        })
                    }

                    this.loadFixedProductList();
                })

                this.orderIdxReset()
              } else {
                throw new Error()
              }
            })
            .catch(e => {
              this.setState({
                show_rp_product_list_table_loading_bar: false
              })
                console.log(e)
            })  
    }

    /** 카페24에서 카테고리 리스트를 불러오는 함수
     * @param {*} parentCategory 목록이 바로 포함하는 상위 카테고리 번호
     * @param {*} depth 카테고리 깊이 순서
     * @param {*} key_name 리스트 값이 저장될 이름
    */
    async loadCafe24Category(parentCategory, depth, key_name, is_cafe24_show_exception_category) {
        console.log("loadCafe24Category is_cafe24_show_exception_category", is_cafe24_show_exception_category)
        await APIs.rp.getCafe24Category(depth, parentCategory)
            .then(res => {
                if(res.data.code == "200"){
                    const product_category_list = res.data.product_category_list;
                    /** 검사 시 사용되는 부분 */
                    if(product_category_list.length > 0){
                        if(depth < 2){
                            // 페이지 로드시 한번 호출
                            this.setState({
                                cafe24_category_no_1: product_category_list[0].category_no,
                                cafe24_category_no : product_category_list[0].category_no,
                            }, () => {
                                
                                this.checkCafe24CategorySetting(null, is_cafe24_show_exception_category);
                            });
                        } else{
                            product_category_list.splice(0,0,{category_name_no:"전체상품", category_name : "전체상품", category_no : "전체상품"})
                        }
                    }
                    this.setState({[key_name+depth]: product_category_list});
                } else{
                    throw new Error()
                }
            })
            .catch(error => {
                alert("카테고리 목록을 조회하는데 실패하였습니다.");
            });
    }
    
    /** 카페24 자동진열 목록 */
    async loadCategoryAutoLayoutList(category_no, main_display_group){
        await APIs.rp.getCategoryAutoLayoutList()
            .then((res) => {
                const categoryAutoLayoutList = res.data.autodisplay;
                
                let isCategoryAutoLayoutUseYn = [false, false, false];
                let isMainAutoLayoutUseYn = false;

                this.setState({ is_cafe24_show_exception_auto: false });
            
                categoryAutoLayoutList.forEach(({ category_no: autoCategoryNo, use_main: autoUseMain, display_group: autoDisplayGroup }) => {
                    if (category_no == autoCategoryNo && autoUseMain == "F" && this.state.iframe_page_id == "robomd_cafe24_category_page") {
                        if (autoDisplayGroup == "1") {
                            isCategoryAutoLayoutUseYn[0] = true;
                        }
                        if (autoDisplayGroup == "2") {
                            isCategoryAutoLayoutUseYn[1] = true;
                        }
                        if (autoDisplayGroup == "3") {
                            isCategoryAutoLayoutUseYn[2] = true;
                        }
                    }
                    if (main_display_group == autoDisplayGroup && autoUseMain == "T" && this.state.iframe_page_id == "robomd_cafe24_main_page") {
                        isMainAutoLayoutUseYn = true;
                    }
                });
            
                this.setState({
                    is_main_auto_display_use: isMainAutoLayoutUseYn,
                    is_category_auto_display_use: isCategoryAutoLayoutUseYn.some(useYn => useYn),
                    is_cafe24_show_exception_auto: true
                }, () => {
                    console.log("category_no", category_no)
                    console.log("is_category_auto_display_use", this.state.is_category_auto_display_use)
                });
            })
            .catch((error) => {
                alert("카페24 자동진열 목록 조회에 실패하였습니다.");
            });
    }

    /** 카페24 카테고리 분류 설정 검사 : 단일 카테고리 조회 */
    async checkCafe24CategorySetting(type, is_cafe24_show_exception_category){
        await APIs.rp.getCheckingCafe24CategorySettingSingle(this.state.cafe24_category_no)
            .then((res) => {
                if(res.data.code == "200"){
                    const product_category = res.data["product_category"];
                    this.setState({
                        cafe24_category_product_display_scope : product_category.product_display_scope,
                        cafe24_category_product_display_type : product_category.product_display_type,
                        cafe24_category_product_display_key : product_category.product_display_key,
                        cafe24_category_product_display_sort : product_category.product_display_sort,
                        cafe24_category_product_display_period : product_category.product_display_period,
                        cafe24_category_full_name : Object.values(product_category.full_category_name).filter(c => c !== null && c !== undefined).join(' - '),
                        cafe24_sub_category_product_display : product_category.sub_category_product_display,
                    }, () => {
                        console.log("is_cafe24_show_exception_category 200", is_cafe24_show_exception_category)
                        if(type == "load"){
                            this.updateCafe24CategorySetting("load");
                        }
                        if (is_cafe24_show_exception_category) {
                            this.setState({
                                is_cafe24_show_exception_category: is_cafe24_show_exception_category
                            }, () => {
                                console.log("is_cafe24_show_exception_category fianal", this.state.is_cafe24_show_exception_category)
                            })
                        }
                    });
                } else if(res.data.code == "404"){
                    alert("cafe24에서 삭제된 카테고리 페이지 입니다.");
                    this.setState({del_cafe24_category_no : true});
                } else {
                    throw new Error()
                }
            })
            .catch((error) => {
                alert("카테고리 분류 조회에 실패하였습니다.");
            });
    }

    /** 카페24 카테고리별 진열 상품 목록 불러오기 */
    async loadCafe24CategoryProductList(){
        await APIs.rp.getCafe24CategoryProductList(this.state.cafe24_category_no, this.state.cafe24_category_display_group)
		.then(res => {
			if (res.data.code == 200) {
				this.setState({
                    // cafe24_category_product_list : res.data["category_product_list"],
                    event_rp_product_list: res.data['category_product_list'],
                    cafe24_category_before_order_list: res.data["category_product_list"],
                    show_rp_product_list_table_loading_bar: false,
                }, () => {
                    this.setState({
                        cafe24_category_change_order_list : [],
                        rp_check_product_list: [],
                    });
                    this.orderIdxReset();
                });
			} else {
                throw new Error()
            }
		})
		.catch(error => {
            alert("상품 목록을 불러오는데 실패하였습니다.");
		});
    }

    /** 카페24 카테고리 분류 업데이트 */
    updateCafe24CategorySetting(type, item){

        /** 분류별 진열인데, 진열 관리 저장 전 요청일 경우 : 다이얼로그 안내*/
        if(type != "load" && (!this.state.iframe_html_id)){
            this.basicDialogNeedSave()
            return false;
        }

        let save_dialog_content = "";
        switch (type) {
            case "add":
            case "selectAdd":
                if (type == "selectAdd" && this.state.event_product_checked_list.length <= 0) {
                    this.basicDialogNeedProducts()
                    return false
                }
                save_dialog_content = "상품 추가중 입니다."
                break
            case "del":
                if (this.state.rp_check_product_list.lengt > 30) {
                    this.basicDialogLimit30UnDisplay()
                    return false
                }
                save_dialog_content = "미진열 적용중 입니다."
                break
            case "change":
                save_dialog_content = "순서 변경중 입니다."
                break
            case "fixed":
                save_dialog_content = "순서 고정 여부 업데이트 중 입니다."
                break
            default:
                break
        }
        if(type == "add"){
            save_dialog_content = "상품 추가중 입니다.";
        } else if(type == "selectAdd"){
            if(this.state.event_product_checked_list.length <= 0){
                this.basicDialogNeedProducts()
                return false;
            }
            save_dialog_content = "상품 추가중 입니다.";
        } else if(type == "del"){
            if(this.state.rp_check_product_list.length > 30){
                this.basicDialogLimit30UnDisplay()
                return false;
            }
            save_dialog_content = "미진열 적용중 입니다.";
        } else if(type == "change"){
            save_dialog_content = "순서 변경중 입니다.";
        } else if(type == "fixed"){
            save_dialog_content = "순서 고정 여부 업데이트 중 입니다.";
        }

        if(type != "load"){
            this.setState({confirm_dialog_show_state: false})
            this.saveDialogSimpleInform(save_dialog_content, "N")
        }

        let request;

        if(this.state.cafe24_category_product_display_scope == "A"){
            if(this.state.cafe24_category_display_group == "1"){
                request = {
                    "product_display_scope": "G",
                    
                    "normal_product_display_type": "U",
                    "normal_product_display_key": "A",
                    "normal_product_display_sort": "D",
                
                    "recommend_product_display_type": this.state.cafe24_category_product_display_type,
                    "recommend_product_display_key": this.state.cafe24_category_product_display_key,
                    "recommend_product_display_sort": this.state.cafe24_category_product_display_sort,
                    "recommend_product_display_period": this.state.cafe24_category_product_display_period,
                    
                    "new_product_display_type": this.state.cafe24_category_product_display_type,
                    "new_product_display_key": this.state.cafe24_category_product_display_key,
                    "new_product_display_sort": this.state.cafe24_category_product_display_sort,
                    "new_product_display_period": this.state.cafe24_category_product_display_period
                } 
            } else if(this.state.cafe24_category_display_group == "2"){
                request = {
                    "product_display_scope": "G",
                    
                    "normal_product_display_type": this.state.cafe24_category_product_display_type,
                    "normal_product_display_key": this.state.cafe24_category_product_display_key,
                    "normal_product_display_sort": this.state.cafe24_category_product_display_sort,
                    "normal_product_display_period": this.state.cafe24_category_product_display_period,
                
                    "recommend_product_display_type": "U",
                    "recommend_product_display_key": "A",
                    "recommend_product_display_sort": "D",
                    
                    "new_product_display_type": this.state.cafe24_category_product_display_type,
                    "new_product_display_key": this.state.cafe24_category_product_display_key,
                    "new_product_display_sort": this.state.cafe24_category_product_display_sort,
                    "new_product_display_period": this.state.cafe24_category_product_display_period
                }
            } else if(this.state.cafe24_category_display_group == "3"){
                request = {
                    "product_display_scope": "G",
                    
                    "normal_product_display_type": this.state.cafe24_category_product_display_type,
                    "normal_product_display_key": this.state.cafe24_category_product_display_key,
                    "normal_product_display_sort": this.state.cafe24_category_product_display_sort,
                    "normal_product_display_period": this.state.cafe24_category_product_display_period,
                
                    "recommend_product_display_type": this.state.cafe24_category_product_display_type,
                    "recommend_product_display_key": this.state.cafe24_category_product_display_key,
                    "recommend_product_display_sort": this.state.cafe24_category_product_display_sort,
                    "recommend_product_display_period": this.state.cafe24_category_product_display_period,
                    
                    "new_product_display_type": "U",
                    "new_product_display_key": "A",
                    "new_product_display_sort": "D"
                }
            }
        } else if(this.state.cafe24_category_product_display_scope == "G"){
            let prefix = this.state.cafe24_category_display_group == "1" ? "normal" : this.state.cafe24_category_display_group == "2" ? "recommend" : "new"
            request = {
                [`${prefix}_product_display_type`]: "U",
                [`${prefix}_product_display_key`]: "A",
                [`${prefix}_product_display_sort`]: "D"
            }
        }

        /** TODO: 카테고리 */
        APIs.rp.updateCafe24CategorySetting(this.state.cafe24_category_no, request)
            .then((res) => {
                if(res.data.code == "404"){
                    alert("카테고리 분류 업데이트에 실패하였습니다.");
                } else {
                    // 상품목록 로드 이후, 카페24 관리자에서 분류별 설정을 변경했을 경우를 대비해서 설정 변경하고 저장(add/selectAdd/del)
                    if(type == "add"){
                        this.onClickPopupCheckedProductApply(item);
                    } else if(type == "selectAdd"){
                        this.selectAddCafe24CategoryProduct();
                    } else if(type == "del"){
                        this.onClickCheckedRpProductDelete();
                    } else if(type == "change"){
                        this.cafe24CategoryOrderSetting();
                    } else if(type == "load"){
                        /** Cafe24 쇼핑몰에 진열된 리스트는 더이상 사용하지 않음. */
                    } else if(type ==  "fixed"){
                        this.cafe24CategoryOrderFix(item);
                    }
                }
            })
            .catch((error) => {
              console.log(error)
              alert("카테고리 분류 업데이트에 실패하였습니다.");
            });
        }

    /** 카페24 카테고리 상품 추가 */
    addCafe24CategoryProduct(list, update_list){

        let product_list = list;
        let product_no = list.map(product => Number(product["product_no"]));
        let create_type_cds = list.map(product => product["create_type_cd"] == null ? "" : product["create_type_cd"]);
    
        APIs.rp.addCafe24CategoryProduct(this.state.cafe24_category_display_group, product_no, this.state.cafe24_category_no, create_type_cds, this.state.iframe_page_id, this.state.iframe_html_id, this.getListSelfSelectSend())
        .then((res) => {
            if(res.data.code == "200"){
                let {cafe24_category_before_order_list} = this.state;
                cafe24_category_before_order_list = [...list, ...cafe24_category_before_order_list];

                this.setState({
                    cafe24_category_product_list : update_list,
                    event_rp_product_list: update_list,
                    cafe24_category_before_order_list : cafe24_category_before_order_list,
                }, () => {
                    this.cafe24ProductFixedReorder("cafe24_category_product_list");
                    this.cafe24ProductFixedReorder("cafe24_category_before_order_list");
                    this.cafe24ProductFixedReorder("event_rp_product_list")
                });
                
                // 정상 작동인 경우
                this.saveDialogSimpleInform("적용됐습니다.")

            } else if(res.data.code == "422"){
                alert("변경 사항이 적용되지 않았습니다. 동시에 수정중인 상품목록인지 확인해주세요.");
                //팝업 닫기
                this.setState({ save_dialog_show_state: false });
            } else if(res.data.code == "include_delete_product_400"){
                let msg = res.data["msg"];
                const remove_product_list = res.data["remove_product_list"];
                remove_product_list.forEach(productNo => {
                    msg += "\n- " + list.find(product => product.product_no == productNo)["product_name"];
                });
                alert(msg);
                //팝업 닫기
                this.setState({ save_dialog_show_state: false });
            } else{
                alert("변경사항이 적용되지 않았습니다.");
                //팝업 닫기
                this.setState({ save_dialog_show_state: false });
            }
        })
        .catch((error) => {
            alert("변경사항이 적용되지 않았습니다.");
            //팝업 닫기
            this.setState({ save_dialog_show_state: false });
        });
    }

    /** 카페24 카테고리 상품 삭제(미진열) */
    deleteCafe24CategoryProduct(list, update_list){
        // 에러 알럿 비활성화
        setIsErrorAlert(false);

        let product_list = JSON.parse(JSON.stringify(list));
        let product_no = product_list.map(product => Number(product["product_no"]));
        let create_type_cds = product_list.map(product => product["create_type_cd"] == null ? "" : product["create_type_cd"]);    

        let runAPI = setTimeout(() => {
            // 분류별 진열 API 실행 조회 여부 활성화
            checkCafe24CategoryRunAPI = true;
            this.cafe24CategoryAPIRun("D", list, update_list);
            return false;
        },50000); //50초로 변경해야 함.

        APIs.rp.deleteCafe24CategoryProduct(this.state.iframe_page_id, this.state.iframe_html_id, create_type_cds, this.state.cafe24_category_no,this.state.cafe24_category_display_group, product_no)
        .then(res => {
            // 에러 알럿 활성화
            setIsErrorAlert(true);
            // 50초를 넘겨 API 실행여부를 확인중인 경우
            if(checkCafe24CategoryRunAPI){
                return false;
            }
            // 50초 안에 return 받아서 API 실행여부 확인이 필요없는 경우
            clearTimeout(runAPI);

            this.deleteCafe24CategoryAfterReturn(list, update_list, res.data);
        })
        .catch((error) => {
            // 에러 알럿 활성화
            setIsErrorAlert(true);

            // 50초를 넘겨 API 실행여부를 확인중인 경우
            if(checkCafe24CategoryRunAPI){
                return false;
            }
            // 50초 안에 return 받아서 API 실행여부 확인이 필요없는 경우
            clearTimeout(runAPI);

            alert("변경사항이 적용되지 않았습니다.");
            //팝업 닫기
            this.setState({ save_dialog_show_state: false });
        });
    }

    /** 카페24 분류별 진열 상품 삭제 : return 후 작업 */
    deleteCafe24CategoryAfterReturn(product_list, update_list, result_data){
        const product_no = product_list.map(product => Number(product["product_no"]));

        // 응답 데이터 검증
        const isAllSuccess = product_list.every(product => result_data[product["product_no"]].code === 200);
        if (!isAllSuccess) {
            alert("변경사항이 적용되지 않았습니다.");
            this.setState({ save_dialog_show_state: false });
            return;
        }
    

        // 정상 작동인 경우 : 상품 미진열 프론트 작업
        let {cafe24_category_before_order_list, cafe24_category_change_order_list, rp_check_product_list} = this.state;

        const rp_check_product_no_set = new Set(rp_check_product_list.map(obj => obj.product_no));

        cafe24_category_before_order_list = cafe24_category_before_order_list.filter(obj => !rp_check_product_no_set.has(obj.product_no));
        cafe24_category_change_order_list = cafe24_category_change_order_list.filter(obj => !rp_check_product_no_set.has(obj));


        this.setState({
            cafe24_category_product_list : update_list,
            event_rp_product_list: update_list,
            cafe24_category_before_order_list : cafe24_category_before_order_list,
            cafe24_category_change_order_list : cafe24_category_change_order_list,
        }, () => {
            this.cafe24ProductFixedReorder("cafe24_category_product_list");
            this.cafe24ProductFixedReorder("cafe24_category_before_order_list");
            this.cafe24ProductFixedReorder("event_rp_product_list")
            this.orderIdxReset();
        });

        // 체크 해제
        this.setState({
            rp_check_product_list: [],
        });

        this.saveDialogSimpleInform("적용됐습니다.")
    }

    /** 카페24 분류별 진열 선택된 상품 추가 */
    selectAddCafe24CategoryProduct(){
        if (this.state.iframe_page_id == "robomd_cafe24_category_page" && this.state.is_category_auto_display_use) {
            return false;
        }

        // 에러 알럿 비활성화
        setIsErrorAlert(false);

        let runAPI = setTimeout(() => {
            // 분류별 진열 API 실행 조회 여부 활성화
            checkCafe24CategoryRunAPI = true;
            this.cafe24CategoryAPIRun("S");
            return false;
        },50000); //50초로 변경해야 함.
        const reversedList = [...this.state.event_rp_product_list].reverse();

        APIs.rp.deleteAddCafe24CategoryProduct(
          this.state.iframe_page_id, 
          this.state.iframe_html_id, 
          this.state.cafe24_category_no, 
          this.state.cafe24_category_display_group, 
          // this.state.event_product_checked_list.reverse(),
          reversedList, 
          this.getListSelfSelectSend(), 
          this.state.cafe24_category_display_type, 
          this.state.cafe24_product_manage_type)
        .then(async (res) => {
            // 에러 알럿 활성화
            setIsErrorAlert(true);
            // 50초를 넘겨 API 실행여부를 확인중인 경우
            if(checkCafe24CategoryRunAPI){
                return false;
            }
            // 50초 안에 return 받아서 API 실행여부 확인이 필요없는 경우
            clearTimeout(runAPI);
            if (res.data.code == "include_delete_product_400") {
                //팝업 닫기
                this.setState({ save_dialog_show_state: false }, () => {
                    let msg = res.data["msg"];
                    const remove_product_list = res.data["remove_product_list"];
                    for(var i=0;i<remove_product_list.length;i++){
                        msg += "\n- " + this.state.event_rp_product_list.find((product) => product.product_no == remove_product_list[i])["product_name"];
                    }
                    alert(msg);
                });
                return false;
            }  else {
                this.selectAddCafe24CategoryAfterReturn(res.data);
            }
        })
        .catch((error) => {
            // 에러 알럿 활성화
            setIsErrorAlert(true);

            // 50초를 넘겨 API 실행여부를 확인중인 경우
            if(checkCafe24CategoryRunAPI){
                return false;
            }
            // 50초 안에 return 받아서 API 실행여부 확인이 필요없는 경우
            clearTimeout(runAPI);

            alert("변경사항이 적용되지 않았습니다.");
            //팝업 닫기
            this.setState({ save_dialog_show_state: false });
        });
    }

    /** 카페24 분류별 진열 선택된 상품 추가 : return 후 작업 */
    selectAddCafe24CategoryAfterReturn(result_data){
        this.setState({
            // event_rp_product_list: result_data.final_category_product_list,
            // cafe24_category_product_list : result_data.final_category_product_list,
            // cafe24_category_before_order_list : result_data.final_category_product_list,
            cafe24_category_change_order_list : [],
            rp_check_product_list: [],
            show_rp_product_list_table_loading_bar: false
        }, async () => {
            await this.saveRpEventResultProducts();
            await this.saveFixedProducts();
            await this.getRpEventResultProducts(this.state.cafe24_category_display_group)
            await this.orderIdxReset();
        });

        this.saveDialogSimpleInform("적용됐습니다.")
    }

    /** 카페24 분류별 진열 순서 변경 작업 */
    cafe24CategoryOrderWorkList = () => {
        let {event_rp_product_list, cafe24_category_before_order_list} = this.state;

        let product_list = event_rp_product_list;
        let change_order_list = this.state.cafe24_category_change_order_list;

        let cafe24_category_product_no_list=[];
        for(var i=0;i<event_rp_product_list.length;i++){
            cafe24_category_product_no_list.push(event_rp_product_list[i].product_no);
        }
        
        // 순서변경 API 작업 모음
        let cafe24_category_order_work = [];

        cafe24_category_before_order_list = cafe24_category_before_order_list.map((product) => product.product_no);

        for(var i=0;i<cafe24_category_before_order_list.length;i++){
            const product_no = cafe24_category_before_order_list[i];
            if(change_order_list.indexOf(product_no) >= 0){
                cafe24_category_order_work.push({
                    product_no: product_no,
                    create_type_cd : product_list[i].create_type_cd == null ? "" : product_list[i].create_type_cd,
                });
            }
        }

        // 순서변경 API를 상품 하나당 순차적으로 보내는 것으로 인한 오류 방지 : 위에있는 상품이 아래로 내려갈때 사이에 있는 상품 위치가 한칸씩 올라감
        // 상품이 있던 원래 위치보다 변경위치가 바로 아래쪽인 상품부터 상품이 변할 위치까지 + 1, 다만 해당 상품 제외
        // +1로 이동한 위치가 고정 위치라면 추가로 +1 진행 (반대의 경우 -1)
        for(var i=0;i<cafe24_category_order_work.length;i++){
            let product_no = cafe24_category_order_work[i].product_no;
            let goal_product_idx = event_rp_product_list.findIndex(product => product.product_no == product_no)+1;
            let before_product_idx = cafe24_category_before_order_list.indexOf(product_no)+1;
            cafe24_category_order_work[i].sequence = goal_product_idx;

            console.log(`before_product_idx : ${before_product_idx}, goal_product_idx : ${goal_product_idx}`)
            
            if(before_product_idx < goal_product_idx){
                for(var idx2=i-1;idx2>=0;idx2--){
                    const target_idx = cafe24_category_before_order_list.indexOf(cafe24_category_order_work[idx2].product_no)+1; // 순서 변경 대상의 현재 시점 idx
                    if(target_idx >= before_product_idx && target_idx <= goal_product_idx && cafe24_category_order_work[idx2].product_no != product_no){
                        let add = 1;
                        cafe24_category_order_work[idx2].sequence += 1;
                        // 이동한 위치가 고정 위치라면 추가로 +1 진행
                        if(event_rp_product_list[cafe24_category_order_work[idx2].sequence-1].fixed_sort){
                            add += 1;
                            cafe24_category_order_work[idx2].sequence += 1;
                        }
                        cafe24_category_before_order_list.splice(target_idx-1, 1);
                        cafe24_category_before_order_list.splice(target_idx-1 + add, 0,cafe24_category_order_work[idx2].product_no);

                        console.log(`product_no: ${cafe24_category_order_work[idx2].product_no}`)
                        console.log(`add: ${add}`)
                        
                        // 고정 상품 재정렬
                        const fixed_product_no_list = this.state.cafe24_category_fixed_product.map(product => product.product_no);
                        cafe24_category_before_order_list = [...cafe24_category_before_order_list.filter(product_num => fixed_product_no_list.indexOf(product_num) < 0)];
                        this.state.cafe24_category_fixed_product.forEach((product) => {
                            cafe24_category_before_order_list.splice(product.sequence_no-1, 0, product.product_no);
                        });
                    }
                }
            } else if(before_product_idx > goal_product_idx){
                for(var idx2=0;idx2<i;idx2++){
                    const target_idx = cafe24_category_before_order_list.indexOf(cafe24_category_order_work[idx2].product_no)+1; // 순서 변경 대상의 현재 시점 idx
                    if(target_idx >= goal_product_idx && target_idx <= before_product_idx && cafe24_category_order_work[idx2].product_no != product_no){
                        let add = -1;
                        cafe24_category_order_work[idx2].sequence -= 1;
                        // 이동한 위치가 고정 위치라면 추가로 -1 진행
                        if(event_rp_product_list[cafe24_category_order_work[idx2].sequence-1].fixed_sort){
                            add -= 1;
                            cafe24_category_order_work[idx2].sequence -= 1;
                        }
                        cafe24_category_before_order_list.splice(target_idx-1, 1);
                        cafe24_category_before_order_list.splice(target_idx-1 + add, 0,cafe24_category_order_work[idx2].product_no);
                        
                        // 고정 상품 재정렬
                        const fixed_product_no_list = this.state.cafe24_category_fixed_product.map(product => product.product_no);
                        cafe24_category_before_order_list = [...cafe24_category_before_order_list.filter(product_num => fixed_product_no_list.indexOf(product_num) < 0)];
                        this.state.cafe24_category_fixed_product.forEach((product) => {
                            cafe24_category_before_order_list.splice(product.sequence_no-1, 0, product.product_no);
                        });
                    }
                }
            }
            
            cafe24_category_before_order_list.splice(cafe24_category_before_order_list.indexOf(product_no), 1);
            cafe24_category_before_order_list.splice(goal_product_idx-1, 0, product_no);

            const fixed_product_no_list = this.state.cafe24_category_fixed_product.map(product => product.product_no);
            cafe24_category_before_order_list = [...cafe24_category_before_order_list.filter(product_num => fixed_product_no_list.indexOf(product_num) < 0)];
            this.state.cafe24_category_fixed_product.forEach((product) => {
                cafe24_category_before_order_list.splice(product.sequence_no-1, 0, product.product_no);
            });
        }

        let request_list = [];
        let create_type_cds = [];
        
        for(var i=0;i<cafe24_category_order_work.length;i++){
            request_list.push({
                display_group: this.state.cafe24_category_display_group,
                product_no: Number(cafe24_category_order_work[i].product_no),
                sequence: cafe24_category_order_work[i].sequence,
            });
            create_type_cds.push(cafe24_category_order_work[i].create_type_cd);
        }

        return {request_list : request_list, create_type_cds : create_type_cds};
    }

    /** 카페24 분류별 진열 순서 적용 버튼 클릭 */
    cafe24CategoryOrderSetting(){
        // 에러 알럿 비활성화
        setIsErrorAlert(false);

        const {request_list, create_type_cds}= this.cafe24CategoryOrderWorkList();

        let runAPI = setTimeout(() => {
            // 분류별 진열 API 실행 조회 여부 활성화
            checkCafe24CategoryRunAPI = true;
            this.cafe24CategoryAPIRun("U");
            return false;
        },50000); //50초로 변경해야 함.

        APIs.rp.setCafe24CategoryOrder(this.state.iframe_page_id, this.state.iframe_html_id, create_type_cds, this.state.cafe24_category_no, request_list)
        .then((res) => {
            // 에러 알럿 활성화
            setIsErrorAlert(true);
            // 50초를 넘겨 API 실행여부를 확인중인 경우
            if(checkCafe24CategoryRunAPI){
                return false;
            }
            // 50초 안에 return 받아서 API 실행여부 확인이 필요없는 경우
            clearTimeout(runAPI);

            this.updateCafe24CategoryAfterReturn(res.data);
        })
        .catch((error) => {
            // 에러 알럿 활성화
            setIsErrorAlert(true);

            // 50초를 넘겨 API 실행여부를 확인중인 경우
            if(checkCafe24CategoryRunAPI){
                return false;
            }
            // 50초 안에 return 받아서 API 실행여부 확인이 필요없는 경우
            clearTimeout(runAPI);

            alert("순서 변경이 꼬였습니다.")
                //팝업 닫기
                this.setState({ save_dialog_show_state: false });
        });
    }

    cafe24CategoryOrderFix = (productNo) => {
        const {event_rp_product_list} = this.state;
        const targetIdx = event_rp_product_list.findIndex((obj) => obj.product_no == productNo);

        APIs.rp.setCafe24CategoryOrder(this.state.iframe_page_id, this.state.iframe_html_id, ['22999'], this.state.cafe24_category_no, [{
            display_group: this.state.cafe24_category_display_group,
            product_no: Number(productNo),
            fixed_sort : event_rp_product_list[targetIdx].fixed_sort ? "F" : "T",
        }])
        .then((res) => {
            let product_list = JSON.parse(JSON.stringify(this.state.event_rp_product_list));
            product_list = product_list.map((obj, idx) => (productNo === obj.product_no ? {...obj, fixed_sort : !obj.fixed_sort, sequence_no : idx+1} : {...obj}));
            this.setState({
                save_dialog_show_state: false,
                event_rp_product_list : product_list,
            });
        })
        .catch((error) => {
            alert("상품 순서 잠금 업데이트에 실패하였습니다.")
            //팝업 닫기
            this.setState({ save_dialog_show_state: false });
        });
    };

    /** 카페24 분류별 진열 순서 적용 : return 후 작업 */
    updateCafe24CategoryAfterReturn(result_data){
        if(result_data.code === "200"){
            this.saveDialogSaveCategoryOrder()
        } else {
            alert("순서 변경이 꼬였습니다.")
            //팝업 닫기
            this.setState({ save_dialog_show_state: false });
        }
    }

    /** 카페24 분류별 진열 API 실행 여부 조회(삭제 , 순서변경)
     * @param {*} type 실행 API 종류가 삭제인지 수정인지에 대한 타입 (D,U)
     * @param {*} list 삭제 API 마무리시 사용될 cafe24_category_product_list 값
     * @param {*} update_list 삭제 API 마무리시 사용될 삭제된 상품목록
     * @param {*} first_load 페이지 로드시 API 실행 여부 확인 (true시 동작)
    */
    async cafe24CategoryAPIRun(type, list, update_list, first_load){
        await APIs.rp.getCheckingCafe24CategoryAPIRun(this.state.cafe24_category_no, this.state.cafe24_category_display_group, (type != "load" ? type : null))
		.then(res => {
            const apiRunList = res.data["cafe24_category_api_run_list"];
            const isNotFinished = apiRunList.length > 0 && apiRunList[0].is_finish == "N";

            if (isNotFinished) {
                if (first_load) this.saveDialogSimpleInform("이전 변경사항 저장중 입니다.", "N");
                setTimeout(() => {
                    this.cafe24CategoryAPIRun(type, list, update_list, first_load);
                },3000);
            } else {
                /** 페이지 첫 진입시 */
                if (first_load) {
                    if (type === "D") this.cafe24CategoryAPIRun("S", null, null, true)
                    else {
                        // 분류 사용자 지정으로 변경 후, 카페24 카테고리 진열 상품목록 불러오기
                        this.checkCafe24CategorySetting(null, first_load);
                        this.getRpEventResultProducts(this.state.cafe24_category_display_group);
                        this.setState({ save_dialog_show_state: false})
                    }
                } else {
                    checkCafe24CategoryRunAPI = false
                    if (type === "D") {
                        this.deleteCafe24CategoryAfterReturn(list, update_list, apiRunList[0].result_data);
                    } else if (type === "U") {
                        this.updateCafe24CategoryAfterReturn(apiRunList[0].result_data);
                    } else if (type === "S") {
                        this.selectAddCafe24CategoryAfterReturn(apiRunList[0].result_data);
                    }
                }
            }
		})
		.catch(error => {
		});
    }

    /** 카페24 메인 진열 API 실행 여부 조회(삭제 , 순서변경)
     * @param {*} first_load 페이지 로드시 API 실행 여부 확인 (true시 동작)
    */
    cafe24MainAPIRun = async (first_load) => {
        return await APIs.rp.getCheckingCafe24MainAPIRun(this.state.cafe24_main_display_group, this.state.iframe_html_id)
            .then(res => {
                if (res.data["cafe24_main_api_run_list"].length > 0 && res.data["cafe24_main_api_run_list"][0].is_finish == "N"){
                    if(first_load) {this.saveDialogSimpleInform("이전 변경사항 저장중 입니다.", "N")}
                    setTimeout(() => {this.cafe24MainAPIRun(first_load)}, 3000)
                } else {
                    this.getRpEventResultProducts(this.state.cafe24_main_display_group)
                    this.setState({save_dialog_show_state: false})
                    return true
                }
            }).catch(err => {return false})
    }

   /**
    * 왼쪽 영역 저장
    */
    saveListSetting() {
        const firstSave = !this.state.iframe_html_id;
        // list_self_select는 저장시에 json 형태로 통으로 저장되기 때문에 프론트에서 사용하기 위해 독자적으로 넣은 데이터는 삭제하여 전송
        let list_self_select_send = this.getListSelfSelectSend();

        // 기본 저장 멘트
        let title_content_dialog_title = "";
        
        if(this.state.iframe_page_id != "robomd_cafe24_category_page"){
            title_content_dialog_title = firstSave ? "진열제목, 진열위치, 자동화설정 정보를<br/>모두 저장하시겠습니까?<br/><br/>! 저장하셔도 내 쇼핑몰에 바로 반영되지 않습니다." : "저장하셔도 쇼핑몰에 바로 반영되지 않습니다.<br/>현재 변경된 설정정보를 저장하시겠습니까?";
        }

        // 카테고리 진열의 경우
        let cafe24_category_no_list = JSON.parse(JSON.stringify(this.state.cafe24_category_no_1));
        let cafe24_category_content = getSelectBoxSelectIdx(this.state.cafe24_category_list_1, "category_name","category_no", this.state.cafe24_category_no_1);
        if(this.state.iframe_page_id == "robomd_cafe24_category_page"){
            if(this.state.cafe24_category_no_2 != null && this.state.cafe24_category_no_2 != "" && this.state.cafe24_category_no_2 != "전체상품"){
                cafe24_category_no_list += ","+this.state.cafe24_category_no_2;
                cafe24_category_content += " - "+getSelectBoxSelectIdx(this.state.cafe24_category_list_2, "category_name","category_no", this.state.cafe24_category_no_2);
            }
            if(this.state.cafe24_category_no_3 != null && this.state.cafe24_category_no_3 != "" && this.state.cafe24_category_no_3 != "전체상품"){
                cafe24_category_no_list += ","+this.state.cafe24_category_no_3;
                cafe24_category_content += " - "+getSelectBoxSelectIdx(this.state.cafe24_category_list_3, "category_name","category_no", this.state.cafe24_category_no_3);
            }
            if(this.state.cafe24_category_no_4 != null && this.state.cafe24_category_no_4 != "" && this.state.cafe24_category_no_4 != "전체상품"){
                cafe24_category_no_list += ","+this.state.cafe24_category_no_4;
                cafe24_category_content += " - "+getSelectBoxSelectIdx(this.state.cafe24_category_list_4, "category_name","category_no", this.state.cafe24_category_no_4);
            }
            if(firstSave){
                title_content_dialog_title += `변경한 설정 값을 저장하시겠습니까?<br/><br/>저장 시 카페24 '<span style="font-weight: 800;">`+cafe24_category_content+
                `'</span> 카테고리가 '<span style="font-weight: 800;">사용자 지정</span>' 정렬로 변경됩니다.<br/><br/>변경후에는 실시간으로 로보md에서 카테고리 상품 진열을 조정하실 수 있습니다.`
            } else{
                title_content_dialog_title += `변경한 설정 값을 저장하시겠습니까?<br/><br/>변경후에는 실시간으로 로보md에서<br/>카테고리 상품 진열을 조정하실 수 있습니다.`
            }
        }

        let {weekday_list} = this.state;
        if (weekday_list && weekday_list.length > 0) {
            weekday_list = weekday_list.replace("-1,", "");
        }

        const body = {
            user_seq: this.state.user_seq,
            shop_no: this.state.shop_no,
            iframe_page_id: this.state.iframe_page_id,
            iframe_html_id: this.state.iframe_html_id,
            iframe_html_name: this.state.iframe_html_name,
            cafe24_main_display_group: this.state.cafe24_main_display_group,
            cafe24_category_no_list : cafe24_category_no_list,
            cafe24_category_display_group : this.state.cafe24_category_display_group,
            cafe24_category_display_type: this.state.cafe24_category_display_type,
            image_type_cd: this.state.image_type_cd,
            link_open_type: this.state.link_open_type,
            display_name: this.state.display_name,
            display_name_cd: this.state.display_name_cd,
            display_type: this.state.display_type,
            event_cycle: this.state.event_cycle,
            event_time: this.state.event_time,
            event_type_cd: this.state.event_type_cd,
            event_item_price_show_type : this.state.event_item_price_show_type,
            event_category_select_type: this.state.event_category_select_type,
            event_category_list: this.state.event_category_list,
            event_view_cnt: this.state.event_view_cnt,
            event_mobile_view_cnt: this.state.event_mobile_view_cnt,
            platform_type: this.state.platform_type,
            auto_rolling_yn: this.state.auto_rolling_yn,
            transition_mode: this.state.transition_mode,
            transition_speed: this.state.transition_speed,
            transition_pause: this.state.transition_pause,
            auto_create_yn: this.state.auto_create_yn,
            event_item_created_period : this.state.event_item_created_period,
            event_item_analysis_period : this.state.event_item_analysis_period,

            item_select_type: this.state.item_select_type,
            list_self_select : list_self_select_send,
            event_item_price_filter_yn: "Y",
            event_item_min_price: this.state.event_item_min_price != "" ? this.state.event_item_min_price : null,
            event_item_max_price: this.state.event_item_max_price != "" ? this.state.event_item_max_price : null,
            event_total_item_select_cnt: this.state.event_total_item_select_cnt,
            cafe24_product_manage_type: this.state.cafe24_product_manage_type,

            // auto_create_type : this.state.auto_create_type,
            event_cycle_type : this.state.event_cycle_type,

            weekday_use_yn : this.state.weekday_use_yn,
            weekday_cycle : this.state.weekday_cycle,
            weekday_list : weekday_list,

            real_time_cycle : this.state.real_time_cycle,
            real_time_txt_use_yn : this.state.real_time_txt_use_yn,

            reservation_use_yn : this.state.reservation_use_yn,
            reservation_date : StringUtil.dateFormater(this.state.reservation_date),
            reservation_hour : this.state.reservation_hour,

            event_start_date : StringUtil.dateFormater(this.state.event_start_date),
            // event_start_hour : this.state.event_start_hour,
            
            real_time_start_hour: this.state.real_time_start_hour,
            real_time_end_hour: this.state.real_time_end_hour,
        }

        // this.titleContentDialogSaveLeftSetting(
        //     this.state.iframe_page_id != "robomd_cafe24_category_page" ? (firstSave ? "진열위치 및 설정정보저장" : "설정정보저장") : title_content_dialog_title,
        //     this.state.iframe_page_id != "robomd_cafe24_category_page" ? title_content_dialog_title : null,
        //         body, firstSave, 
        //     () => {
        //             if(!cafe24ListExpandCheckRef.current.checked){
        //             cafe24ListExpandRef.current.click();
        //         }
        //         rpTitleRef.current.scrollIntoView({block:"start"}); 
        //     }
        // )

        APIs.rp.saveListSetting(body)
        .then(res => {
            if(res.data.err_code == "9004"){
                this.setState({
                    confirm_dialog_show_state : true,
                    confirm_dialog_content : "리얼타임 랭킹위젯을 사용하기 위해서는<br/>진열앱 설치가 필요합니다.<br/><br/>지금 설치할까요?",
                    confirm_dialog_button_list : [
                        {
                            title: "확인",
                            type: "1",
                            event_method: () => {
                                this.setState({
                                    confirm_dialog_show_state: false,
                                });
                                window.open("https://store.cafe24.com/kr/apps/14376", '_blank');
                            }
                        },
                        {
                            title: "아니요",
                            type: "0",
                            event_method: () => {
                                this.setState({
                                    confirm_dialog_show_state: false,
                                });
                            }
                        }
                    ]
                });
                return false;
            }

            if (res.data.insertCnt > 0) {
                if(firstSave){
                    this.setState({
                        iframe_html_id : res.data.iframe_html_id,
                        iframe_page_id : res.data.iframe_page_id,
                    }, () => {
                        // 왼쪽 영역 저장값 불러오기 (초기 저장시 : 위치는 저장후에 변경 불가능 하기 때문에 다시 불러와서 해당 설정을 적용시킨다)
                        this.loadRpEventSetting(true,true);
                        this.loadRpEventExceptSettingsToBe(true);
                        // 링크 주소에 param값으로 iframe_html_id와 iframe_page_id를 붙인 형태로 변경한다.
                        window.history.replaceState("","",'/shop/rp/event/product/cafe24List'+"?page_id="+this.state.iframe_page_id+"&html_id="+this.state.iframe_html_id);
                        this_location ="/shop/rp/event/product/cafe24List?page_id="+this.state.iframe_page_id+"&html_id="+this.state.iframe_html_id;
                    
                        // 카테고리 설정 불러오기
                        this.checkCafe24CategorySetting();
                        
                        // 덮어쓰기
                        this.onClickOverWritePreview(firstSave);
                    });
                } else {
                    /** 설정저장 -> 알고리즘 결과 상품 목록 함께 저장. */
                    this.saveRpEventResultProducts();
                    this.saveFixedProducts();
                }
                this.saveExcludeProductList();
                this.saveExceptSettingList(true);
                if(firstSave) {
                    // this.setState({left_is_modified: false})
                    // this.titleContentDialogForm(
                    //     "진열자동화적용",
                    //     "이제 설정된 내 쇼핑몰 상품 진열을<br/>로보MD 자동 진열로 바로 바꿔보실까요?",
                    //     {
                    //         title: "네",
                    //         type: "1",
                    //         event_method: () => {
                    //             if(this.state.iframe_page_id === "robomd_cafe24_category_page"){
                    //                 //팝업 닫기
                    //                 this.setState({title_content_dialog_show_state: false});
                    //             } else {
                    //                 //팝업 닫기
                    //                 this.setState({title_content_dialog_show_state: false});
                    //                 this.saveDialogSimpleInform("저장 중 입니다.", "N", function(){})
                    //                 this.onClickSaveRightSetting(true);
                    //             }
                    //         }
                    //     },
                    //     {
                    //         title: "아니요",
                    //         type: "0",
                    //         event_method: () => {
                    //             //팝업 닫기
                    //             this.titleContentDialogForm(
                    //                 "상담예약",
                    //                 "좀 더 상세하게 서비스 상담 및<br/>사용법을 안내해드릴까요?",
                    //                 {
                    //                     title: "네",
                    //                     type: "1",
                    //                     event_method: () => {
                    //                         //팝업 닫기
                    //                         this.setState({title_content_dialog_show_state: false});
                    //                         this.goConsultingPage();
                    //                     }
                    //                 },
                    //             )
                    //         }
                    //     }
                    // )
                } else {
                    this.setState({ left_is_modified: false })
                    this.clearTitleContentDialog()
                    this.saveDialogSimpleInform(this.state.iframe_page_id !== "robomd_cafe24_category_page" ? "저장됐습니다." : "저장됐습니다.<br/><br/>👉 카테고리 상품 진열&nbsp;&nbsp;<br/>실시간 진열정보가 적용됩니다.<br/>실시간 반영됨을 꼭 기억해주세요.")
                }
            } else {
                this.clearTitleContentDialog()
                throw new Error()
            }
        })
        .catch(err => {
            this.clearTitleContentDialog()
            alert("진열 설정 저장에 실패하였습니다.")
        })

        this.setGaEvent("저장")
    }

    /* ---------------------------------- 왼쪽 영역 관련 함수 --------------------------------------- */

    /** 진열 추가시 로드되는 왼쪽영역 기본세팅값 */
    async loadDefaultSetting(){
        let cafe24_category_display_group = this.state.cafe24_category_display_group
        let cafe24_category_display_type = this.state.cafe24_category_display_type
        if (StringUtil.getUrlParams("cafe24_category_display_group")) {
            cafe24_category_display_group = StringUtil.getUrlParams("cafe24_category_display_group");
            if (cafe24_category_display_group !== "1") {cafe24_category_display_type = "1"}
        }

        await APIs.rp.getSettingsByUpperCode("36000")
		.then(res => {
			if (res.data != null && res.data != '') {
				this.setState({
                    display_name_use_yn : res.data[4].val1 == "33099"? "N" : "Y",
                    display_type : res.data[0].val1,
                    platform_type : res.data[1].val1,
                    iframe_page_id : res.data[2].val1,
                    display_name : res.data[3].val1,
                    display_name_cd : res.data[4].val1,
                    event_view_cnt : res.data[5].val1,
                    event_mobile_view_cnt : res.data[6].val1,
                    event_category_list : res.data[7].val1,
                    item_select_type : res.data[8].val1,
                    event_total_item_select_cnt : res.data[9].val1,
                    auto_create_yn : "N",
                    event_cycle: "",
                    event_time: "-1",
                    event_type_cd : res.data[13].val1,
                    event_category_select_type : res.data[14].val1,
                    event_item_price_show_type : res.data[15].val1,
                    transition_mode : res.data[16].val1,
                    transition_pause : res.data[17].val1,
                    transition_speed : res.data[18].val1,
                    auto_rolling_yn : res.data[19].val1,
                    iframe_html_name : res.data[20].val1,
                    event_item_created_period : res.data[21].val1,
                    event_item_analysis_period : res.data[22].val1,
                    image_type_cd : res.data[23].val1,
                    link_open_type : res.data[24].val1,
                    show_rp_product_list_table_loading_bar : false,
                    cafe24_product_manage_type: "2",
                    force_logic: '22001',
                    force_is_except_invisible_category: 'N',
                    force_analysis_period: 0,
                    force_select_created_yn: 'N',
                    force_created_period: 0,
                    force_category: {
                        "product_rp_category_no_1": "",
                        "product_rp_category_no_2": "",
                        "product_rp_category_no_3": "",
                        "product_rp_category_no_4": "",
                    },
                    cafe24_category_display_group: cafe24_category_display_group,
                    cafe24_category_display_type: cafe24_category_display_type,
                }, () => {
                    if (StringUtil.getUrlParams("favorite_algorithm_seq")) {
                        // 자주 사용하는 알고리즘 불러오기
                        this.loadFavoriteAlgorithm();
                    } else {
                        // 카페24의 경우 추가 기본값 불러오기
                        if (window.location.href.includes('/16009')) {
                            this.loadCafe24MainDefaultSetting("B2000");
                        } else {
                            this.loadCafe24MainDefaultSetting();
                        }
                    }

                    this.setState ({
                        is_cafe24_show_exception_category: true,
                    })


                    // 카페24 자동진열 사용 여부
                    this.loadCategoryAutoLayoutList(this.state.cafe24_category_no, this.state.cafe24_main_display_group); 
                });
			}
		})
		.catch(error => {
		});
    }

    /** 카페24 디폴트값 불러오기 (iframe_page_id, list_self_select) */
    async loadCafe24MainDefaultSetting(upper_code_cd = "47000"){
        await APIs.rp.getSettingsByUpperCode(upper_code_cd)
		.then(res => {
			if (res.data != null && res.data != '') {
                let list_self_select = JSON.parse(res.data[upper_code_cd == "47000" ? 3 : 1].val1);
                for(var i=0;i<list_self_select.length;i++){
                    list_self_select[i]["product_rp_category_list_1"] = JSON.parse(JSON.stringify(this.state.first_category_list));
                    list_self_select[i]["product_rp_category_list_2"] = [];
                    list_self_select[i]["product_rp_category_list_3"] = [];
                    list_self_select[i]["product_rp_category_list_4"] = [];

                    list_self_select[i]["product_rp_category_no_1"] = "";
                    list_self_select[i]["product_rp_category_no_2"] = "";
                    list_self_select[i]["product_rp_category_no_3"] = "";
                    list_self_select[i]["product_rp_category_no_4"] = "";

                    list_self_select[i]["product_keyword_list"] = [""];
                    list_self_select[i]["product_except_keyword_list"] = [""];
                    list_self_select[i]["color_list"] = [];

                    list_self_select[i]["self_select_area_checked"] = true;
                    
                    // 숨긴카테고리 등록상품 자동 제외여부
                    list_self_select[i]["is_except_invisible_category"] = "N";

                    if (list_self_select[i]["event_item_condition_list"] == null) {
                        list_self_select[i]["event_item_condition_list"] = [
                            "A2999",
                            "A2999"
                        ]
                    }

                    // uuid 부여
                    list_self_select[i].uuid = StringUtil.generateUUID();
                    list_self_select[i].detail_filter_expand_check = false;
                    list_self_select[i].item_select_type_start_idx = 1;

                    const isEmpty = (v) => v === null || v === undefined || v === "";
                    
                    if (isEmpty(list_self_select[i]["max_item_analysis"])) {
                        list_self_select[i]["max_item_analysis"] = "3";
                    }

                    if (isEmpty(list_self_select[i]["max_item_analysis_value"])) {
                        list_self_select[i]["max_item_analysis_value"] = "10";
                    }

                    if (isEmpty(list_self_select[i].past_order_sort_type)) {
                        list_self_select[i].past_order_sort_type = "1";
                    }

                    // 제외 카테고리 초기화 
                    list_self_select[i]["product_rp_except_category_no_list"] = [{}];

                    let copy_first_category_list = JSON.parse(JSON.stringify(this.state.first_category_list))
                    if (copy_first_category_list != null && copy_first_category_list[0] != null) {
                        copy_first_category_list[0] = {
                            "category_name": "사용 안함",
                            "category_name_no_format": "사용 안함",
                            "category_no": ""
                        }
                    }
                    list_self_select[i]["product_rp_except_category_no_list"][0]["product_rp_except_category_list_1"] = JSON.parse(JSON.stringify(copy_first_category_list));
                    list_self_select[i]["product_rp_except_category_no_list"][0]["product_rp_except_category_list_2"] = [];
                    list_self_select[i]["product_rp_except_category_no_list"][0]["product_rp_except_category_list_3"] = [];
                    list_self_select[i]["product_rp_except_category_no_list"][0]["product_rp_except_category_list_4"] = [];
                     
                    list_self_select[i]["product_rp_except_category_no_list"][0]["product_rp_except_category_no_1"] = "";

                    list_self_select[i]["event_except_category_list"] = [];
                    list_self_select[i]["event_except_category_list"][0] = "";
                }

                var force_category_list_1 = JSON.parse(JSON.stringify(this.state.first_category_list));
                var force_category_list_2 = [];
                var force_category_list_3 = [];
                var force_category_list_4 = [];

                var force_category = {};
                force_category["product_rp_category_no_1"] = "";
                force_category["product_rp_category_no_2"] = "";
                force_category["product_rp_category_no_3"] = "";
                force_category["product_rp_category_no_4"] = "";

                const lastObj =
                    list_self_select && list_self_select.length > 0
                        ? list_self_select[list_self_select.length - 1]
                        : {};

                // 주소창에 진열 위치 값 포함되어있으면 해당 위치 설정되도록 처리
				this.setState({
                    iframe_page_id : window.location.href.includes('/16006') ? "robomd_cafe24_main_page" : window.location.href.includes('/16009') ? "robomd_cafe24_category_page" : res.data[0].val1,
                    list_self_select : list_self_select,
                    max_item_analysis: lastObj.max_item_analysis || "3",
                    max_item_analysis_value: lastObj.max_item_analysis_value || "10",
                    force_category: force_category,
                    force_category_list_1: force_category_list_1,
                    force_category_list_2: force_category_list_2,
                    force_category_list_3: force_category_list_3,
                    force_category_list_4: force_category_list_4,
                    is_left_load_first_setting : true,
                }, () => {
                    const {highlightType} = this.state;
                    if(highlightType){
                        // if(highlightType == 'connect'){
                        //     highlightConnect.current.scrollIntoView({block:"start"});
                        // }
                        if(highlightType == 'ranking'){
                            highlightRanking.current.scrollIntoView({block:"start"});
                        } else if(highlightType == 'keyword'){
                            highlightKeyword.current.scrollIntoView({block:"center"});
                        } else if(highlightType == 'period'){
                            highlightPeriod.current.scrollIntoView({block:"center"});
                        }

                        let this_component = this;
                        document.body.addEventListener('click', () => {
                            this_component.setState({highlightType : ""});
                        });
                    }
                });
			}
		})
		.catch(error => {
            console.log(error)
		});
    }

    /** 자주 사용하는 알고리즘 */
    async loadFavoriteAlgorithm(){
        await http.get("/rest/shop/rp/favorite/algorithm?seq="+StringUtil.getUrlParams("favorite_algorithm_seq"))
		.then(res => {
			if (res.data != null && res.data != '') {
                // 진열 강제 설정
                let force_use_yn = "N";
                let force_logic = "22001";
                let force_category_list_1 = JSON.parse(JSON.stringify(this.state.first_category_list));
                let force_category_list_2 = [];
                let force_category_list_3 = [];
                let force_category_list_4 = [];
                let force_category = {
                    "product_rp_category_no_1": "전체상품",
                };
                let force_auto_remove = "";
                let force_analysis_period = 0;
                let force_select_created_yn = "N";
                let force_created_period_type = "";
                let force_created_period = 0;
                let force_created_start_date = "";
                let force_created_end_date = "";
                let force_is_except_invisible_category = "N";

                // 진열 최대 개수
                let max_item_analysis = this.state.max_item_analysis;
                let max_item_analysis_value = this.state.max_item_analysis_value;

                // 최종 상품 순서
                let total_sort_type = this.state.total_sort_type;

                const {product_color_list, first_category_list} = this.state;

                // let list_self_select = JSON.parse(res.data.manual_json);
                let list_self_select = res.data.manual_json;
                // console.log("### list_self_select 1 ###", list_self_select);
                for(var idx=0;idx<list_self_select.length;idx++){
                    // uuid 부여
                    if (list_self_select[idx].uuid == null) {
                        list_self_select[idx].uuid = StringUtil.generateUUID();
                    }
                    if (!list_self_select[idx].item_select_type_start_idx) {
                        list_self_select[idx].item_select_type_start_idx = 1;
                    }
                    // if (list_self_select[idx].detail_filter_expand_check == null) {
                        // 첫 로드시 닫힘
                        list_self_select[idx].detail_filter_expand_check = false;
                    // }

                    // null이라는 문자값으로 들어오는것을 방지
                    if(list_self_select[idx].min_hit_cnt == null){ list_self_select[idx].min_hit_cnt = ""; }
                    if(list_self_select[idx].max_hit_cnt == null){ list_self_select[idx].max_hit_cnt = ""; }

                    if(list_self_select[idx].min_cart_cnt == null){ list_self_select[idx].min_cart_cnt = ""; }
                    if(list_self_select[idx].max_cart_cnt == null){ list_self_select[idx].max_cart_cnt = ""; }

                    if(list_self_select[idx].min_price == null){ list_self_select[idx].min_price = ""; }
                    if(list_self_select[idx].max_price == null){ list_self_select[idx].max_price = ""; }

                    if(list_self_select[idx].min_order_cnt == null){ list_self_select[idx].min_order_cnt = ""; }
                    if(list_self_select[idx].max_order_cnt == null){ list_self_select[idx].max_order_cnt = ""; }

                    if(list_self_select[idx].min_order_price == null){ list_self_select[idx].min_order_price = ""; }
                    if(list_self_select[idx].max_order_price == null){ list_self_select[idx].max_order_price = ""; }
                    
                    if(list_self_select[idx].min_review_cnt == null){ list_self_select[idx].min_review_cnt = ""; }
                    if(list_self_select[idx].max_review_cnt == null){ list_self_select[idx].max_review_cnt = ""; }

                    if(list_self_select[idx].min_review_point == null){ list_self_select[idx].min_review_point = ""; }
                    if(list_self_select[idx].max_review_point == null){ list_self_select[idx].max_review_point = ""; }
                
                    if(list_self_select[idx].min_quantity == null){ list_self_select[idx].min_quantity = ""; }
                    if(list_self_select[idx].max_quantity == null){ list_self_select[idx].max_quantity = ""; }

                    // 상품 선택 수가 빈문자로 들어오는것을 방지 (select 영역)
                    if(list_self_select[idx].cnt == null || list_self_select[idx].cnt == ""){ list_self_select[idx].cnt = 0; }

                    // 카테고리 목록을 불러올 수 없다면 전체선택으로 변경 (전체선택 or 기존 대카테고리 목록값 들어오는 경우[a,b,c] or 오류)
                    if(list_self_select[idx].category == null || list_self_select[idx].category.length == 0){
                        list_self_select[idx].event_category_list = "";
                    }

                    // 알고리즘 분석 기간이 null이라면
                    if(!list_self_select[idx].event_item_analysis_period && list_self_select[idx].event_item_analysis_period != 0){
                        list_self_select[idx].event_item_analysis_period = '4';
                    }

                    // 상품 선택일 관련 작업
                    if(list_self_select[idx].event_item_created_period != null && list_self_select[idx]["self_select_created_yn"] == 'Y'){
                        list_self_select[idx].event_item_created_start_date = list_self_select[idx].event_item_created_start_date != null ? new Date(StringUtil.dateFormater(list_self_select[idx].event_item_created_start_date)) : null;
                        list_self_select[idx].event_item_created_end_date = list_self_select[idx].event_item_created_end_date != null ? new Date(StringUtil.dateFormater(list_self_select[idx].event_item_created_end_date)) : null;
                    } else{
                        list_self_select[idx].event_item_created_period = (list_self_select[idx].event_item_created_period != null ? list_self_select[idx].event_item_created_period : "0");
                        list_self_select[idx].event_item_created_period_type = list_self_select[idx].event_item_created_period_type ? list_self_select[idx].event_item_created_period_type : "W";
                        list_self_select[idx].event_item_created_start_date = null;
                        list_self_select[idx].event_item_created_end_date = null;
                    }
                    // 강제설정 날짜 포맷 맞추기
                    list_self_select[idx].force_created_start_date = list_self_select[idx].force_created_start_date != null && list_self_select[idx].force_created_start_date != "" ? new Date(StringUtil.dateFormater(list_self_select[idx].force_created_start_date)) : null;
                    list_self_select[idx].force_created_end_date = list_self_select[idx].force_created_end_date != null && list_self_select[idx].force_created_end_date != "" ? new Date(StringUtil.dateFormater(list_self_select[idx].force_created_end_date)) : null;

                    // 카테고리 목록 및 값
                    list_self_select[idx]["product_rp_category_list_1"] = JSON.parse(JSON.stringify(first_category_list));
                    list_self_select[idx]["product_rp_category_list_2"] = [];
                    list_self_select[idx]["product_rp_category_list_3"] = [];
                    list_self_select[idx]["product_rp_category_list_4"] = [];

                    list_self_select[idx]["product_rp_category_no_1"] = list_self_select[idx]["category"] && list_self_select[idx]["category"].length > 0 ? list_self_select[idx]["category"][0].category_no : "";
                    list_self_select[idx]["product_rp_category_no_2"] = list_self_select[idx]["category"] && list_self_select[idx]["category"].length > 1 ? list_self_select[idx]["category"][1].category_no : "";
                    list_self_select[idx]["product_rp_category_no_3"] = list_self_select[idx]["category"] && list_self_select[idx]["category"].length > 2 ? list_self_select[idx]["category"][2].category_no : "";
                    list_self_select[idx]["product_rp_category_no_4"] = list_self_select[idx]["category"] && list_self_select[idx]["category"].length > 3 ? list_self_select[idx]["category"][3].category_no : "";

                    const event_except_category_list = list_self_select[idx]["event_except_category_list"];
                    // 제외 카테고리 세팅
                    if (
                        !list_self_select[idx]["product_rp_except_category_no_list"] ||
                        !Array.isArray(list_self_select[idx]["product_rp_except_category_no_list"]) ||
                        list_self_select[idx]["product_rp_except_category_no_list"].length === 0
                    ) {
                        list_self_select[idx]["product_rp_except_category_no_list"] = [{}];
                    }

                    let copy_first_category_list = JSON.parse(JSON.stringify(first_category_list));
                    if (copy_first_category_list != null && copy_first_category_list[0] != null) {
                        copy_first_category_list[0] = {
                            category_name: "사용 안함",
                            category_name_no_format: "사용 안함",
                            category_no: ""
                        };
                    }

                    for (let exIdx = 0; exIdx < list_self_select[idx]["product_rp_except_category_no_list"].length; exIdx++) {
                        const exceptObj = list_self_select[idx]["product_rp_except_category_no_list"][exIdx] || {};

                        // 응답에 들어있던 list 값은 사용하지 않고 다시 세팅
                        exceptObj["product_rp_except_category_list_1"] = JSON.parse(JSON.stringify(copy_first_category_list));
                        exceptObj["product_rp_except_category_list_2"] = [];
                        exceptObj["product_rp_except_category_list_3"] = [];
                        exceptObj["product_rp_except_category_list_4"] = [];

                        if (!exceptObj["product_rp_except_category_no_1"]) {
                            exceptObj["product_rp_except_category_no_1"] = "";
                        }
                        if (!exceptObj["product_rp_except_category_no_2"]) {
                            exceptObj["product_rp_except_category_no_2"] = "";
                        }
                        if (!exceptObj["product_rp_except_category_no_3"]) {
                            exceptObj["product_rp_except_category_no_3"] = "";
                        }
                        if (!exceptObj["product_rp_except_category_no_4"]) {
                            exceptObj["product_rp_except_category_no_4"] = "";
                        }

                        list_self_select[idx]["product_rp_except_category_no_list"][exIdx] = exceptObj;
                    }

                    if (!event_except_category_list || !Array.isArray(event_except_category_list) || event_except_category_list.length === 0) {
                        list_self_select[idx]["event_except_category_list"] = [""];
                    }

                    // list_self_select[idx]["product_rp_except_category_no_1"] = list_self_select[idx]["category"] && list_self_select[idx]["category"].length > 0 ? list_self_select[idx]["category"][0].category_no : "";
                    // list_self_select[idx]["product_rp_except_category_no_2"] = list_self_select[idx]["category"] && list_self_select[idx]["category"].length > 1 ? list_self_select[idx]["category"][1].category_no : "";
                    // list_self_select[idx]["product_rp_except_category_no_3"] = list_self_select[idx]["category"] && list_self_select[idx]["category"].length > 2 ? list_self_select[idx]["category"][2].category_no : "";
                    // list_self_select[idx]["product_rp_except_category_no_4"] = list_self_select[idx]["category"] && list_self_select[idx]["category"].length > 3 ? list_self_select[idx]["category"][3].category_no : "";
                    
                    // 자동 선택 상품 키워드
                    list_self_select[idx]["product_keyword_list"] = list_self_select[idx]["product_keyword_list"] ? list_self_select[idx]["product_keyword_list"] : [""];
                    // 제외 키워드
                    list_self_select[idx]["product_except_keyword_list"] = list_self_select[idx]["product_except_keyword_list"] ? list_self_select[idx]["product_except_keyword_list"] : [""];

                    // 여닫기 체크 상태
                    // if (!first_save) {
                    //     list_self_select[idx]["self_select_area_checked"] = (idx == 0 ? true : false);
                    // }
                    list_self_select[idx].self_select_area_checked = true;

                    if (!list_self_select[idx]["event_item_condition_list"] 
                            || (list_self_select[idx]["event_item_condition_list"] && list_self_select[idx]["event_item_condition_list"].length <= 0)) {
                        // 알고리즘(~중에)) 초기화
                        list_self_select[idx]["event_item_condition_list"] = [
                            "A2999",
                            "A2999"
                        ]                                            
                    }
                    // 컬러 목록
                    if(list_self_select[idx].color_seq_list){
                        let color_seq_list = list_self_select[idx].color_seq_list;
                        const color_list = product_color_list.filter(obj => color_seq_list.indexOf(obj.color_seq) != -1);
                        list_self_select[idx].color_list = color_list;
                        delete list_self_select[idx].color_seq_list;
                    } else{
                        list_self_select[idx].color_list = [];
                    }

                    if (!list_self_select[idx].past_order_date_use_yn) {
                        // 과거 판매 상품 사용 여부가 없으나,
                        if (list_self_select[idx].past_order_start_date_type 
                            || list_self_select[idx].past_order_end_date_type) {
                                // 시작일 또는 종료일 둘중 하나가 있는 경우
                                list_self_select[idx].past_order_date_use_yn = "Y";
                        } else {
                            // 시작일과 종료일 둘 다 없는 경우
                            list_self_select[idx].past_order_date_use_yn = "N";
                        }
                    }

                    // 과거 판매 시작일 또는 종료일 둘중 하나가 없는 경우 (이전 버전에서 생략으로 선택한 경우)
                    if (!list_self_select[idx].past_order_start_date_type) {
                        list_self_select[idx].past_order_date_use_yn = "N";
                    }
                    if (!list_self_select[idx].past_order_end_date_type) {
                        list_self_select[idx].past_order_date_use_yn = "N";
                    }
                    
                    // 과거 알고리즘이 없는 경우 1로 초기화 (기존 설정들)
                    if (!list_self_select[idx].past_order_sort_type) {
                        list_self_select[idx].past_order_sort_type = "1";
                    }

                    // 진열 최대 개수 없는 경우
                    if (!list_self_select[idx].max_item_analysis) {
                        list_self_select[idx].max_item_analysis = "1";
                    }
                    if (!list_self_select[idx].max_item_analysis_value) {
                        list_self_select[idx].max_item_analysis_value = "10";
                    }

                    // 죄종 상품 순서 없는 경우
                    if (!list_self_select[idx].total_sort_type) {
                        list_self_select[idx].total_sort_type = "1";
                    }
                    
                    // 강제 알고리즘
                    if( list_self_select[idx].force_use_yn ) force_use_yn = list_self_select[idx].force_use_yn;
                    if( list_self_select[idx].force_logic ) force_logic = list_self_select[idx].force_logic;
                    if( list_self_select[idx].force_category ) force_category = list_self_select[idx].force_category;
                    if( list_self_select[idx].force_auto_remove ) force_auto_remove = list_self_select[idx].force_auto_remove;
                    if( list_self_select[idx].force_analysis_period ) force_analysis_period = list_self_select[idx].force_analysis_period;
                    if( list_self_select[idx].force_select_created_yn ) force_select_created_yn = list_self_select[idx].force_select_created_yn;
                    if( list_self_select[idx].force_created_period_type ) force_created_period_type = list_self_select[idx].force_created_period_type;
                    if( list_self_select[idx].force_created_period ) force_created_period = list_self_select[idx].force_created_period;
                    if( list_self_select[idx].force_created_start_date ) force_created_start_date = list_self_select[idx].force_created_start_date;
                    if( list_self_select[idx].force_created_end_date ) force_created_end_date = list_self_select[idx].force_created_end_date;
                    if( list_self_select[idx].force_is_except_invisible_category ) force_is_except_invisible_category = list_self_select[idx].force_is_except_invisible_category;
                    if( list_self_select[idx].max_item_analysis ) max_item_analysis = list_self_select[idx].max_item_analysis;
                    if( list_self_select[idx].max_item_analysis_value ) max_item_analysis_value = list_self_select[idx].max_item_analysis_value;
                    if( list_self_select[idx].total_sort_type ) total_sort_type = list_self_select[idx].total_sort_type;
                }
                console.log("### list_self_select 2 ###", list_self_select);

                // 주소창에 진열 위치 값 포함되어있으면 해당 위치 설정되도록 처리
				this.setState({
                    iframe_page_id : window.location.href.includes('/16006') ? "robomd_cafe24_main_page" : window.location.href.includes('/16009') ? "robomd_cafe24_category_page" : res.data[0].val1,
                    list_self_select : list_self_select,
                    force_use_yn: force_use_yn,
                    force_logic: force_logic,
                    force_category: force_category,
                    force_category_list_1: force_category_list_1,
                    force_category_list_2: force_category_list_2,
                    force_category_list_3: force_category_list_3,
                    force_category_list_4: force_category_list_4,
                    force_auto_remove: force_auto_remove,
                    force_analysis_period: force_analysis_period,
                    force_select_created_yn: force_select_created_yn,
                    force_created_period_type: force_created_period_type,
                    force_created_period: force_created_period,
                    force_created_start_date: force_created_start_date,
                    force_created_end_date: force_created_end_date,
                    force_is_except_invisible_category: force_is_except_invisible_category,
                    max_item_analysis: max_item_analysis,
                    max_item_analysis_value: max_item_analysis_value,
                    total_sort_type: total_sort_type,
                    is_left_load_first_setting : true,
                }, () => {
                    const {highlightType} = this.state;
                    if(highlightType){
                        // if(highlightType == 'connect'){
                        //     highlightConnect.current.scrollIntoView({block:"start"});
                        // }
                        if(highlightType == 'ranking'){
                            highlightRanking.current.scrollIntoView({block:"start"});
                        } else if(highlightType == 'keyword'){
                            highlightKeyword.current.scrollIntoView({block:"center"});
                        } else if(highlightType == 'period'){
                            highlightPeriod.current.scrollIntoView({block:"center"});
                        }

                        let this_component = this;
                        document.body.addEventListener('click', () => {
                            this_component.setState({highlightType : ""});
                        });
                    }

                    let {list_self_select} = this.state;
                    for(let idx=0;idx<list_self_select.length;idx++){
                        // 상품 선택 영역 카테고리 리스트 선택되어 있도록 하는 작업
                        if(list_self_select[idx].category != null && list_self_select[idx].category.length!=0){
                            for (var idx2 in list_self_select[idx].category) {
                                const name = "product_rp_category_no_"+(Number(idx2)+1);
                                this.setState({
                                    [name]: list_self_select[idx].category[idx2].category_no,
                                });
                                this.loadProductCategory(list_self_select[idx].category[Number(idx2)].parent_category_no, Number(idx2)+1, "product_rp_category_list_",idx)
                            }
    
                            const category_length = list_self_select[idx].category.length;
                            // 불러온 카테고리의 가장 하위 카테고리는, 다음 카테고리가 전체선택인 채로 저장되었을 수도 있으니 불러온다. (아니면 안불러옴)
                            if(category_length > 0){
                                this.loadProductCategory(list_self_select[idx].category[category_length-1].category_no, category_length+1, "product_rp_category_list_",idx);
                            }
                        }
                    }

                    for (let idx = 0; idx < list_self_select.length; idx++) {
                        const exceptCategoryNoList = list_self_select[idx].product_rp_except_category_no_list;

                        if (exceptCategoryNoList && exceptCategoryNoList.length > 0) {
                            for (let exIdx = 0; exIdx < exceptCategoryNoList.length; exIdx++) {
                                const exceptObj = exceptCategoryNoList[exIdx];
                                if (!exceptObj) continue;

                                if (exceptObj.product_rp_except_category_no_1) {
                                    this.loadProductCategory(
                                        exceptObj.product_rp_except_category_no_1,
                                        2,
                                        "product_rp_except_category_list_",
                                        idx,
                                        exIdx
                                    );
                                }

                                if (exceptObj.product_rp_except_category_no_2) {
                                    this.loadProductCategory(
                                        exceptObj.product_rp_except_category_no_2,
                                        3,
                                        "product_rp_except_category_list_",
                                        idx,
                                        exIdx
                                    );
                                }

                                if (exceptObj.product_rp_except_category_no_3) {
                                    this.loadProductCategory(
                                        exceptObj.product_rp_except_category_no_3,
                                        4,
                                        "product_rp_except_category_list_",
                                        idx,
                                        exIdx
                                    );
                                }
                            }
                        }
                    }

                    // 상품 선택 영역 카테고리 리스트 선택되어 있도록 하는 작업
                    let {force_category} = this.state;
                    // if(force_category != null && force_category.length!=0){
                    if (force_category && Object.keys(force_category).length > 0) {
                        idx = 1;
                        for (var key in force_category) {
                            if( key === 'event_category_list') continue;
                            if( force_category[key] == "") continue;
                            this.loadProductCategory(force_category[key], Number(idx)+1, "force_category_list_")
                            idx++;
                        }
                    }
                });
			} else {
                // 자주 사용하는 알고리즘 로드 실패 시 디폴트 세팅 로드
                this.loadCafe24MainDefaultSetting();
            }
		})
		.catch(error => {
            console.error(error);
            // 자주 사용하는 알고리즘 로드 실패 시 디폴트 세팅 로드
            this.loadCafe24MainDefaultSetting();
		});
    }



    onClickEventFolderForce() {
        const target = "#list_select_expand_force";
        let list_select_height = $(target).outerHeight();
        let list_select_1_height = $(target).next(".list_select_expand_1").outerHeight();
        let {force_select_area_checked} = this.state;

        if($(target).find(".list_select_expand_check").is(":checked")){ // 펼치기
            $(target).parent(".list_select_expand_wrap").css({height :list_select_height+list_select_1_height});
            setTimeout(() => {
                if($(target).find(".list_select_expand_check").is(":checked")){
                    $(target).parent(".list_select_expand_wrap").css("overflow","visible");
                    $(target).parent(".list_select_expand_wrap").css({height :"auto"});
                }
            },200);
            force_select_area_checked = false;
        }
        else{ // 접기
            $(target).parent(".list_select_expand_wrap").css("overflow","hidden");
            $(target).parent(".list_select_expand_wrap").css({height :list_select_height});
            force_select_area_checked = true;
        }
        this.setState({
            force_select_area_checked: force_select_area_checked,
        })
    }

    /** 자동 진열 설정  여닫기
     * @param {*} idx 알고리즘 순서
     * @param {*} cnt_focus 포커싱할 상품 선택 수 id값, null이 아닐때만 포커싱
    */
    onClickEventFolder(idx, cnt_focus) {
        const target = document.querySelector(`#list_select_expand_${idx}`);
        const expand1 = target?.nextElementSibling;
        const parentWrap = target?.closest(".list_select_expand_wrap");
        const expandContent = parentWrap?.querySelector(".list_select_expand_1");
        const isChecked = target.querySelector(".list_select_expand_check")?.checked;
    
        if (!target || !parentWrap) return;
    
        let { list_self_select } = this.state;
    
        if (isChecked) { // 펼치기
            // 높이 측정 전에 일단 보여지게 처리
            expandContent.classList.remove("hidden_algorithm");
            expandContent.classList.add("visible_algorithm");
    
            requestAnimationFrame(() => {
                const totalHeight =
                    target.scrollHeight + (expand1?.scrollHeight || 0);
    
                parentWrap.style.overflow = "visible";
                parentWrap.style.height = totalHeight + "px";
    
                // 포커스 이동
                if (cnt_focus) {
                    setTimeout(() => {
                        document.querySelector(cnt_focus)?.focus();
                    }, 10);
                } else {
                    // 100ms 후 auto 설정으로 자연스러운 전환 마무리
                    setTimeout(() => {
                        const checkbox = target.querySelector('.list_select_expand_check');
                        if (checkbox && checkbox.checked) {
                            const parentWrap = target.closest('[data-parent-wrap-selector]'); // 적절한 부모 셀렉터로 변경하세요
                            if (parentWrap) {
                                parentWrap.style.height = 'auto';
                            }
                        }
                    }, 100);
                }
            });
    
            list_self_select[idx].self_select_area_checked = true;
    
        } else { // 접기
            parentWrap.style.overflow = "visible";
    
            expandContent.classList.remove("visible_algorithm");
            expandContent.classList.add("hidden_algorithm");
    
            requestAnimationFrame(() => {
                const height1 = target ? target.scrollHeight : 0;
    
                // 닫힐 때는 첫 영역 높이만 적용 (애니메이션 고려 시)
                parentWrap.style.height= height1;

                setTimeout(() => {
                    parentWrap.style.height= "auto";
                }, 100);
            });
    
            list_self_select[idx].self_select_area_checked = false;
        }
    
        this.setState({ list_self_select });
    }

    /**
     * 알고리즘 조작 : 인터렉션 후 UI 접기
     */
    foldAlgorithm(idx) {
        const target = "#list_select_expand_" + idx;
        let { list_self_select } = this.state;
        const parentWrap = $(target).parent(".list_select_expand_wrap");
        const expandContent = parentWrap.children(".list_select_expand_1");
        parentWrap.css({ overflow: "visible"})
        expandContent.removeClass("visible_algorithm").addClass("hidden_algorithm");
        list_self_select[idx].self_select_area_checked = false;
        $("#list_select_arrow_"+idx).prop("checked",list_self_select[idx].self_select_area_checked);
        this.setState({
            list_self_select: list_self_select,
        });
        setTimeout(() => {
            parentWrap.css({ height: "auto" });
        }, 20);
    }

    /** 자동 진열 설정  여닫기 : 애니메이션 없음
     * @param {*} idx 알고리즘 순서
    */
     onClickEventFolderNoneAni(idx){
        const target = "#list_select_expand_"+idx;
        let list_select = $(target).outerHeight();

        if($(target).find(".list_select_expand_check").is(":checked")){ // 펼치기
            $(target).parent(".list_select_expand_wrap").css("overflow","visible");
            $(target).parent(".list_select_expand_wrap").css({height :"auto"});
        }
        else{ // 접기
            $(target).parent(".list_select_expand_wrap").css("overflow","hidden");
            $(target).parent(".list_select_expand_wrap").css({height :list_select});
        }
    }

     /** '대 카테고리 사용 설정' 팝업 높이 구하기 (최대 5개까지 보이고 그 이후 스크롤) */
    category_list_setting_table(){
        let category_list_thead_height = $(".category_list_setting_table thead td").height();
        let category_list_td_height = $(".category_list_setting_table tbody td").height();
        let category_list_td_max_height = category_list_td_height * 5;
        let category_list_total_height = category_list_thead_height + category_list_td_max_height;
        $(".category_list_setting_table_wrap").css({
            "height":category_list_total_height
        });
    }

    /** 왼쪽 영역 선택지들 불러오기 */
    async loadUpperCodeList() {
        /** 이미지 타입 (목록이미지, 상세이미지) */
        await APIs.rp.getSettingsByUpperCode("45000")
            .then(res => {
                if (res.data != null && res.data != '') {
                    this.setState({image_type_list : res.data});
                }
                load_upper_num++
            })
            .catch(err => load_upper_num++)

        /** 최초진입 혹은 메인 진열 */
        if (this.getPageStatus() === "init" || this.getPageStatus() === "main") {
            /** HTTP Error alert 비활성화 */
            setIsErrorAlert(false)
            /** 메인 진열 카테고리 목록 */
            await APIs.rp.getMainCategory()
                .then(res => {
                    if (res.data.code == 200) {
                        this.setState({
                            main_category_list : res.data["main_category_list"],
                            cafe24_main_display_group : res.data["main_category_list"][0]["display_group"],
                        }, () => {
                            if (!this.state.iframe_page_id && !this.state.iframe_html_id) {
                                this.loadCafe24MainProductList();
                            }
                        });
                    }
                    load_upper_num++
                    /** http 에러 알럿 활성화 */
                    setIsErrorAlert(true);
                })
                .catch(error => {
                    load_upper_num++
                    /** http 에러 알럿 활성화 */
                    setIsErrorAlert(true);
                });
        }

        /** 위치 */
        await APIs.rp.getSettingsByUpperCode("16000", is_test_use)
            .then(res => {
                if (res.data != null && res.data != '') {
                    let iframe_page_id_list = res.data;
                    // 헤더페이지는 마켓비와 테스트 계정에서만 보이도록 한다.
                    if(user_id != "test_rp" && user_id != "marketb"){
                        for(let i=0;i<iframe_page_id_list.length;i++){
                            if(iframe_page_id_list[i].code_cd == "16002"){
                                iframe_page_id_list.splice(i, 1);
                                i--;
                                continue;
                            }
                            if(iframe_page_id_list[i].val2 != "cafe24"){
                                iframe_page_id_list.splice(i, 1);
                                i--;
                            }
                        }
                    }
                    this.setState({
                        iframe_page_id_list : iframe_page_id_list,
                    });
                }
                load_upper_num++
            })
            .catch(error => {
                load_upper_num++
            });

        /** 상품 선택 알고리즘 (~중에) */
        await APIs.rp.getSettingsByUpperCode("A2000", is_test_use)
            .then(res => {
                if (res.data != null && res.data != '') {
                    this.setState({item_condition_list : res.data });
                }
                load_upper_num += 1;
            })
            .catch(error => {
                load_upper_num += 1;
            });

        /** 상품 선택 알고리즘 */
        await APIs.rp.getSettingsByUpperCode("22000", is_test_use)
            .then(res => {
                if (res.data != null && res.data != '') {
                    // 테스트 및 마켓비 계정의 경우 로보MD 베스트 추천이 아닌 마켓비 베스트 추천으로 보이도록 함
                    if(["test_rp", "marketb"].includes(user_id)){
                        const item_select_type_list = res.data.map(item => {
                            if (item.code_cd == "22001") return { ...item, val1: "마켓비 베스트 추천"}
                            else return item
                        })

                        this.setState({
                            item_select_type_list : item_select_type_list
                        }, () => {
                            // 직접 지정 영역 기본값 1개
                            this.addListSelfSelect(true);
                        });
                    } else{
                        this.setState({
                            item_select_type_list : res.data,
                        }, () => {
                            // 직접 지정 영역 기본값 1개
                            this.addListSelfSelect(true);
                        });
                    }
                }
                load_upper_num += 1;
            })
            .catch(error => {
                load_upper_num += 1;
            });
        // 새로운 페이지가 아니라면, 기존 진열설정 및 상품 목록을 불러온다
        if (!["main", "category"].includes(this.getPageStatus())) {
            this.loadDefaultSetting();
        }
        else {
            this.loadRpEventSetting();
        }
    }

    /** 현재 페이지 상태 */
    getPageStatus = () => {
        let status = "";
        if (this.state.iframe_page_id != null && this.state.iframe_page_id != "" && this.state.iframe_html_id != null && this.state.iframe_html_id != "") {
            if (this.state.iframe_page_id == "robomd_cafe24_main_page") {
                status = "main"
                return status
            } else if (this.state.iframe_page_id == "robomd_cafe24_category_page") {
                status = "category"
                return status
            }
        }
        status = "init"
        // console.log("getPageStatus", status);
        return status
    }

    /** 관리자 진열 제목 변경 */
    onChangeListName(e){
        this.setState({
            iframe_html_name:  e.target.value,
            left_is_modified : true,
        });
    }

    /** 위치 변경 (onClickOption)
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id(question_idx, answer_idx 포함)
    */
    onChangeListPosition(text, value, id){
        this.setState({
            show_add_product_popup : false, // 상품 추가 팝업 닫기
            show_exclude_product_list_popup : false, // 제외 상품 팝업 닫기
            show_event_product_list_popup : false, // 선택된 상품목록 팝업 닫기
            show_except_setting_popup : false, // 진열 간 상품 중복 제외 팝업 닫기
            show_self_except_setting_popup : false, // 셀프 진열 간 상품 중복 제외 팝업 닫기
            show_except_product_popup: false,
            show_essential_product_list_popup: false, // 필수 상품 설정 팝업 닫기
        });
        
        this.setState({
            iframe_page_id : value,
            left_is_modified : true,
        },() => {
            
            // 카페24 메인 진열이고, 불러온 상품목록이 없다면
            if(value == "robomd_cafe24_main_page" && this.state.cafe24_main_product_list == ""){
                // 카페24 메인 진열 상품 목록 불러오기
                this.loadCafe24MainProductList();
            } else if(value == "robomd_cafe24_category_page" && this.state.cafe24_category_product_list == ""){
                // 카테고리 상품목록
                $('#cafe24_category_display_group_'+this.state.cafe24_category_display_group).prop('checked', true);
            }

            this.countTotalItemSelectCntRange();
            this.orderIdxReset(); // 순번 초기화

            // 카페24 자동진열 사용 여부
            this.loadCategoryAutoLayoutList(this.state.cafe24_category_no, this.state.cafe24_main_display_group);
        });


        // 상품목록이 변경되기 때문에 기존 체크도 풀려야 한다
        this.setState({
            rp_check_product_list: [],
        });
    }
    
    /** 카페24 카테고리 상품분류 변경
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id(question_idx, answer_idx 포함)
    */
    onChangeCafe24Category = (text, value, id) => {
        const depth = Number(id.split('_')[2]) + 1;
        var category_name = "cafe24_category_no_" + (Number(depth)-1);

        let newState = {
            [category_name] : value,
            left_is_modified: true,
        }

        if((value === "전체상품" || value === "")){
            if(depth > 2){
                newState.cafe24_category_no = this.state["cafe24_category_no_" + (Number(depth) - 2)];
            } else{
                newState.cafe24_category_no = "";
            }
        } else{
            newState.cafe24_category_no = value;
        }

        // 세분류가 아니라면 하위카테고리 관련 작업을 진행
        if(depth < 5){
            // 선택한 카테고리의 자식 카테고리 목록을 불러온다
            if (value !== "전체상품" && value !== "") {
                this.loadCafe24Category(value, depth, "cafe24_category_list_");
            } else {
                var category_list = "cafe24_category_list_"+depth;
                this.setState({ [category_list] : []});
            }

            // 선택한 카테고리의 하위 카테고리 리스트를 초기화 시킨다
            for(let idx = depth+1; idx <=4; idx++) {
                newState["cafe24_category_list_" + idx] = [];
            }

            // 선택한 카테고리 이후의 자식 카테고리 넘버를 초기화 시킨다
            for(let idx = depth; idx <=4; idx++) {
                newState["cafe24_category_no_" + idx] = "";
            }
        }

        // [핵심 수정 포인트] depth < 5 조건과 상관없이 밖으로 빼서 한 번만 호출!
        // 사용자가 직접 조작한 것이므로 무조건 true를 전달하여 즉각적으로 UI를 갱신합니다.
        this.setState(newState, () => {
            this.loadCategoryAutoLayoutList(this.state.cafe24_category_no, this.state.cafe24_main_display_group);
            this.checkCafe24CategorySetting(null, true); 
        });
    }

    /** 카페24 카테고리 상세 상품분류 변경 */
    onChangeCategoryDisplayGroup(e){
        this.setState({ cafe24_category_display_group : e.target.value });

        /** 추천상품, 신상품일 경우엔 항상 덮어쓰기. */
        if (e.target.value !== "1") this.setState({cafe24_category_display_type: "1"})
    }

    /** 
     * 카페24 카테고리 진열 타입 변경 
     * 1: 덮어쓰기
     * 2: 유지 및 상단추가
     * */
    onChangeCategoryRollingType(e) {
        this.setState({ cafe24_category_display_type: e.target.value})

        /** 덮어쓰기일 경우 경고 다이얼로그 출력 */
        if(e.target.value === "1") this.titleContentDialogOverwrite()
    }

    /** 복사하기 */
    pasteAction() {
        const {event_rp_product_list, cafe24_main_product_list} = this.state;

            let fixed_sort_list = cafe24_main_product_list.filter(obj => obj.fixed_sort);
            let fixed_sort_no_list = fixed_sort_list.map(obj => obj.product_no);

            let product_list = event_rp_product_list.map(obj => ({...obj, iframe_page_id: this.state.iframe_page_id, iframe_html_id:this.state.iframe_html_id}));
            product_list = product_list.filter((obj) => fixed_sort_no_list.indexOf(obj.product_no) == -1)

            // 카페24 메인 진열인 경우, 해당 상품목록 적용
            if(this.state.iframe_page_id == "robomd_cafe24_main_page"){
                this.setState({cafe24_main_product_list : [...product_list, ...fixed_sort_list]} , () => {
                    this.cafe24ProductFixedReorder("cafe24_main_product_list");
                });
            }
            this.setState({
                show_event_product_list_popup : false, // 선택된 상품목록 팝업 닫기
                show_rp_product_list_table_loading_bar : false,
                rp_check_product_list : [],
                event_rp_product_list : [],
                title_content_dialog_show_state: false,
                right_is_modified: true,
            }, () => {
                this.orderIdxReset();
            });
    }

    /** 덮어쓰기 경고 TitleContent Dialog */
    titleContentDialogOverwrite = (onComplete = function() {}) => {
      if (this.state.event_rp_product_list.length < 1) {
        /** 
         * 선택된 상품이 없을경우 후처리. 
         * 1. 강제로 알고리즘 돌려서 상품 가져오기.
         * 2. 물어보기.
         * 이 함수는 functional 임.
         * */
      }
        if (localStorage.getItem("ignore_popup") === "Y") {
            onComplete(true)
            return
        }
        this.titleContentDialogForm(
            titleContentOverwrite.stepOneTitle,
            titleContentOverwrite.stepOneContent(overwriteImageURLs['overwrite1']),
            {
                title: "확인",
                type: "1",
                event_method: () => {
                    this.setState({
                        title_content_dialog_show_state: false,
                        cafe24_category_display_type: "1"
                    });
                    onComplete(true)
                }
            },
            {
                title: "돌아가기",
                type: "0",
                event_method: () => {
                    this.setState({
                        title_content_dialog_show_state: false,
                        cafe24_category_display_type: "2"
                    });
                    onComplete(false); // 콜백 호출
                }
            },
            () => {},
            "다시보지 않기"
        )
    }

    /** 100개 초과 선택 저장 경고 TitleContent Dialog */
    titleContentDialogSaveOver100Algorithm = () => {
        this.titleContentDialogForm(
            "새벽에 자동진열 되도록<br>저장하시겠습니까?",
            "101개 이상의 대량 상품 자동 진열시에는<br>데이터 안정적인 교체를 위해서<br>새벽 3시에 자동으로 진열됩니다.<br>",
            {
                title: "네",
                type: "1",
                event_method: () => {
                    this.setState({title_content_dialog_show_state: false,});
                    this.saveListSetting();
                }
            }
        )
    }

    /** 100개 이상 선택 실시간 추가 경고 TitleContent Dialog */
    titleContentDialogDeleteAddOver100Algorithm = (onComplete = function(){}) => { 
        this.titleContentDialogForm(
            "대량 상품교체시 일시 미노출안내",
            "많은 상품을 한번에 교체시에<br>교체시간동안 상품이 미노출됩니다.<br>문제가 없도록 새벽 자동예약을 권장드립니다.<br>그럼에도 현재 상품을 교체하시겠습니까?",
            {
                title: "네",
                type: "1",
                event_method: () => {
                    this.setState({title_content_dialog_show_state: false} 
                        , () => {
                            this.titleContentDialogForm(
                                "상품 진열시간 안내",
                                "많은 상품을 한번에 교체시에<br>교체시간이 오래 걸릴 수 있습니다.<br>덮어쓰기를 진행하시면 원상복구가 불가능합니다.<br>계속 진행 하시겠습니까?",
                                {
                                    title: "네",
                                    type: "1",
                                    event_method: () => {
                                        this.setState({title_content_dialog_show_state: false});
                                        this.updateCafe24CategorySetting("selectAdd")
                                        onComplete(true)
                                    }
                                },
                                {
                                    title: "아니요",
                                    type: "0",
                                    event_method: () => {
                                        this.setState({title_content_dialog_show_state: false});
                                        onComplete(false)
                                    }
                                }
                            )
                        })
                }
            }, 
            {
                title: "아니요",
                type: "0",
                event_method: () => {
                    this.setState({title_content_dialog_show_state: false});
                    onComplete(false)
                }
            }
        )
    }

    /** 상품제외 or 미진열 처리 확인 팝업 */
    titleContentDialogAlertExceptProduct = () => {
        this.titleContentDialogForm(
            "확인",
            "선택하신 상품을 미진열 하시겠습니까?",
            {
                title: "네",
                type: "1",
                event_method: () => {
                    this.setState({title_content_dialog_show_state: false});
                    this.onClickCheckedRpProductDelete()
                }
            }
        )
    }

    /** 선택된 상품목록 적용하기 */
    titleContentDialogAlertOverwritePreview = (firstSave) => {
        let overwriteAction = (function (this_component) {
            this_component.setState({
                show_rp_product_list_table_loading_bar : true,
                title_content_dialog_show_state: false,
                is_loading_overwrite_product : !firstSave ? true : false,
            });

            this_component.getProductsByAlgorithm()
            .then(res => {
                if (res.data.code == "200") {
                    /** 
                     * 겹치는것이 있을경우에
                     * 1. 완전히 같을 경우엔 다이얼로그 표시.
                     * 2. 일부 같을 경우 해당 품목을 제외한 나머지 새 품목들을 하단추가.
                     * */
                    /** 완전히 같을 경우 */
                    if (JSON.stringify(this_component.state.event_rp_product_list.map(f => {return f.product_no})) === JSON.stringify(res.data["list"].map(f=> {return f.product_no}))) {
                        if(!firstSave) this_component.basicDialogSimpleInform("기존 상품 목록과 동일합니다.")
                    } 
                    this_component.setState({
                        event_rp_product_list: res.data['list'],
                    }, () => {
                        if (firstSave) {
                            this_component.saveRpEventResultProducts(firstSave);
                        }

                        /** 통계 수치 분석 기간 데이터로 다시 적용하기 */
                        this_component.reloadProductByAnalysisStandard("event_rp_product_list", this_component.state.event_rp_product_list, this_component.state.analysis_standard_value);

                        /** 고정 상품 체크 */
                        this_component.loadFixedProductList();

                        /** 예약 진열인 경우 추가 후 상품 개수 체크 */
                        if (this_component.state.event_rp_product_list.length > flagCafe24BulkConversionProductCount && this_component.state.auto_create_yn == 'N' && this_component.state.reservation_use_yn == 'Y') {
                            this_component.setState({
                                reservation_hour: 3,
                            })
                        }
                        if (this_component.state.iframe_page_id=='robomd_cafe24_main_page' && this_component.state.event_rp_product_list.length > cafe24_main_page_max_product_num && this_component.state.auto_create_yn == 'N' && this_component.state.reservation_use_yn == 'Y') {
                            this_component.setState({
                                reservation_use_yn: "N",
                            })
                        }
                        if(this_component.state.iframe_page_id=='robomd_cafe24_category_page' && this_component.state.event_rp_product_list.length > nayeol_event_total_item_select_range_category && this_component.state.auto_create_yn == 'N' && this_component.state.reservation_use_yn == 'Y'){
                            this_component.setState({
                                reservation_use_yn: "N",
                            })
                        }
                    })
                    this_component.setState({
                        show_rp_product_list_table_loading_bar: false,
                        is_loading_overwrite_product : false,
                    }, () => {this_component.orderIdxReset()})
                } else {
                    throw new Error()
                }
            })
            .catch(err => {
                console.log(err)
                alert("상품 선택에 실패하였습니다.")
                
                this_component.setState({
                    event_rp_product_list: [],
                    show_rp_product_list_table_loading_bar: false,
                    is_loading_overwrite_product : false,
                })
            })
        });

        if (firstSave) {
            overwriteAction(this);
        } else {
            // this.titleContentDialogForm(
            //     "미리보기에 덮어쓰기 됩니다.<br/>적용 하시겠습니까?",
            //     "",
            //     {
            //         title: "네",
            //         type: "1",
            //         event_method: () => {
            //             overwriteAction(this);
            //         }
            //     }   
            // )
            overwriteAction(this);
        }
    }

    /** 진열간 상품 중복 제외 설정 취소 버튼 클릭 */
    titleContentDialogExceptSettingList = () => {
        this.titleContentDialogForm(
            "변경사항을 취소 하시겠습니까?",
            "",
            {
                title: "네",
                type: "1",
                event_method: () => {
                    this.setState({
                        title_content_dialog_show_state: false,
                    });

                    if(this.state.iframe_html_id == null || this.state.iframe_html_id == ""){
                        this.setState({
                            except_setting_list : [],
                            except_setting_is_modified : false,
                        });
                    } else{
                        this.loadRpEventExceptSettingsDone();
                    }
                }
            }
        )
    }

    /** 진열 간 상품 중복 제외 설정 저장 */
    titleContentDialogSaveExceptSettingList = (url, body, config) => {
        this.titleContentDialogForm(
            "변경된 설정을 저장 하시겠습니까?",
            "",
            {
                title: "네",
                type: "1",
                event_method: () => {
                    this.setState({
                        title_content_dialog_show_state: false,
                        save_dialog_show_state: true,
                        save_dialog_content: "저장 중 입니다.",
                        save_dialog_button_list: [
                            {
                                title: "확인",
                                type: "1",
                                display_yn:"N",
                                event_method: () => {
                                    //팝업 닫기
                                    this.setState({ save_dialog_show_state: false });
                                }
                            }
                        ]
                    });

                    http
                    .post(url, body, config)
                    .then((res) => {
                        if (res.data.code == "200") {
                            this.setState({
                                save_dialog_show_state: true,
                                save_dialog_content: "저장됐습니다.",
                                save_dialog_button_list: [
                                    {
                                        title: "확인",
                                        type: "1",
                                        event_method: () => {
                                            //팝업 닫기
                                            this.setState({
                                                save_dialog_show_state: false,
                                                except_setting_is_modified : false,
                                            });
                                        }
                                    }
                                ]
                            });
                        } else {
                           throw new Error()
                        }
                    })
                    .catch((error) => {
                        alert('진열 간 상품 중복 제외 설정 저장에 실패하였습니다.');
                        this.setState({ save_dialog_show_state: false });
                    });

                    this.setGaEvent("진열 간 상품 중복 제외 설정 저장");
                }
            }
        )
    }

    /** 오른쪽 영역 저장 - 왼쪽 영역 저장 안했을때 */
    titleContentDialogSaveRightSetting = () => {
        this.titleContentDialogForm(
            "진열 관리 설정을 저장하신 후에<br/>상품 목록을 저장하실 수 있습니다.",
            "진열 관리 설정을 먼저 저장하시겠습니까?",
            {
                title: "네",
                type: "1",
                event_method: () => {
                    this.setState({title_content_dialog_show_state : false});
                    this.onClickSaveLeftSetting();
                }
            }
        )
    }

    /** 오른쪽 영역 초기화 */
    titleContentDialogResetRightSetting = () => {
        this.titleContentDialogForm(
            "상품목록을 변경하지 않고 기존<br/>목록을 보시겠습니까?",
            "초기화하시면 변경하신 값은<br/>따로 저장되지 않습니다.",
            {
                title: "네",
                type: "1",
                event_method: () => {
                    this.setState({
                        show_rp_product_list_table_loading_bar : true,
                        title_content_dialog_show_state : false,
                        right_is_modified : false,
                        rp_check_product_list : [],
                    }, () => {
                    });
                    if(this.state.iframe_page_id == "robomd_cafe24_main_page"){
                        this.loadCafe24MainProductList(); // 카페24 메인진열 상품 목록 불러오기
                    }
                }
            }
        )
    }

    /** 왼쪽 영역 취소 버튼 클릭 (초기화) */
    titleContentDialogResetLeftSetting = () => {
        this.titleContentDialogForm(
            "설정 값 변경을 취소하시겠습니까?",
            "",
            {
                title: "네",
                type: "1",
                event_method: () => {
                    this.setState({
                        left_is_modified : false, // 왼쪽 영역 수정 여부
                        cafe24_main_display_group : this.state.main_category_list != "" ? this.state.main_category_list[0]["display_group"] : "", // 카페24 메인진열 카테고리
                        total_item_select_cnt_range : [], // 상품 선택 수 선택을 위한 리스트

                        rp_check_product_list : [], // 오른쪽 영역 선택된 상품목록
                        // 상품 카테고리 목록
                        product_rp_category_list_1:[],
                        product_rp_category_list_2:[],
                        product_rp_category_list_3:[],
                        product_rp_category_list_4:[],

                        product_rp_category_no_1: "",
                        product_rp_category_no_2: "",
                        product_rp_category_no_3: "",
                        product_rp_category_no_4: "",
                    }, () => {
                        this.loadProductCategory("", 1, "product_rp_category_list_");
                        this.loadExcludeProductList();
                        this.loadRpEventExceptSettingsDone();
                        // 진열 추가 페이지일 경우
                        if(this.state.iframe_html_id == null || this.state.iframe_html_id==""){
                            this.loadDefaultSetting();
                        } else{ // 저장한 기록이 있는 페이지일 경우
                            this.loadRpEventSetting(true);
                        }
                        this.setState({title_content_dialog_show_state : false });
                        this.basicDialogSimpleInform("변경이 취소되었습니다.")
                    });
                }
            },
        )
    }

    /** 카페24 메인진열 카테고리 변경 (onClickOption)
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id(question_idx, answer_idx 포함)
    */
    titleContentDialogDisplayGroup = (cafe24_main_display_group_name, cafe24_main_display_group) => {
        this.setState({
          cafe24_main_display_group,
          title_content_dialog_show_state: false,
          left_is_modified : true,
          right_is_modified : false,
        }, () => {
            // 카페24 메인 진열 상품 목록 불러오기
            this.loadCafe24MainProductList();
  
            // 카페24 자동진열 사용 여부
            this.loadCategoryAutoLayoutList(this.state.cafe24_category_no, cafe24_main_display_group);
        });
    }

    /** 진열 쇼핑몰 바로 적용 확인 */
    titleContentDialogApplyProductMainDisplay = () => {
        this.titleContentDialogForm(
            "변경하신 목록을 쇼핑몰에 바로<br/>적용하시겠습니까?",
            "",
            {
                title: "네",
                type: "1",
                event_method: () => {
                    this.setState({title_content_dialog_show_state: false}, 
                        async () => {
                            /** 자동진열로 이미 뽑힌것을 재등록하는경우, 모든 진열 상품을 삭제하는 경우를 제외하고 상품목록 저장 */
                            if (this.state.event_rp_product_list_yn !== "Y" 
                                && this.state.event_rp_product_list.length !== 0
                            ) {
                                this.saveRpEventResultProducts();
                                this.saveFixedProducts();
                            }
                            this.saveDialogSimpleInform("저장 중 입니다.", "N")
                            if (this.getPageStatus() === "main") {
                              /** 메인진열 바로 적용 */
                              this.saveCafe24MainProductList()
                            } else {
                              /** 카테고리진열 바로 적용 */
                              await this.updateCafe24CategorySetting("load");
                              await this.selectAddCafe24CategoryProduct();
                            }
                            this.setGaEvent("저장")
                        }
                    )
                }
            }
        )
    }

    /** 진열 저장. */
    titleContentDialogSaveLeftSetting = (title, content, body, firstSave, callbackFunc) => {
        this.titleContentDialogForm(
            title,
            content,
            {
                title: "네",
                type: "1",
                event_method: () => {
                    APIs.rp.saveListSetting(body)
                    .then(res => {
                        if (res.data.insertCnt > 0) {
                            if(firstSave){
                                this.setState({
                                    iframe_html_id : res.data.iframe_html_id,
                                    iframe_page_id : res.data.iframe_page_id,
                                }, () => {
                                    // 왼쪽 영역 저장값 불러오기 (초기 저장시 : 위치는 저장후에 변경 불가능 하기 때문에 다시 불러와서 해당 설정을 적용시킨다)
                                    this.loadRpEventSetting(true,true);
                                    this.loadRpEventExceptSettingsToBe(true);
                                    // 링크 주소에 param값으로 iframe_html_id와 iframe_page_id를 붙인 형태로 변경한다.
                                    window.history.replaceState("","",'/shop/rp/event/product/cafe24List'+"?page_id="+this.state.iframe_page_id+"&html_id="+this.state.iframe_html_id);
                                    this_location ="/shop/rp/event/product/cafe24List?page_id="+this.state.iframe_page_id+"&html_id="+this.state.iframe_html_id;
                                
                                    // 카테고리 설정 불러오기
                                    this.checkCafe24CategorySetting();
                                    
                                    // 덮어쓰기
                                    this.onClickOverWritePreview(firstSave);
                                });
                            } else {
                                /** 설정저장 -> 알고리즘 결과 상품 목록 함께 저장. */
                                this.saveRpEventResultProducts();
                                this.saveFixedProducts();
                            }
                            this.saveExcludeProductList();
                            this.saveExceptSettingList(true);
                            if(firstSave) {
                                // this.setState({left_is_modified: false})
                                // this.titleContentDialogForm(
                                //     "진열자동화적용",
                                //     "이제 설정된 내 쇼핑몰 상품 진열을<br/>로보MD 자동 진열로 바로 바꿔보실까요?",
                                //     {
                                //         title: "네",
                                //         type: "1",
                                //         event_method: () => {
                                //             if(this.state.iframe_page_id === "robomd_cafe24_category_page"){
                                //                 //팝업 닫기
                                //                 this.setState({title_content_dialog_show_state: false});
                                //             } else {
                                //                 //팝업 닫기
                                //                 this.setState({title_content_dialog_show_state: false});
                                //                 this.saveDialogSimpleInform("저장 중 입니다.", "N", function(){})
                                //                 this.onClickSaveRightSetting(true);
                                //             }
                                //         }
                                //     },
                                //     {
                                //         title: "아니요",
                                //         type: "0",
                                //         event_method: () => {
                                //             //팝업 닫기
                                //             this.titleContentDialogForm(
                                //                 "상담예약",
                                //                 "좀 더 상세하게 서비스 상담 및<br/>사용법을 안내해드릴까요?",
                                //                 {
                                //                     title: "네",
                                //                     type: "1",
                                //                     event_method: () => {
                                //                         //팝업 닫기
                                //                         this.setState({title_content_dialog_show_state: false});
                                //                         this.goConsultingPage();
                                //                     }
                                //                 },
                                //             )
                                //         }
                                //     }
                                // )
                            } else {
                                this.setState({ left_is_modified: false })
                                this.clearTitleContentDialog()
                                this.saveDialogSimpleInform(this.state.iframe_page_id !== "robomd_cafe24_category_page" ? "저장됐습니다." : "저장됐습니다.<br/><br/>👉 카테고리 상품 진열&nbsp;&nbsp;<br/>실시간 진열정보가 적용됩니다.<br/>실시간 반영됨을 꼭 기억해주세요.")
                            }
                        } else {
                            this.clearTitleContentDialog()
                            throw new Error()
                        }
                    })
                    .catch(err => {
                        this.clearTitleContentDialog()
                        alert("진열 설정 저장에 실패하였습니다.")
                    })

                    this.setGaEvent("저장")
                }
            },
            {
                title: "아니요",
                type: "0",
                event_method: () => { 
                    this.clearTitleContentDialog() 
                }
            },
            callbackFunc
        )
    }

    /** 존재하는 진열 진입시도시 최초 화면에서 가이드. */
    basicDialogGuideModifyDisplay = () => {
        this.basicDialogSimpleInform(
            basicDialogModifyDisplay.title 
            + basicDialogModifyDisplay.content(
                overwriteImageURLs['modify'],
                this.state.iframe_html_name,
                "카페24 카테고리 진열",
                // this.state.test_category_name,
                // "아우터",
                this.state.cafe24_category_full_name,
                this.state.event_cycle,
                this.state.event_time
            )
        )
    }

    /** 선택된 상품목록 선택한 상품 추가 버튼 클릭 - 상품 선택 안했을시 */
    basicDialogNeedProducts = () => {
        this.basicDialogSimpleInform(
            "상품을 선택해 주세요."
        )
    }

    /** 분류별 진열인데, 진열 관리 저장 전 요청일 경우 : 다이얼로그 안내*/
    basicDialogNeedSave = () => {
        this.basicDialogSimpleInform(
            "진열 관리 먼저 저장해주세요."
        )
    }

    /** 분류별 진열인데, 진열 관리 저장 전 요청일 경우 : 다이얼로그 안내*/
    warningDialogEssentialProductCnt = (message) => {
        this.warningDialogSimpleInform(
            !message ? "상품 선택 수는 고정 상품의 개수보다 커야 합니다." : message
        )
    }

    /** 미진열 한번에 30개까지 가능. */
    basicDialogLimit30UnDisplay = () => {
        this.basicDialogSimpleInform(
            "미진열은 한번에 30개까지 가능합니다."
        )
    }

    /** 관련 상품명 <- 추가는 100개까지만 */
    basicDialogLimit100AddProductsAutoDisplay = () => {
        this.basicDialogSimpleInform(
            "자동 상품 진열 추가는<br/>최대 100개까지만 가능합니다.",
        )
    }

    /** 상품 선택 수 범위를 넘었을 경우 다이얼로그 */
    basicDialogTotalCount = () => {
        this.basicDialogSimpleInform(
            "상품 선택 수 합계가 <br/> "+(this.state.total_item_select_cnt_range.indexOf("자동") >= 0 ? this.state.total_item_select_cnt_range.length-2 : this.state.total_item_select_cnt_range.length-1)+"이 넘지 않도록 입력해 주세요.",
            {
                title: "확인",
                type: "1",
                event_method: () => {
                    //팝업 닫기
                    this.setState({ basic_dialog_show_state: false })
                    // 자동 진열 선택 영역 열기
                    if(!$("#list_side_title_arrow_2").is(":checked")){
                        $("#listCategoryExpand").trigger('click');
                    }

                    // 상품선택 수 input focus 작업
                    const self_select_idx = this.state.list_self_select.length-1;
                    $("#list_select_arrow_"+self_select_idx).prop("checked",true);
                    this.onClickEventFolder(self_select_idx, "#EventTotalItemSelectCntSelectInput_"+self_select_idx);
                }
            }
        )
    }

    /** 왼쪽 영역 저장 -> 관리자 진열 제목이 공백 */
    basicDialogNeedDisplayName = () => {
        this.basicDialogSimpleInform(
            "관리자 진열 제목을 입력해주세요.",
            {
                title: "확인",
                type: "1",
                event_method: () => {
                    //팝업 닫기
                    this.setState({ basic_dialog_show_state: false });
                    $("#iframe_html_name_input").focus();
                }
            }
        )
    }

    /** 왼쪽 영역 저장 -> 상품분류(카테고리)가 없는 경우 다이얼로그 */
    basicDialogNeedCategory = () => {
        this.basicDialogSimpleInform(
            "상품분류를 선택해 주세요.",
            {
                title: "확인",
                type: "1",
                event_method: () => {
                    //팝업 닫기
                    this.setState({ basic_dialog_show_state: false });
                    rpTitleRef.current.scrollIntoView({block:"start"});
                }
            }
        )
    }
    /** 카페24 분류별 진열 순서 적용 : return 후 작업 -> 저장 다이얼로그 */
    saveDialogSaveCategoryOrder = () => {
        this.saveDialogSimpleInform(
            "적용됐습니다.",
            "Y",
            () => {
                const {cafe24_category_product_list} = this.state;

                // 변경된 순서 저장
                let cafe24_category_before_order = [];
                for(var i=0;i<cafe24_category_product_list.length;i++){
                    cafe24_category_before_order.push(cafe24_category_product_list[i]);
                }
                    
                this.setState({
                    cafe24_category_change_order_list : [],
                    cafe24_category_before_order_list : cafe24_category_before_order,
                    category_order_is_modified : false,
                });

                //팝업 닫기
                this.setState({ save_dialog_show_state: false });
            }
        )
    }

    /** 왼쪽 영역 저장 -> 시작시점 입력 안 한 경우 */
    basicDialogNeedStartDate = () => {
        this.basicDialogSimpleInform(
            "시작시점을 입력해주세요.",
            {
                title: "확인",
                type: "1",
                event_method: () => {
                    //팝업 닫기
                    this.setState({ basic_dialog_show_state: false });
                    $("#event_start_date").focus();
                }
            }
        )
    }
    /** 왼쪽 영역 저장 -> 요일을 입력 안 한 경우 */
    basicDialogNeedWeekDay= () => {
        this.basicDialogSimpleInform(
            "반복요일을 선택해주세요.",
            {
                title: "확인",
                type: "1",
                event_method: () => {
                    //팝업 닫기
                    this.setState({ basic_dialog_show_state: false });
                    $("#rp_weekday").scrollTop();
                }
            }
        )
    }
    /** 왼쪽 영역 저장 -> 예약일을 입력 안 한 경우 */
    basicDialogNeedReservationDate= () => {
        this.basicDialogSimpleInform(
            "예약일을 선택해주세요.",
            {
                title: "확인",
                type: "1",
                event_method: () => {
                    //팝업 닫기
                    this.setState({ basic_dialog_show_state: false });
                    $("#reservation_date").focus();
                }
            }
        )
    }
    /** 왼쪽 영역 저장 -> 예약 시간을 입력 안 한 경우 */
    basicDialogNeedReservationHour= () => {
        this.basicDialogSimpleInform(
            "예약시간을 선택해주세요.",
            {
                title: "확인",
                type: "1",
                event_method: () => {
                    //팝업 닫기
                    this.setState({ basic_dialog_show_state: false });
                    $("#reservation_hour").focus();
                }
            }
        )
    }

    /** 단순 정보 Guide 용 Basic dialog */
    basicDialogSimpleInform = (
        basic_dialog_content, 
        button = {
            title: "확인",
            type: "1",
            event_method: () => {this.setState({basic_dialog_show_state:false})}
        },
        basic_dialog_width
        ) => {
        this.setState({
            basic_dialog_show_state: true,
            basic_dialog_content,
            basic_dialog_button_list: [
                {...button}
            ],
            basic_dialog_width
        })
    }

    /** 단순 정보 Guide 용 Warning dialog */
    warningDialogSimpleInform = (
        warning_message, 
        ) => {
        this.setState({
            warning_state: true,
            warning_message,
        })
    }

    /** 저장 알림 다이얼로그 */
    saveDialogSimpleInform = (
        save_dialog_content = "저장 중 입니다.", 
        display_yn = "Y", 
        event_method = () => {this.setState({save_dialog_show_state:false})}) => 
    {
        this.setState({
            save_dialog_show_state: true,
            save_dialog_content,
            save_dialog_button_list: [
                {
                    title: "확인",
                    type: "1",
                    display_yn,
                    event_method: () => event_method()
                }
            ]
        })
    }

    /** 제목 내용 다이얼로그 */
    titleContentDialogForm = (
        title_content_dialog_title = "",
        title_content_dialog_content = "",
        title_content_dialog_ok = {
            title: "확인",
            type: "1",
            event_method: () => {this.setState({title_content_dialog_show_state: false})}
        },
        title_content_dialog_cancel = {
            title: "아니요",
            type: "0",
            event_method: () => {this.setState({title_content_dialog_show_state: false})}
        },
        callbackFunc = () => {},
        title_content_dialog_check_box_text = ""
    ) => {
        this.setState({
            title_content_dialog_show_state: true,
            title_content_dialog_title, 
            title_content_dialog_content,
            title_content_dialog_check_box_text,
            title_content_dialog_button_list: [
                {...title_content_dialog_ok},
                {...title_content_dialog_cancel}
            ]
        } , callbackFunc)
    }

    /** 제목 내용 다이얼로그 지우기 */
    clearTitleContentDialog = () => {
        this.setState({
            title_content_dialog_show_state: false,
            title_content_dialog_title: "",
            title_content_dialog_content : "",
        })
    }

    /** 자동진열 충돌 조치안내 */
    autoDisplayWarningDialoog = () => {
        let content = `
        <div style="margin-top: 15px;">
        <b>현재 카페24상품자동진열을 이용 중으로</b><br/>
        데이터 충돌로 로보MD자동진열을 쇼핑몰에 적용할 수 없습니다<br/>
        <b><font style="color:#FF2E00">카페24상품자동진열을 OFF한</font> 후 사용해주세요</b><br/>
        </div>
        `
        if (window.innerWidth <= 800) {
            content = `
            <div style="margin-top: 15px;">
            <b>현재 카페24상품자동진열을 이용 중으로</b><br/>
            데이터 충돌로 로보MD자동진열을<br/>
            쇼핑몰에 적용할 수 없습니다<br/>
            <b><font style="color:#FF2E00">카페24상품자동진열을<br/>
            OFF한</font> 후 사용해주세요</b><br/>
            </div>  
            `
        }
        this.basicDialogSimpleInform(
           `
            <div style='display:flex; flex-direction:column; justify-content:center; width:auto; max-width:610px'>
                <div style="margin-bottom: 15px;font-size: 1.3em;">자동진열 충돌 조치안내</div>
                <svg width="457" height="198" viewBox="0 0 457 198" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="width: 100%; height: auto;">
                <g filter="url(#filter0_d_11437_116683)">
                <rect x="114" y="6" width="335" height="182" fill="url(#pattern0_11437_116683)"/>
                <rect x="8" y="6" width="106" height="182" fill="url(#pattern1_11437_116683)"/>
                </g>
                <defs>
                <filter id="filter0_d_11437_116683" x="0" y="0" width="457" height="198" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dy="2"/>
                <feGaussianBlur stdDeviation="4"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11437_116683"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11437_116683" result="shape"/>
                </filter>
                <pattern id="pattern0_11437_116683" patternContentUnits="objectBoundingBox" width="1" height="1">
                <use xlink:href="#image0_11437_116683" transform="scale(0.00292018 0.00543478)"/>
                </pattern>
                <pattern id="pattern1_11437_116683" patternContentUnits="objectBoundingBox" width="1" height="1">
                <use xlink:href="#image1_11437_116683" transform="matrix(0.0036828 0 0 0.00215054 -0.000863874 0)"/>
                </pattern>
                <image id="image0_11437_116683" width="363" height="184" xlink:href="data:image/jpeg;base64,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"/>
                <image id="image1_11437_116683" width="343" height="465" xlink:href="data:image/png;base64,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"/>
                </defs>
                </svg>
                ${content}
            </div>   
            `,
            {
                title: "확인",
                type: "1",
                event_method: () => {
                    //팝업 닫기
                    this.setState({ basic_dialog_show_state: false, basic_dialog_width: null });
                    rpTitleRef.current.scrollIntoView({block:"start"});
                }
            },
            "auto"
        )
    }

    /**
     * 카페24 일반상품 관리 방식 변경
     */
    onChangeCategoryProductManageType(e){
        this.setState({
            cafe24_product_manage_type : e.target.value,
        });
    }

    /** 상품 선택 수 가능 범위 계산
     * 설치형에서 조건별로 상품 선택 수 가능 범위가 달라지고, cafe24 진열에서도 추후 변경될 수 있음
    */
    countTotalItemSelectCntRange(){
        const rangeLimitAlgorithm = this.state.iframe_page_id === "robomd_cafe24_main_page"
        ? nayeol_event_total_item_select_range_main
        : nayeol_event_total_item_select_range_category

        let total_item_select_cnt_range = [];
        if( this.state.max_item_analysis !== '1' ) total_item_select_cnt_range.push('자동');
        for(var i=0; i<=rangeLimitAlgorithm; i++){
            total_item_select_cnt_range.push(i);
        }
        this.setState({
            total_item_select_cnt_range : total_item_select_cnt_range
        });
    }

    /** 기존 상품 선택 수 초과 대응
     * @param {*} range 상품 선택 수 최대 범위로 설정할 값
    */
    totalItemSelectCntRangeCheck(range){
        let {event_total_item_select_cnt} = this.state;
        let total_item_select_cnt_range = [];
        for(var i=0; i<=range; i++){
            total_item_select_cnt_range.push(i);
        }
        // 기존 상품 선택 수가 변경될 상품 선택 수 범위를 초과했을 경우
        if(event_total_item_select_cnt>range){
            this.setState({
                total_item_select_cnt_range : total_item_select_cnt_range,
            }, () =>{
                // this.totalCntDiolog();
                this.basicDialogTotalCount();
            });
            return false;
        }
        this.setState({
            total_item_select_cnt_range : total_item_select_cnt_range,
        });
    }

    /**
     * 이미지 타입 변경
     * @param {*} text 
     * @param {*} value 
     * @param {*} id 
     */
    onChangeImageType(text, value, id){
        this.setState({
            image_type_cd : value,
            left_is_modified : true,
        });
    }    

    /**
     * 알고리즘 조작 : 해당 알고리즘 복사 붙여넣기
     * @param {} idx : 복사 요청 대상 알고리즘.
     */
    copyPasteAlgorithm = (e, idx) => {
        e.stopPropagation();
        const {item_select_type_list ,list_self_select} = this.state
        /** 관련 상품명 <- 추가 */
        if(list_self_select.length > 99){
            this.setState({
                basic_dialog_show_state: true,
                basic_dialog_content: "알고리즘 추가는<br/>최대 100개까지만 가능합니다.",
                basic_dialog_button_list: [
                    {
                        title: "확인",
                        type: "1",
                        event_method: () => {
                            //팝업 닫기
                            this.setState({ basic_dialog_show_state: false });
                            // $("#self_title_input").focus();
                        }
                    }
                ]
            });

            return false;
        }
        item_select_type_list.every((ele) => {
            if(ele.val1 != null && ele.val1 !== "") { 
                list_self_select.push({
                    ...structuredClone(list_self_select[idx]),  // 깊은 복사
                    self_select_area_checked: true,
                    detail_filter_expand_check: false,
                    uuid: StringUtil.generateUUID(),
                });
            } 
        });


        this.setState({
            list_self_select,
            left_is_modified : true
        }, () => {
            this.SumEventTotalItemSelectCnt();
            /** 모든 알고리즘 expand 줄이기 */
            // for(var i=0;i<this.state.list_self_select.length; i++){
            //     $("#list_select_arrow_"+i).prop("checked",this.state.list_self_select[i].self_select_area_checked);
            //     this.foldAlgorithm(i);
            // }

            for(var i=0;i<this.state.list_self_select.length; i++){
                console.log("### self_select_area_checked_"+i, this.state.list_self_select[i].self_select_area_checked)
                if (!this.state.list_self_select[i].self_select_area_checked) {
                    this.foldAlgorithm(i);
                } else {
                    const target = "#list_select_expand_"+i;
                    const parentWrap = $(target).parent(".list_select_expand_wrap");
                    const expandContent = $(parentWrap).children(".list_select_expand_1");
                    $(expandContent).removeClass("hidden_algorithm").addClass("visible_algorithm");
                    $("#list_select_arrow_"+i).prop("checked",this.state.list_self_select[i].self_select_area_checked);
                    $(target).parent(".list_select_expand_wrap").css("overflow","visible");
                    $(target).parent(".list_select_expand_wrap").css({height :"auto"});
                }
            }

            const lastIndex = this.state.list_self_select.length-1; // 복제 후 길이
            const $target = $("#list_select_content_" + lastIndex);

            if ($target && $target.length) {
                if (window.innerWidth <= 800) {
                    $target.css('scroll-margin-top', '60px');
                }
                $target
                    .addClass("highlight")
                    .get(0)
                    .scrollIntoView({ behavior: "smooth", block: "start" });

                setTimeout(() => {
                    $target.removeClass("highlight");
                }, 1200);
            }
        });
    }

    /**
     * 알고리즘 조작 : 해당 알고리즘 삭제
     */
    onDeleteAlgorithm = (e, idx) => {
        e.stopPropagation();
        if(this.state.list_self_select.length < 2) {
            this.basicDialogSimpleInform("최소 한개의 알고리즘이 필요합니다.")
            return
        }
        this.titleContentDialogForm(
            "선택하신 제품 알고리즘을 삭제하시겠습니까?",
            "",
            {
                title: "네",
                type: "1",
                event_method: () => {
                    const {list_self_select} = this.state;
                    let list = [...list_self_select]
                    list.splice(idx,1);

                    this.setState({
                        list_self_select : list,
                        left_is_modified : true,
                        title_content_dialog_show_state: false,
                    }, () => {
                        this.SumEventTotalItemSelectCnt();
                        // 삭제 후에 체크값을 유지하기 위한 작업
                        // for(var i=0;i<this.state.list_self_select.length; i++){
                        //     $("#list_select_arrow_"+i).prop("checked",this.state.list_self_select[i].self_select_area_checked);
                        //     this.foldAlgorithm(i);
                        // }

                        for(var i=0;i<this.state.list_self_select.length; i++){
                            console.log("### self_select_area_checked_"+i, this.state.list_self_select[i].self_select_area_checked)
                            if (!this.state.list_self_select[i].self_select_area_checked) {
                                this.foldAlgorithm(i);
                            } else {
                                const target = "#list_select_expand_"+i;
                                const parentWrap = $(target).parent(".list_select_expand_wrap");
                                const expandContent = $(parentWrap).children(".list_select_expand_1");
                                $(expandContent).removeClass("hidden_algorithm").addClass("visible_algorithm");
                                $("#list_select_arrow_"+i).prop("checked",this.state.list_self_select[i].self_select_area_checked);
                                $(target).parent(".list_select_expand_wrap").css("overflow","visible");
                                $(target).parent(".list_select_expand_wrap").css({height :"auto"});
                            }
                        }

                        const $target = $("#list_select_content_" + idx);
                        const $target_up = $("#list_select_content_" + (idx -1));

                        if ($target && $target.length) {
                            if (window.innerWidth <= 800) {
                                $target.css('scroll-margin-top', '60px');
                            }
                            $target
                                .get(0)
                                .scrollIntoView({ behavior: "smooth", block: "start" });
            
                            setTimeout(() => {
                                // $target.removeClass("highlight");
                            }, 1000);
                        } else if ($target_up && $target_up.length) {
                            if (window.innerWidth <= 800) {
                                $target_up.css('scroll-margin-top', '60px');
                            }
                            $target_up
                                .get(0)
                                .scrollIntoView({ behavior: "smooth", block: "start" });
                        }
                    });
                }
            }
        )
    }

    /**
     * 알고리즘 조작 : 해당 알고리즘 순서 맨 위로 변경
     */
    onChangeTopSequenceAlgorithm = (e, idx) => {
        e.stopPropagation();
        if (idx <= 0) {
            this.basicDialogSimpleInform("이미 가장 처음 위치입니다.");
            return;
        }

        const $target = $("#list_select_content_" + idx);
        const firstRect = $target[0].getBoundingClientRect(); // 이동 전 위치

        this.setState(prevState => {
            const list = [...prevState.list_self_select];
            const itemToMove = list.splice(idx, 1)[0]; // 선택된 항목 제거 후 저장
            list.unshift(itemToMove); // 리스트의 맨 처음에 추가
    
            return { list_self_select: list };
        }, () => {
            for(var i=0;i<this.state.list_self_select.length; i++){
                console.log("### self_select_area_checked_"+i, this.state.list_self_select[i].self_select_area_checked)
                if (!this.state.list_self_select[i].self_select_area_checked) {
                    this.foldAlgorithm(i);
                } else {
                    const target = "#list_select_expand_"+i;
                    const parentWrap = $(target).parent(".list_select_expand_wrap");
                    const expandContent = $(parentWrap).children(".list_select_expand_1");
                    $(expandContent).removeClass("hidden_algorithm").addClass("visible_algorithm");
                    $("#list_select_arrow_"+i).prop("checked",this.state.list_self_select[i].self_select_area_checked);
                    $(target).parent(".list_select_expand_wrap").css("overflow","visible");
                    $(target).parent(".list_select_expand_wrap").css({height :"auto"});
                }
            }
            
            this.scrollToAlgorithm(0); // 이동 후 맨 위 항목으로 스크롤
        });
    }
    
    /**
     * 알고리즘 조작 : 해당 알고리즘 순서 맨 아래로 변경
     */
    onChangeBottomSequenceAlogorithm = (e, idx) => {
        e.stopPropagation();
        const { list_self_select } = this.state;
        if (idx === list_self_select.length - 1) {
            this.basicDialogSimpleInform("이미 가장 마지막 위치입니다.");
            return;
        }
        this.setState(prevState => {
            const list = [...prevState.list_self_select];
            const itemToMove = list.splice(idx, 1)[0]; // 선택된 항목 제거 후 저장
            list.push(itemToMove); // 리스트의 맨 아래로 추가
    
            return { list_self_select: list };
        }, () => {
            for(var i=0;i<this.state.list_self_select.length; i++){
                console.log("### self_select_area_checked_"+i, this.state.list_self_select[i].self_select_area_checked)
                if (!this.state.list_self_select[i].self_select_area_checked) {
                    this.foldAlgorithm(i);
                } else {
                    const target = "#list_select_expand_"+i;
                    const parentWrap = $(target).parent(".list_select_expand_wrap");
                    const expandContent = $(parentWrap).children(".list_select_expand_1");
                    $(expandContent).removeClass("hidden_algorithm").addClass("visible_algorithm");
                    $("#list_select_arrow_"+i).prop("checked",this.state.list_self_select[i].self_select_area_checked);
                    $(target).parent(".list_select_expand_wrap").css("overflow","visible");
                    $(target).parent(".list_select_expand_wrap").css({height :"auto"});
                }
            }

            this.scrollToAlgorithm(this.state.list_self_select.length - 1);
        });
    }

    /**
     * 알고리즘 조작 : 해당 알고리즘 순서 위로 변경
     */
    onChangeUpSequenceAlgorithm = (e, idx) => {
        e.stopPropagation();
        if (idx <= 0) {
            this.basicDialogSimpleInform("이미 가장 처음 위치입니다.")
            return
        }
        this.setState(prevState => {
            const list = [...prevState.list_self_select]
            const temp = list[idx - 1];
            list[idx - 1] = list[idx];
            list[idx] = temp;

            return {list_self_select: list}
        }, () => {
            for(var i=0;i<this.state.list_self_select.length; i++){
                console.log("### self_select_area_checked_"+i, this.state.list_self_select[i].self_select_area_checked)
                if (!this.state.list_self_select[i].self_select_area_checked) {
                    this.foldAlgorithm(i);
                } else {
                    const target = "#list_select_expand_"+i;
                    const parentWrap = $(target).parent(".list_select_expand_wrap");
                    const expandContent = $(parentWrap).children(".list_select_expand_1");
                    $(expandContent).removeClass("hidden_algorithm").addClass("visible_algorithm");
                    $("#list_select_arrow_"+i).prop("checked",this.state.list_self_select[i].self_select_area_checked);
                    $(target).parent(".list_select_expand_wrap").css("overflow","visible");
                    $(target).parent(".list_select_expand_wrap").css({height :"auto"});
                }
            }
            
            this.scrollToAlgorithm(idx - 1);
        })
    }
    /**
     * 알고리즘 조작 : 해당 알고리즘 순서 아래로 변경
     */
    onChangeDownSequenceAlogorithm = (e, idx) => {
        e.stopPropagation();
        const {list_self_select} = this.state
        if (idx === list_self_select.length - 1) {
            this.basicDialogSimpleInform("이미 가장 마지막 위치입니다.")
            return
        }
        this.setState(prevState => {
            const list = [...prevState.list_self_select]
            const temp = list[idx + 1];
            list[idx + 1] = list[idx];
            list[idx] = temp;

            return {list_self_select: list}
        }, () => {
            for(var i=0;i<this.state.list_self_select.length; i++){
                console.log("### self_select_area_checked_"+i, this.state.list_self_select[i].self_select_area_checked)
                if (!this.state.list_self_select[i].self_select_area_checked) {
                    this.foldAlgorithm(i);
                } else {
                    const target = "#list_select_expand_"+i;
                    const parentWrap = $(target).parent(".list_select_expand_wrap");
                    const expandContent = $(parentWrap).children(".list_select_expand_1");
                    $(expandContent).removeClass("hidden_algorithm").addClass("visible_algorithm");
                    $("#list_select_arrow_"+i).prop("checked",this.state.list_self_select[i].self_select_area_checked);
                    $(target).parent(".list_select_expand_wrap").css("overflow","visible");
                    $(target).parent(".list_select_expand_wrap").css({height :"auto"});
                }
            }

            this.scrollToAlgorithm(idx + 1);
        })
    }

    scrollToAlgorithm(idx) {
        const $target = $("#list_select_content_" + idx);
        if ($target.length) {
            if (window.innerWidth <= 800) {
                $target.css('scroll-margin-top', '60px');
            }
            $target
            .addClass("highlight")
            .get(0)
            .scrollIntoView({ behavior: "smooth", block: "start" });

            setTimeout(() => {
                $target.removeClass("highlight");
            }, 1200);
        }
    }

    onDragStartAlgorithm = (e, idx) => {
        e.dataTransfer.setData("draggedItemIndex", idx);
    }

    onDragOverAlgorithm = (e) => {
        e.preventDefault()
    }

    onDropAlgorithm = (e, dropIndex) => {
        const draggedItemIndex = e.dataTransfer.getData("draggedItemIndex");
        if (draggedItemIndex !== dropIndex) {
            let list = [...this.state.list_self_select];
            const draggedItem = list[draggedItemIndex];
            list.splice(draggedItemIndex, 1);
            list.splice(dropIndex, 0, draggedItem);
            this.setState({ list_self_select: list });
          }
    }

    /** 직접 지정 : 선택지 추가
     * @param {*} none_modified default로 추가되는 경우(수정이 아닌 경우)
    */
    addListSelfSelect(none_modified){
        const {item_select_type_list, list_self_select, first_category_list} = this.state;

        const list = [...list_self_select]
        
        /** 관련 상품명 <- 추가 */
        if(list.length > 99){
            this.setState({
                basic_dialog_show_state: true,
                basic_dialog_content: "자동 상품 진열 추가는<br/>최대 100개까지만 가능합니다.",
                basic_dialog_button_list: [
                    {
                        title: "확인",
                        type: "1",
                        event_method: () => {
                            //팝업 닫기
                            this.setState({ basic_dialog_show_state: false });
                            $("#self_title_input").focus();
                        }
                    }
                ]
            });

            return false;
        }

        // 제외 카테고리 초기화 
        let product_rp_except_category_no_list = [{}];

        let copy_first_category_list = JSON.parse(JSON.stringify(first_category_list))
        if (copy_first_category_list != null && copy_first_category_list[0] != null) {
            copy_first_category_list[0] = {
                "category_name": "사용 안함",
                "category_name_no_format": "사용 안함",
                "category_no": ""
            }
        }
        product_rp_except_category_no_list[0]["product_rp_except_category_list_1"] = JSON.parse(JSON.stringify(copy_first_category_list));
        product_rp_except_category_no_list[0]["product_rp_except_category_list_2"] = [];
        product_rp_except_category_no_list[0]["product_rp_except_category_list_3"] = [];
        product_rp_except_category_no_list[0]["product_rp_except_category_list_4"] = [];
        
        product_rp_except_category_no_list[0]["product_rp_except_category_no_1"] = "";

        let event_except_category_list = [];
        event_except_category_list[0] = "";

        item_select_type_list.every(function(ele){
            if(ele.val1 != null && ele.val1 != ""){
                list.push({
                    cd : ele.code_cd,
                    cnt : '10',
                    event_category_list : '',
                    self_except_setting_list: [], // 순위별 진열코너 중복 제외 설정
                    event_item_price_filter_yn: "Y",
                    min_hit_cnt:'',
                    max_hit_cnt:'',
                    min_cart_cnt:'',
                    max_cart_cnt:'',
                    min_price :'',
                    max_price:'',
                    min_order_cnt:'',
                    max_order_cnt:'',
                    min_order_price:'',
                    max_order_price:'',
                    min_review_cnt:'',
                    max_review_cnt:'',
                    min_review_point:'',
                    max_review_point:'',
                    min_quantity:'',
                    max_quantity:'',
                    event_item_created_period: "0",
                    event_item_created_period_type: "W",
                    // 상품 등록일 기준이 직접지정인지에 대한 여부
                    // 직접 지정이면서 값이 없는경우 상품 선택이 안되기 때문에 날짜무관으로 저장하고 프론트에서 다시 직접 지정으로 관리하기 위해 존재
                    self_select_created_yn : "N",
                    event_item_created_start_date: null,
                    event_item_created_end_date: null,
					event_item_analysis_period: "4",

                    product_rp_category_list_1: [...first_category_list],
                    product_rp_category_list_2:[],
                    product_rp_category_list_3:[],
                    product_rp_category_list_4:[],

                    product_rp_category_no_1: "",
                    product_rp_category_no_2: "",
                    product_rp_category_no_3: "",
                    product_rp_category_no_4: "",

                    product_keyword_list:[""],
                    product_except_keyword_list:[""],
                    color_list: [],

                    self_select_area_checked : none_modified ? true : false,

                    // 숨긴카테고리 등록상품 자동 제외여부
                    is_except_invisible_category : "N",

                    event_item_condition_list : [
                        "A2999",
                        "A2999"
                    ],

                    uuid: StringUtil.generateUUID(),
                    detail_filter_expand_check: false,
                    item_select_type_start_idx: 1, 
                    past_order_sort_type: "1",

                    // 제외 카테고리
                    product_rp_except_category_no_list: product_rp_except_category_no_list,
                    event_except_category_list: event_except_category_list,

                    // 메인분류 선택/제외
                    event_main_display_group: "",
                    event_except_main_display_group_list: [],
                });
                return false;
            }
        });
        if(none_modified){
            // 사용 가능한 첫번째 알고리즘으로 생성
            this.setState({
                list_self_select : list,
            }, () => {
                this.SumEventTotalItemSelectCnt();
            });
        } else{
            this.setState({
                list_self_select : list,
                left_is_modified : true,
            }, () => {
                this.SumEventTotalItemSelectCnt();
                this.onClickEventFolder(this.state.list_self_select.length-1);
            });
        }
    }

    /** 직접 지정 : 알고리즘 변경 (onClickOption)
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id(question_idx, answer_idx 포함)
    */
    onChangeSelfSelectListCd(text, value, id) {
        let idx = id.split("_")[4];

        let {list_self_select} = this.state;
        let list = _.cloneDeep(this.state.list_self_select);
        list[idx]["cd"] = value;

        this.setState({
            list_self_select : list,
            left_is_modified : true,
        });
    }

    /** 직접 지정 : 알고리즘 변경 (onClickOption)
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id(question_idx, answer_idx 포함)
    */
    onChangeSelfSelectListCdForce(text, value, id) {
        this.setState({
            force_logic : value,
            left_is_modified : true,
        });
    }

    /** 상품 선택 수 합계 구하기 */
    SumEventTotalItemSelectCnt(){
        let {list_self_select} = this.state;
        let event_total_item_select_cnt = 0;

        if( this.state.max_item_analysis == '1' ) {
        // Y값인 직접지정 영역을 활성화 시켜준다
            let showAlert = false;
            list_self_select.forEach(function(ele, idx){
                if( ele.cnt == '자동' ) {
                    showAlert = true;
                    ele.cnt = '0';
                }
                event_total_item_select_cnt += Number(ele.cnt);
            });
            if( showAlert == true ) {
                this.basicDialogSimpleInform("숫자는 자동에서 0개로 변경되었습니다.");
            }
        } else if( this.state.max_item_analysis == '2' ) {
            let total_ele_cnt = 0;
            let is_auto_cnt = false;
            list_self_select.forEach(function(ele, idx){
                if (ele.cnt == '자동') {
                    is_auto_cnt = true;
                } else {
                    total_ele_cnt+= Number(ele.cnt);
                }
            });
            if (total_ele_cnt > Number(this.state.max_item_analysis_value)) {
                event_total_item_select_cnt = Number(this.state.max_item_analysis_value);
            } else {
                if (is_auto_cnt == true) {
                    event_total_item_select_cnt = Number(this.state.max_item_analysis_value);
                } else {
                    event_total_item_select_cnt = total_ele_cnt;
                }
            }
        } else {
            let total_ele_cnt = 0;
            list_self_select.forEach(function(ele, idx){
                total_ele_cnt+= Number(ele.cnt);
            });
            if (this.state.force_use_yn != "Y") {
                if (Number(this.state.max_item_analysis_value) > total_ele_cnt) {
                    event_total_item_select_cnt = total_ele_cnt;
                } else {
                    event_total_item_select_cnt = Number(this.state.max_item_analysis_value);
                }
            } else {
                event_total_item_select_cnt = Number(this.state.max_item_analysis_value);
            }
        }
        
        this.setState({
            event_total_item_select_cnt : event_total_item_select_cnt,
        }, () => {
            if (this.state.auto_create_yn === "Y" && this.state.event_total_item_select_cnt > flagCafe24BulkConversionProductCount) {
                const {event_cycle_type} = this.state;
                this.setState({
                    event_cycle_type: event_cycle_type == "A8003" ? "A8001" : event_cycle_type,
                    event_time: "3"
                })
            }
        });
    }

    /** 강제 상품 설정 카테고리 변경 (onClickOption)
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id(question_idx, answer_idx 포함)
    */
     onChangeForceCategory = (text, value, id) => {
        const current_category = id.split('/')[1];
        const depth = Number(current_category) + 1; // Number(current_category.split('_')[4])+1;
        var category_name = "product_rp_category_no_"+(Number(depth)-1);
        let {force_category} = this.state;
        var event_category_list;
            
        // 전체상품을 선택한 경우, 대카테고리가 아니면 상위 카테고리 번호를 대표 카테고리 번호로 설정
        if((value==="전체상품" || value==="")){
            if(Number(depth)>2){
                const parent_category_no = force_category["product_rp_category_no_"+(Number(depth)-2)];
                event_category_list = parent_category_no;
            } else{ // 대카테고리인 경우 ""로 변경
                event_category_list = "";
            }
        }else{
            event_category_list = value;
        }
        force_category[category_name] = value;
        force_category["event_category_list"] = event_category_list;
        this.setState({
            force_category : force_category,
            left_is_modified : true,
        })

        // 세분류가 아니라면 하위카테고리 관련 작업을 진행
        if(depth < 5){

            // 선택한 카테고리의 자식 카테고리 목록을 불러온다
            if (value !=="전체상품" && value !=="") {
                this.loadProductCategory(value, depth, "force_category_list_", null);
            } else{
                var category_list = "force_category_list_"+depth;
                this.setState({ 
                    [category_list] : [],
                    force_category : force_category,
                    left_is_modified : true,
                });
            }

            // 선택한 카테고리의 하위 카테고리 리스트를 초기화 시킨다
            for(var idx = depth+1; idx <=4; idx++) {
                var category_list = "force_category_list_"+idx;
                this.setState({ 
                    [category_list] : [],
                    left_is_modified : true,
                });
            }

            // 선택한 카테고리 이후의 자식 카테고리 넘버를 초기화 시킨다
            for(var idx = depth; idx <=4; idx++) {
                var category_name = "product_rp_category_no_"+idx;
                force_category[category_name] = "";
                this.setState({
                    force_category : force_category,
                    left_is_modified : true,
                });
            }
        }
    }

    /** 상품 카테고리 변경 (onClickOption)
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id(question_idx, answer_idx 포함)
    */
    onChangeRpCategory = (text, value, id) => {
        const current_category = id.split('/')[0];
        const index = id.split('/')[1];
        const depth = Number(current_category.split('_')[4])+1;
        var category_name = "product_rp_category_no_"+(Number(depth)-1);
        let {list_self_select} = this.state;
        let list = _.cloneDeep(this.state.list_self_select);
        var event_category_list;
            
        // 전체상품을 선택한 경우, 대카테고리가 아니면 상위 카테고리 번호를 대표 카테고리 번호로 설정
        if((value=="전체상품" || value == "")){
            if(Number(depth)>2){
                const parent_category_no = list[index]["product_rp_category_no_"+(Number(depth)-2)];
                event_category_list = parent_category_no;
            } else{ // 대카테고리인 경우 ""로 변경
                event_category_list = "";
            }
        }else{
            event_category_list = value;
        }
        list[index][category_name] = value;
        list[index]["event_category_list"] = event_category_list;
        if(this.state.event_category_select_type=="34001"){
            this.setState({
                list_self_select : list,
                left_is_modified : true,
            })
        } else{
            this.setState({
                event_category_list : event_category_list,
                list_self_select : list,
                left_is_modified : true,
            })
        }

        // 세분류가 아니라면 하위카테고리 관련 작업을 진행
        if(depth < 5){

            // 선택한 카테고리의 자식 카테고리 목록을 불러온다
            if (value !="전체상품" && value !="") {
                this.loadProductCategory(value, depth, "product_rp_category_list_", index);
            } else{
                var category_list = "product_rp_category_list_"+depth;
                list[index][category_list] = [];
                this.setState({ list_self_select : list });
            }

            // 선택한 카테고리의 하위 카테고리 리스트를 초기화 시킨다
            for(var idx = depth+1; idx <=4; idx++) {
                var category_list = "product_rp_category_list_"+idx;
                list[index][category_list] = [];
                this.setState({ list_self_select : list});
            }

            // 선택한 카테고리 이후의 자식 카테고리 넘버를 초기화 시킨다
            for(var idx = depth; idx <=4; idx++) {
                var category_name = "product_rp_category_no_"+idx;
                list[index][category_name] = "";
                this.setState({
                    list_self_select : list,
                });
            }
        }
    }

    /** 관련 상품명 변경
     * @param {*} e
     * @param {*} idx 영역 idx 번호
     * @param {*} keyword_list 영역 키워드 리스트 idx 번호 product_keyword_list
    */
    onChangeEventItemProductKeyword = (e, idx, keyword_idx) => {
        let input_value = e.target.value;
        let {list_self_select} = this.state;
        list_self_select[idx]["product_keyword_list"][keyword_idx] = input_value;
        this.setState({
            list_self_select : list_self_select,
            left_is_modified : true,
        });
    }

    addEventItemProductKeyword = (idx,keyword_idx) => {
        let {list_self_select} = this.state;
        let keyword_list = list_self_select[idx]["product_keyword_list"];
        keyword_list = [...keyword_list.slice(0, keyword_idx+1), "", ...keyword_list.slice(keyword_idx+1)];
        list_self_select[idx]["product_keyword_list"] = [...keyword_list];
        this.setState({list_self_select : list_self_select});
    }

    delEventItemProductKeyword = (idx,keyword_idx) => {
        let {list_self_select} = this.state;
        let keyword_list = list_self_select[idx]["product_keyword_list"];
        keyword_list.splice(keyword_idx,1);
        list_self_select[idx]["product_keyword_list"] = [...keyword_list];
        this.setState({list_self_select : list_self_select});
    }

    /** 제외 키워드 변경
     * @param {*} e
     * @param {*} idx 영역 idx 번호
     * @param {*} keyword_list 영역 키워드 리스트 idx 번호 product_except_keyword_list
    */
    onChangeEventItemProductExceptKeyword = (e, idx, keyword_idx) => {
        let input_value = e.target.value;
        let {list_self_select} = this.state;
        list_self_select[idx]["product_except_keyword_list"][keyword_idx] = input_value;
        this.setState({
            list_self_select : list_self_select,
            left_is_modified : true,
        });
    }

    addEventItemProductExceptKeyword = (idx,keyword_idx) => {
        let {list_self_select} = this.state;
        let keyword_list = list_self_select[idx]["product_except_keyword_list"];
        keyword_list = [...keyword_list.slice(0, keyword_idx+1), "", ...keyword_list.slice(keyword_idx+1)];
        list_self_select[idx]["product_except_keyword_list"] = [...keyword_list];
        this.setState({list_self_select : list_self_select});
    }

    delEventItemProductExceptKeyword = (idx,keyword_idx) => {
        let {list_self_select} = this.state;
        let keyword_list = list_self_select[idx]["product_except_keyword_list"];
        keyword_list.splice(keyword_idx,1);
        list_self_select[idx]["product_except_keyword_list"] = [...keyword_list];
        this.setState({list_self_select : list_self_select});
    }

     /** 번 상품부터 진열 선택
     * @param {*} e <e.target.name : item_select_type_start_idx>
     * @param {*} idx 영역 idx 번호
    */
     onChangeEventItemSelectTypeStartIdx(e, idx){
        let input_value = StringUtil.inputOnlyNumberFormat(e.target.value);
        
        // 입력값이 1 미만인 경우 빈 문자열로 변경
        if (parseInt(input_value, 10) < 1) {
            input_value = ""; // 1 미만이면 초기화
        }

        let {list_self_select} = this.state;
        list_self_select[idx][e.target.name] = input_value;
        this.setState({
            list_self_select : list_self_select,
            left_is_modified : true,
        });
    }

    /** 판매가 변경
     * @param {*} e <e.target.name : min_price or max_price>
     * @param {*} idx 영역 idx 번호
    */
    onChangeEventItemPrice(e, idx, max_value, allowNegative){
        let input_value = "";
        if (allowNegative == true) {
            input_value = StringUtil.inputSignedNumberFormat(e.target.value, max_value);
            console.log("input_value_1", input_value);
        } else {
            input_value = StringUtil.inputOnlyNumberFormat(e.target.value, max_value);
            console.log("input_value_2", input_value);
        }
        if(input_value.length > 9){input_value = input_value.slice(0, 9);}
        let {list_self_select} = this.state;
        list_self_select[idx][e.target.name] = input_value;
        this.setState({
            list_self_select : list_self_select,
            left_is_modified : true,
        });
    }

    /** 알고리즘 분석 기간 변경 (onClickOption)
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id
    */
    onChangeEventItemConditionPeried(text, value, id){
        const idx = id.split('_')[1];
        let {list_self_select} = this.state;
        list_self_select[idx]["event_item_condition_period"] = value;
        this.setState({
            list_self_select : list_self_select,
            left_is_modified : true,
        });
    }

    /** 알고리즘 분석 기간 변경 (onClickOption)
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id
    */
    onChangeEventItemAnalysisPeried(text, value, id){
        const idx = id.split('_')[1];
        let {list_self_select} = this.state;
        list_self_select[idx]["event_item_analysis_period"] = value;
        this.setState({
            list_self_select : list_self_select,
            left_is_modified : true,
        });
    }

    /** 데이터 분석 기간 변경 (onClickOption)
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id
    */
    onChangeEventItemAnalysisPeriedForce(text, value, id){
        this.setState({
            force_analysis_period : value,
        });
    }

    /** 최종 상품 순서 (onClickOption)
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id
    */
    onChangeTotalSortType(text, value, id){
        this.setState({
            total_sort_type : value,
        });
    }

    /** 진열 최대 개수 설정 변경 (onClickOption)
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id
    */
    onChangeMaxItemAnalysis(text, value, id){
        this.setState({
            max_item_analysis : value,
        }, () => {
            this.SumEventTotalItemSelectCnt();
            this.countTotalItemSelectCntRange();
        });
    }

    /** 진열 최대 개수 변경 (onClickOption)
     * @param {*} e <e.target.name : min_price or max_price>
    */
    onChangeMaxItemAnalysisValue(e){
        let input_value = StringUtil.inputOnlyNumberFormat(e.target.value);
        if(input_value.length > 4){input_value = input_value.slice(0, 4);}
        this.setState({
            max_item_analysis_value : input_value,
        }, () => {
            this.SumEventTotalItemSelectCnt();
        });
    }

    /** 상품등록일 기준 변경 변경 (onClickOption)
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} idx 셀렉트 박스 idx
    */
    onChangeEventItemCreatedPeriod(value, idx){
        let {list_self_select} = this.state;
        // 변경전 값이 직접 지정이라면, 날짜값을 비우고 변경한다
        if(value != '-1' && list_self_select[idx]["self_select_created_yn"] == 'Y'){
            list_self_select[idx].event_item_created_start_date = null;
            list_self_select[idx].event_item_created_end_date = null;
        }
        // 변경할 값에 따라 직접지정 여부 업데이트
        list_self_select[idx].self_select_created_yn = (value == '-1' ? "Y" : "N");

        // 값과 타입의 구분자인 '/'가 없는 경우는 0으로 취급 (-1 : 직접 지정, 0 : 날짜 무관)
        let [period_value, period_type] = value == "-999" // -999를 고르면, 무조건 날짜 무관(0) 값으로 전환
                                        ? [0, '']
                                        : String(value).includes('/') ? value.split('/') : [0,'w'];
        
        list_self_select[idx]["event_item_created_period"] = period_value;
        list_self_select[idx]["event_item_created_period_type"] = period_type;
        this.setState({
            list_self_select : list_self_select,
            left_is_modified : true,
        });
    }

    /** 상품등록일 기준 변경 변경 (onClickOption)
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} idx 셀렉트 박스 idx
    */
    onChangeEventItemCreatedPeriodForce(value){
        // 변경전 값이 직접 지정이라면, 날짜값을 비우고 변경한다
        if( value != '-1' && this.state.force_select_created_yn === 'Y' ){
            this.setState({
                force_created_start_date: null,
                force_created_end_date: null,
                left_is_modified : true,
            })
        }

        // 값과 타입의 구분자인 '/'가 없는 경우는 0으로 취급 (-1 : 직접 지정, 0 : 날짜 무관)
        let [period_value, period_type] = value == "-999" // -999를 고르면, 무조건 날짜 무관(0) 값으로 전환
                                        ? [0, '']
                                        : String(value).includes('/') ? value.split('/') : [0,'w'];

        // 변경할 값에 따라 직접지정 여부 업데이트
        this.setState({
            force_select_created_yn: (value == '-1' ? "Y" : "N"),
            force_created_period: period_value,
            force_created_period_type: period_type,
            left_is_modified : true,
        })
    }

    /**
    * 과거 주문 날짜 사용 여부
    * @param {*} idx 알고리즘 idx
    * @param {*} value 선택된 option 값
    */
    onChangePastOrderDateUseYn(idx, value){
        let {list_self_select} = this.state;
        list_self_select[idx]["past_order_date_use_yn"] = value;
        if (value == "Y") {
            // 시작일, 종료일 값이 없는 경우에 초기화
            if (!list_self_select[idx]["past_order_start_date_type"]) {
                list_self_select[idx]["past_order_start_date_type"] = "-1";
            }
            if (!list_self_select[idx]["past_order_end_date_type"]) {
                list_self_select[idx]["past_order_end_date_type"] = "-1";
            }
        } else {
            // 복합 알고리즘이 '과거 판매된 상품 순서대로'으로 선택 된 경우, '판매액 많은 순'으로 변경.
            if (list_self_select[idx]["cd"] == "-1") {
                list_self_select[idx]["cd"] = "22004"
            }
        }
        this.setState({
            list_self_select : list_self_select,
            left_is_modified : true,
        });
    }

    /**
    * 과거 주문 날짜 기준
    * @param {*} value 셀렉트 박스 선택된 option 값
    * @param {*} idx 셀렉트 박스 idx
    * @param {*} target_name 필드명
    */
    onChangePastOrderType(value, idx, target_name){
        let {list_self_select} = this.state;
        list_self_select[idx][target_name] = value;
        this.setState({
            list_self_select : list_self_select,
            left_is_modified : true,
        });
    }

    /** 상품등록일 기준 시작 날짜 변경
     * @param {*} date 선택한 날짜
     * @param {*} idx 리스트 내 idx 번호
    */
    onChangeSelectStartDate = (date, idx) => {
        let {list_self_select} = this.state;
        list_self_select[idx].event_item_created_start_date = date;
        this.setState({
            list_self_select: list_self_select,
            left_is_modified : true,
        }, () => {
            let {list_self_select} = this.state;
            // 변경된 시작 날짜가 종료날짜보다 크면, 시작날짜 값을 종료날짜에도 넣어준다
            if(list_self_select[idx].event_item_created_end_date!= null && list_self_select[idx].event_item_created_end_date !='' && new Date(list_self_select[idx].event_item_created_start_date) > new Date(list_self_select[idx].event_item_created_end_date)){
                list_self_select[idx].event_item_created_end_date = list_self_select[idx].event_item_created_start_date;
                this.setState({
                    list_self_select: list_self_select,
                });
            }
        });
    };

    /** 상품등록일 기준 시작 날짜 변경
     * @param {*} date 선택한 날짜
     * @param {*} idx 리스트 내 idx 번호
    */
    onChangeSelectStartDateForce = (date) => {
        this.setState({
            force_created_start_date: date,
        }, () => {
            let {list_self_select} = this.state;
            // 변경된 시작 날짜가 종료날짜보다 크면, 시작날짜 값을 종료날짜에도 넣어준다
            if( this.state.force_created_end_date !== null && this.state.force_created_end_date !=='' && new Date(this.state.force_created_start_date) > new Date(this.state.force_created_end_date) ){
                this.setState({
                    force_created_end_date: this.state.force_created_start_date,
                    left_is_modified : true,
                });
            }
        });
    };

    /** 상품등록일 기준 종료 날짜 변경
     * @param {*} date 선택한 날짜
     * @param {*} idx 리스트 내 idx 번호
    */
    onChangeSelectEndDate = (date, idx) => {
        let {list_self_select} = this.state;
        list_self_select[idx].event_item_created_end_date = date;
        this.setState({
            list_self_select: list_self_select,
            left_is_modified : true,
        });
    };

    /** 상품등록일 기준 종료 날짜 변경
     * @param {*} date 선택한 날짜
     * @param {*} idx 리스트 내 idx 번호
    */
    onChangeSelectEndDateForce = (date) => {
        this.setState({
            force_created_end_date: date,
            left_is_modified : true,
        });
    };

    /** 상품 선택 수 값 변경 : input
     * @param {*} e <e.target.value : 상품 선택 수 값>
     * @param {*} idx 영역 idx 번호
     * @param {*} onBlur blur가 된 경우
    */
    onChangeEventTotalItemSelectCntInput(e, idx, onBlur) {
        const {list_self_select} = this.state;

        // 값이 없는데 blur가 실행되면 0으로 설정
        if(onBlur && (e.target.value == null || e.target.value=="")){
            list_self_select[idx]["cnt"] = "0";
            this.setState({
                list_self_select : list_self_select
            }, () => {
                this.SumEventTotalItemSelectCnt();
            });
            return;
        }

        let input_value = StringUtil.inputOnlyNumberFormat(e.target.value);
        list_self_select[idx]["cnt"] = input_value;
        this.setState({
            list_self_select : list_self_select,
            left_is_modified : true,
        }, () => {
            this.SumEventTotalItemSelectCnt();
        });

        if (this.state.auto_create_yn === "Y" && input_value > flagCafe24BulkConversionProductCount) {
            const {event_cycle_type} = this.state;
            this.setState({
                event_cycle_type: event_cycle_type == "A8003" ? "A8001" : event_cycle_type,
                event_time: "3"
            })
        }
    }

    /** 상품 선택 수 값 변경 : select (onClickOption)
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id(question_idx, answer_idx 포함)
    */
    onChangeEventTotalItemSelectCntSelect(text, value, id){
        const idx = id.split('_')[1];
        const {list_self_select} = this.state;
        list_self_select[idx]["cnt"] = value;
        this.setState({
            list_self_select : list_self_select,
            left_is_modified : true,
        }, () => {
            this.SumEventTotalItemSelectCnt();
        });
    }

    /** 자동 진열 일정관리 사용 여부 변경 */
    onChangeAutoCreateYn(e){
        if(e.target.value === "Y") {
            if(this.state.is_main_auto_display_use || this.state.is_category_auto_display_use) {
                this.autoDisplayWarningDialoog();
                // return false;
            }
            if(this.state.iframe_page_id=='robomd_cafe24_main_page' && this.state.cafe24_main_page_over_product){
                alert("진열 되어있는 상품 수가 "+cafe24_main_page_max_product_num+"개를 넘겼습니다.\ncafe24 관리자에서 상품 수를 "+cafe24_main_page_max_product_num+"개 이하로 수정 후 사용해 주세요.");
                return false;
            }
            if (this.state.event_total_item_select_cnt > flagCafe24BulkConversionProductCount) {
                const {event_cycle_type} = this.state;
                this.setState({
                    event_cycle_type: event_cycle_type == "A8003" ? "A8001" : event_cycle_type,
                    event_cycle: "2",
                    event_time: "3",
                })
            } else {
                this.setState({
                    event_cycle: "2",
                    event_time: "7",
                })
            }
        } else {
            this.setState({
                event_cycle: "",
                event_time: "-1"
            })
        }
        this.setState({
            auto_create_yn : e.target.value,
            left_is_modified : true,
        });
    }

    /** 강제 알고리즘 사용 여부 변경 */
    onChangeForceUseYn(e){
        this.setState({
            force_use_yn : e.target.value,
            left_is_modified : true,
        }, () => {
            this.SumEventTotalItemSelectCnt();
        });
    }

    /** 자동 진열 일정관리 날짜 변경(주기) (onClickOption)
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id(question_idx, answer_idx 포함)
    */
    onChangeEventCycle(text, value, id){
        this.setState({
            event_cycle : value,
            left_is_modified : true,
        });
    }

    /** 자동 진열 일정관리 시간 변경 (onClickOption)
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id(question_idx, answer_idx 포함)
    */
    onChangeEventTime(text, value, id){
        this.setState({
            event_time : value,
            left_is_modified : true, // event_start_hour
        });
    }
    
    onChangeRealEventStartHour(text, value, id){
        this.setState({
            real_time_start_hour : value,
            left_is_modified : true, // event_start_hour
        });
    }

    onChangeRealEventEndHour(text, value, id){
        this.setState({
            real_time_end_hour : value,
            left_is_modified : true, // event_start_hour
        });
    }

    /** 왼쪽 영역 저장 버튼 클릭 */
    async onClickSaveLeftSetting(){
        const pageStatus = this.getPageStatus();

        // 메인 진열의 경우
        // if(this.state.iframe_page_id == "robomd_cafe24_main_page"){
        //     if (this.state.is_main_auto_display_use) {
        //         this.setState({
        //             warning_state: true,
        //             warning_message: "로보MD를 이용하시려면<br/>카페24 자동진열을 해제후 사용해주세요."
        //         })
        //         return false;
        //     }
        // }
        
        // 카테고리 진열의 경우
        // if(this.state.iframe_page_id == "robomd_cafe24_category_page"){
        //     if (this.state.is_category_auto_display_use) {
        //         this.setState({
        //             warning_state: true,
        //             warning_message: "로보MD를 이용하시려면<br/>추천상품/신상품의 카페24 자동진열을<br/>모두 해제후 사용해주세요."
        //         })
        //         return false;
        //     }
        // }

        /** 덮어쓰기일 경우 & 신규저장일때 먼저 체크. */
        /** basic_dialog <-> title_content_dialog */
        if (this.state.cafe24_category_display_type === "1") {
            await new Promise((resolve, reject) => {
                this.titleContentDialogOverwrite((result) => {
                    if (result) {
                        resolve();
                    } else {
                        reject();   
                    }
                });
            })
        }

        const {event_total_item_select_cnt, total_item_select_cnt_range, iframe_html_name} = this.state;
        const range = total_item_select_cnt_range.indexOf("자동") >= 0 ? total_item_select_cnt_range.length-2 : total_item_select_cnt_range.length-1;
        const iframe_html_name_check = iframe_html_name.replaceAll(' ','').length;
        // 상품 선택 수가 범위를 넘었다면 저장하지말고, 다이얼로그를 띄운다.
        if (event_total_item_select_cnt > range){
            this.basicDialogTotalCount()
        } else if (!this.checkEssentialProductCnt()) {
            // 상품 선택 수가 필수 상품의 개수보다 큰 알고리즘이 있는지 체크
            this.warningDialogEssentialProductCnt();
        } 
        // else if (this.state.max_item_analysis != "1" && this.totalEssentialProductCnt() > this.state.max_item_analysis_value) {
        //     // 상품 최대 개수가 총 필수 상품 개수 보다 작은지 체크
        //     this.warningDialogEssentialProductCnt("최대 상품 선택 수는 필수 상품의 총 개수보다 커야 합니다.");
        // } 
        else if(iframe_html_name_check <= 0){
            // 관리자 진열 제목이 공백이라면 관리자 진열 제목을 작성해달라고 한다.
            this.basicDialogNeedDisplayName()
        } else if(this.state.iframe_page_id == "robomd_cafe24_category_page" && this.state.cafe24_category_list_1.length == 0){
            // 상품분류(카테고리)가 없는 경우
            this.basicDialogNeedCategory()
        } else if (this.state.event_total_item_select_cnt > 100 && this.state.auto_create_yn === "Y" && !this.state.iframe_html_id){
            /** 상품선택 100개 이상, 자동 진열일시 & 최초저장일때만 경고창. */
            this.titleContentDialogSaveOver100Algorithm()
        } 
        else if (!this.validateCheckForautoCreateY()) {
            /** 반복관리 필수값 체크 */
        } 
        else if (!this.validateCheckForautoCreateN()) {
            /** 예약관리 필수값 체크 */
        }
        else{
            this.saveListSetting();
        }
    }

    validateCheckForautoCreateY() {
        if (this.state.auto_create_yn == "Y") {
            const firstSave = !this.state.iframe_html_id;
            if (this.state.event_cycle_type == "A8001") {
                // if (firstSave) {
                    // 시작시간 입력 여부 체크
                    if (!this.state.event_start_date) {
                        this.basicDialogNeedStartDate();
                        return false;
                    }
                // }
            }
            if (this.state.event_cycle_type == "A8002") {
                // if (firstSave) {
                    // 시작시간 입력 여부 체크
                    if (!this.state.event_start_date) {
                        this.basicDialogNeedStartDate();
                        return false;
                    }
                // }
    
                /* 요일 */
                const {weekday_list} = this.state;
                const weekdat_list_2 = weekday_list.replace("-1,", "");
                if (weekday_list != null) {
                    let array_weekday_list = weekdat_list_2 ? weekdat_list_2.split(",") : [];
                    if (array_weekday_list.length == 0) {
                        this.basicDialogNeedWeekDay();
                        return false;
                    }
                } else {
                    this.basicDialogNeedWeekDay();
                    return false;
                }
    
            }
            if (this.state.event_cycle_type == "A8003") {
                // if (firstSave) {
                    // 시작시간 입력 여부 체크
                    if (!this.state.event_start_date) {
                        this.basicDialogNeedStartDate();
                        return false;
                    }
                // }
    
                /* 요일 */
                const {weekday_list} = this.state;
                const weekdat_list_2 = weekday_list.replace("-1,", "");
                if (weekday_list != null) {
                    let array_weekday_list = weekdat_list_2 ? weekdat_list_2.split(",") : [];
                    if (array_weekday_list.length == 0) {
                        this.basicDialogNeedWeekDay();
                        return false;
                    }
                } else {
                    this.basicDialogNeedWeekDay();
                    return false;
                }
            }
        } 
        return true;
    }

    validateCheckForautoCreateN() {
        if (this.state.auto_create_yn == "N") {
            const {reservation_use_yn} = this.state;
            if (reservation_use_yn == "Y") {
                if (!this.state.reservation_date) {
                    this.basicDialogNeedReservationDate();
                    return false;
                }
                if (!this.state.reservation_hour) {
                    this.basicDialogNeedReservationHour();
                    return false;
                }
            }
        }
        return true;
    }

    /* ---------------------------------- 자동 진열된 상품 목록 팝업 관련 함수 --------------------------------------- */

    /** 상품 선택 수가  필수 상품의 개수보다 큰 알고리즘이 있는지 체크 */
    checkEssentialProductCnt() {
        const {list_self_select} = this.state
        for (let list_self_select_index in list_self_select) {
            if ((list_self_select[list_self_select_index]["essential_product_no_list"] 
                ? list_self_select[list_self_select_index]["essential_product_no_list"].length  
                : 0) > list_self_select[list_self_select_index]["cnt"]) {
                    this.warningDialogEssentialProductCnt();
                    return false;
                }
        }
        return true;
    }

    /** 등록된 필수 상품이 있는데, 상품 선택 수가 '자동'인 경우  */
    checkEssentialProductAutoCnt() {
        const {list_self_select} = this.state
        for (let list_self_select_index in list_self_select) {
            if (list_self_select[list_self_select_index]["essential_product_no_list"] 
                && list_self_select[list_self_select_index]["essential_product_no_list"].length > 0
                && list_self_select[list_self_select_index]["cnt"] == '자동') {
                return false;
            }
        }
        return true;
    }

    /** 미리보기 덮어쓰기 버튼 */
    onClickOverWritePreview(firstSave){
        if (this.getPageStatus() == "init") {
            this.basicDialogNeedSave();
            return false;
        }

        // 상품 선택 수가 필수 상품의 개수보다 큰 알고리즘이 있는지 체크
        if (!this.checkEssentialProductCnt()) {
            this.warningDialogEssentialProductCnt();
            return false;
        }
        // 등록된 필수 상품이 있는데, 상품 선택 수가 '자동'인 경우
        if (!this.checkEssentialProductAutoCnt()) {
            this.warningDialogEssentialProductCnt("고정 상품이 설정되어 있는경우, 상품 선택 수는 ‘자동’으로 할 수 없습니다.");
            return false;
        }
        // 상품 최대 개수가 총 필수 상품 개수 보다 작은지 체크
        // if (this.state.max_item_analysis != "1" && this.totalEssentialProductCnt() > this.state.max_item_analysis_value) {
        //     this.warningDialogEssentialProductCnt("최대 상품 선택 수는 필수 상품의 총 개수보다 커야 합니다.");
        //     return false;
        // }

        this.setState({
            show_add_product_popup : false, // 상품 추가 팝업 닫기
            show_exclude_product_list_popup : false, // 제외 상품 팝업 닫기
            show_except_setting_popup : false, // 진열 간 상품 중복 제외 팝업 닫기
            show_self_except_setting_popup : false, // 셀프 진열 간 상품 중복 제외 팝업 닫기
            show_except_product_popup: false,
            show_essential_product_list_popup: false, // 필수 상품 설정 팝업 닫기
            event_product_checked_list : [],
        }, () => {
          /** 덮어쓰기 여부 경고 다이얼로그 */
          this.titleContentDialogAlertOverwritePreview(firstSave)
        });
    }

     /** 선택된 상품목록 이벤트 생성 : 직접 지정 */
     loadSelfEventProductList() {
        this.setState({
            show_rp_product_list_table_loading_bar : true,
            event_rp_product_list : [],
        });

        this.getProductsByAlgorithm()
        .then(res => {
            if (res.data.code == "200") {
              this.setState({
                event_rp_product_list: res.data["list"],
                show_rp_product_list_table_loading_bar: false
              }, () => {
                const {cafe24_main_product_list, cafe24_category_product_list} = this.state;
                let product_list = [];
                // 카페24 메인 진열인 경우, 해당 상품목록 불러오기
                if(this.state.iframe_page_id == "robomd_cafe24_main_page"){
                    product_list = JSON.parse(JSON.stringify(cafe24_main_product_list));
                }
                else if(this.state.iframe_page_id === "robomd_cafe24_category_page"){
                    product_list = JSON.parse(JSON.stringify(cafe24_category_product_list));
                }
                this.orderIdxReset()
  
                let product_no_list = new Set(product_list.map(obj => obj.product_no));
                let event_product_checked_list = this.state.event_rp_product_list.filter(obj => product_no_list.has(obj.product_no));
                this.setState({
                    event_product_checked_list : event_product_checked_list,
                    show_rp_product_list_table_loading_bar: false
                });
              })
            } else {
              throw new Error()
            }
          })
          .catch(err => {
            console.log(err)
            alert("상품 선택에 실패하였습니다.")
            
            this.setState({event_rp_product_list: []})
          })
    }

    /** 알고리즘 기반 상품목록 요청 */
    getProductsByAlgorithm = async () => {
        let list_self_select = _.cloneDeep(this.state.list_self_select);;
        for(var i=0;i<list_self_select.length;i++){
            if(list_self_select[i].event_item_created_start_date != null && list_self_select[i].event_item_created_start_date != ""){
                list_self_select[i].event_item_created_start_date = StringUtil.dateFormater(list_self_select[i].event_item_created_start_date);
            }
            if(list_self_select[i].event_item_created_end_date != null && list_self_select[i].event_item_created_end_date != ""){
                list_self_select[i].event_item_created_end_date = StringUtil.dateFormater(list_self_select[i].event_item_created_end_date);
            }
            if( list_self_select[i].cnt == '자동' ) {
                list_self_select[i].cnt = -1;
            }

            let color_list = list_self_select[i].color_list.map(obj => obj.color_seq);
            list_self_select[i].color_seq_list = color_list;
            delete list_self_select[i].color_list;

            delete list_self_select[i].force_use_yn;
            delete list_self_select[i].force_logic;
            delete list_self_select[i].force_category;
            delete list_self_select[i].force_auto_remove;
            delete list_self_select[i].force_analysis_period;
            delete list_self_select[i].force_select_created_yn;
            delete list_self_select[i].force_created_period_type;
            delete list_self_select[i].force_created_period;
            delete list_self_select[i].force_created_start_date;
            delete list_self_select[i].force_created_end_date;
            delete list_self_select[i].force_is_except_invisible_category;
            delete list_self_select[i].max_item_analysis;
            delete list_self_select[i].max_item_analysis_value;
            delete list_self_select[i].total_sort_type;
        }

        let last_select_index = list_self_select.length-1;
        list_self_select[last_select_index].force_use_yn = this.state.force_use_yn;
        list_self_select[last_select_index].force_logic = this.state.force_logic;
        list_self_select[last_select_index].force_category = this.state.force_category;
        list_self_select[last_select_index].force_auto_remove = this.state.force_auto_remove;
        list_self_select[last_select_index].force_analysis_period = this.state.force_analysis_period;
        list_self_select[last_select_index].force_select_created_yn = this.state.force_select_created_yn;
        list_self_select[last_select_index].force_created_period_type = this.state.force_created_period_type;
        list_self_select[last_select_index].force_created_period = this.state.force_created_period;
        list_self_select[last_select_index].force_created_start_date = StringUtil.dateFormater(this.state.force_created_start_date);
        list_self_select[last_select_index].force_created_end_date = StringUtil.dateFormater(this.state.force_created_end_date);
        list_self_select[last_select_index].force_is_except_invisible_category = this.state.force_is_except_invisible_category;
        list_self_select[last_select_index].max_item_analysis = this.state.max_item_analysis;
        list_self_select[last_select_index].max_item_analysis_value = this.state.max_item_analysis_value;
        list_self_select[last_select_index].total_sort_type = this.state.total_sort_type;
      /** 알고리즘으로 상품목록 호출시 해당 상품목록의 출처를 위해 auto_yn 을 N으로 설정. */
      this.setState({
        event_rp_product_list_created: moment.utc(new Date()).local().format('YYYY년 MM월 DD일 HH시 mm분 ss초'),
        event_rp_product_list_yn: "N"
      })
      
      return APIs.rp.getProductsByAlgorithmV5({
        user_seq: this.state.user_seq, 
        shop_no: this.state.shop_no,
        create_type_cd : "22998",
        row_cnt : this.state.event_total_item_select_cnt,
        iframe_page_id : this.state.iframe_page_id,
        iframe_html_id : this.state.iframe_html_id,
        event_category_list : this.state.event_category_list,
        list_self_select : list_self_select,
        event_item_price_filter_yn : "Y",
        order_gubun : this.state.event_order_gubun,
        order_type : this.state.event_order_type,
      })
    }

/** 미리보기 하단 추가 */
onClickAddPlusAtCurrentProducts(){
    if (this.getPageStatus() == "init") {
        this.basicDialogNeedSave();
        return false;
    }

    // 상품 선택 수가 필수 상품의 개수보다 큰 알고리즘이 있는지 체크
    if (!this.checkEssentialProductCnt()) {
        this.warningDialogEssentialProductCnt();
        return false;
    }
    // 상품 최대 개수가 총 필수 상품 개수 보다 작은지 체크
    // if (this.state.max_item_analysis != "1" && this.totalEssentialProductCnt() > this.state.max_item_analysis_value) {
    //     this.warningDialogEssentialProductCnt("최대 상품 선택 수는 필수 상품의 총 개수보다 커야 합니다.");
    //     return false;
    // }
    // 등록된 필수 상품이 있는데, 상품 선택 수가 '자동'인 경우
    if (!this.checkEssentialProductAutoCnt()) {
        this.warningDialogEssentialProductCnt("고정 상품이 설정되어 있는경우, 상품 선택 수는 ‘자동’으로 할 수 없습니다.");
        return false;
    }

    this.setState({
      show_rp_product_list_table_loading_bar : true,
      title_content_dialog_show_state: false,
      is_loading_add_below_product : true,
    });


    this.getProductsByAlgorithm()
    .then(res => {
      if (res.data.code == "200") {
          /** 
           * 겹치는것이 있을경우에
           * 1. 완전히 같을 경우엔 다이얼로그 표시.
           * 2. 일부 같을 경우 해당 품목을 제외한 나머지 새 품목들을 하단추가.
           * */
          /** 완전히 같을 경우 */
          if (JSON.stringify(this.state.event_rp_product_list.map(f => {return f.product_no})) === JSON.stringify(res.data["list"].map(f=> {return f.product_no}))) {
              this.basicDialogSimpleInform("기존 상품 목록과 동일합니다.")
          } else {
              const productMap = new Map();
              [...this.state.event_rp_product_list, ...res.data["list"]].forEach(product => {
                  if (!productMap.has(product.product_no)) productMap.set(product.product_no, product);
              });

              /** 별도의 알고리즘을 통해 나온 결과물들은 독립적인 order_no 를 가지고 있어 재정렬. */
              const result = Array.from(productMap.values()).map((f,i) => {return {...f, order_no: i+1}});
              this.setState({
                event_rp_product_list: result,
              }, async () => {
                /** 통계 수치 분석 기간 데이터로 다시 적용하기 */
                await this.reloadProductByAnalysisStandard("event_rp_product_list", this.state.event_rp_product_list, this.state.analysis_standard_value);

                /** 고정 상품 체크 */
                this.loadFixedProductList();
              })
          }

          this.setState({
            show_rp_product_list_table_loading_bar: false,
            is_loading_add_below_product : false
        }, () => {this.orderIdxReset()})
      } else {
        throw new Error()
      }
    })
    .catch(err => {
      console.log(err)
      alert("상품 선택에 실패하였습니다.")
      
      this.setState({
          event_rp_product_list: [],
          show_rp_product_list_table_loading_bar: false,
          is_loading_add_below_product : false
      })
    })
    
  }

    /** 정렬 기준이 변경될때 실행되는 함수 (onClickOption)
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id(question_idx, answer_idx 포함)
    */
    onChangeEventOrderGubun(text, value, id){
        const org_value = value;

        if(value == "org"){
            value = "";
        }
        const order_data = value.split("/");

        this.setState({
            select_event_order_gubun_type : org_value,
            event_order_gubun : order_data[0],
            event_order_type : order_data[1],
        }, () => {
            this.loadSelfEventProductList();
        })
    }

    /** 선택된 상품목록 팝업 전체 체크
     * @param {*} e 전체 체크 상태
    */
    onChangeEventProductListCheckAll(e){
        if(e.target.checked == true){
            this.setState({
                event_product_checked_list: JSON.parse(JSON.stringify(this.state.event_rp_product_list)),
            })
        }
        else{
            const {cafe24_main_product_list, cafe24_category_product_list} = this.state;
            let product_list = [];
            // 카페24 메인 진열인 경우, 해당 상품목록 불러오기
            if(this.state.iframe_page_id == "robomd_cafe24_main_page"){
                product_list = JSON.parse(JSON.stringify(cafe24_main_product_list));
            }
            else if(this.state.iframe_page_id === "robomd_cafe24_category_page"){
                // product_list = JSON.parse(JSON.stringify(cafe24_category_product_list));
            }

            let product_no_list = new Set(product_list.map(obj => obj.product_no));
            let event_product_checked_list = this.state.event_rp_product_list.filter(obj => product_no_list.has(obj.product_no));
            this.setState({
                event_product_checked_list : event_product_checked_list,
            });
        }
    }

    /** 선택된 상품목록 팝업 체크
     * @param {*} e 체크 상태
     * @param {*} idx 체크된 idx 번호
    */
    onChangeEventProductListCheck(e){
        let idx = e.target.value;
        if (!e.currentTarget.checked) {
            const {event_rp_product_list, event_product_checked_list} = this.state;
            
            for(var idx2 in event_product_checked_list) {
                if (event_product_checked_list[idx2].product_no == event_rp_product_list[idx].product_no) {
                    idx = idx2;
                    break;
                }
            }

            var event_product_checked_list_copy = JSON.parse(JSON.stringify(event_product_checked_list));
            event_product_checked_list_copy.splice(idx, 1);
            
            this.setState({
                event_product_checked_list: event_product_checked_list_copy,
            })
        } else {
            const {event_rp_product_list, event_product_checked_list} = this.state;
            event_product_checked_list.push(event_rp_product_list[idx])
            this.setState({
                event_product_checked_list: event_product_checked_list,
            })
        }
    }

    /** 선택된 상품목록 적용하기 버튼 클릭 */
    onClickRpProductListPaste(copy){
        let pasteAction = function(this_component){
            const {event_rp_product_list, cafe24_main_product_list} = this_component.state;

            let fixed_sort_list = cafe24_main_product_list.filter(obj => obj.fixed_sort);
            let fixed_sort_no_list = fixed_sort_list.map(obj => obj.product_no);

            let product_list = event_rp_product_list.map(obj => ({...obj, iframe_page_id: this_component.state.iframe_page_id, iframe_html_id:this_component.state.iframe_html_id}));
            product_list = product_list.filter((obj) => fixed_sort_no_list.indexOf(obj.product_no) == -1)

            // 카페24 메인 진열인 경우, 해당 상품목록 적용
            if(this_component.state.iframe_page_id == "robomd_cafe24_main_page"){
                this_component.setState({cafe24_main_product_list : [...product_list, ...fixed_sort_list]} , () => {
                    this_component.cafe24ProductFixedReorder("cafe24_main_product_list");
                });
            }
            this_component.setState({
                show_event_product_list_popup : false, // 선택된 상품목록 팝업 닫기
                show_rp_product_list_table_loading_bar : false,
                rp_check_product_list : [],
                event_rp_product_list : [],
                confirm_dialog_show_state: false,
                right_is_modified: true,
            }, () => {
                this_component.orderIdxReset();
            });
        };

        this.setState({
            title_content_dialog_show_state: true,
            title_content_dialog_title: "미리보기에 덮어쓰기 됩니다.<br/>적용 하시겠습니까?",
            title_content_dialog_button_list: [
                {
                    title: "네",
                    type: "1",
                    event_method: () => {
                        if(copy){
                            this.setState({
                                show_rp_product_list_table_loading_bar : true,
                                title_content_dialog_show_state: false,
                            });
                            let list_self_select = _.cloneDeep(this.state.list_self_select);;
                            for(var i=0;i<list_self_select.length;i++){
                                if(list_self_select[i].event_item_created_start_date != null && list_self_select[i].event_item_created_start_date != ""){
                                    list_self_select[i].event_item_created_start_date = StringUtil.dateFormater(list_self_select[i].event_item_created_start_date);
                                }
                                if(list_self_select[i].event_item_created_end_date != null && list_self_select[i].event_item_created_end_date != ""){
                                    list_self_select[i].event_item_created_end_date = StringUtil.dateFormater(list_self_select[i].event_item_created_end_date);
                                }

                                let color_list = list_self_select[i].color_list.map(obj => obj.color_seq);
                                list_self_select[i].color_seq_list = color_list;
                                delete list_self_select[i].color_list;

                                delete list_self_select[i].force_use_yn;
                                delete list_self_select[i].force_logic;
                                delete list_self_select[i].force_category;
                                delete list_self_select[i].force_auto_remove;
                                delete list_self_select[i].force_analysis_period;
                                delete list_self_select[i].force_select_created_yn;
                                delete list_self_select[i].force_created_period_type;
                                delete list_self_select[i].force_created_period;
                                delete list_self_select[i].force_created_start_date;
                                delete list_self_select[i].force_created_end_date;
                                delete list_self_select[i].force_is_except_invisible_category;
                                delete list_self_select[i].max_item_analysis;
                                delete list_self_select[i].max_item_analysis_value;
                                delete list_self_select[i].total_sort_type;
                            }

                            let last_select_index = list_self_select.length-1;
                            list_self_select[last_select_index].force_use_yn = this.state.force_use_yn;
                            list_self_select[last_select_index].force_logic = this.state.force_logic;
                            list_self_select[last_select_index].force_category = this.state.force_category;
                            list_self_select[last_select_index].force_auto_remove = this.state.force_auto_remove;
                            list_self_select[last_select_index].force_analysis_period = this.state.force_analysis_period;
                            list_self_select[last_select_index].force_select_created_yn = this.state.force_select_created_yn;
                            list_self_select[last_select_index].force_created_period_type = this.state.force_created_period_type;
                            list_self_select[last_select_index].force_created_period = this.state.force_created_period;
                            list_self_select[last_select_index].force_created_start_date = StringUtil.dateFormater(this.state.force_created_start_date);
                            list_self_select[last_select_index].force_created_end_date = StringUtil.dateFormater(this.state.force_created_end_date);
                            list_self_select[last_select_index].force_is_except_invisible_category = this.state.force_is_except_invisible_category;
                            list_self_select[last_select_index].max_item_analysis = this.state.max_item_analysis;
                            list_self_select[last_select_index].max_item_analysis_value = this.state.max_item_analysis_value;
                            list_self_select[last_select_index].total_sort_type = this.state.total_sort_type;

                            const config = {
                                headers: {
                                    'Content-Type': 'application/json',
                                    },
                            };
                            const url = '/rest/shop/rp/event/create/manual/v5';
                            const body = {
                                user_seq: this.state.user_seq, 
                                shop_no: this.state.shop_no,
                                create_type_cd : "22998",
                                row_cnt : this.state.event_total_item_select_cnt,
                                iframe_page_id : this.state.iframe_page_id,
                                iframe_html_id : this.state.iframe_html_id,
                                event_category_list : this.state.event_category_list,
                                list_self_select : list_self_select,
                                event_item_price_filter_yn : "Y",
                                order_gubun : this.state.event_order_gubun,
                                order_type : this.state.event_order_type,
                            }
                            http
                            .post(url, body, config)
                            .then(res => {
                                if (res.data.code == "200") {
                                    //console.log(res.data["list"]);
                                    this.setState( {
                                        event_rp_product_list : res.data["list"],
                                    }, () => {
                                        // 상품 이미지 byte로 변환
                                        const {event_rp_product_list} = this.state;
                                        // for(let i=0;i<event_rp_product_list.length;i++){
                                        //     // 이미지가 재로딩 되지 않은 경우에만 byte변환 api를 타도록 한다
                                        //     if(event_rp_product_list[i]["image_reload_yn"]!="Y"){
                                        //         this.changeImageToByte(event_rp_product_list[i]["image_url"],i,"event_rp_product_list");
                                        //         this.changeImageToByte(event_rp_product_list[i]["detail_image_url"],i,"event_rp_product_list", "detail_image_url");
                                        //     }
                                        // }
                                        pasteAction(this);
                                    });
                                } else{
                                    alert("상품 선택에 실패하였습니다.")
                                    this.setState( {
                                        event_rp_product_list : [],
                                    });
                                }
                            })
                            .catch(error => {
                                alert("상품 선택에 실패하였습니다.")
                                this.setState( {
                                    event_rp_product_list : [],
                                });
                            });
                        } else{
                            pasteAction(this);
                        }
                    }
                },
                {
                    title: "아니요",
                    type: "0",
                    event_method: () => {
                        this.setState({
                            confirm_dialog_show_state: false,
                        });
                    }
                }
            ]
        });
    }

    /** 선택된 상품목록 선택한 상품 추가 버튼 클릭 */
    onClickAddSelectEventProductList(){
        const {cafe24_main_product_list, cafe24_category_product_list, event_product_checked_list} = this.state;

        let product_list = [];
        // 카페24 메인 진열인 경우, 해당 상품목록 불러오기
        if(this.state.iframe_page_id == "robomd_cafe24_main_page"){
            product_list = JSON.parse(JSON.stringify(cafe24_main_product_list));
        }
        else if(this.state.iframe_page_id === "robomd_cafe24_category_page"){
            product_list = JSON.parse(JSON.stringify(cafe24_category_product_list));
        }

        var add_product_list = [];

        add_product_list = event_product_checked_list.filter(function(obj) {
            return !this.has(obj.product_no);
        }, new Set(product_list.map(obj => obj.product_no))); // 상품 중복 체크

        if(add_product_list.length === 0){
            this.basicDialogNeedProducts()
            return false;
        }
        
        let ga_product_list = [];
        let cafe24_category_list = [];
        for (var idx in add_product_list) {
            var obj = add_product_list[idx];
            var result_obj = {
                category_no: obj.category_no,
                create_type_cd: obj.create_type_cd,
                created_date : obj.created_date,
                hit_cnt :obj.hit_cnt,
				cart_cnt :obj.cart_cnt,
				wish_cnt :obj.wish_cnt,
                quantity :obj.quantity,
                mod_user_seq: obj.mod_user_seq,
                review_cnt : obj.review_cnt,
                sale_percent : obj.sale_percent,
                order_price : obj.order_price,
                retail_price: obj.retail_price,
                del_yn: obj.del_yn,
                order_cnt : obj.order_cnt,
                review_point : obj.review_point,
                display_yn: obj.display_yn,
                iframe_html_id: this.state.iframe_html_id,
                iframe_page_id: this.state.iframe_page_id,
                image_url: obj.image_url,
                detail_image_url: obj.detail_image_url,
                price: obj.price,
                pc_discount_price: obj.pc_discount_price,
                product_name: obj.product_name,
                product_no: obj.product_no,
            }
            if(this.state.iframe_page_id === "robomd_cafe24_category_page"){
                product_list.splice(idx,0,result_obj) // 실제 추가 할 상품
            } else{
                product_list.push(result_obj) // 실제 추가 할 상품
            }
            var ga_result_obj = {
                product_name: obj.product_name,
                product_no: obj.product_no,
            }
            cafe24_category_list.push(result_obj);
            ga_product_list.push(ga_result_obj) // GA 이벤트 표기용 상품
        }

        // 카페24 메인 진열인 경우, 해당 상품목록 적용
        if(this.state.iframe_page_id == "robomd_cafe24_main_page"){
            this.setState({cafe24_main_product_list : product_list});
        }
        else if(this.state.iframe_page_id === "robomd_cafe24_category_page"){
            // 추가 api 실행
            this.addCafe24CategoryProduct(cafe24_category_list,product_list);
        }
        this.setState({
            show_event_product_list_popup : false, // 선택된 상품목록 팝업 닫기
            event_product_checked_list: [],
            event_rp_product_list : [],
        }, () => {
            this.orderIdxReset();

            if (ga_product_list != null && ga_product_list.length > 0) {
                // alert("선택 상품 추가하기 - "+ga_product_list.length+"개 "+ JSON.stringify(ga_product_list) +" ("+ this.state.ga_rp_category_name + ")")
                this.setPopupGaEvent("선택 상품 추가하기 - "+ga_product_list.length+"개 "+ JSON.stringify(ga_product_list));
            }
        })
        if(this.state.iframe_page_id != "robomd_cafe24_category_page"){
            this.setState({right_is_modified: true});
        }
    }

    /** 선택된 상품목록 팝업 닫기 */
    closeEventListPopup(){
        this.setState({
            show_event_product_list_popup : false,
            show_except_setting_popup : false,
            show_except_product_popup : false,
            show_essential_product_list_popup: false, // 필수 상품 설정 팝업 닫기
            show_self_except_setting_popup : false, // 셀프 진열 간 상품 중복 제외 팝업 닫기
            except_product_list : [],
            except_products: [],
            event_product_checked_list : [],
        });
    }

    
    /* ---------------------------------- 필수 상품 목록 팝업 관련 함수 --------------------------------------- */
    
    /** 필수 상품 목록 보기 버튼 클릭 */
    onClickEssentialProductListPopup(uuid){
        console.log("uuid",uuid);
        this.setState({
            essential_list_self_select_uuid : uuid,
        }, () => {
            // if(!this.state.show_essential_product_list_popup){
                this.setState({
                    show_add_product_popup : false, // 다른 팝업 닫기
                    show_event_product_list_popup : false, // 선택된 상품목록 팝업 닫기
                    show_except_setting_popup : false, // 진열 간 상품 중복 제외 팝업 닫기
                    show_self_except_setting_popup : false, // 셀프 진열 간 상품 중복 제외 팝업 닫기
                    show_except_product_popup: false,
                    show_essential_product_list_popup: false, // 필수 상품 설정 팝업 닫기
                    show_exclude_product_list_popup : false, // 제외 상품 설정 팝업 닫기
                }, () => {
                    this.setState({
                        show_essential_product_list_popup : true, // 팝업 열기
                    });
                });
            // }
        })
    }

    /** 필수 상품 목록 팝업 닫기 */
    closeEssentialListPopup(){
        this.setState({
            show_essential_product_list_popup : false, // 팝업 닫기
        });
    }
    
    /* ---------------------------------- 제외 상품 목록 팝업 관련 함수 --------------------------------------- */

    /** 제외 상품 목록 보기 버튼 클릭 */
    onClickExcludeProductListPopup(){
        if(!this.state.show_exclude_product_list_popup){
            this.setState({
                show_add_product_popup : false, // 다른 팝업 닫기
                show_event_product_list_popup : false, // 선택된 상품목록 팝업 닫기
                show_except_setting_popup : false, // 진열 간 상품 중복 제외 팝업 닫기
                show_self_except_setting_popup : false, // 셀프 진열 간 상품 중복 제외 팝업 닫기
                show_except_product_popup: false,
                show_essential_product_list_popup: false, // 필수 상품 설정 팝업 닫기
            }, () => {
                this.setState({
                    show_exclude_product_list_popup : true, // 팝업 열기
                });
            });
        }
    }

    /** 제외 상품 목록 팝업 닫기 */
    closeExcludeListPopup(){
        this.setState({
            show_exclude_product_list_popup : false, // 팝업 닫기
        });
    }

    /** 제외 상품 목록 불러오기 */
    async loadExcludeProductList(){
        this.props.excludeProductLoad(this.state.iframe_page_id, this.state.iframe_html_id)
    }

    /** 제외 상품 목록 저장 */
    saveExcludeProductList(){
        if(!this.props.excludeProductModified){
            return;
        }

        this.props.excludeProductSave({
            list: this.props.excludeProductList,
            iframe_page_id : this.state.iframe_page_id,
            iframe_html_id : this.state.iframe_html_id,
        });
    }

    /* ---------------------------------- 진열 간 상품 중복 제외 설정 팝업 관련 함수 --------------------------------------- */

    /** 진열 간 상품 중복 제외 설정 팝업 열기 버튼 클릭 */
    async onClickExceptSettingPopup(){
        if(!this.state.show_except_setting_popup){
            this.setState({
                show_add_product_popup : false, // 상품 추가 팝업 닫기
                show_exclude_product_list_popup : false, // 제외 상품 팝업 닫기
                show_event_product_list_popup : false, // 선택된 상품목록 팝업 닫기
                show_except_product_popup: false,
                show_essential_product_list_popup: false, // 필수 상품 설정 팝업 닫기
                show_self_except_setting_popup : false, // 셀프 진열 간 상품 중복 제외 팝업 닫기
            }, async () => {
                this.setState({
                    show_except_setting_popup : true, // 팝업 열기
                    rp_event_setting_list : [],
                })

                await this.loadRpEventExceptSettingsToBe();

                const {rp_event_setting_list} = this.state;
                let {select_except_rp_setting} = this.state;
                if(select_except_rp_setting == ""){
                    for(var i=0;i<rp_event_setting_list.length;i++){
                        if(this.state.except_setting_list.map(obj => obj.id).indexOf(rp_event_setting_list[i].id) < 0){
                            select_except_rp_setting = rp_event_setting_list[i].id;
                            break;
                        }
                    }
                }
                this.setState({
                    select_except_rp_setting : select_except_rp_setting,
                });
            });
        }
    }

    /** 진열 설정 목록 불러오기 (셀렉트 박스)*/
    async loadRpEventExceptSettingsToBe(add_page){
        await APIs.rp.getRpEventExceptSettingsToBe(this.state.iframe_page_id, this.state.iframe_html_id)
            .then(res => {
                if (res.data.code == "200") {
                    let rp_event_setting_list = res.data["list"];
                    if (rp_event_setting_list != null && rp_event_setting_list.length > 0) {
                        for(var i=0;i<rp_event_setting_list.length;i++){
                            rp_event_setting_list[i].id = rp_event_setting_list[i].iframe_page_id+"/"+rp_event_setting_list[i].iframe_html_id;
                            rp_event_setting_list[i].name = "["+rp_event_setting_list[i].iframe_page_name+"] "+rp_event_setting_list[i].display_name;
                        }
                    }

                    this.setState({
                        rp_event_setting_list: rp_event_setting_list,
                    }, () =>{
                        if(add_page){
                            if (rp_event_setting_list != null && rp_event_setting_list.length > 0) {
                                let select_except_rp_setting = rp_event_setting_list[0].id;
                                this.setState({select_except_rp_setting: select_except_rp_setting,})
                            }
                        }
                    });

                } else {
                    throw new Error()
                }
            })
            .catch(error => {alert("진열 설정 목록을 불러오는데 실패하였습니다.")});
    }

    /** 진열 간 상품 중복 제외 설정 목록 불러오기 (테이블)*/
    async loadRpEventExceptSettingsDone(){
        await APIs.rp.getRpEventExceptSettingsDone(this.state.iframe_page_id, this.state.iframe_html_id)
            .then(res => {
                if (res.data.code == "200") {
                    let except_setting_list = res.data["list"];
                    for(var i=0;i<except_setting_list.length;i++){
                        except_setting_list[i].id = except_setting_list[i].iframe_page_id+"/"+except_setting_list[i].iframe_html_id;
                        except_setting_list[i].name = "["+except_setting_list[i].iframe_page_name+"] "+except_setting_list[i].display_name;
                    }
                    this.setState({
                        except_setting_list: except_setting_list,
                        except_setting_is_modified : false,
                    });
                } else{
                    throw new Error()
                }
            })
            .catch(error => {alert("진열 간 상품 중복 제외 설정 목록을 불러오는데 실패하였습니다.")});
    }

    /** 진열 간 상품 중복 제외 설정의 셀렉트박스가 변경될때 실행되는 함수 (onClickOption)
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id(question_idx, answer_idx 포함)
    */
    onChangeSelectExceptRpSetting(text, value, id){
        this.setState({select_except_rp_setting : value});
    }

    /** 진열 간 상품 중복 제외 설정의 셀렉트박스가 변경될때 실행되는 함수 (onClickOption)
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id(question_idx, answer_idx 포함)
    */
    onChangeSelectExceptProductCategory(text, value, id){
        this.setState({
            except_product_list: this.state.except_products[value].list,
            except_select_category : value,
        });
    }

    /** 진열 간 상품 중복 제외 설정 상품 목록 보기
     * @param {*} obj 진열 정보
    */
    async showExceptSettingProductList(obj, selectedCategoryNo){
        this.setState({
            show_except_product_popup: true,
            except_select_category : "",
        }, () => {
            this.setState({show_except_product_list_table_loading_bar : true,});
        });
        let api; // iframe_page_id 값에 따라 변경될 api

        // if(obj.iframe_page_id == "robomd_cafe24_main_page"){
        //     api = "/rest/shop/cafe24/main/product?display_group="+obj.cafe24_main_display_group;
        // }
        // else if(obj.iframe_page_id == "robomd_cafe24_category_page"){
        //     const category_no_list = obj.cafe24_category_no_list.split(',');
        //     api = "/rest/shop/cafe24/category/products?category_no="+category_no_list[category_no_list.length-1]+"&display_group="+obj.cafe24_category_display_group
        // }
        // else
        if(obj.iframe_page_id == "robomd_cafe24_main_page") {
            api = "/rest/shop/rp/event/result?iframe_page_id="+obj.iframe_page_id+"&iframe_html_id="+obj.iframe_html_id+"&display_group="+obj.cafe24_main_display_group;
        } else if (obj.iframe_page_id == "robomd_cafe24_category_page") {
            api = "/rest/shop/rp/event/result?iframe_page_id="+obj.iframe_page_id+"&iframe_html_id="+obj.iframe_html_id+"&display_group="+obj.cafe24_category_display_group;
        } else if(obj.iframe_page_id == "robomd_product_detail_page" && obj.event_category_select_type == "34001"){
            api = "/rest/shop/rp/category/event/select/v3?iframe_page_id="+obj.iframe_page_id+"&iframe_html_id="+obj.iframe_html_id;
        } else{
            api = "/rest/shop/rp/event/select/v2?iframe_page_id="+obj.iframe_page_id+"&iframe_html_id="+obj.iframe_html_id;
        }
        await http.get(api)
		.then(res => {
			if (res.data.code == "200") {
                let list = [];
                let products = {};
                let except_event_category_list = [];
                let select_category = "";

                // if(obj.iframe_page_id == "robomd_cafe24_main_page"){
                //     list = res.data["main_product_list"];
                // }
                // else if(obj.iframe_page_id == "robomd_cafe24_category_page"){
                //     list = res.data["category_product_list"];
                // }
                // else
                if(obj.iframe_page_id == "robomd_cafe24_main_page"
                    || obj.iframe_page_id == "robomd_cafe24_category_page"
                ) { 
                    list = res.data.product_list || [];    
                } else if(obj.iframe_page_id == "robomd_product_detail_page" && obj.event_category_select_type == "34001"){
                    let category_list = res.data["event_category_array"] || [];

                    // 상품보기 버튼에서 전달한 카테고리가 있으면 그 카테고리를 우선 선택
                    if (
                        selectedCategoryNo != null
                        && selectedCategoryNo !== ""
                        && category_list.map(String).indexOf(String(selectedCategoryNo)) >= 0
                    ) {
                        select_category = String(selectedCategoryNo);
                    } else {
                        select_category = category_list.length > 0 ? String(category_list[0]) : "";
                    }

                    if (select_category !== "" && res.data[select_category]) {
                        list = res.data[select_category].list;
                    } else {
                        list = [];
                    }

                    for(var i=0;i<category_list.length;i++){
                        products[category_list[i]] = res.data[category_list[i]];
                        except_event_category_list.push({
                            category_name : res.data[category_list[i]].category_name,
                            category_name_no_format : res.data[category_list[i]].category_name_no_format,
                            category_no : category_list[i],
                        });
                    }
                } else{
                    list = res.data["list"];
                }
                this.setState({
                    except_product_list: list,
                    except_products: products,
                    except_event_category_list : except_event_category_list,
                    except_select_category : select_category,
                    show_except_product_list_table_loading_bar : false,
                });

			} else {
                this.setState({show_except_product_list_table_loading_bar : false,});
                alert("상품 목록을 불러오는데 실패하였습니다.");
            }
		})
		.catch(error => {
            this.setState({show_except_product_list_table_loading_bar : false,});
		 });
    }

    /** 진열 간 상품 중복 제외 상품 목록 팝업 닫기 */
    closeExceptSettingProductList(){
        this.setState({
            except_product_list : [],
            except_products: [],
            show_except_product_popup : false,
        });
    }

    /** 진열 간 상품 중복 제외 설정 추가 */
    addExceptSettingList(){
        let {except_setting_list} = this.state;

        for(var i=0;i<except_setting_list.length;i++){
            if(except_setting_list[i].id == this.state.select_except_rp_setting){
                alert("이미 추가된 진열 설정입니다.");
                return false;
            }
        }

        const iframe_page_id = this.state.select_except_rp_setting.split("/")[0];
        const iframe_html_id = this.state.select_except_rp_setting.split("/")[1];
        
        // 선택한 진열을 찾아서 진열 간 상품 중복 제외 설정 목록에 추가
        for(var i=0;i<this.state.rp_event_setting_list.length;i++){
            if(this.state.rp_event_setting_list[i].iframe_page_id == iframe_page_id && this.state.rp_event_setting_list[i].iframe_html_id == iframe_html_id){
                except_setting_list.push(this.state.rp_event_setting_list[i]);
                break;
            }
        }

        this.setState({
            except_setting_list : except_setting_list,
            except_setting_is_modified : true,
        });
    }

    /** 진열 간 상품 중복 제외 설정 삭제 (x버튼 클릭) */
    delExceptSetting(idx){
        let {except_setting_list} = this.state;

        except_setting_list.splice(idx,1);
        this.setState({
            except_setting_list: except_setting_list,
            except_setting_is_modified : true,
        });
    }

    /** 진열 간 상품 중복 제외 설정 취소 버튼 클릭 */
    //TODO: 삭제
    clickCancelExceptSettingList(){
        this.setState({
            title_content_dialog_show_state: true,
            title_content_dialog_title: "변경사항을 취소 하시겠습니까?",
            title_content_dialog_button_list: [
                {
                    title: "네",
                    type: "1",
                    event_method: () => {
                        this.setState({
                            title_content_dialog_show_state: false,
                        });

                        if(this.state.iframe_html_id == null || this.state.iframe_html_id == ""){
                            this.setState({
                                except_setting_list : [],
                                except_setting_is_modified : false,
                            });
                        } else{
                            this.loadRpEventExceptSettingsDone();
                        }
                    }
                },
                {
                    title: "아니요",
                    type: "0",
                    event_method: () => {
                        this.setState({
                            title_content_dialog_show_state: false,
                        });
                    }
                }
            ]
        });
    }

    /** 진열 간 상품 중복 제외 설정 저장 */
    saveExceptSettingList(save_left){
        const config = {
            headers: {
                'Content-Type': 'application/json',
                },
        };
        const url = '/rest/shop/rp/event/exceptSetting/save';
        const body = {
            list : this.state.except_setting_list,
            iframe_page_id : this.state.iframe_page_id,
            iframe_html_id : this.state.iframe_html_id,
        }

        if(save_left){
            if(this.state.except_setting_is_modified){
                http
                .post(url, body, config)
                .then((res) => {
                    if (res.data.code == "200") {
                        this.setState({
                            except_setting_is_modified : false,
                        });
                    } else {
                        alert('진열 간 상품 중복 제외 설정 저장에 실패하였습니다.');
                    }
                })
                .catch((error) => {
                    alert('진열 간 상품 중복 제외 설정 저장에 실패하였습니다.');
                });
    
                this.setGaEvent("진열 간 상품 중복 제외 설정 저장");
            }
        } else{
            this.titleContentDialogSaveExceptSettingList(url, body, config)
        }
    }

    /** 진열 간 상품 중복 제외 설정 팝업 닫기 */
    closeExceptSettingPopup(){
        this.setState({
            show_except_setting_popup : false, // 팝업 닫기
        });
    }

    /* ------------------------------------------ 메인 테이블 관련 함수 ---------------------------------------------- */

    /** 메인 테이블이 로드 될떄 드래그 스크롤을 위한 max_height 설정 */
    onLoadMainTable(){
        let window_height = $(window).height();
        // window 높이에 따라서 메인테이블의 max-height가 달라지도록 적용(드래그 스크롤을 위한 작업)
        $("#list_admin_main_board").css({"max-height":window_height-330});
        $("#main_table_tbody").css({"max-height":window_height-400});
    }

    /** 상품 고정 상태 변경
     */
    changeProductFix = (productNo) => {
        const {event_rp_product_list} = this.state;
        let product_list = [];
        // 카페24 메인 진열인 경우, 해당 상품목록 불러오기
        // if(this.state.iframe_page_id == "robomd_cafe24_main_page"){
            product_list = JSON.parse(JSON.stringify(event_rp_product_list));
            product_list = product_list.map((obj, idx) => (productNo === obj.product_no ? {...obj, fixed_sort : !obj.fixed_sort, sequence_no : idx+1} : {...obj}));
            this.setState({event_rp_product_list : product_list});
        // }
        // else if(this.state.iframe_page_id == "robomd_cafe24_category_page"){
        //     this.updateCafe24CategorySetting("fixed", productNo);
        // }
    }

    /** 상품의 순번을 순차적으로 초기화하는 함수 */
    orderIdxReset() {
        // 번호가 순차적으로 보일 수 있도록 main_order_idx를 초기화
        let main_order_idx = [];
        const {event_rp_product_list} = this.state;
        let product_list = [];
        // 카페24 메인 진열인 경우, 해당 상품목록 불러오기
        product_list = JSON.parse(JSON.stringify(event_rp_product_list));

        for(var i=0;i<product_list.length;i++){
            main_order_idx[i]=i+1;
        }
        // 반영
        this.setState({
            main_order_idx:  main_order_idx,
        }, ()=>{
            // input width가 숫자 길이에 따라 변환되도록 조절
            for(var i=0;i<this.state.main_order_idx.length;i++){
                let str_length = String(i+1).length;
                $("#main_order_input_"+i).css({width: Number(((str_length-1)*5)+24)+"px"});
            }
        })
    }

    cafe24ProductFixedReorder = (name) => {
        let fixed_product_list = [...this.state[name]].filter(product => product.fixed_sort);
        let non_fixed_product_list = [...this.state[name]].filter(product => !product.fixed_sort);
        
        // 주어진 인덱스에 값을 추가
        fixed_product_list.forEach((product, i) => {
            non_fixed_product_list.splice(product.sequence_no-1, 0, product);
        });

        this.setState({[name]: non_fixed_product_list.map((obj,idx) => (obj.fixed_sort ? {...obj, sequence_no: idx+1} : {...obj}))}, () => {
            this.orderIdxReset();
        });
    }

    /** 상품의 순서를 나타내는 input값 타이핑 가능하도록 하는 함수
    * @param {*} e < e.target.name : idx 번호, e.target.value : 입력 값>
    */
    onChangeInput(e) {
        const {main_order_idx} = this.state;
        main_order_idx[e.target.name] =  StringUtil.inputOnlyNumberFormat(e.target.value); // 배열의 해당 위치값을 이벤트로 받아온 값으로 변경
        this.setState({
            main_order_idx: main_order_idx, // 적용
        }, ()=>{
            // input width가 숫자 길이에 따라 변환되도록 조절
            $("#"+e.target.id).css({width: Number(((this.state.main_order_idx[e.target.name].length-1)*5)+24)+"px"});
        })
    }

    /** 상품의 순서를 input 입력 값으로 변경하는 함수
     * @param {*} e < e.target.name : idx 번호, e.target.value : 입력 값>
     * @param {*} onBlur blur 된 경우
    */
    onChangeOrderIdx(idx, onBlur, e) {
        // 엔터키를 눌렀을때 해당 순서 범위가 유효한 범위라면 순서 변경
        if(onBlur || e.key=='Enter'){
            // 상품 목록
            const {event_rp_product_list, main_order_idx} = this.state;
            let input_value = main_order_idx[idx];
            let product_list = [];

            product_list = JSON.parse(JSON.stringify(event_rp_product_list));

            let cafe24_category_change_order_list = JSON.parse(JSON.stringify(this.state.cafe24_category_change_order_list));
            if(input_value>0 && input_value<=product_list.length){

                if(product_list[idx].fixed_sort){
                    this.orderIdxReset(); // 순번 초기화
                    return;
                } else if(product_list[Number(input_value) - 1].fixed_sort){
                    const new_main_order_idx = this.state.main_order_idx.map((obj, index) => idx === index ? Number(input_value)+1 : obj);
                    this.setState({main_order_idx : new_main_order_idx}, () => {
                        this.onChangeOrderIdx(idx, true);
                    });
                    return false;
                }

                // 이전과 값이 달라진 경우
                if(idx != input_value-1){
                    const change_idx = Number(input_value)-1;
                    const change_product = product_list[idx]; // 순서를 변경할 상품의 임시 저장소
                    change_product.create_type_cd = "22999"; // 수동 선택으로 변경
                    product_list.splice(idx,1); // 위치를 변경할 상품을 리스트에서 제거 후
                    product_list.splice(input_value-1,0,change_product); // 변경된 위치에 추가

                    // 카페24 분류별 진열 작업
                    if(cafe24_category_change_order_list.indexOf(product_list[input_value-1].product_no) == -1){
                        cafe24_category_change_order_list.push(product_list[input_value-1].product_no); // 순서변경 상품 번호
                    }
                    
                    this.orderIdxReset(); // 순번 초기화
                    
                    // 카페24 메인 진열인 경우, 해당 상품목록 적용
                    if(this.state.iframe_page_id == "robomd_cafe24_main_page"){
                        this.setState({event_rp_product_list : product_list}, () => {
                            this.cafe24ProductFixedReorder("event_rp_product_list");
                            $("#main_order_input_"+change_idx).focus();
                        });
                    }
                    else if(this.state.iframe_page_id == "robomd_cafe24_category_page"){
                        this.setState({
                            cafe24_category_product_list : product_list,
                            cafe24_category_change_order_list : cafe24_category_change_order_list,
                        }, () => {
                            this.cafe24ProductFixedReorder("cafe24_category_product_list");
                            $("#main_order_input_"+change_idx).focus();
                        });
                    }

                    if(this.state.iframe_page_id != "robomd_cafe24_category_page"){
                        this.setState({right_is_modified: true});
                    } else{
                        this.setState({category_order_is_modified: true});
                    }
                }
            } else{
                this.orderIdxReset(); // 순번 초기화
            }
        }
    }

    /** 체크된 상품을 이동시키는 함수
     * @param {*} to 이동할 계산 값 product_list.length or 1 or -1 or 0
    */
    onChangeProductOrder(to) {
        let {cafe24_main_product_list, cafe24_category_product_list, rp_check_product_list} = this.state;
        let product_list = [];
        let fixed_idx_list = [];
        let check_product_no_list = [];
        let main_checked_idx = [];
        
        // 카페24 메인 진열인 경우, 해당 상품목록 불러오기
        if(this.state.iframe_page_id == "robomd_cafe24_main_page"){
            product_list = JSON.parse(JSON.stringify(cafe24_main_product_list));
        }
        else if(this.state.iframe_page_id == "robomd_cafe24_category_page"){
            product_list = JSON.parse(JSON.stringify(cafe24_category_product_list)).filter(product => !product.fixed_sort);
            rp_check_product_list = rp_check_product_list.filter(product => !product.fixed_sort);
        }

        fixed_idx_list = product_list.filter((obj) => obj.fixed_sort).map((obj,idx) => idx);

        for(var i=0;i<rp_check_product_list.length;i++){
            check_product_no_list.push(rp_check_product_list[i].product_no);
        }

        for(var i=0;i<product_list.length;i++){
            if(check_product_no_list.indexOf(product_list[i].product_no) != -1){
                main_checked_idx.push(i);
            }
        }

        // 체크된 상품이 없다면 종료
        if(main_checked_idx.length === 0){
            return false;
        }

        const checked_idx_length = main_checked_idx.length;
        main_checked_idx = main_checked_idx.sort(function(a,b){
            return a - b;
        }); // 체크된 idx를 정렬(숫자 정렬을 사용)

        // 모든 상품이 선택된 경우에는 동작하지 않는다.
        if (checked_idx_length == product_list.length) {
            return false;
        }
        let cafe24_category_change_order_list = JSON.parse(JSON.stringify(this.state.cafe24_category_change_order_list));
        
        // cafe24 분류별 진열 순서 적용을 위한 동작
        var auto_change_product_no = rp_check_product_list.map(obj => obj.product_no);

        var update_checked_idx = [...fixed_idx_list]; // 체크 상품이 변경된 위치들 (고정 위치도 변화 없어야 해서 추가)
        if(to == 0){
            // 체크 상품 순서대로 위치 이동
            for(var idx=0;idx<main_checked_idx.length;idx++){
                let update_idx = 0; // 이동할 위치 값
                // 앞서 변경된 체크 상품 위치들 중, 현재의 update_idx와 같은것이 있다면,
                // 그 자리는 이미 차지된 자리이니 한칸 더 아래로 간다.
                for(var idx2=0;idx2<update_checked_idx.length;idx2++){
                    if(update_checked_idx[idx2] == update_idx){
                        update_idx += 1;
                    }
                }
                // update_idx값으로 상품을 옮길것이니, 해당 자리가 사용되었음을 나타내기 위해
                // 체크 상품이 변경된 위치들에 추가한다.
                update_checked_idx.push(update_idx);

                // 상품을 새로운 위치에 넣기
                const checked_product = product_list.splice(Number(main_checked_idx[idx]),1);
                checked_product[0].create_type_cd = "22999"; // 수동 선택으로 변경
                product_list.splice(update_idx, 0, checked_product[0]);

                // 카페24 분류별 진열 작업
                if(cafe24_category_change_order_list.indexOf(product_list[update_idx].product_no) == -1){
                    cafe24_category_change_order_list.push(product_list[update_idx].product_no); // 순서변경 상품 번호
                }
            }
        } else if(to == -1){
            for(var idx=0;idx<main_checked_idx.length;idx++){
                // 상품을 한칸 위로 올리는 위치
                let update_idx = Number(main_checked_idx[idx])-1;
                // 만약 한칸 위로 올렸을때 0보다 작아진다면, 0으로 설정한다.
                if(update_idx<0){
                    update_idx = 0;
                }
                for(var idx2=0;idx2<update_checked_idx.length;idx2++){
                    if(update_checked_idx[idx2] == update_idx){
                        update_idx += 1;
                    }
                }
                update_checked_idx.push(update_idx);

                // 상품을 새로운 위치에 넣기
                const checked_product = product_list.splice(Number(main_checked_idx[idx]),1);
                checked_product[0].create_type_cd = "22999"; // 수동 선택으로 변경
                product_list.splice(update_idx, 0, checked_product[0]);

                // 카페24 분류별 진열 작업
                if(cafe24_category_change_order_list.indexOf(product_list[update_idx].product_no) == -1){
                    cafe24_category_change_order_list.push(product_list[update_idx].product_no); // 순서변경 상품 번호
                }
            }
        } else if(to == 1){
            for(var idx=main_checked_idx.length-1;idx>=0;idx--){
                // 상품을 한칸 아래로 내리는 위치
                let update_idx = Number(main_checked_idx[idx])+1;
                // 만약 한칸 아래로 내렸을 경우 상품 배열 idx를 넘어갈 경우, 마지막 idx값으로 설정한다.
                if(update_idx>product_list.length-1){
                    update_idx = product_list.length-1;
                }
                for(var idx2=0;idx2<update_checked_idx.length;idx2++){
                    if(update_checked_idx[idx2] == update_idx){
                        update_idx -= 1;
                    }
                }
                update_checked_idx.push(update_idx);

                // 상품을 새로운 위치에 넣기
                const checked_product = product_list.splice(Number(main_checked_idx[idx]),1);
                checked_product[0].create_type_cd = "22999"; // 수동 선택으로 변경
                product_list.splice(update_idx, 0, checked_product[0]);

                // 카페24 분류별 진열 작업
                if(cafe24_category_change_order_list.indexOf(product_list[update_idx].product_no) == -1){
                    cafe24_category_change_order_list.push(product_list[update_idx].product_no); // 순서변경 상품 번호
                }
            }
        } else {
            for(var idx=main_checked_idx.length-1;idx>=0;idx--){
                let update_idx = product_list.length-1;
                for(var idx2=0;idx2<update_checked_idx.length;idx2++){
                    if(update_checked_idx[idx2] == update_idx){
                        update_idx -= 1;
                    }
                }
                update_checked_idx.push(update_idx);

                // 상품을 새로운 위치에 넣기
                const checked_product = product_list.splice(Number(main_checked_idx[idx]),1);
                checked_product[0].create_type_cd = "22999"; // 수동 선택으로 변경
                product_list.splice(update_idx, 0, checked_product[0]);

                // 카페24 분류별 진열 작업
                if(cafe24_category_change_order_list.indexOf(product_list[update_idx].product_no) == -1){
                    cafe24_category_change_order_list.push(product_list[update_idx].product_no); // 순서변경 상품 번호
                }
            }
        }

        // 카페24 메인 진열인 경우, 해당 상품목록 적용
        if(this.state.iframe_page_id == "robomd_cafe24_main_page"){
            this.setState({
                cafe24_main_product_list : product_list,
            }, () => {this.cafe24ProductFixedReorder("cafe24_main_product_list")});
        }
        else if(this.state.iframe_page_id == "robomd_cafe24_category_page"){
            auto_change_product_no = auto_change_product_no.filter(function(obj) {
                return !this.has(obj);
            }, new Set(cafe24_category_change_order_list.map(obj => obj)));

            for(var i=0;i<auto_change_product_no.length;i++){
                cafe24_category_change_order_list.push(auto_change_product_no[i]);
            }

            this.setState({
                cafe24_category_change_order_list : [...cafe24_category_change_order_list],
                cafe24_category_product_list : [...product_list],
            }, () => {
                this.cafe24ProductFixedReorder("cafe24_category_product_list");
            });
        }

        if(this.state.iframe_page_id != "robomd_cafe24_category_page"){
            this.setState({right_is_modified: true});
        } else{
            this.setState({category_order_is_modified: true});
        }
    }

    /** 체크 상태 변경 :전체 */
    onChangeRpProductCheckAll(e) {
        const {cafe24_main_product_list, cafe24_category_product_list} = this.state;
        let product_list = [];
        // 카페24 메인 진열인 경우, 해당 상품목록 불러오기
        if(this.state.iframe_page_id == "robomd_cafe24_main_page"){
            product_list = JSON.parse(JSON.stringify(cafe24_main_product_list));
        }
        else if(this.state.iframe_page_id == "robomd_cafe24_category_page"){
            product_list = JSON.parse(JSON.stringify(cafe24_category_product_list));
        }
        var rp_check_product_list = [];

        if (e.currentTarget.checked) {
            for(var idx in product_list) {
                rp_check_product_list.push(product_list[idx])
            }
        }

        this.setState({
            rp_check_product_list: rp_check_product_list,
        });
    }

    /** 체크 상태 변경
     * @param {*} e <e.target.value : 상품 목록 idx 번호>
    */
    onChangeRpProductCheck(e) {
        var idx = e.target.value;
        const {cafe24_main_product_list, cafe24_category_product_list, rp_check_product_list} = this.state;
        let product_list = [];
        // 카페24 메인 진열인 경우, 해당 상품목록 불러오기
        if(this.state.iframe_page_id == "robomd_cafe24_main_page"){
            product_list = JSON.parse(JSON.stringify(cafe24_main_product_list));
        }
        else if(this.state.iframe_page_id == "robomd_cafe24_category_page"){
            product_list = JSON.parse(JSON.stringify(cafe24_category_product_list));
        }
        
        // 체크를 한 경우와 풀은 경우
        if (!e.currentTarget.checked) {
            for(var idx2 in rp_check_product_list) {
                if (rp_check_product_list[idx2]["product_no"] == product_list[idx]["product_no"]) {
                    rp_check_product_list.splice(idx2, 1);
                    break;
                }
            }
            this.setState({
                rp_check_product_list: rp_check_product_list,
            })

        } else {
            rp_check_product_list.push(product_list[idx])
            this.setState({
                rp_check_product_list: rp_check_product_list,
            })
        }
    }

    /** 체크된 상품을 미진열(삭제)하는 함수 */
    onClickCheckedRpProductDelete() {
        const {event_rp_product_list, event_product_checked_list} = this.state;
        let product_list = [];
        
        // 기존 상품 목록을 복사
        product_list = JSON.parse(JSON.stringify(event_rp_product_list));
        var product_list_copy = JSON.parse(JSON.stringify(product_list));
        
        // 복사한 상품 목록에서 체크한 상품을 뺀 나머지 상품만 남겨둠
        product_list_copy = product_list_copy.filter(function(obj) {
            return !this.has(obj.product_no);
        }, new Set(event_product_checked_list.map(obj => obj.product_no)));

        // 체크한 상품을 뺀 나머지 상품으로 교체
        this.setState({event_rp_product_list : product_list_copy}, () => {
            // this.cafe24ProductFixedReorder("event_rp_product_list")
        });
        this.setState({
            event_product_checked_list: [],
            right_is_modified: true
        });


        var ga_check_product_list = [];
        for (var idx in event_product_checked_list) {
            var obj = event_product_checked_list[idx];
            ga_check_product_list.push({
                product_name: obj.product_name,
                product_no: obj.product_no,
            })
        }
        if (product_list.length == event_product_checked_list.length) {
            // alert("전체 삭제 - "+rp_check_product_list.length+"개 "+JSON.stringify(ga_check_product_list) + " ("+this.state.ga_rp_category_name+")")
            this.setGaEvent("미진열 - "+event_product_checked_list.length+"개 "+JSON.stringify(ga_check_product_list) + " ("+this.state.ga_rp_category_name+")")
        } else {
            // alert("선택 삭제 - "+rp_check_product_list.length+"개 "+JSON.stringify(ga_check_product_list)+ " ("+this.state.ga_rp_category_name+")")
            this.setGaEvent("미진열 - "+event_product_checked_list.length+"개 "+JSON.stringify(ga_check_product_list)+ " ("+this.state.ga_rp_category_name+")")
        }
    }

    /** 오른쪽 영역 저장 */
    onClickSaveRightSetting(none_dialog){
        if(this.state.is_main_auto_display_use || this.state.is_category_auto_display_use) {
            this.autoDisplayWarningDialoog();
            return false;
        }

        if(this.getPageStatus() === "main" && this.state.cafe24_main_product_list.length > cafe24_main_page_max_product_num) {
            // 카페24 메인진열 상품목록이 저장 가능한 개수를 초과한 경우
            this.setState({
                save_dialog_show_state : false,
                basic_dialog_show_state: true,
                basic_dialog_content: "<p>cafe24 메인 진열에 저장할 수 있는<br/>상품 수는 최대 "+cafe24_main_page_max_product_num+"개입니다.</p>상품 수를 "+cafe24_main_page_max_product_num+"개 이하로 설정해 주세요.",
                basic_dialog_button_list: [
                    {
                        title: "확인",
                        type: "1",
                        event_method: () => {
                            //팝업 닫기
                            this.setState({ basic_dialog_show_state: false });
                        }
                    }
                ]
            });
            return false;
        }

        /** 
         * 진열 일원화 이후, 오른쪽 화면은 알고리즘 결과물을 출력하는 창. 
         * 알고리즘 출력을 하지 않고 [쇼핑몰 바로 진열]시 빈 상품목록을 바로 쇼핑몰에 적용할수도 있음.
         * 때문에 빈 상품 목록이라면 오른쪽을 저장하지 않는다.
         *  */
                                                
        // 진열 추가시 왼쪽 영역을 저장하지 않았다면
        if(this.getPageStatus() === 'init'){
            this.titleContentDialogSaveRightSetting()
        } else {
            this.titleContentDialogApplyProductMainDisplay()
        }
    }

    /* ---------------------------------- 상품 추가 팝업 관련 함수 --------------------------------------- */
    onClickAddProductbtn(popup_check_product_list){
        if (this.getPageStatus() == "init") {
            this.basicDialogNeedSave();
            return false;
        }

        // if(this.state.iframe_page_id === "robomd_cafe24_category_page"){
        //     let {event_rp_product_list} = this.state;
        //     popup_check_product_list = popup_check_product_list.filter(function(obj) {
        //         return !this.has(obj.product_no);
        //     }, new Set(event_rp_product_list.map(obj => obj.product_no))); // 상품 중복 체크
        //     if(popup_check_product_list.length == 0){
        //         /** 상품 선택 안했을때 */
        //         this.basicDialogNeedProducts()
        //     } else{
        //         this.updateCafe24CategorySetting("add",popup_check_product_list);
        //     }
        // } else{
        //     this.onClickPopupCheckedProductApply(popup_check_product_list);
        // }
        this.onClickPopupCheckedProductApply(popup_check_product_list);

    }

    /** 상품 추가 팝업 : 선택 상품 추가하기 버튼 클릭 */
    onClickPopupCheckedProductApply(popup_check_product_list) {
        const {event_rp_product_list} = this.state;
        let product_list = JSON.parse(JSON.stringify(event_rp_product_list));


        let add_product_list = popup_check_product_list.filter(function(obj) {
          return !this.has(obj.product_no);
        }, new Set(product_list.map(obj => obj.product_no))); // 상품 중복 체크

        if(add_product_list.length === 0){
            /** 상품 선택 안했을때 */
            this.basicDialogNeedProducts()  
            return false;
        }
        
        let ga_product_list = [];
        let cafe24_category_list = [];
        add_product_list.forEach((obj, idx) => {
          let result_obj = {
              category_no: obj.category_no,
              created_date: obj.created_date,
              hit_cnt: obj.hit_cnt,
              cart_cnt: obj.cart_cnt,
              wish_cnt: obj.wish_cnt,
              quantity: obj.quantity,
              mod_user_seq: obj.mod_user_seq,
              review_cnt: obj.review_cnt,
              sale_percent: obj.sale_percent,
              order_price: obj.order_price,
              pc_discount_price: obj.pc_discount_price,
              del_yn: obj.del_yn,
              order_cnt: obj.order_cnt,
              order_rate: obj.order_rate,
              review_point: obj.review_point,
              display_yn: obj.display_yn,
              iframe_html_id: this.state.iframe_html_id,
              iframe_page_id: this.state.iframe_page_id,
              image_url: obj.image_url,
              detail_image_url: obj.detail_image_url,
              price: obj.price,
              product_name: obj.product_name,
              product_no: obj.product_no,
              create_type_cd: "22999", // 수동 선택
          };
      
        //   if (this.state.iframe_page_id === "robomd_cafe24_category_page") {
        //       product_list.splice(idx, 0, result_obj); // 실제 추가 할 상품
        //   } else {
        //       product_list.push(result_obj); // 실제 추가 할 상품
        //   }
        product_list.push(result_obj); // 실제 추가 할 상품
      
          let ga_result_obj = {
              product_name: obj.product_name,
              product_no: obj.product_no,
          };
      
          cafe24_category_list.push(result_obj);
          ga_product_list.push(ga_result_obj); // GA 이벤트 표기용 상품
      });
      
     //   카페24 메인 진열인 경우, 해당 상품목록 적용
     //   if(this.state.iframe_page_id === "robomd_cafe24_main_page"){
     //       // this.setState({cafe24_main_product_list : product_list}, () => {this.orderIdxReset()});
     //       this.setState({event_rp_product_list : product_list}, () => {this.orderIdxReset()});
     //   }
     //   else if(this.state.iframe_page_id === "robomd_cafe24_category_page"){
     //       // 추가 api 실행
     //       this.addCafe24CategoryProduct(cafe24_category_list, product_list);
     //   }
      this.setState({event_rp_product_list : product_list}, () => {
        this.orderIdxReset();

        /** 예약 진열인 경우 추가 후 상품 개수 체크 */
        if (this.state.event_rp_product_list.length > flagCafe24BulkConversionProductCount && this.state.auto_create_yn == 'N' && this.state.reservation_use_yn == 'Y') {
            this.setState({
                reservation_hour: 3,
            })
        }
        if (this.state.iframe_page_id=='robomd_cafe24_main_page' && this.state.event_rp_product_list.length > cafe24_main_page_max_product_num && this.state.auto_create_yn == 'N' && this.state.reservation_use_yn == 'Y') {
            this.setState({
                reservation_use_yn: "N",
            })
        }
        if(this.state.iframe_page_id=='robomd_cafe24_category_page' && this.state.event_rp_product_list.length > nayeol_event_total_item_select_range_category && this.state.auto_create_yn == 'N' && this.state.reservation_use_yn == 'Y'){
            this.setState({
                reservation_use_yn: "N",
            })
        }
      });

      if(this.state.iframe_page_id != "robomd_cafe24_category_page"){
          this.setState({right_is_modified: true,});
      }

      // 상품 추가 팝업 닫기
      this.closeAddProductPopup();

      if (ga_product_list != null && ga_product_list.length > 0) {
          this.setPopupGaEvent("선택 상품 추가하기 - "+ga_product_list.length+"개 "+ JSON.stringify(ga_product_list));
      }
    }

    /** 상품 추가 팝업 열기 */
    onClickAddProductPopup(){
        this.setPopupGaEvent("상품 추가 팝업 열기")

        this.setState({
            show_event_product_list_popup : false, // 선택된 상품목록 팝업 닫기
            show_except_setting_popup : false, // 진열 간 상품 중복 제외 팝업 닫기
            show_self_except_setting_popup : false, // 셀프 진열 간 상품 중복 제외 팝업 닫기
            show_except_product_popup: false,
            show_essential_product_list_popup: false, // 필수 상품 설정 팝업 닫기
            show_add_product_popup : true, // 팝업 열기
        }, () => {
            window.dispatchEvent(new Event('resize'));
        });
    }

    /** 상품 추가 팝업 닫기 */
    closeAddProductPopup(){
        this.setState({
            show_add_product_popup : false, // 팝업 닫기
        });
    }

    /** 이미지 백엔드에서 byte로 변환
     * @param {*} url 이미지 url
     * @param {*} idx 상품 위치 idx
     * @param {*} product_list_name 상품 목록 이름
     * @param {*} product_image_url_name 이미지 종류 (메인/상세)
    */
    async changeImageToByte(url,idx,product_list_name,product_image_url_name){
        await APIs.rp.changeImageToByte(url)
          .then(res => {
              if (res.data != null && res.data != '') {
                  let product_list = this.state[product_list_name];
                  product_list[idx][product_image_url_name == null ? "image_url" : product_image_url_name] = "data:image/png;base64," + window.btoa(String.fromCharCode.apply(null, new Uint8Array(res.data)));
                  product_list[idx]["image_reload_yn"] = "Y";
                  this.setState({[product_list_name] : product_list});
              }
          })
          .catch(error => {
          });
    }

    onChangeItemConditionListCd(text, value, id) {
        let idx = id.split("_")[3];
        let inner_idx = id.split("_")[4];

        let {list_self_select} = this.state;
        let list = _.cloneDeep(this.state.list_self_select);
        let event_item_condition_list = list[idx]["event_item_condition_list"];
        event_item_condition_list[inner_idx] = value;
        list[idx]["event_item_condition_list"] = event_item_condition_list;

        this.setState({
            list_self_select : list,
            left_is_modified : true,
        });
    }

    /** 플랫폼 API 연동 상태 조회 */
    loadShopSyncStateAndSyncDate = (is_sync_date_check_and_sync_start) => {
        APIs.rp.getShopSyncStateAndSyncDate()
          .then(res => {
            if (res.data != null && res.data != '') {
                this.setState({
                    syncState : res.data.sync_state,
                    syncDateFormat : res.data.sync_date_full_format
                });
                if (is_sync_date_check_and_sync_start == true) {
                    if (res.data.sync_state == "1") {
                        alert("상품 목록을 불러오는 중입니다. 완료될 때까지 기다려 주세요.\n"+
                                "상품 수에 따라 짧게는 몇 분에서 길게는 몇 시간이 걸릴 수 있습니다.");
                    } else {
                        this.setState({refresh_data_show_state : true});
                    }
                }
            }
          })
          .catch(error => {
          });
    }
    
    fn_refreshDataSync = () => {
        // 에러 알럿 비활성화
        setIsErrorAlert(false);
        try {
            this.hasFetchedSyncData.current = true
            this.setState({syncState : "1"});            
            axios.post('/rest/shop/refreshDataSyncShop', {}, {
                headers: {
                    'Connection' : 'keep-alive',
                    'Keep-Alive' : 'timeout=40000',
                    'X-requested-With' : 'XMLHttpRequest',
                    'Content-type': 'application/json;',
                }
            })
            .then(res => {
                // 에러 알럿 활성화
                setIsErrorAlert(true);
                /** 최초 호출시 cafe24API 호출 connection timeout 외 예외 발생시 */
                if (!res || res.data.code !== 200) {
                    if (this.hasFetchedSyncData.current) {
                        throw new Error('ERR_EMPTY_RESPONSE')
                    }
                } else {
                    /** 200/OK */
                    this.loadShopSyncStateAndSyncDate()
                    this.loadCafe24MainProductList()
                }
            })   
            .catch(error => {
                // 에러 알럿 활성화
                setIsErrorAlert(true);
                /** 서버 타임아웃 */
                subscribeShopDataSyncState(new Date().getTime())
                    .then(res => this.callBackSubscribeShopDataSyncState(res))
                
            })
        } catch (err) {
            // 에러 알럿 활성화
            setIsErrorAlert(true);
            console.log(err)
        }
    }

    callBackSubscribeShopDataSyncState = (res) => {
        this.hasFetchedSyncData.current = false
        if (res === 0) return;
        if (res === true) {
            this.setState({syncState: "0"})
            this.loadCafe24MainProductList()
        }
        else if (typeof res === "string"){
            /** 시간초과 || 서버 메세지*/
            console.log(res)
        } else {
            /** response.data 없을 경우 */
            console.err(res)
        }
    }

    loadProductColorList = () => {
        APIs.rp.getProductColorList()
        .then(res => {
            if (res.data && res.data.color_list) {
                this.setState({product_color_list : res.data.color_list});
            }
        })
        .catch(error => {});
    }

    onChangeIsExceptInvisibleCategory = (idx, value) => {
        let list_self_select = [...this.state.list_self_select];
        let new_list_self_select = list_self_select.map((obj,index) => index == idx ? {...obj, is_except_invisible_category : value} : {...obj});
        this.setState({list_self_select : new_list_self_select});
    }

    onChangeIsExceptInvisibleCategoryForce = (value) => {
        this.setState({
            force_is_except_invisible_category: value,
        });
    }

    onChangeMirroringType = (value) => {
        this.setState({
            mirroring_type: value,
        });
    }

    onChangeIsExceptOptionSoldout = (idx, value) => {
        let list_self_select = [...this.state.list_self_select];
        let new_list_self_select = list_self_select.map((obj,index) => index == idx ? {...obj, is_except_option_soldout : value} : {...obj});
        this.setState({list_self_select : new_list_self_select});
    }

    onChangeIsExceptSoldout = (idx, value) => {
        let list_self_select = [...this.state.list_self_select];
        let new_list_self_select = list_self_select.map((obj,index) => index == idx ? {...obj, is_except_soldout : value} : {...obj});
        this.setState({list_self_select : new_list_self_select});
    }
    
    selectProductColor = (idx, value) => {
        let list_self_select = [...this.state.list_self_select];
        let new_list_self_select = list_self_select.map((obj,index) => index == idx ? {...obj, color_list : value} : {...obj});
        this.setState({list_self_select : new_list_self_select});
    }

    onChangeSalePercentType = (idx, value) => {
        let list_self_select = [...this.state.list_self_select];
        let new_list_self_select = list_self_select.map((obj,index) => index == idx ? {...obj, sale_percent_type : value} : {...obj});
        this.setState({list_self_select : new_list_self_select});
    }

    /** 알고리즘 분석 표기 기준 변경 (onClickOption)
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id
    */
    onChangeEventItemAnalysisStandard(text, value, id){
        this.setState({
            analysis_standard_value : value,
        }, () => {
            /** 일원화 */
            this.reloadProductByAnalysisStandard("event_rp_product_list", this.state.event_rp_product_list, this.state.analysis_standard_value)
        });
    }
    
    // - Promise를 반환합니다(호출부에서 await 가능)
    // - 중첩 for → Map 조회로 O(n) 머지
    // - 필요한 필드만 안전하게 덮어쓰기
    // - 비어있으면 조용히 종료
    reloadProductByAnalysisStandard = async () => {
        try {
            const orgList = Array.isArray(this.state.event_rp_product_list)
            ? this.state.event_rp_product_list
            : [];

            if (orgList.length === 0) return orgList;

            const productNoList = orgList.map(it => String(it.product_no));

            const res = await APIs.rp.getProductsByAnalysisStandard(
                productNoList,
                this.state.analysis_standard_value,
                0,
                productNoList.length
            );

            const list = Array.isArray(res?.data?.list) ? res.data.list : [];
            const respMap = new Map(list.map(row => [String(row.product_no), row]));

            const fields = [
                "hit_cnt",
                "cart_cnt",
                "wish_cnt",
                "review_point",
                "review_cnt",
                "order_cnt",
                "order_rate",
                "order_price",
                "click_value",
            ];

            const nextList = orgList.map(orig => {
            const found = respMap.get(String(orig.product_no));
            if (!found) return orig;

            const patched = { ...orig };
            for (const f of fields) {
                if (found[f] !== undefined && found[f] !== null) patched[f] = found[f];
            }
            return patched;
            });

            await new Promise(resolve =>
                this.setState({ event_rp_product_list: nextList }, resolve)
            );

            return nextList;
        } catch (err) {
            console.error("reloadProductByAnalysisStandard error:", err);
            throw err;
        }
    };

    handleToggle = (state, autoCloseSecond) => {
        this.setState({
            [state] : !this.state[state]
        }, () => {
            if(autoCloseSecond){
                setTimeout(() => {this.setState({ [state] : !this.state[state] })}, autoCloseSecond*1000)
            }
        });
    }

    getListSelfSelectSend() {
        let list_self_select_send = _.cloneDeep(this.state.list_self_select);;
        for(var i=0;i<list_self_select_send.length;i++){
            list_self_select_send[i].event_item_created_start_date = StringUtil.dateFormater(list_self_select_send[i].event_item_created_start_date);
            list_self_select_send[i].event_item_created_end_date = StringUtil.dateFormater(list_self_select_send[i].event_item_created_end_date);
            delete list_self_select_send[i].category;

            delete list_self_select_send[i].product_rp_category_list_1;
            delete list_self_select_send[i].product_rp_category_list_2;
            delete list_self_select_send[i].product_rp_category_list_3;
            delete list_self_select_send[i].product_rp_category_list_4;

            delete list_self_select_send[i].product_rp_category_no_1;
            delete list_self_select_send[i].product_rp_category_no_2;
            delete list_self_select_send[i].product_rp_category_no_3;
            delete list_self_select_send[i].product_rp_category_no_4;

            delete list_self_select_send[i].self_select_area_checked;

            let color_list = list_self_select_send[i].color_list ? list_self_select_send[i].color_list.map(obj => obj.color_seq) : [];
            list_self_select_send[i].color_seq_list = color_list;
            delete list_self_select_send[i].color_list;

            delete list_self_select_send[i].force_use_yn;
            delete list_self_select_send[i].force_logic;
            delete list_self_select_send[i].force_category;
            delete list_self_select_send[i].force_auto_remove;
            delete list_self_select_send[i].force_analysis_period;
            delete list_self_select_send[i].force_select_created_yn;
            delete list_self_select_send[i].force_created_period_type;
            delete list_self_select_send[i].force_created_period;
            delete list_self_select_send[i].force_created_start_date;
            delete list_self_select_send[i].force_created_end_date;
            delete list_self_select_send[i].force_is_except_invisible_category;
            delete list_self_select_send[i].max_item_analysis;
            delete list_self_select_send[i].max_item_analysis_value;
            delete list_self_select_send[i].total_sort_type;

            // 제외 카테고리 번호 리스트 재가공
            if (Array.isArray(list_self_select_send[i].product_rp_except_category_no_list)) {
                list_self_select_send[i].event_except_category_list =
                    list_self_select_send[i].product_rp_except_category_no_list
                        .map((exceptObj) => {
                            const categoryNo = (
                                exceptObj.product_rp_except_category_no_4 ||
                                exceptObj.product_rp_except_category_no_3 ||
                                exceptObj.product_rp_except_category_no_2 ||
                                exceptObj.product_rp_except_category_no_1 ||
                                ""
                            );

                            return categoryNo === "전체상품" ? "" : categoryNo;
                        })
                        .filter((categoryNo) => categoryNo !== "");
            }

            if (list_self_select_send[i].event_main_display_group == null) {
                list_self_select_send[i].event_main_display_group = "";
            } else {
                list_self_select_send[i].event_main_display_group = String(list_self_select_send[i].event_main_display_group);
            }

            if (!Array.isArray(list_self_select_send[i].event_except_main_display_group_list)) {
                list_self_select_send[i].event_except_main_display_group_list = [];
            } else {
                list_self_select_send[i].event_except_main_display_group_list =
                    list_self_select_send[i].event_except_main_display_group_list.map(String);
            }

            if (!Array.isArray(list_self_select_send[i].self_except_setting_list)) {
                list_self_select_send[i].self_except_setting_list = [];
            } else {
                list_self_select_send[i].self_except_setting_list =
                    list_self_select_send[i].self_except_setting_list.map(exceptObj => ({
                        id: exceptObj.id,
                        iframe_page_id: exceptObj.iframe_page_id,
                        iframe_html_id: exceptObj.iframe_html_id,
                        name: exceptObj.name,

                        cafe24_main_display_group: exceptObj.cafe24_main_display_group,
                        cafe24_category_display_group: exceptObj.cafe24_category_display_group,
                        cafe24_category_no_list: exceptObj.cafe24_category_no_list,
                        event_category_select_type: exceptObj.event_category_select_type,

                        except_event_category_no: exceptObj.except_event_category_no || "",
                        except_event_category_name_no_format: exceptObj.except_event_category_name_no_format || "",

                        except_order_start_no: exceptObj.except_order_start_no == null ? "" : String(exceptObj.except_order_start_no),
                        except_order_end_no: exceptObj.except_order_end_no == null ? "" : String(exceptObj.except_order_end_no),
                    }));
            }
        }

        let last_select_index = list_self_select_send.length-1;
        list_self_select_send[last_select_index].force_use_yn = this.state.force_use_yn;
        list_self_select_send[last_select_index].force_logic = this.state.force_logic;
        list_self_select_send[last_select_index].force_category = this.state.force_category;
        list_self_select_send[last_select_index].force_auto_remove = this.state.force_auto_remove;
        list_self_select_send[last_select_index].force_analysis_period = this.state.force_analysis_period;
        list_self_select_send[last_select_index].force_select_created_yn = this.state.force_select_created_yn;
        list_self_select_send[last_select_index].force_created_period_type = this.state.force_created_period_type;
        list_self_select_send[last_select_index].force_created_period = this.state.force_created_period;
        list_self_select_send[last_select_index].force_created_start_date = StringUtil.dateFormater(this.state.force_created_start_date);
        list_self_select_send[last_select_index].force_created_end_date = StringUtil.dateFormater(this.state.force_created_end_date);
        list_self_select_send[last_select_index].force_is_except_invisible_category = this.state.force_is_except_invisible_category;
        list_self_select_send[last_select_index].max_item_analysis = this.state.max_item_analysis;
        list_self_select_send[last_select_index].max_item_analysis_value = this.state.max_item_analysis_value;
        list_self_select_send[last_select_index].total_sort_type = this.state.total_sort_type;

        return list_self_select_send;
    }

    addEssentialProduct = (list_self_select_uuid, newProductNoList) => {
        let {list_self_select} = this.state;
        let obj = {}
        for (let idx in list_self_select) {
            if (list_self_select[idx]["uuid"] == list_self_select_uuid) {
                obj = {...list_self_select[idx]};
                obj["essential_product_no_list"] = newProductNoList;
                list_self_select[idx] = obj;
                this.setState({
                    list_self_select: list_self_select
                })
                break;
            }
        }

    }

    /** 총 필수 상품 개수 추출 */
    totalEssentialProductCnt() {
        let totalEssentialProductCnt = 0;
        const {list_self_select} = this.state
        for(let idx in list_self_select) {
            totalEssentialProductCnt+= list_self_select[idx]["essential_product_no_list"] ? list_self_select[idx]["essential_product_no_list"].length : 0;
        }
        // console.log("totalEssentialProductCnt", totalEssentialProductCnt);
        return totalEssentialProductCnt;
    }

    /**
     * 실시간 서비스 신청 여부 & 이용 여부
     */
    loadRegistedService(service_type) {
        http.get("/rest/shop/get/additionFunction?function_cd="+service_type)
        .then(res => {
            let regist_state_name = "regist_yn_"+service_type;
            let operate_state_name = "operate_yn_"+service_type;
            this.setState({
                [regist_state_name]: res.data.regist_cnt > 0 ? "Y" : "N",
                [operate_state_name]: res.data.operate_cnt > 0 ? "Y" : "N",
            })
        }).catch(error => {
            console.log(error);
        });
    }

    /** 시작 날짜 변경 */
    handleChangeStartDate = date => {
        console.log("###### date", date);
        // if (date != null) {
            this.setState({
                event_start_date: date,
                left_is_modified : true,
            });
        // } 
    };
    onChangeEventStartHour(text, value, id){
        this.setState({
            event_start_hour : value,
            left_is_modified : true,
        });
    }

    onChangeWeekdayCycle(text, value, id){
        this.setState({
            weekday_cycle : value,
            left_is_modified : true,
        });
    }

    onChangeRealTimeCycle(text, value, id){
        this.setState({
            real_time_cycle : value,
            left_is_modified : true, // event_start_hour
        });
    }

    onChangeAutoCreateType(e){
        if (e.target.value == 'A7001' || e.target.value == 'A7003') {
            if(this.state.is_main_auto_display_use || this.state.is_category_auto_display_use) {
                this.autoDisplayWarningDialoog();
                return false;
            }
            if(this.state.iframe_page_id=='robomd_cafe24_main_page' && this.state.cafe24_main_page_over_product){
                alert("진열 되어있는 상품 수가 "+cafe24_main_page_max_product_num+"개를 넘겼습니다.\ncafe24 관리자에서 상품 수를 "+cafe24_main_page_max_product_num+"개 이하로 수정 후 사용해 주세요.");
                return false;
            }
        }

        let event_cycle_type = this.state.event_cycle_type;
        let event_cycle = this.state.event_cycle;
        let event_time = this.state.event_time;
        if (e.target.value == 'A7003') {
            if (this.state.operate_yn_0100201001 == "Y" || this.state.operate_yn_0100201002 == "Y") {
                event_cycle_type = 'A8003';
            } else {
                this.setState({
                    real_time_service_regist_show_state : true
                })
                return false;
            }
        } else if (e.target.value == 'A7001') {
            if (this.state.event_cycle_type == 'A8003') {
                event_cycle_type = 'A8001';
            }

            if (this.state.event_total_item_select_cnt > flagCafe24BulkConversionProductCount) {
                const {event_cycle_type} = this.state;
                this.setState({
                    event_cycle_type: event_cycle_type == "A8003" ? "A8001" : event_cycle_type,
                    event_cycle: "2",
                    event_time: "3",
                })
            } else {
                if (event_cycle == null || event_cycle == "") {
                    event_cycle = "2";
                    event_time = "7";
                } 
                this.setState({
                    event_cycle: event_cycle,
                    event_time: event_time,
                })
            }
        }

        this.setState({
            auto_create_type : e.target.value,
            event_cycle_type : event_cycle_type,
            left_is_modified : true,
        });
    }

    onChangeReservationUseYn(e) {
        if(this.state.is_main_auto_display_use || this.state.is_category_auto_display_use) {
            this.autoDisplayWarningDialoog();
            return false;
        }
        if(this.state.iframe_page_id=='robomd_cafe24_main_page' && this.state.cafe24_main_page_over_product){
            alert("진열 되어있는 상품 수가 "+cafe24_main_page_max_product_num+"개를 넘겼습니다.\ncafe24 관리자에서 상품 수를 "+cafe24_main_page_max_product_num+"개 이하로 수정 후 사용해 주세요.");
            return false;
        }
        if(this.state.iframe_page_id=='robomd_cafe24_main_page' && this.state.event_rp_product_list.length > cafe24_main_page_max_product_num){
            alert("미리보기에 추가된 상품수가 "+cafe24_main_page_max_product_num+"개를 넘겼습니다.\n미리보기에 추가된 상품 수를 "+cafe24_main_page_max_product_num+"개 이하로 수정 후 사용해 주세요.");
            return false;
        }
        if(this.state.iframe_page_id=='robomd_cafe24_category_page' && this.state.event_rp_product_list.length > nayeol_event_total_item_select_range_category){
            alert("미리보기에 추가된 상품수가 "+nayeol_event_total_item_select_range_category+"개를 넘겼습니다.\n미리보기에 추가된 상품 수를 "+nayeol_event_total_item_select_range_category+"개 이하로 수정 후 사용해 주세요.");
            return false;
        }
        if (e.target.value == "Y") {
            if(this.state.is_main_auto_display_use || this.state.is_category_auto_display_use) {
                this.autoDisplayWarningDialoog();
                return false;
            }
        }
        this.setState({
            reservation_use_yn: e.target.value,
        })
    }

    handleChangeReservationDate = date => {
        console.log("###### date", date);
        // if (date != null) {
            this.setState({
                reservation_date: date,
                left_is_modified : true,
            });
        // } 
    };
    onChangeReservationHour(text, value, id){
        this.setState({
            reservation_hour : value,
            left_is_modified : true,
        });
    }

    onClickWeeklyButton(obj) {
        const {weekday_list} = this.state;
        if (weekday_list != null) {
            let array_weekday_list = weekday_list ? weekday_list.split(",") : [];
            if (obj.code_cd == "-1") {
                if (array_weekday_list.filter(day => day.trim() != "-1").length < 7) {
                    array_weekday_list = [];
                    for (let idx = -1; idx <=6; idx++) {
                        array_weekday_list.push(idx);
                    }
                } else {
                    array_weekday_list = [];
                }
            } else if (array_weekday_list.indexOf(obj.code_cd) >= 0) {
                array_weekday_list = array_weekday_list.filter(weekday => weekday != obj.code_cd);
                if (array_weekday_list.filter(day => day.trim() != "-1").length < 7) {
                    array_weekday_list = array_weekday_list.filter(day => day.trim() != "-1");
                }
            } else {
                array_weekday_list.push(obj.code_cd);
                if (array_weekday_list.filter(day => day.trim() != "-1").length >= 7) {
                    array_weekday_list = array_weekday_list.filter(day => day.trim() != "-1");
                    array_weekday_list.push("-1");
                } else {
                    array_weekday_list = array_weekday_list.filter(day => day.trim() != "-1");
                }
            }
            this.setState({
                weekday_list : array_weekday_list.toString().replace("[").replace("]")
            })
        }
    }

    renderDailySetting () {
        return (
            <>
                {/* "일별" */}
                <div className='text_small list_admin_side_design_title m-b-8' style={{marginTop:"18px", marginBottom: "8px"}}>반복주기</div>
                <div class="list_admin_side_row_5_select">
                    <div>
                        <div class="list_admin_side_select_area">
                            {/* {this.state.auto_create_yn=="Y"
                            ? */}
                            <SelectBoxV2
                                id={"event_cycle_select"}
                                tabIndex={0}
                                width="100%"
                                height="36px"
                                padding="14px 36px 14px 16px"
                                list= {this.state.event_cycle_list}
                                optionTexttName = "title"
                                optionValuetName = "value"
                                // selectAreaMaxHeight = "120px"
                                selectedValue = {this.state.event_cycle}
                                onClickOption={this.onChangeEventCycle.bind(this)}
                            />
                        </div>
                        <span class="text_14" style={{marginLeft:"4px", paddingBottom: 0}}>마다</span>
                    </div>
                    <div class="list_auto_selected_last_div">
                        <div class="list_admin_side_select_area">
                        {
                            // 자동 진열 시각
                            // this.state.auto_create_yn === "Y"
                            // ?
                            <SelectBoxV2
                                id={"event_time_select"}
                                tabIndex={0}
                                width="100%"
                                height="36px"
                                padding="14px 36px 14px 16px"
                                list= {this.state.event_time_list}
                                disabled={this.state.event_total_item_select_cnt > flagCafe24BulkConversionProductCount ? true : false}
                                optionTexttName = "title"
                                optionValuetName = "value"
                                // selectAreaMaxHeight = "120px"
                                selectedValue = {this.state.event_time}
                                onClickOption={this.onChangeEventTime.bind(this)}
                            />
                        }
                        </div>
                        <span class="text_14" style={{marginLeft:"4px", paddingBottom: 0}}>에 추천함</span>
                    </div>
                </div>
                <div>
                <div className='text_small list_admin_side_design_title m-b-8' style={{marginBottom: "8px"}}>자동진열 시작 날짜</div>
                    <div className='flexBox' style={{justifyContent:'space-between', }}>
                        <div className='flexBox'>
                            <div className="style_guide_v2 rp_event_start_date_wrapper" style={{width:"170px"}}>
                                <DatePicker name="event_start_date" id="event_start_date" className="rp_event_start_date border_form_radius_b_h_42"
                                    selected={this.state.event_start_date}
                                    // onSelect={this.handleSelect} //when day is clicked
                                    onChange={this.handleChangeStartDate} //only when value has changed
                                    placeholderText="마지막 쇼핑몰적용"
                                    // showTimeSelect
                                    // minDate={moment().add(1,'days').toDate()}
                                    maxDate={new Date("9999-12-31")}
                                    dateFormat="yyyy-MM-dd"
                                    locale={ko}
                                    todayButton="오늘"
                                    autoComplete="off"
                                    showYearDropdown
                                    yearDropdownItemNumber={15}
                                    scrollableYearDropdown
                                />
                                <div className="icn_calendar"/>
                            </div>
                            <span className="text_14 m-l-5" style={{alignContent: "center"}}>{"부터 진열함"}</span>
                        </div>
                    </div>
                </div>
            </>
        )
    }
    renderWeeklySetting () {
        return (
            <>
                {/* "요일별" */}
                <div className='text_small list_admin_side_design_title m-b-8' style={{marginTop:"18px", marginBottom: "8px"}}>반복요일</div>
                <div class="list_admin_side_row_5_select rp_weekday" id="rp_weekday">
                    {this.state.weekday_selectbox_list.map((obj, idx) => (
                        <button style={{fontWeight: 400, border: "1px solid #d1d1d1", flex: obj.code_name.length >=2 ? 1.5 : 1, justifyContent: "center", backgroundColor: (this.state.weekday_list.indexOf(obj.code_cd) >= 0 || (obj.code_cd == -1 && this.state.weekday_list && this.state.weekday_list.split(",").filter(day => day.trim() != "-1").length >= 7)) ? "#C4F6FD" : null}}
                        onClick={ () => {
                                this.onClickWeeklyButton(obj);
                            }
                        }
                        >
                            {obj.code_name}
                        </button>
                    ))}
                    {/* <div className='m-l-5'> 추천함</div> */}
                </div>
                <div className='text_small list_admin_side_design_title m-b-8' style={{marginBottom: "8px"}}>반복시간</div>
                <div class="list_admin_side_row_5_select">
                    <div className='list_auto_selected_last_div'>
                        <div class="list_admin_side_select_area">
                            <SelectBoxV2
                                id={"weekday_event_time"}
                                tabIndex={0}
                                width="100%"
                                height="36px"
                                padding="14px 36px 14px 16px"
                                list= {this.state.event_time_list}
                                disabled={this.state.event_total_item_select_cnt > flagCafe24BulkConversionProductCount ? true : false}
                                optionTexttName = "title"
                                optionValuetName = "value"
                                // selectAreaMaxHeight = "120px"
                                selectedValue = {this.state.event_time}
                                onClickOption={this.onChangeEventTime.bind(this)}
                            />
                        </div>
                        <span class="text_14" style={{marginLeft:"4px", paddingBottom: 0}}>에</span>
                    </div>
                </div>
                <div>
                    <div className='text_small list_admin_side_design_title m-b-8' style={{marginBottom: "8px"}}>자동진열 시작 날짜</div>
                    <div className='flexBox' style={{justifyContent:'space-between', }}>
                        <div className='flexBox'>
                            <div className="style_guide_v2 rp_event_start_date_wrapper" style={{width:"170px"}}>
                                <DatePicker name="event_start_date" id="event_start_date" className="rp_event_start_date border_form_radius_b_h_42"
                                    selected={this.state.event_start_date}
                                    // onSelect={this.handleSelect} //when day is clicked
                                    onChange={this.handleChangeStartDate} //only when value has changed
                                    placeholderText="마지막 쇼핑몰적용"
                                    // showTimeSelect
                                    // minDate={moment().add(1,'days').toDate()}
                                    maxDate={new Date("9999-12-31")}
                                    dateFormat="yyyy-MM-dd"
                                    locale={ko}
                                    todayButton="오늘"
                                    autoComplete="off"
                                    showYearDropdown
                                    yearDropdownItemNumber={15}
                                    scrollableYearDropdown
                                />
                                <div className="icn_calendar"/>
                            </div>
                            <span className="text_14 m-l-5" style={{alignContent: "center"}}>{"부터 진열함"}</span>
                        </div>
                    </div>
                </div>
            </>
        )
    }
    renderRealTimeSetting () {
        return (
            <>
                <div className='real_time_waraper'>
                    <div className='text_small list_admin_side_design_title m-b-8' style={{marginTop:"18px", marginBottom: "8px"}}>반복주기</div>
                    <div class="flexBox">
                        {/* <span class="text_14" style={{paddingBottom: 0}}>매일</span> */}
                        <div>
                            <div className="list_admin_side_select_area">
                            <SelectBoxV2
                                id={"weekday_event_time"}
                                tabIndex={0}
                                width="100%"
                                height="36px"
                                padding="14px 36px 14px 16px"
                                list= {this.state.operate_yn_0100201002 == "Y" ? this.state.real_time_cycle_selectbox_list_by_premium : this.state.real_time_cycle_selectbox_list_by_basic}
                                optionTexttName = "code_name"
                                optionValuetName = "code_cd"
                                // selectAreaMaxHeight = "120px"
                                selectedValue = {this.state.real_time_cycle}
                                onClickOption={this.onChangeRealTimeCycle.bind(this)}
                            />
                            </div>
                        </div>
                        <span class="text_14 m-l-5" style={{paddingBottom: 0}}>마다</span>
                    </div>
                    <div className='text_small list_admin_side_design_title m-b-8' style={{marginBottom: "8px"}}>반복요일</div>
                    <div class="list_admin_side_row_5_select rp_weekday" id="rp_weekday">
                        {this.state.weekday_selectbox_list.map((obj, idx) => (
                            <button style={{fontWeight: 400, border: "1px solid #d1d1d1", flex: obj.code_name.length >=2 ? 1.5 : 1, justifyContent: "center", backgroundColor: (this.state.weekday_list.indexOf(obj.code_cd) >= 0 || (obj.code_cd == -1 && this.state.weekday_list && this.state.weekday_list.split(",").filter(day => day.trim() != "-1").length >= 7)) ? "#C4F6FD" : null}}
                            onClick={ () => {
                                    this.onClickWeeklyButton(obj);
                                }
                            }
                            >
                                {obj.code_name}
                            </button>
                        ))}
                        {/* <div className='m-l-5'> 추천함</div> */}
                    </div>
                    <div className='text_small list_admin_side_design_title m-b-8' style={{marginBottom: "8px"}}>반복 적용 시간</div>
                    <div className="flexBox">
                        <div className='flexBox'>
                            <div class="list_admin_side_select_area">
                            {
                                <SelectBoxV2
                                    id={"event_time_select"}
                                    tabIndex={0}
                                    width="100%"
                                    height="36px"
                                    padding="14px 36px 14px 16px"
                                    list= {this.state.event_time_list}
                                    optionTexttName = "title"
                                    optionValuetName = "value"
                                    // selectAreaMaxHeight = "120px"
                                    selectedValue = {this.state.real_time_start_hour}
                                    onClickOption={this.onChangeRealEventStartHour.bind(this)}
                                />
                            }
                            </div>
                            <span class="text_14" style={{marginLeft:"4px", paddingBottom: 0}}>부터</span>
                        </div>
                        <div class="flexBox m-l-10">
                            <div class="list_admin_side_select_area">
                            {
                                <SelectBoxV2
                                    id={"event_time_select"}
                                    tabIndex={0}
                                    width="100%"
                                    height="36px"
                                    padding="14px 36px 14px 16px"
                                    list= {this.state.event_time_list_v2}
                                    optionTexttName = "title"
                                    optionValuetName = "value"
                                    // selectAreaMaxHeight = "120px"
                                    selectedValue = {this.state.real_time_end_hour}
                                    onClickOption={this.onChangeRealEventEndHour.bind(this)}
                                />
                            }
                            </div>
                            <span class="text_14" style={{marginLeft:"4px", paddingBottom: 0}}>까지</span>
                        </div>
                    </div>    

                    <div className='text_small list_admin_side_design_title m-b-8' style={{marginBottom: "8px"}}>자동진열 시작 날짜</div>
                    <div className='flexBox' style={{justifyContent:'space-between', }}>
                        <div className='flexBox'>
                            <div className="style_guide_v2 rp_event_start_date_wrapper" style={{width:"170px"}}>
                                    <DatePicker name="event_start_date" id="event_start_date" className="rp_event_start_date border_form_radius_b_h_42"
                                        selected={this.state.event_start_date}
                                        // onSelect={this.handleSelect} //when day is clicked
                                        onChange={this.handleChangeStartDate} //only when value has changed
                                        placeholderText="마지막 쇼핑몰적용"
                                        // showTimeSelect
                                        // minDate={moment().add(1,'days').toDate()}
                                        maxDate={new Date("9999-12-31")}
                                        dateFormat="yyyy-MM-dd"
                                        locale={ko}
                                        todayButton="오늘"
                                        autoComplete="off"
                                        showYearDropdown
                                        yearDropdownItemNumber={15}
                                        scrollableYearDropdown
                                    />
                                    <div className="icn_calendar"/>
                            </div>
                            <span className="text_14 m-l-5" style={{alignContent: "center"}}>{"부터 진열함"}</span>
                        </div>
                    </div>
                    <div className='text_small list_admin_side_design_title m-b-8' style={{marginBottom: "8px"}}>리얼타임 랭킹위젯</div>
                    <div className='real_time_txt_use_yn flexBox'>
                    {
                        this.state.use_yn_list.map((obj, idx) => (
                            <RadioButton
                                id={"real_time_txt_use"+obj.value}
                                name={"real_time_txt_use_yn"}
                                value={obj.value}
                                text={obj.text}
                                checked={this.state.real_time_txt_use_yn==obj.value}
                                onChangeCheck={e => {
                                    this.setState({
                                        real_time_txt_use_yn: obj.value
                                    })
                                }}
                            />
                        ))
                    }
                    </div>
                </div>
            </>
        )
    }

    /**
     * 자주 사용하는 알고리즘 저장
     * @param {*} algorithm_name 
     */
    saveFavoriteAlgorithm(e) {
        this.setState({
            input_dialog_show_state: true,
            input_dialog_title: "알고리즘 제목을 입력해 주세요.",
            input_dialog_content: "",
            input_dialog_input_value: "",
            input_dialog_input_placeholder : "",
            input_dialog_button_list: [
                {
                    title: "저장",
                    type: "1",
                    event_method: (e) => {
                        // list_self_select는 저장시에 json 형태로 통으로 저장되기 때문에 프론트에서 사용하기 위해 독자적으로 넣은 데이터는 삭제하여 전송
                        let list_self_select_send = this.getListSelfSelectSend();

                        const config = {
                            headers: {
                                'Content-Type': 'application/json',
                                },
                        };
                        const url = "/rest/shop/rp/favorite/algorithm/save";
                        const body = {
                            iframe_page_id : this.state.iframe_page_id,
                            iframe_html_id : this.state.iframe_html_id,
                            cafe24_category_display_group : this.state.cafe24_category_display_group,
                            algorithm_name : e.target.value,
                            manual_json : list_self_select_send,
                        }

                        this.setState({
                            input_dialog_show_state: false,
                            confirm_dialog_show_state: false,
                            save_dialog_show_state: true,
                            save_dialog_content: "저장 중 입니다.",
                            save_dialog_button_list: [
                                {
                                    title: "확인",
                                    type: "1",
                                    display_yn:"N",
                                    event_method: () => {
                                        //팝업 닫기
                                        this.setState({ save_dialog_show_state: false });
                                    }
                                }
                            ]
                        });

                        http.post(url, body, config)
                        .then((res) => {
                            this.setState({
                                save_dialog_show_state : false,
                                basic_dialog_show_state: true,
                                basic_dialog_content: res.data.insert_cnt > 0 ? "저장하였습니다." : "저장에 실패하였습니다.",
                                basic_dialog_button_list: [
                                    {
                                        title: "확인",
                                        type: "1",
                                        event_method: () => {
                                            //팝업 닫기
                                            this.setState({ basic_dialog_show_state: false });
                                        }
                                    }
                                ]
                            });
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                    }
                },
                {
                    title: "취소",
                    type: "0",
                    event_method: () => {
                        this.setState({input_dialog_show_state: false});
                    }
                }
            ]
        });
    }

    onClicAlgorithmDetailFilterFolder(e, idx, cnt_focus) {
        const target = "#detail_filter_header_" + idx;
        const list_select = $(target).outerHeight();
        const list_select_1 = $(target).next(".detail_filter_area").outerHeight();
        const list_select_total = list_select + list_select_1;
        let { list_self_select } = this.state;
        const parentWrap = $(target).parent(".detail_filter_wrapper");
        const expandContent = parentWrap.children(".detail_filter_area");
        const detailFilterSummary = parentWrap.next(".detail_filter_summary");
    
        if (!$(target).find(".detail_filter_expand_check").is(":checked")) { // 펼치기
            $(target).find(".detail_filter_expand_check").prop('checked', true);
            detailFilterSummary.hide();

            this.syncAlgorithmExpandWrap(idx);
    
            parentWrap.animate({ height: list_select_total }, 300, () => {
                expandContent.removeClass("hidden_algorithm").addClass("visible_algorithm");
                parentWrap.css({ overflow: "visible", height: "auto" });
            });
            list_self_select[idx].detail_filter_expand_check = true;
        } else { // 접기
            $(target).find(".detail_filter_expand_check").prop('checked', false);
            detailFilterSummary.show();

            // 접기 애니메이션: 현재 높이에서 0으로 줄어들게 함
            parentWrap.animate({ height: list_select }, 300, () => {
                expandContent.removeClass("visible_algorithm").addClass("hidden_algorithm");
                parentWrap.css({ overflow: "hidden", height: "auto" });

                this.syncAlgorithmExpandWrap(idx);
            });
            list_self_select[idx].detail_filter_expand_check = false;
        }
    
        this.setState({
            list_self_select: list_self_select,
        });
    }

    syncAlgorithmExpandWrap = (idx) => {
        const $target = $("#list_select_expand_" + idx);
        const $parentWrap = $target.parent(".list_select_expand_wrap");
        const $expandContent = $parentWrap.children(".list_select_expand_1");

        if (!$target.length || !$parentWrap.length || !$expandContent.length) {
            return;
        }

        $expandContent.removeClass("hidden_algorithm").addClass("visible_algorithm");
        $("#list_select_arrow_" + idx).prop("checked", true);
        $parentWrap.css({
            overflow: "visible",
            height: "auto"
        });
    }

    onClicRemoveMinMaxFilter(min_target_name, max_target_name, idx) {
        let {list_self_select} = this.state;
        list_self_select[idx][min_target_name] = "";
        list_self_select[idx][max_target_name] = "";
        this.setState({
            list_self_select : list_self_select,
            left_is_modified : true,
        });
    }

    onClicRemoveListFilter(target_name, idx) {
        let {list_self_select} = this.state;
        list_self_select[idx][target_name] = [];
        this.setState({
            list_self_select : list_self_select,
            left_is_modified : true,
        });
    }

     /** 직접 지정 : 과거 판매 상품 정렬 기준
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id(question_idx, answer_idx 포함)
    */
    onChangePastOrderSortType(text, value, id) {
        let idx = id.split("_")[6];

        let {list_self_select} = this.state;
        let list = _.cloneDeep(this.state.list_self_select);
        list[idx]["past_order_sort_type"] = value;

        this.setState({
            list_self_select : list,
            left_is_modified : true,
        });
    }

    /* 어떤 알고리즘인지 리턴 */
    getWhichAlgorithm(item_select_type_self_list, uuid) {
        const {list_self_select} = this.state
        let algorithm_idx = -1;
        let algorithm_name = "";
        if (uuid) { // 저장된 uuid가 있는 경우만 실행 
            if (uuid != "-1") {
                for(let idx in list_self_select) {
                    if (list_self_select[idx]["uuid"] == uuid) {
                        for(let i in item_select_type_self_list){
                            if(item_select_type_self_list[i].code_cd == list_self_select[idx]["cd"]){
                                algorithm_idx = idx;
                                algorithm_name = (Number(algorithm_idx) + 1)+"순위 진열 상품 설정";
                                break;
                            }
                        }
                        break;
                    }
                }
                if (algorithm_idx == -1) {
                    algorithm_name = "알 수 없음"
                }
            } else {
                algorithm_name = "백업용 | 자동진열할 상품  부족시  상품설정"
            }
        }
        
        return algorithm_name
    }

    /** 상품 카테고리 변경 (onClickOption)
     * @param {*} text 셀렉트 박스 선택된 option 이름
     * @param {*} value 셀렉트 박스 선택된 option 값
     * @param {*} id 셀렉트 박스 id(question_idx, answer_idx 포함)
    */
    onChangeRpExceptCategory = (text, value, id) => {
        const current_category = id.split('/')[0];
        const index = id.split('/')[1];
        const except_category_idx = id.split('/')[2]; 
        const depth = Number(current_category.split('_')[5])+1;
        var category_name = "product_rp_except_category_no_"+(Number(depth)-1);
        let {list_self_select} = this.state;
        let list = _.cloneDeep(this.state.list_self_select);
        var event_except_category_list = list[index].event_except_category_list ? list[index].event_except_category_list : [];

        let product_rp_except_category_no_list = list[index]["product_rp_except_category_no_list"];
        let product_rp_except_category_no_inner_list = product_rp_except_category_no_list[except_category_idx];
            
        // 전체상품을 선택한 경우, 대카테고리가 아니면 상위 카테고리 번호를 대표 카테고리 번호로 설정
        if((value=="전체상품" || value == "")){
            if(Number(depth)>2){
                const parent_category_no = product_rp_except_category_no_inner_list["product_rp_except_category_no_"+(Number(depth)-2)];
                event_except_category_list[except_category_idx] = parent_category_no;
            } else{ // 대카테고리인 경우 ""로 변경
                event_except_category_list[except_category_idx] = "";
            }
        }else{
            event_except_category_list[except_category_idx] = value;
        }
        product_rp_except_category_no_inner_list[category_name] = value;
        list[index]["event_except_category_list"] = event_except_category_list;
        
        console.log("event_except_category_list", event_except_category_list);

        if(this.state.event_category_select_type=="34001"){
            this.setState({
                list_self_select : list,
                left_is_modified : true,
            })
        } else{
            this.setState({
                list_self_select : list,
                left_is_modified : true,
            })
        }

        // 세분류가 아니라면 하위카테고리 관련 작업을 진행
        if(depth < 5){

            // 선택한 카테고리의 자식 카테고리 목록을 불러온다
            if (value !="전체상품" && value !="") {
                this.loadProductExceptCategory(value, depth, "product_rp_except_category_list_", index, except_category_idx);
            } else{
                var category_list = "product_rp_except_category_list_"+depth;
                product_rp_except_category_no_inner_list[category_list] = [];
                this.setState({ list_self_select : list });
            }

            // 선택한 카테고리의 하위 카테고리 리스트를 초기화 시킨다
            for(var idx = depth+1; idx <=4; idx++) {
                var category_list = "product_rp_except_category_list_"+idx;
                product_rp_except_category_no_inner_list[category_list] = [];
                this.setState({ list_self_select : list});
            }

            // 선택한 카테고리 이후의 자식 카테고리 넘버를 초기화 시킨다
            for(var idx = depth; idx <=4; idx++) {
                var category_name = "product_rp_except_category_no_"+idx;
                product_rp_except_category_no_inner_list[category_name] = "";
                this.setState({
                    list_self_select : list,
                });
            }
        }
    }

    addExceptCategoryList = (idx, except_category_idx) => {
        let list = _.cloneDeep(this.state.list_self_select);
        let product_rp_except_category_no_list = list[idx]["product_rp_except_category_no_list"];
        let first_category_list = _.cloneDeep(this.state.first_category_list);
    
        if (first_category_list != null && first_category_list[0] != null) {
            first_category_list[0] = {
                "category_name": "사용 안함",
                "category_name_no_format": "사용 안함",
                "category_no": ""
            };
        }
    
        // 배열이 null이거나 정의되지 않은 경우 초기화
        if (!product_rp_except_category_no_list) {
            product_rp_except_category_no_list = [];
            list[idx]["product_rp_except_category_no_list"] = product_rp_except_category_no_list;
        }
    
        // 해당 위치에 값이 존재하면 한 칸 뒤로 밀어야 함
        if (product_rp_except_category_no_list.length > except_category_idx + 1) {
            product_rp_except_category_no_list.splice(except_category_idx + 1, 0, {});
        } else {
            product_rp_except_category_no_list.push({});
        }
    
        // 값 할당
        product_rp_except_category_no_list[except_category_idx + 1]["product_rp_except_category_list_1"] = first_category_list;
        product_rp_except_category_no_list[except_category_idx + 1]["product_rp_except_category_no_1"] = "";
    
        let event_except_category_list = list[idx].event_except_category_list ? [...list[idx].event_except_category_list] : [];
    
        if (event_except_category_list.length > except_category_idx + 1) {
            event_except_category_list.splice(except_category_idx + 1, 0, "");
        } else {
            event_except_category_list[except_category_idx + 1] = "";
        }
    
        list[idx]["event_except_category_list"] = event_except_category_list;
    
        // 상태 업데이트
        this.setState({
            list_self_select: list,
        });
    
        console.log(product_rp_except_category_no_list); 
        console.log(list); 
        console.log(event_except_category_list); 
    };
    

    deleteExceptCategoryList = (idx, except_category_idx) => {
        let list = _.cloneDeep(this.state.list_self_select);
    
        // 예외 카테고리 리스트 가져오기
        let product_rp_except_category_no_list = list[idx]["product_rp_except_category_no_list"];
        let event_except_category_list = list[idx]["event_except_category_list"];
    
        // 배열이 null이거나 정의되지 않은 경우 초기화
        if (!product_rp_except_category_no_list) {
            product_rp_except_category_no_list = [];
            list[idx]["product_rp_except_category_no_list"] = product_rp_except_category_no_list;
        }
    
        if (!event_except_category_list) {
            event_except_category_list = [];
            list[idx]["event_except_category_list"] = event_except_category_list;
        }
    
        // 해당 인덱스가 유효하면 삭제
        if (product_rp_except_category_no_list.length > except_category_idx) {
            product_rp_except_category_no_list.splice(except_category_idx, 1);
        }
    
        if (event_except_category_list.length > except_category_idx) {
            event_except_category_list.splice(except_category_idx, 1);
        }
    
        // 상태 업데이트
        this.setState({
            list_self_select: list,
        });
    
        console.log(product_rp_except_category_no_list);
        console.log(list);
        console.log(event_except_category_list);
    }
    
    onChangeProductPreviewType() {
        this.setState({
            product_preview_type: this.state.product_preview_type == "1" ? "2" : "1",
        });
    }

    handleDragEnd = (event) => {
        const scrollTop = this.list_main_board_table_wrap.current.scrollTop;
        const { active, over } = event;
        if (!over || active.id === over.id) return;
    
        const items = JSON.parse(JSON.stringify(this.state.event_rp_product_list));
        const oldIndex = items.findIndex(item => item.product_no === active.id);
        const newIndex = items.findIndex(item => item.product_no === over.id);
    
        if (oldIndex !== -1 && newIndex !== -1) {
          const [moved] = items.splice(oldIndex, 1);
          items.splice(newIndex, 0, moved);
          this.setState({ event_rp_product_list: items }, () => {
            requestAnimationFrame(() => { // 렌더링이 "완전히 끝난 후" 한 번만 콜백을 실행
                this.list_main_board_table_wrap.current.scrollTop = scrollTop;
            });
          });
        }
    };

    setGridColumnCount(value) {
        this.setState({
            grid_column_count: value
        })
    }

    // 버튼 onClick={() => this.toggleFixed(item.product_no)} 형태로 사용
    toggleFixed = (product_no) => {
        this.setState(prev => ({
            event_rp_product_list: (prev.event_rp_product_list || []).map(item =>
            String(item.product_no) === String(product_no)
                ? { ...item, is_fixed: !Boolean(item.is_fixed) }
                : item
            )
        }));
    };

    getSelfSelectMainCategoryOptions(useAll) {
        const list = Array.isArray(this.state.self_select_main_category_list)
            ? this.state.self_select_main_category_list
            : [];

        const result = list.map(obj => ({
            display_group: String(obj.display_group),
            display_group_format: obj.display_group_format
        }));

        if (useAll) {
            return [
                {
                    display_group: "",
                    display_group_format: "선택 안함"
                },
                ...result
            ];
        }

        return result;
    }

    getSelectedExceptMainCategoryOptions(eventExceptMainDisplayGroupList) {
        const selectedList = Array.isArray(eventExceptMainDisplayGroupList)
            ? eventExceptMainDisplayGroupList.map(String)
            : [];

        return this.getSelfSelectMainCategoryOptions(false).filter(obj =>
            selectedList.indexOf(String(obj.display_group)) !== -1
        );
    }

    onChangeSelfSelectMainDisplayGroup = (text, value, id) => {
        const idx = id.split("/")[1];

        let list = _.cloneDeep(this.state.list_self_select);

        list[idx]["event_main_display_group"] = value == null ? "" : String(value);

        this.setState({
            list_self_select: list,
            left_is_modified: true
        });
    }

    onChangeSelfSelectExceptMainDisplayGroup = (idx, selectedOption) => {
        let list = _.cloneDeep(this.state.list_self_select);

        list[idx]["event_except_main_display_group_list"] = Array.isArray(selectedOption)
            ? selectedOption.map(obj => String(obj.display_group))
            : [];

        this.setState({
            list_self_select: list,
            left_is_modified: true
        });
    }

    getSelfExceptSettingList = (idx) => {
        const list = this.state.list_self_select || [];

        if (!list[idx] || !Array.isArray(list[idx].self_except_setting_list)) {
            return [];
        }

        return list[idx].self_except_setting_list;
    }

    getSelfExceptSelectableList = (idx) => {
        const selectedIds = this.getSelfExceptSettingList(idx).map(obj => obj.id);

        return (this.state.rp_event_setting_list || []).filter(obj =>
            selectedIds.indexOf(obj.id) < 0
        );
    }

    // onChangeSelectSelfExceptRpSetting = (text, value, id) => {
    //     const idx = id.split("/")[1];

    //     let list = _.cloneDeep(this.state.list_self_select);

    //     list[idx].select_self_except_rp_setting = value;

    //     this.setState({
    //         list_self_select: list,
    //         left_is_modified: true,
    //     });
    // }

    onChangeSelectSelfExceptRpSetting = (text, value, id) => {
        this.setState({
            select_self_except_rp_setting: value,
            self_except_event_category_list: [],
            select_self_except_event_category: "",
            self_except_event_category_products: {},
        }, () => {
            const selectedObj = (this.state.rp_event_setting_list || []).find(obj => obj.id == value);

            if (
                selectedObj
                && selectedObj.iframe_page_id == "robomd_product_detail_page"
                && selectedObj.event_category_select_type == "34001"
            ) {
                this.loadSelfExceptEventCategoryList(selectedObj);
            }
        });
    }

    loadSelfExceptEventCategoryList = async (selectedObj) => {
        if (!selectedObj) {
            return;
        }

        const api = "/rest/shop/rp/category/event/select/v3"
            + "?iframe_page_id=" + selectedObj.iframe_page_id
            + "&iframe_html_id=" + selectedObj.iframe_html_id;

        await http.get(api)
            .then(res => {
                if (res.data.code == "200") {
                    const categoryArray = res.data["event_category_array"] || [];
                    const categoryList = [];
                    const products = {};

                    for (let i = 0; i < categoryArray.length; i++) {
                        const categoryNo = categoryArray[i];

                        products[categoryNo] = res.data[categoryNo];

                        categoryList.push({
                            category_no: categoryNo,
                            category_name: res.data[categoryNo].category_name,
                            category_name_no_format: res.data[categoryNo].category_name_no_format,
                        });
                    }

                    this.setState({
                        self_except_event_category_list: categoryList,
                        select_self_except_event_category: categoryArray.length > 0 ? categoryArray[0] : "",
                        self_except_event_category_products: products,
                    });
                } else {
                    this.setState({
                        self_except_event_category_list: [],
                        select_self_except_event_category: "",
                        self_except_event_category_products: {},
                    });
                }
            })
            .catch(error => {
                this.setState({
                    self_except_event_category_list: [],
                    select_self_except_event_category: "",
                    self_except_event_category_products: {},
                });
            });
    }

    addSelfExceptSettingList = (idx) => {
        let list = _.cloneDeep(this.state.list_self_select);

        const selectedId = list[idx].select_self_except_rp_setting;

        if (!selectedId) {
            alert("제외할 진열코너를 선택해주세요.");
            return;
        }

        const currentList = Array.isArray(list[idx].self_except_setting_list)
            ? list[idx].self_except_setting_list
            : [];

        if (currentList.some(obj => obj.id === selectedId)) {
            alert("이미 추가된 진열 설정입니다.");
            return;
        }

        const selectedObj = (this.state.rp_event_setting_list || []).find(obj => obj.id === selectedId);

        if (!selectedObj) {
            alert("선택한 진열 설정을 찾을 수 없습니다.");
            return;
        }

        currentList.push({
            id: selectedObj.id,
            iframe_page_id: selectedObj.iframe_page_id,
            iframe_html_id: selectedObj.iframe_html_id,
            name: selectedObj.name,

            iframe_page_name: selectedObj.iframe_page_name,
            display_name: selectedObj.display_name,

            cafe24_main_display_group: selectedObj.cafe24_main_display_group,
            cafe24_category_display_group: selectedObj.cafe24_category_display_group,
            cafe24_category_no_list: selectedObj.cafe24_category_no_list,

            event_category_select_type: selectedObj.event_category_select_type,

            except_order_start_no: "",
            except_order_end_no: "",
        });

        list[idx].self_except_setting_list = currentList;
        list[idx].select_self_except_rp_setting = "";

        this.setState({
            list_self_select: list,
            left_is_modified: true,
        });
    }

    delSelfExceptSetting = (idx, exceptIdx) => {
        let list = _.cloneDeep(this.state.list_self_select);

        if (!Array.isArray(list[idx].self_except_setting_list)) {
            list[idx].self_except_setting_list = [];
        }

        list[idx].self_except_setting_list.splice(exceptIdx, 1);

        this.setState({
            list_self_select: list,
            left_is_modified: true,
        });
    }

    onChangeSelfExceptOrderNo = (idx, exceptIdx, key, value) => {
        let list = _.cloneDeep(this.state.list_self_select);

        value = String(value || "").replace(/[^0-9]/g, "");

        if (!Array.isArray(list[idx].self_except_setting_list)) {
            list[idx].self_except_setting_list = [];
        }

        list[idx].self_except_setting_list[exceptIdx][key] = value;

        this.setState({
            list_self_select: list,
            left_is_modified: true,
        });
    }

    openSelfExceptSettingPopup = async (idx) => {
        this.setState({
            show_add_product_popup : false, // 다른 팝업 닫기
            show_exclude_product_list_popup : false,
            show_event_product_list_popup : false, // 선택된 상품목록 팝업 닫기
            show_except_product_popup: false,
            show_essential_product_list_popup: false, // 필수 상품 설정 팝업 닫기
            show_except_setting_popup : false,

            show_self_except_setting_popup: true,
            self_except_setting_idx: idx,
            rp_event_setting_list: [],
            self_except_event_category_list: [],
            select_self_except_event_category: "",
            self_except_event_category_products: {},
        });

        await this.loadRpEventExceptSettingsToBe();

        const rpEventSettingList = this.state.rp_event_setting_list || [];
        const firstObj = rpEventSettingList.length > 0 ? rpEventSettingList[0] : null;

        this.setState({
            // 중요: 0번째 값을 실제 state에도 넣음
            select_self_except_rp_setting: firstObj ? firstObj.id : "",
        }, () => {
            if (
                firstObj
                && firstObj.iframe_page_id == "robomd_product_detail_page"
                && String(firstObj.event_category_select_type) == "34001"
            ) {
                this.loadSelfExceptEventCategoryList(firstObj);
            }
        });
    }
    
    closeSelfExceptSettingPopup = () => {
        this.setState({
            show_self_except_setting_popup: false,
            self_except_setting_idx: null,
            select_self_except_rp_setting: "",
        });
    }

    getCurrentSelfExceptSettingList = () => {
        const idx = this.state.self_except_setting_idx;

        if (idx == null) {
            return [];
        }

        const list = this.state.list_self_select || [];

        if (!list[idx] || !Array.isArray(list[idx].self_except_setting_list)) {
            return [];
        }

        return list[idx].self_except_setting_list;
    }

    // getCurrentSelfExceptSelectableList = () => {
    //     const currentList = this.getCurrentSelfExceptSettingList();
    //     const selectedIds = currentList.map(obj => obj.id);

    //     return (this.state.rp_event_setting_list || []).filter(obj =>
    //         selectedIds.indexOf(obj.id) < 0
    //     );
    // }

    getCurrentSelfExceptSelectableList = () => {
        return this.state.rp_event_setting_list || [];
    }

    addCurrentSelfExceptSetting = () => {
        const idx = this.state.self_except_setting_idx;
        const rpEventSettingList = this.state.rp_event_setting_list || [];

        const selectedId = this.state.select_self_except_rp_setting
        || (rpEventSettingList.length > 0 ? rpEventSettingList[0].id : "");


        if (idx == null) {
            return;
        }

        if (!selectedId) {
            alert("제외할 진열코너를 선택해주세요.");
            return;
        }

        let list = _.cloneDeep(this.state.list_self_select);

        if (!Array.isArray(list[idx].self_except_setting_list)) {
            list[idx].self_except_setting_list = [];
        }

        const selectedObj = (this.state.rp_event_setting_list || []).find(obj => obj.id === selectedId);

        if (!selectedObj) {
            alert("선택한 진열 설정을 찾을 수 없습니다.");
            return;
        }

        const isDetailMultiCategory =
            selectedObj.iframe_page_id == "robomd_product_detail_page"
            && selectedObj.event_category_select_type == "34001";

        let exceptEventCategoryNo = "";
        let exceptEventCategoryName = "";
        let exceptEventCategoryNameNoFormat = "";

        if (isDetailMultiCategory) {
            exceptEventCategoryNo = this.state.select_self_except_event_category;

            if (!exceptEventCategoryNo) {
                alert("제외할 상세페이지 카테고리를 선택해주세요.");
                return;
            }

            const selectedCategoryObj = (this.state.self_except_event_category_list || []).find(
                obj => String(obj.category_no) == String(exceptEventCategoryNo)
            );

            if (selectedCategoryObj) {
                exceptEventCategoryName = selectedCategoryObj.category_name;
                exceptEventCategoryNameNoFormat = selectedCategoryObj.category_name_no_format;
            }
        }

        list[idx].self_except_setting_list.push({
            id: selectedObj.id,
            iframe_page_id: selectedObj.iframe_page_id,
            iframe_html_id: selectedObj.iframe_html_id,
            name: selectedObj.name,

            iframe_page_name: selectedObj.iframe_page_name,
            display_name: selectedObj.display_name,

            cafe24_main_display_group: selectedObj.cafe24_main_display_group,
            cafe24_category_display_group: selectedObj.cafe24_category_display_group,
            cafe24_category_no_list: selectedObj.cafe24_category_no_list,
            event_category_select_type: selectedObj.event_category_select_type,

            except_event_category_no: exceptEventCategoryNo,
            except_event_category_name: exceptEventCategoryName,
            except_event_category_name_no_format: exceptEventCategoryNameNoFormat,

            except_order_start_no: "",
            except_order_end_no: "",
        });

        this.setState({
            list_self_select: list,
            select_self_except_rp_setting: "",
            left_is_modified: true,
        });
    }

    onChangeCurrentSelfExceptOrderNo = (exceptIdx, key, value) => {
        const idx = this.state.self_except_setting_idx;

        if (idx == null) {
            return;
        }

        let list = _.cloneDeep(this.state.list_self_select);

        value = String(value || "").replace(/[^0-9]/g, "");

        list[idx].self_except_setting_list[exceptIdx][key] = value;

        this.setState({
            list_self_select: list,
            left_is_modified: true,
        });
    }

    deleteCurrentSelfExceptSetting = (exceptIdx) => {
        const idx = this.state.self_except_setting_idx;

        if (idx == null) {
            return;
        }

        let list = _.cloneDeep(this.state.list_self_select);

        if (!Array.isArray(list[idx].self_except_setting_list)) {
            list[idx].self_except_setting_list = [];
        }

        list[idx].self_except_setting_list.splice(exceptIdx, 1);

        this.setState({
            list_self_select: list,
            left_is_modified: true,
        });
    }

    getCurrentSelectedSelfExceptRpSetting = () => {
        const list = this.getCurrentSelfExceptSelectableList();
        const selectedId = this.state.select_self_except_rp_setting
            || (list.length > 0 ? list[0].id : "");

        if (!selectedId) {
            return null;
        }

        return list.find(obj => obj.id === selectedId) || null;
    }

    render() {
        const{cafe24_main_product_list, cafe24_category_product_list, event_rp_product_list} = this.state;
        
        let product_list = [];
        let product_no_list = [];
        let event_rp_product_no_list = [];

        // 카페24 메인 진열인 경우, 해당 상품목록 불러오기
        if(this.state.iframe_page_id == "robomd_cafe24_main_page"){
            product_list = JSON.parse(JSON.stringify(cafe24_main_product_list));
        } else if(this.state.iframe_page_id == "robomd_cafe24_category_page"){
            // 카테고리 쪽 상품목록 불러오기
            product_list = JSON.parse(JSON.stringify(cafe24_category_product_list));
        }

        // product_no_list 값 초기화
        for(var i=0;i<product_list.length;i++){
            product_no_list.push(product_list[i].product_no);
        }
        for(var i=0;i<event_rp_product_list.length;i++){
            if(product_no_list.indexOf(event_rp_product_list[i].product_no) == -1){
                event_rp_product_no_list.push(event_rp_product_list[i].product_no);
            }
        }

        // 왼쪽 영역 선택지 모두 불러오기 전에는 진열 수정이 불가능 하도록 클릭을 막는다
        if(load_upper_num < 4){
            $("#common-page-wrapper").css({pointerEvents: "none"});
        } else{
            $("#common-page-wrapper").css({pointerEvents: ""});
        }

        // 상품추가 정렬 기준 목록
        let select_order_gubun_type_list = [...this.state.select_event_order_gubun_type_list];
        select_order_gubun_type_list.splice(0,1);

        // 직접 지정 영역 알고리즘 목록
        let item_select_type_self_list = [...this.state.item_select_type_list];
        for(var i=0;i<this.state.item_select_type_list.length;i++){
            if(item_select_type_self_list[i].code_cd == "22998"){
                item_select_type_self_list.splice(i,1);
            }
        }
        
        let item_select_type_self_list_add_past_order_sort = [...item_select_type_self_list];
        item_select_type_self_list_add_past_order_sort.unshift({ val1: "과거 판매된 상품 순서대로", code_cd: "-1" }); // 첫 번째 요소로 추가

        const SortableItem = ({ obj, idx, product_list }) => { // dnd-kit 아이템 컴포넌트
            const {
            attributes,
            listeners,
            setNodeRef,
            transform,
            transition
            } = useSortable({ id: obj.product_no });
    
            const style = {
            transform: CSS.Transform.toString(transform),
            transition,
            };

            const algo = this.getWhichAlgorithm(item_select_type_self_list_add_past_order_sort, obj.uuid);
  
            return (
                <div className="rp-grid-item" ref={setNodeRef} style={style} {...attributes} {...listeners} 
                    onPointerDown={(e) => {
                        if (e.pointerType === "touch") {
                            e.preventDefault(); // 터치일 때 드래그 방지
                        } else {
                            listeners.onPointerDown?.(e); // 원래 dnd-kit의 onPointerDown 실행
                        }
                    }}
                >
                        <div className="info_area">
                            {algo && (
                                <div className="info_algorithm flexBox" style={{
                                flexWrap: 'nowrap',
                                gap: '5px',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                                }}>
                                    <span>선택기준:</span> <span style={{ fontSize: '13px', textAlign: 'left' }}>{algo}</span>
                                </div>
                            )}
                            {[
                                ["주문수", obj.order_cnt],
                                ["조회수", obj.hit_cnt],
                                ["장바구니수", obj.cart_cnt],
                                ["리뷰수", obj.review_cnt],
                                ["상품등록일", obj.created_date
                                    ? obj.created_date.replaceAll("-", "").replace(/^(\d{4})/, (_, y) => y.slice(2))
                                    : ""],
                                ["주문 전환율", obj.order_rate],
                                ["클릭가치", obj.click_value],
                                ["총 주문액", obj.order_price?.replace("원", "")],
                            ].map(([title, value], i) => (
                                <div className="flexBox" key={i}>
                                    <div className="price info_title">{title}</div>
                                    <div className="price info_content">{value}</div>
                                </div>
                            ))}
                        </div>
                
                        <div className={"idx_area"+ (obj.is_fixed ? ' active' : '')}>{idx + 1}</div>

                        <button className={'btn_fixed' + (obj.is_fixed ? ' active' : '')}
                            title={(obj.is_fixed ? '고정 해제' : '고정')}
                            onClick={() => this.toggleFixed(obj.product_no)}
                            onPointerDown={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                            }} 
                        >
                            <svg viewBox="0 0 24 24">
                                <path d="M16 9V4l1 0c.55 0 1-.45 1-1v0c0-.55-.45-1-1-1H7C6.45 2 6 2.45 6 3v0 C6 3.55 6.45 4 7 4l1 0v5c0 1.66-1.34 3-3 3h0v2h5.97v7l1 1l1-1v-7H19v-2h0C17.34 12 16 10.66 16 9z"></path>
                            </svg>
                        </button>

                        {
                            obj.sold_out == "T" &&
                            <div className="sold_out">{"품절"}</div>
                        }
                
                        <div className="img_area">
                            <LazyLoad 
                            offset="600"
                            once="true"
                            scrollContainer="#list_main_board_table_wrap"
                            throttle={100}
                            // unmountIfInvisible={false}
                            // placeholder={}
                            style={{ width: '100%' }}>
                                <img
                                    src={obj.image_url}
                                    onError={(e) => {
                                    e.target.src = "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/white.jpg";
                                    e.target.style.border = "0.5px solid #bbbbbb";
                                    }}
                                />
                            </LazyLoad>

                            <div className="delete-overlay">
                                <button className="delete-btn" onClick={
                                    (e) => {
                                        const product_list_copy = JSON.parse(JSON.stringify(product_list));
                                        product_list_copy.splice(idx, 1);
                                        this.setState({
                                            event_rp_product_list: product_list_copy,
                                            // left_is_modified: true,
                                        });
                                    }}
                                    onPointerDown={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }}
                                >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path>
                                    </svg>
                                    삭제
                                </button>
                            </div>
                        </div>
                        
                        <div style={{position: "relative", flex: 1}}>
                            <div className="product_name two-line-ellipsis">{obj.product_name}</div>
                    
                            <div className="product_price">
                                <div className="sale_price">{obj.pc_discount_price}</div>
                                <div className="retail_price">{obj.price}</div>
                            </div>
                        </div>
                </div>
            );
        };

        return (
            <>
                <style>
                    {
                        `
                            .detail_filter_area h4 {
                                font-size: 15px;
                            }

                            /* 순위별 진열코너간 같은 상품 제외등록 팝업 */
                            .self_except_setting_table_wrap {
                                max-height: 360px;
                                overflow-y: auto;
                                overflow-x: auto;
                            }

                            /* 기존 except_setting_table 스타일을 유지하면서 순번 입력 영역만 보정 */
                            .self_except_setting_table {
                                table-layout: fixed;
                            }

                            /* 진열 제목 */
                            .self_except_setting_table .self_except_title_td {
                                width: 300px !important;
                            }

                            /* 페이지 */
                            .self_except_setting_table .self_except_page_td {
                                width: 120px !important;
                            }

                            /* 제외 순번 */
                            .self_except_setting_table .self_except_order_td {
                                width: 240px !important;
                            }

                            /* 상품보기 / 삭제 */
                            .self_except_setting_table .self_except_btn_td {
                                width: 90px !important;
                            }

                            /* 순번 입력 */
                            .self_except_order_input {
                                width: 48px;
                                height: 28px;
                                padding: 0 6px;
                                border: 1px solid #d9d9d9;
                                border-radius: 4px;
                                font-size: 12px;
                                text-align: center;
                                box-sizing: border-box;
                            }

                            .self_except_order_input:focus {
                                outline: none;
                                border-color: #999;
                            }

                            /* 순번 안내 텍스트 */
                            .self_except_setting_info {
                                margin-top: 10px;
                                font-size: 12px;
                                color: #878B90;
                                line-height: 18px;
                            }

                            .span_bun {
                                width: auto !important;
                                height: auto !important;
                                padding: 2px 6px !important;
                                background-color: transparent !important;
                            }

                            .self_except_setting_table .list_exclude_btn {
                                width: 100% !important;
                            }

                            @media (max-width: 1024px) {
                                #self_except_setting_popup_header {
                                    flex-wrap: wrap;
                                }
                                .self_except_setting_popup_header_item {
                                    width: 100%;
                                }
                            }
                            #self_except_setting_popup_header {
                                gap: 10px;
                            }
                            .self_except_setting_popup_header_item:first-child {
                                flex:1;
                            }
                            .self_except_setting_popup_header_item {
                                display: flex;
                                flex-direction: row;
                                justify-content: flex-end;
                                gap: 10px;
                            }
                            .self_except_setting_popup_header_item .style_guide_v2 {
                                margin-right: 0px !important;
                            }

                            #event_except_main_display_group_list .css-ymdqty-multiValue {
                                border: 0.5px solid #ACACAC !important;
                                background-color: transparent !important;
                            }
                        `
                    }
                </style>
                <div id='common-page-wrapper'>
                    <div id="list_wrap" class="style_guide_v2 rp_setting_page">
                        <section class="list_admin_wrap">
                            <div class="list_admin_side_menu">
                                <div class="list_admin_side_menu_wrap">
                                    <div class="list_admin_side_row_1">
                                        <h2 class="text_regular">자동진열설정</h2>
                                        {/* <div>
                                            <button class="list_btn_1 hover_lightmint" onClick={() => {this.onClickUserGuide()}}>사용 가이드</button>
                                            {this.state.install_yn == "N"
                                            ?<button class="list_btn_1 hover_dark" onClick={()=> this.onClicExtendPeriod()}>기간 연장하기</button>
                                            :""}
                                        </div> */}
                                    </div>
                                    <div class="list_admin_side_row_2">
                                        <h3 ref={rpTitleRef} class="text_16">관리자 진열 제목</h3>
                                        <input type="text" maxlength="100" placeholder="Best Page" id="iframe_html_name_input" value={this.state.iframe_html_name} onChange={e => this.onChangeListName(e)} autocomplete="off"/>
                                    </div>
                                    <div className={this.state.highlightType == "connect" ? "list_admin_side_row_3 list_expand_wrap rp_border_highlight" : "list_admin_side_row_3 list_expand_wrap"} ref={highlightConnect}>
                                        <div class="list_admin_side_title_1 list_admin_side_design_expand list_expand cafe24_list_expand" id="install_list_expand">
                                            <h3 class="text_16">위치 설정</h3>
                                            <input ref={cafe24ListExpandCheckRef} class="list_expand_check cafe24_list_expand_check" type="checkbox" id="list_side_title_arrow" name="list_side_title_arrow"/>
                                            <label ref={cafe24ListExpandRef} for="list_side_title_arrow">
                                                <svg class="list_arrow-down" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10.0001 14.3751C9.83444 14.3728 9.67561 14.3088 9.55479 14.1954L3.30479 7.94541C3.20512 7.82398 3.15419 7.66981 3.1619 7.5129C3.1696 7.356 3.2354 7.20756 3.34648 7.09648C3.45756 6.9854 3.606 6.9196 3.7629 6.9119C3.91981 6.90419 4.07398 6.95512 4.19541 7.05479L10.0001 12.8673L15.8048 7.05479C15.9262 6.95512 16.0804 6.90419 16.2373 6.9119C16.3942 6.9196 16.5426 6.9854 16.6537 7.09648C16.7648 7.20756 16.8306 7.356 16.8383 7.5129C16.846 7.66981 16.7951 7.82398 16.6954 7.94541L10.4454 14.1954C10.3246 14.3088 10.1658 14.3728 10.0001 14.3751V14.3751Z" fill="#333333"/>
                                                </svg>
                                            </label>
                                        </div>
                                        <div class="list_admin_side_row_3_1 list_expand_1">
                                            <div class="list_admin_side_row_3_1c" style={{marginTop : "0px"}}>
                                                <h3 class="text_small">
                                                    진열 위치
                                                    <span class="i_notice">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                                                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                                                        </svg>
                                                    </span>
                                                    <span class="text_12">저장 후에는 직접 변경하실 수 없습니다.</span>
                                                </h3>
                                                {this.state.iframe_page_id != null && this.state.iframe_html_id != null && this.state.iframe_page_id != "" && this.state.iframe_html_id != ""
                                                ?
                                                    <div class="select_list_position_disabled">
                                                        <SelectBoxV2
                                                            id={"selectListPosition"}
                                                            width="100%"
                                                            height="36px"
                                                            padding="14px 36px 14px 16px"
                                                            list= {this.state.iframe_page_id_list}
                                                            disabled={true}
                                                            optionTexttName = "val1"
                                                            optionValuetName = "code_name"
                                                            selectedValue = {this.state.iframe_page_id}
                                                        />
                                                    </div>
                                                :
                                                    <div class="select_list_position_area">
                                                        <SelectBoxV2
                                                            id={"selectListPosition"}
                                                            tabIndex={0}
                                                            width="100%"
                                                            height="36px"
                                                            padding="14px 36px 14px 16px"
                                                            list= {this.state.iframe_page_id_list}
                                                            optionTexttName = "val1"
                                                            optionValuetName = "code_name"
                                                            selectedValue = {this.state.iframe_page_id}
                                                            onClickOption={this.onChangeListPosition.bind(this)}
                                                        />
                                                    </div>
                                                }
                                                {/* 메인 진열 카테고리 */}
                                                {this.state.iframe_page_id == "robomd_cafe24_main_page"
                                                ? this.state.iframe_page_id != null && this.state.iframe_html_id != null && this.state.iframe_page_id != "" && this.state.iframe_html_id != ""
                                                    ?
                                                    <div style={{marginTop: "5px"}}>
                                                        <SelectBoxV2
                                                            id={"cafe24_main_select_list"}
                                                            tabIndex={0}
                                                            width="100%"
                                                            height="36px"
                                                            padding="14px 36px 14px 16px"
                                                            list= {this.state.main_category_list}
                                                            disabled={true}
                                                            optionTexttName = "display_name_group"
                                                            optionValuetName = "display_group"
                                                            selectedValue = {this.state.cafe24_main_display_group}
                                                        />
                                                    </div>
                                                    :
                                                    <div style={{marginTop: "5px"}}>
                                                        <SelectBoxV2
                                                            id={"cafe24_main_select_list"}
                                                            tabIndex={0}
                                                            width="100%"
                                                            height="36px"
                                                            padding="14px 36px 14px 16px"
                                                            list= {this.state.main_category_list}
                                                            optionTexttName = "display_name_group"
                                                            optionValuetName = "display_group"
                                                            selectedValue = {this.state.cafe24_main_display_group}
                                                            onClickOption={this.titleContentDialogDisplayGroup.bind(this)}
                                                        />
                                                    </div>
                                                : ""
                                                }
                                                {/* 카페24 카테고리 진열 상품분류 */}
                                                {this.state.iframe_page_id == "robomd_cafe24_category_page"
                                                ?<>
                                                    <h3 class="text_small list_admin_side_design_title">
                                                        상품분류
                                                        <span class="i_notice">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                                                                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                                                            </svg>
                                                        </span>
                                                        <span class="text_12">저장 후에는 직접 변경하실 수 없습니다.</span>
                                                    </h3>
                                                    <div class="list_select_margin" style={{width:"100%"}}>
                                                        <div class="list_category_select_box">
                                                            {this.state.iframe_page_id != null && this.state.iframe_html_id != null && this.state.iframe_page_id != "" && this.state.iframe_html_id != ""
                                                            ?<SelectBoxV2
                                                                id={"cafe24_category_1"}
                                                                width="100%"
                                                                height="36px"
                                                                padding="14px 36px 14px 16px"
                                                                list= {this.state.cafe24_category_list_1}
                                                                disabled={true}
                                                                optionTexttName = "category_name_no"
                                                                optionValuetName = "category_no"
                                                                selectedValue = {this.state.cafe24_category_no_1 == "" ? "전체상품" : this.state.cafe24_category_no_1}
                                                            />
                                                            :<SelectBoxV2
                                                                id={"cafe24_category_1"}
                                                                tabIndex={0}
                                                                width="100%"
                                                                height="36px"
                                                                padding="14px 36px 14px 16px"
                                                                list= {this.state.cafe24_category_list_1}
                                                                optionTexttName = "category_name_no"
                                                                optionValuetName = "category_no"
                                                                selectedValue = {this.state.cafe24_category_no_1 == "" ? "전체상품" : this.state.cafe24_category_no_1}
                                                                onClickOption={this.onChangeCafe24Category.bind(this)}
                                                            />}
                                                        </div>
                                                        {
                                                            this.state.cafe24_category_list_2 != null && this.state.cafe24_category_list_2.length > 0
                                                            ?
                                                            <div class="list_category_select_box list_category_select_box_1">
                                                                {this.state.iframe_page_id != null && this.state.iframe_html_id != null && this.state.iframe_page_id != "" && this.state.iframe_html_id != ""
                                                                ?<SelectBoxV2
                                                                    id={"cafe24_category_2"}
                                                                    width="100%"
                                                                    height="36px"
                                                                    padding="14px 36px 14px 16px"
                                                                    list= {this.state.cafe24_category_list_2}
                                                                    disabled={true}
                                                                    optionTexttName = "category_name_no"
                                                                    optionValuetName = "category_no"
                                                                    selectedValue = {this.state.cafe24_category_no_2 == "" ? "전체상품" : this.state.cafe24_category_no_2}
                                                                />
                                                                :<SelectBoxV2
                                                                    id={"cafe24_category_2"}
                                                                    tabIndex={0}
                                                                    width="100%"
                                                                    height="36px"
                                                                    padding="14px 36px 14px 16px"
                                                                    list= {this.state.cafe24_category_list_2}
                                                                    optionTexttName = "category_name_no"
                                                                    optionValuetName = "category_no"
                                                                    selectedValue = {this.state.cafe24_category_no_2 == "" ? "전체상품" : this.state.cafe24_category_no_2}
                                                                    onClickOption={this.onChangeCafe24Category.bind(this)}
                                                                />}
                                                            </div>
                                                            :   ""
                                                        }
                                                        {
                                                            this.state.cafe24_category_list_3 != null && this.state.cafe24_category_list_3.length > 0
                                                            ?<div class="list_category_select_box list_category_select_box_1">
                                                                {this.state.iframe_page_id != null && this.state.iframe_html_id != null && this.state.iframe_page_id != "" && this.state.iframe_html_id != ""
                                                                ?<SelectBoxV2
                                                                    id={"cafe24_category_3"}
                                                                    width="100%"
                                                                    height="36px"
                                                                    padding="14px 36px 14px 16px"
                                                                    list= {this.state.cafe24_category_list_3}
                                                                    disabled={true}
                                                                    optionTexttName = "category_name_no"
                                                                    optionValuetName = "category_no"
                                                                    selectedValue = {this.state.cafe24_category_no_3 == "" ? "전체상품" : this.state.cafe24_category_no_3}
                                                                />
                                                                :<SelectBoxV2
                                                                    id={"cafe24_category_3"}
                                                                    tabIndex={0}
                                                                    width="100%"
                                                                    height="36px"
                                                                    padding="14px 36px 14px 16px"
                                                                    list= {this.state.cafe24_category_list_3}
                                                                    optionTexttName = "category_name_no"
                                                                    optionValuetName = "category_no"
                                                                    selectedValue = {this.state.cafe24_category_no_3 == "" ? "전체상품" : this.state.cafe24_category_no_3}
                                                                    onClickOption={this.onChangeCafe24Category.bind(this)}
                                                                />}
                                                            </div>
                                                            :   ""
                                                        }
                                                        {
                                                            this.state.cafe24_category_list_4 != null && this.state.cafe24_category_list_4.length > 0
                                                            ?<div class="list_category_select_box list_category_select_box_1">
                                                                {this.state.iframe_page_id != null && this.state.iframe_html_id != null && this.state.iframe_page_id != "" && this.state.iframe_html_id != ""
                                                                ?<SelectBoxV2
                                                                    id={"cafe24_category_4"}
                                                                    width="100%"
                                                                    height="36px"
                                                                    padding="14px 36px 14px 16px"
                                                                    list= {this.state.cafe24_category_list_4}
                                                                    disabled={true}
                                                                    optionTexttName = "category_name_no"
                                                                    optionValuetName = "category_no"
                                                                    selectedValue = {this.state.cafe24_category_no_4 == "" ? "전체상품" : this.state.cafe24_category_no_4}
                                                                />
                                                                :<SelectBoxV2
                                                                    id={"cafe24_category_4"}
                                                                    tabIndex={0}
                                                                    width="100%"
                                                                    height="36px"
                                                                    padding="14px 36px 14px 16px"
                                                                    list= {this.state.cafe24_category_list_4}
                                                                    optionTexttName = "category_name_no"
                                                                    optionValuetName = "category_no"
                                                                    selectedValue = {this.state.cafe24_category_no_4 == "" ? "전체상품" : this.state.cafe24_category_no_4}
                                                                    onClickOption={this.onChangeCafe24Category.bind(this)}
                                                                />}
                                                            </div>
                                                            :   ""
                                                        }
                                                    </div>
                                                </>
                                                :""}
                                                {/* 카테고리 진열 상세 상품분류 */}
                                                {this.state.iframe_page_id == "robomd_cafe24_category_page"
                                                ?<>
                                                    <h3 class="text_small list_admin_side_design_title">
                                                        <div style={{whiteSpace:"nowrap"}}>
                                                            상세 상품분류
                                                        </div>
                                                        <span class="i_notice">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                                                                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                                                            </svg>
                                                        </span>
                                                        <span class="text_12">저장 후에는 직접 변경하실 수 없습니다.</span>
                                                    </h3>
                                                    <div class="list_admin_side_row_3_1c_radio">
                                                        {this.state.cafe24_category_display_group_list.map((obj, idx) => (
                                                            <RadioButton
                                                                id={"cafe24_category_display_group_"+obj.value}
                                                                name={"category_display_group"}
                                                                value={obj.value}
                                                                text={obj.title}
                                                                checked={this.state.cafe24_category_display_group==obj.value}
                                                                disabled={this.state.iframe_page_id && this.state.iframe_html_id}
                                                                onChangeCheck={(this.state.iframe_page_id && this.state.iframe_html_id) ? null : this.onChangeCategoryDisplayGroup.bind(this)}
                                                            />
                                                        ))}
                                                    </div>
                                                </>
                                                :""}
                                                {this.state.iframe_page_id == "robomd_cafe24_category_page"
                                                ?<>
                                                    <h3 class="text_small list_admin_side_design_title">
                                                        <div style={{whiteSpace:"nowrap"}}>
                                                            상품 상세분류 진열방식
                                                        </div>
                                                    </h3>
                                                    <div class="list_admin_side_row_3_1c_radio">
                                                        {this.state.cafe24_category_display_type_list.map((obj, idx) => (
                                                            <RadioButton
                                                                id={"cafe24_category_display_type"+obj.value}
                                                                name={"category_manage_product_type"}
                                                                value={obj.value}
                                                                text={obj.title}
                                                                checked={this.state.cafe24_category_display_type==obj.value}
                                                                disabled={this.state.cafe24_category_display_group != "1"}
                                                                onChangeCheck={this.onChangeCategoryRollingType.bind(this)}
                                                            />
                                                        ))}
                                                    </div>
                                                    { this.state.cafe24_category_display_type != 1
                                                    ? <>
                                                            <h3 class="text_small list_admin_side_design_title">
                                                                <div style={{whiteSpace:"nowrap"}}>
                                                                영역별 중복 상품 관리
                                                                </div>
                                                            </h3>
                                                            <div class="list_admin_side_row_3_1c_radio" style={{flexWrap:"wrap"}}>
                                                                    {this.state.cafe24_product_manage_type_list.map((obj, idx) => (
                                                                        <>
                                                                            {
                                                                                idx >= 1
                                                                                ? <div style={{width: "100%",marginTop:"8px"}}/>
                                                                                : null
                                                                            }
                                                                            <RadioButton
                                                                                className={"cafe24_product_manage_radio_button"}
                                                                                id={"cafe24_product_manage_type_"+obj.value}
                                                                                name={"cafe24_product_manage_type"}
                                                                                value={obj.value}
                                                                                text={obj.title}
                                                                                checked={this.state.cafe24_product_manage_type==obj.value}
                                                                                onChangeCheck={this.onChangeCategoryProductManageType.bind(this)}
                                                                            />
                                                                        </>
                                                                    ))}
                                                            </div>
                                                        </>
                                                    : null
                                                    }
                                                </>
                                                :""}
                                            </div>
                                            <div class="list_admin_side_rolling_1">
                                                <h3 class="text_small list_admin_side_design_title">진열 노출 상품 이미지</h3>
                                                <SelectBoxV2
                                                    id={"selectImageType"}
                                                    tabIndex={0}
                                                    width="100%"
                                                    height="36px"
                                                    padding="14px 36px 14px 16px"
                                                    list= {this.state.image_type_list}
                                                    optionTexttName = "code_name"
                                                    optionValuetName = "code_cd"
                                                    selectedValue = {this.state.image_type_cd}
                                                    onClickOption={this.onChangeImageType.bind(this)}
                                                />
                                                {
                                                    this.state.iframe_page_id != null && this.state.iframe_page_id.indexOf("_cafe24_") >= 0
                                                    ?
                                                        <div class="list_admin_side_row_3_1a">
                                                            <span class="i_notice">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                                                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                                                                </svg>
                                                            </span>
                                                            <span class="text_12">우측 상품 진열에서 보여질 상품 이미지를 선택해 주세요.</span>
                                                        </div>
                                                    :
                                                        <div class="list_admin_side_row_3_1a">
                                                            <span class="i_notice">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                                                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                                                                </svg>
                                                            </span>
                                                            <span class="text_12">우측 상품 진열과 쇼핑몰 페이지의 상품 목록에 사용 할 이미지를 선택해 주세요.</span>
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className={this.state.highlightType == "period" ? "list_admin_side_row_5 list_expand_wrap rp_border_highlight" : "list_admin_side_row_5 list_expand_wrap"} ref={highlightPeriod}>
                                        <div class="list_expand" id="auto_product_select_list_expand">
                                            {/* <h3 class="text_16">자동관리 사용 설정</h3> */}
                                            <h3 class="text_16">자동관리 일정 설정</h3>
                                            <input class="list_expand_check" type="checkbox" id="list_side_title_arrow_3" name="list_side_title_arrow_3"/>
                                            <label for="list_side_title_arrow_3">
                                                <svg class="list_arrow-down" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10.0001 14.3751C9.83444 14.3728 9.67561 14.3088 9.55479 14.1954L3.30479 7.94541C3.20512 7.82398 3.15419 7.66981 3.1619 7.5129C3.1696 7.356 3.2354 7.20756 3.34648 7.09648C3.45756 6.9854 3.606 6.9196 3.7629 6.9119C3.91981 6.90419 4.07398 6.95512 4.19541 7.05479L10.0001 12.8673L15.8048 7.05479C15.9262 6.95512 16.0804 6.90419 16.2373 6.9119C16.3942 6.9196 16.5426 6.9854 16.6537 7.09648C16.7648 7.20756 16.8306 7.356 16.8383 7.5129C16.846 7.66981 16.7951 7.82398 16.6954 7.94541L10.4454 14.1954C10.3246 14.3088 10.1658 14.3728 10.0001 14.3751V14.3751Z" fill="#333333"/>
                                                </svg>
                                            </label>
                                        </div>
                                        <div class="list_expand_1" style={{paddingTop: 0}}>
                                            <div class="list_admin_side_row_5_radio">
                                                {/* {this.state.auto_create_type_list.map((obj, idx) => (
                                                    <RadioButton
                                                        id={"auto_create_type_"+obj.code_cd}
                                                        name={"auto_create_type_radio"}
                                                        value={obj.code_cd}
                                                        text={obj.code_name}
                                                        checked={
                                                            (
                                                                this.state.auto_create_type == obj.code_cd 
                                                                // || (this.state.auto_create_type == null && this.state.auto_create_yn == "Y" && obj.code_cd == "A7001")
                                                                // || (this.state.auto_create_type == null && this.state.auto_create_yn == "N" && obj.code_cd == "A7002")
                                                            )
                                                            }
                                                        onChangeCheck={
                                                            this.onChangeAutoCreateType.bind(this)
                                                        }
                                                    />
                                                ))} */}
                                                {this.state.auto_yn_list.map((obj, idx) => (
                                                    <RadioButton
                                                        id={"auto_create_"+obj.value}
                                                        name={"list_side_3_radio"}
                                                        value={obj.value}
                                                        text={obj.text}
                                                        // 이전에 N값이 0으로 저장되게 해버려서 0관련 처리 진행
                                                        checked={
                                                            (this.state.auto_create_yn == obj.value || (obj.value == "N" && this.state.auto_create_yn == "0"))
                                                            }
                                                        onChangeCheck={
                                                            this.onChangeAutoCreateYn.bind(this)
                                                        }
                                                    />
                                                ))}
                                            </div>
                                            { this.state.auto_create_yn == "Y"
                                                ?   <>
                                                        <div className="realTimeServiceHeader m-t-20" style={{width:"calc(100% + 32px)", marginLeft: "-16px", borderBottom:"2px solid rgba(0, 0, 0, 0.08)"}}>
                                                            <div className='flexBox' style={{justifyContent:"space-between", padding: "0 32px"}}>
                                                                {this.state.event_cycle_type_list.map((obj, idx) => (
                                                                    <button className={"tab_width_50 " + (this.state.event_cycle_type == obj.code_cd ? "active" : "")} 
                                                                    style={{
                                                                        color: (
                                                                            (obj.code_cd == "A8003" && !(this.state.operate_yn_0100201001 == "Y" || this.state.operate_yn_0100201002 == "Y")) 
                                                                            ? 'lightgrey' 
                                                                            // : (obj.code_cd == "A8003" && this.state.auto_create_type != 'A7003')
                                                                            //     ? 'lightgrey' 
                                                                                // : (obj.code_cd != "A8003" && this.state.auto_create_type == 'A7003')
                                                                                //     ? 'lightgrey' 
                                                                                : obj.code_cd == "A8003" && this.state.event_total_item_select_cnt > flagCafe24BulkConversionProductCount
                                                                                    ? 'lightgrey' 
                                                                                    : '#333'
                                                                        ),
                                                                        paddingBottom: "8px"
                                                                    }}
                                                                    onClick={e => {
                                                                        if (obj.code_cd == "A8003") {
                                                                            if (obj.code_cd == "A8003" && this.state.event_total_item_select_cnt > flagCafe24BulkConversionProductCount
                                                                            ) {
                                                                                    return false;
                                                                            }

                                                                            if (this.state.operate_yn_0100201001 == "Y" || this.state.operate_yn_0100201002 == "Y") {
                                                                                this.setState({
                                                                                    event_cycle_type: obj.code_cd
                                                                                })
                                                                            } else {
                                                                                this.setState({
                                                                                    real_time_service_regist_show_state : true
                                                                                })
                                                                                return false;
                                                                            }
                                                                        } else {
                                                                            // if (obj.code_cd != "A8003" && this.state.auto_create_type == 'A7003') {
                                                                            //     return false;
                                                                            // }
                                                                            this.setState({
                                                                                event_cycle_type: obj.code_cd
                                                                            })
                                                                        }
                                                                    }}>
                                                                        {obj.code_name}
                                                                    </button>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        {
                                                            this.state.event_cycle_type == "A8001"
                                                            ?   this.renderDailySetting()
                                                            :   this.state.event_cycle_type == "A8002"
                                                                ?   this.renderWeeklySetting()
                                                                :   this.state.event_cycle_type == "A8003"
                                                                    ?   this.renderRealTimeSetting()
                                                                    :   this.renderDailySetting()
                                                        }
                                                    </>
                                                :   <>
                                                        <div className="realTimeServiceHeader m-t-20" style={{width:"calc(100% + 32px)", marginLeft: "-16px", borderBottom:"2px solid rgba(0, 0, 0, 0.08)"}}>
                                                            <div className='flexBox' style={{justifyContent:"space-between", padding: "0 32px"}}>
                                                                <button className={"active"} 
                                                                style={{
                                                                    color: '#333',
                                                                    paddingBottom: "8px"
                                                                }}                                                                >
                                                                    {"수동관리 예약 설정"}
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className='m-t-20'>
                                                            <div className="text_small list_admin_side_design_title m-b-8" style={{marginTop:"18px", marginBottom: "8px"}}>예약시간 사용</div>
                                                            <div class="list_admin_side_row_5_radio">
                                                                {this.state.use_yn_list.map((obj, idx) => (
                                                                    <RadioButton
                                                                        id={"reservation_"+obj.value}
                                                                        name={"reservation_radio"}
                                                                        value={obj.value}
                                                                        text={obj.text}
                                                                        checked={
                                                                            (this.state.reservation_use_yn == obj.value)
                                                                        }
                                                                        onChangeCheck={
                                                                            this.onChangeReservationUseYn.bind(this)
                                                                        }
                                                                    />
                                                                ))}
                                                            </div>
                                                            {
                                                                this.state.reservation_use_yn == "Y"
                                                                ?
                                                                <div>
                                                                    <div className='text_small list_admin_side_design_title m-b-8' style={{marginBottom: "8px"}}>예약시간 설정</div>
                                                                    <div className='flexBox' style={{justifyContent:'space-between', }}>
                                                                        <div className='flexBox'>
                                                                            <div className="style_guide_v2 rp_event_start_date_wrapper" style={{width:"140px"}}>
                                                                                <DatePicker name="reservation_date" id="reservation_date" className="rp_event_start_date border_form_radius_b_h_42"
                                                                                    selected={this.state.reservation_date}
                                                                                    // onSelect={this.handleSelect} //when day is clicked
                                                                                    onChange={this.handleChangeReservationDate} //only when value has changed
                                                                                    placeholderText="예약일"
                                                                                    // minDate={moment().add(0,'days').toDate()}
                                                                                    maxDate={new Date("9999-12-31")}
                                                                                    dateFormat="yyyy-MM-dd"
                                                                                    locale={ko}
                                                                                    todayButton="오늘"
                                                                                    autoComplete="off"
                                                                                    showYearDropdown
                                                                                    yearDropdownItemNumber={15}
                                                                                    scrollableYearDropdown
                                                                                />
                                                                                <div className="icn_calendar"/>
                                                                            </div>
                                                                            <span className="text_14 m-l-5" style={{alignContent: "center"}}>{" 일"}</span>
                                                                        </div>
                                                                        <div className='flexBox'>
                                                                            <SelectBoxV2
                                                                                id={"reservation_hour"}
                                                                                placeHolder={"예약시간"}
                                                                                tabIndex={0}
                                                                                width="80px"
                                                                                height="36px"
                                                                                padding="14px 36px 14px 16px"
                                                                                list= {this.state.event_time_list}
                                                                                disabled={this.state.event_rp_product_list.length > flagCafe24BulkConversionProductCount ? true : false}
                                                                                optionTexttName = "title"
                                                                                optionValuetName = "value"
                                                                                // selectAreaMaxHeight = "120px"
                                                                                selectedValue = {this.state.reservation_hour}
                                                                                onClickOption={this.onChangeReservationHour.bind(this)}
                                                                            />
                                                                            <span className="text_14 m-l-5" style={{alignContent: "center"}}>{" 에 적용함"}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                : null
                                                            }
                                                        </div>
                                                    </>
                                            }
                                            {this.state.auto_create_yn == 'N' 
                                                && !(this.state.event_rp_product_list.length > flagCafe24BulkConversionProductCount) 
                                                && !(this.state.iframe_page_id =='robomd_cafe24_main_page' && this.state.event_rp_product_list.length > cafe24_main_page_max_product_num)
                                                && !(this.state.iframe_page_id =='robomd_cafe24_category_page' && this.state.event_rp_product_list.length > nayeol_event_total_item_select_range_category)
                                            ?
                                                <div className='m-t-15'>
                                                    <div class="list_admin_row_4_1a">
                                                        <span class="i_notice">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                                                                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                                                            </svg>
                                                        </span>
                                                        <span class="text_12">예약시간을 사용하시면 미리보기에 저장된 상품을 특정 시간에 진열 하실 수 있습니다.</span>
                                                    </div>
                                                </div>
                                            : null
                                            }
                                            {this.state.event_total_item_select_cnt > flagCafe24BulkConversionProductCount && this.state.auto_create_yn === 'Y'
                                                || this.state.event_rp_product_list.length > flagCafe24BulkConversionProductCount && this.state.auto_create_yn == 'N' && this.state.reservation_use_yn == 'Y'
                                            ?
                                                <div className='m-t-15'>
                                                    <div class="list_admin_row_4_1a">
                                                        {/* {this.state.event_total_item_select_cnt > flagCafe24BulkConversionProductCount && this.state.auto_create_yn === 'Y'
                                                        ?  */}
                                                        <>
                                                            <span class="i_notice">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                                                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                                                                </svg>
                                                            </span>
                                                            <span class="text_12" style={{color: "#ff085e", fontWeight: 400}}>100개이상의 대량 상품 진열은 자동관리시간이 새벽 3시로 자동 고정됩니다.</span>
                                                        </>
                                                        {/* // : <span class="text_12">반복예약 일정 설정을 사용하시면 쇼핑몰 설치 후에는 자동 진열된 상품 목록이 쇼핑몰에 바로 노출도 됩니다.</span>
                                                        : null
                                                        } */}
                                                    </div>
                                                </div>
                                            : null
                                            }
                                            {this.state.iframe_page_id =='robomd_cafe24_main_page' && this.state.event_rp_product_list.length > cafe24_main_page_max_product_num && this.state.auto_create_yn == 'N'
                                            ?
                                                <div className='m-t-15'>
                                                    <div class="list_admin_row_4_1a">
                                                        <>
                                                            <span class="i_notice">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                                                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                                                                </svg>
                                                            </span>
                                                            <span class="text_12" style={{color: "#ff085e", fontWeight: 400}}>{"메인진열인 경우 "+cafe24_main_page_max_product_num+"개 이하의 상품만 추가 가능합니다.\n미리보기에 추가된 상품수가 "+cafe24_main_page_max_product_num+"개를 넘겼습니다."}</span>
                                                        </>
                                                    </div>
                                                </div>
                                            : null
                                            }
                                            {this.state.iframe_page_id =='robomd_cafe24_category_page' && this.state.event_rp_product_list.length > nayeol_event_total_item_select_range_category && this.state.auto_create_yn == 'N'
                                            ?
                                                <div className='m-t-15'>
                                                    <div class="list_admin_row_4_1a">
                                                        <>
                                                            <span class="i_notice">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                                                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                                                                </svg>
                                                            </span>
                                                            <span class="text_12" style={{color: "#ff085e", fontWeight: 400}}>{"최대 "+nayeol_event_total_item_select_range_category+"개 이하의 상품만 추가 가능합니다.\n미리보기에 추가된 상품수가 "+nayeol_event_total_item_select_range_category+"개를 넘겼습니다."}</span>
                                                        </>
                                                    </div>
                                                </div>
                                            : null
                                            }
                                        </div>
                                    </div>
                                    <div className={this.state.highlightType == "ranking" ? "list_admin_side_row_4 list_expand_wrap list_category_expand_wrap rp_border_highlight" : "list_admin_side_row_4 list_expand_wrap list_category_expand_wrap"} id="listCategory" style={{overflow:"visible"}} ref={highlightRanking}>
                                        <div class="list_expand list_category_expand" id="listCategoryExpand">
                                            <h3 class="text_16">자동 진열 설정 </h3>
                                            <div class="setting_exclude_product_btn list_expand_select_num">{"상품 총 "+this.state.event_total_item_select_cnt+"개 | 제외 총 "+this.props.excludeProductList.length+"개"}</div>
                                            <input class="list_expand_check" type="checkbox" id="list_side_title_arrow_2" name="list_side_title_arrow_2"/>
                                            <label for="list_side_title_arrow_2">
                                                <svg class="list_arrow-down" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10.0001 14.3751C9.83444 14.3728 9.67561 14.3088 9.55479 14.1954L3.30479 7.94541C3.20512 7.82398 3.15419 7.66981 3.1619 7.5129C3.1696 7.356 3.2354 7.20756 3.34648 7.09648C3.45756 6.9854 3.606 6.9196 3.7629 6.9119C3.91981 6.90419 4.07398 6.95512 4.19541 7.05479L10.0001 12.8673L15.8048 7.05479C15.9262 6.95512 16.0804 6.90419 16.2373 6.9119C16.3942 6.9196 16.5426 6.9854 16.6537 7.09648C16.7648 7.20756 16.8306 7.356 16.8383 7.5129C16.846 7.66981 16.7951 7.82398 16.6954 7.94541L10.4454 14.1954C10.3246 14.3088 10.1658 14.3728 10.0001 14.3751V14.3751Z" fill="#333333"/>
                                                </svg>
                                            </label>
                                        </div>
                                        <div class="list_side_select_btn_wrap" >
                                            {/* <h3 class="text_16" style={{marginBottom: "10px"}}>자주 쓰는 자동 진열 설정 저장</h3> */}
                                            <button class="selected_list_btn text_extrasmall hover_white" 
                                            onClick={e => {
                                                this.saveFavoriteAlgorithm(e)
                                            }} tabIndex={-1}>자주 쓰는 자동 진열 설정 저장</button>
                                        </div>
                                        <div class="list_admin_side_select list_expand_1" style={{overflow:"visible"}}>
                                            <div class="list_select_content">
                                                <div class="list_select_wrap">
                                                    <div class="list_select_expand_wrap" style={{overflow:'visible'}}>
                                                        <div class="list_select_expand_1 rp_algorithm">
                                                            <div class="list_select_set">
                                                                <h4 class="txt_black text_15" style={{fontWeight:500, marginBottom:"14px"}}>진열 순서 전체 설정방식</h4>
                                                                <h4>진열 상품 순서 적용 방식</h4>
                                                                <div class="list_select_margin">
                                                                    <SelectBoxV2
                                                                        id={"totalSortType"}
                                                                        width="100%"
                                                                        height="36px"
                                                                        padding="14px 36px 14px 16px"
                                                                        list= {this.state.total_sort_type_list}
                                                                        optionTexttName = "title"
                                                                        optionValuetName = "value"
                                                                        selectedValue = {this.state.total_sort_type}
                                                                        onClickOption={this.onChangeTotalSortType.bind(this)}
                                                                    />
                                                                </div>
                                                                <h4 className="flexBox maxItemTypeTitle" style={{gap:"5px", alignItems:"center"}}>총 자동 진열할 상품 수 에 따른 분배 방식 <Tooltip iconWidth={16} iconHeight={16} content={
                                                                        `<b>1. 알고리즘 위부터 총 자동 진열할 상품 수  이하 선정</b>
                                                                        👉 상위 알고리즘부터 필요한 만큼만 채운 뒤 종료됩니다.
                                                                        알고리즘 순서대로 상품을 추출하며, 설정된 총 자동 진열할 상품 수 가 채워지면 이후 알고리즘은 실행되지 않습니다.

                                                                        🔹 자동/수동 혼합 예시
                                                                        - 총 자동 진열할 상품 수 : 10개
                                                                        - 1순위 진열 상품 설정: 자동
                                                                        - 2순위 진열 상품 설정: 수동(5개 지정)
                                                                        <div>→ 1순위 진열 상품 설정에서 가능한 만큼 상품을 추출 후, 부족하면 2순위 진열 상품 설정에서 보충합니다.
                                                                        → 두 알고리즘을 합쳐 최대 10개까지만 추출됩니다.</div>

                                                                        <b>2. 알고리즘별로 총 자동 진열할 상품 수 를 균등 분배</b>
                                                                        👉 자동 설정된 알고리즘 간에 총 자동 진열할 상품 수 를 균등하게 나누어 추출합니다.
                                                                        전체 총 자동 진열할 상품 수 를 기준으로, 자동 설정된 알고리즘끼리 균등하게 분배됩니다.

                                                                        수동으로 개수가 지정된 알고리즘은 지정된 수량이 그대로 반영됩니다.

                                                                        🔹 자동/수동 혼합 예시
                                                                        - 총 자동 진열할 상품 수 : 10개
                                                                        - 1순위 진열 상품 설정: 자동
                                                                        - 2순위 진열 상품 설정: 수동(4개 지정)
                                                                        - 3순위 진열 상품 설정: 자동
                                                                        <div>→ 2순위 진열 상품 설정은 4개로 고정됩니다.
                                                                        → 나머지 6개는 자동 설정된 1순위 진열 상품 설정과 3순위 진열 상품 설정에 각각 3개씩 배분됩니다.</div>

                                                                        <b>3. 알고리즘의 상품 수 합산 개수 선정</b>
                                                                        👉 알고리즘별로 설정한 개수의 총합을 최대치로 간주하며, 해당 범위 내에서 상품을 추출합니다.
                                                                        각 알고리즘에 지정된 수량만큼 순서대로 추출되며, 전체 추출 수량은 <strong>설정된 총합 이하</strong>입니다.
                                                                        
                                                                        <small>※ 즉, 총 자동 진열할 상품 수 는 추출 가능한 범위의 상한이며, 조건에 따라 그보다 적게 추출될 수 있습니다.</small>`
                                                                    }/></h4>
                                                                <div class="list_select_margin" 
                                                                    //style={{marginBottom:this.state.max_item_analysis == "1" ? "0px" : null}}
                                                                >
                                                                    <SelectBoxV2
                                                                        id={"maxItemAnalysis"}
                                                                        width="100%"
                                                                        height="36px"
                                                                        padding="14px 36px 14px 16px"
                                                                        list= {this.state.max_item_analysis_list}
                                                                        optionTexttName = "title"
                                                                        optionValuetName = "value"
                                                                        selectedValue = {this.state.max_item_analysis}
                                                                        onClickOption={this.onChangeMaxItemAnalysis.bind(this)}
                                                                    />
                                                                </div>
                                                                <div class="list_select_margin">
                                                                {this.state.max_item_analysis !== '1'
                                                                ?   <>
                                                                        <h4>총 자동 진열할 상품 수 </h4>
                                                                        <div className='flexBox' style={{flexWrap: 'nowrap', alignItems: 'center'}}>
                                                                            <div className="style_guide_v2" style={{flex: "1"}}>
                                                                                <input style={{width: "100%"}} name={"max_item_analysis_value"} type="text" placeholder="0" value={StringUtil.numberComma(this.state.max_item_analysis_value)} onChange={e => this.onChangeMaxItemAnalysisValue(e)} autocomplete="off"/>
                                                                            </div>
                                                                            <span class="text_14" style={{marginLeft: "5px"}}>개 이하</span>
                                                                        </div>
                                                                    </>
                                                                :   
                                                                    <>
                                                                        <h4>총 자동 진열할 상품 수 </h4>
                                                                        <div className='flexBox' style={{flexWrap: 'nowrap', alignItems: 'center'}}>
                                                                            <div className="style_guide_v2" style={{flex: "1"}}>
                                                                                <input style={{width: "100%"}} type="text" placeholder="0" value={StringUtil.numberComma(this.state.event_total_item_select_cnt)} autocomplete="off" disabled/>
                                                                            </div>
                                                                            <span class="text_14" style={{marginLeft: "5px"}}>개 이하</span>
                                                                        </div>
                                                                    </>
                                                                // :   null
                                                                }
                                                                </div>
                                                                {this.state.iframe_page_id == "robomd_cafe24_category_page"
                                                                ? this.state.max_item_analysis_value > 1000 && this.state.max_item_analysis != "1"
                                                                    ? <div class="alert_warning list_select_margin">
                                                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1229 7.84575 17.2662 5.78033 15.743 4.25704C14.2197 2.73376 12.1543 1.87707 10 1.875ZM9.84375 5.625C10.0292 5.625 10.2104 5.67998 10.3646 5.783C10.5188 5.88601 10.6389 6.03243 10.7099 6.20373C10.7808 6.37504 10.7994 6.56354 10.7632 6.7454C10.7271 6.92725 10.6378 7.0943 10.5067 7.22541C10.3756 7.35652 10.2085 7.44581 10.0267 7.48199C9.84479 7.51816 9.65629 7.49959 9.48499 7.42864C9.31368 7.35768 9.16726 7.23752 9.06425 7.08335C8.96124 6.92918 8.90625 6.74792 8.90625 6.5625C8.90625 6.31386 9.00503 6.0754 9.18084 5.89959C9.35666 5.72377 9.59511 5.625 9.84375 5.625ZM10.625 14.375H10C9.83424 14.375 9.67527 14.3092 9.55806 14.1919C9.44085 14.0747 9.375 13.9158 9.375 13.75V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75H10C10.1658 8.75 10.3247 8.81585 10.4419 8.93306C10.5592 9.05027 10.625 9.20924 10.625 9.375V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375Z" fill="#ACACAC"/></svg>                
                                                                        <span>최대 상품 선정 수는 알고리즘 총합 1000개 입니다.</span>
                                                                    </div>
                                                                    // : // 필수 상품 총 개수
                                                                    // this.state.max_item_analysis != "1" && this.totalEssentialProductCnt() > this.state.max_item_analysis_value
                                                                    // ? <div class="alert_warning list_select_margin">
                                                                    // <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1229 7.84575 17.2662 5.78033 15.743 4.25704C14.2197 2.73376 12.1543 1.87707 10 1.875ZM9.84375 5.625C10.0292 5.625 10.2104 5.67998 10.3646 5.783C10.5188 5.88601 10.6389 6.03243 10.7099 6.20373C10.7808 6.37504 10.7994 6.56354 10.7632 6.7454C10.7271 6.92725 10.6378 7.0943 10.5067 7.22541C10.3756 7.35652 10.2085 7.44581 10.0267 7.48199C9.84479 7.51816 9.65629 7.49959 9.48499 7.42864C9.31368 7.35768 9.16726 7.23752 9.06425 7.08335C8.96124 6.92918 8.90625 6.74792 8.90625 6.5625C8.90625 6.31386 9.00503 6.0754 9.18084 5.89959C9.35666 5.72377 9.59511 5.625 9.84375 5.625ZM10.625 14.375H10C9.83424 14.375 9.67527 14.3092 9.55806 14.1919C9.44085 14.0747 9.375 13.9158 9.375 13.75V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75H10C10.1658 8.75 10.3247 8.81585 10.4419 8.93306C10.5592 9.05027 10.625 9.20924 10.625 9.375V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375Z" fill="#ACACAC"/></svg>                
                                                                    //     <span>최대 상품 선택 수는 필수 상품의 총 개수보다 커야 합니다.</span>
                                                                    // </div>
                                                                    : null
                                                                : this.state.iframe_page_id == "robomd_cafe24_main_page"
                                                                ? this.state.max_item_analysis_value > 200 && this.state.max_item_analysis != "1"
                                                                    ? <div class="alert_warning list_select_margin">
                                                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1229 7.84575 17.2662 5.78033 15.743 4.25704C14.2197 2.73376 12.1543 1.87707 10 1.875ZM9.84375 5.625C10.0292 5.625 10.2104 5.67998 10.3646 5.783C10.5188 5.88601 10.6389 6.03243 10.7099 6.20373C10.7808 6.37504 10.7994 6.56354 10.7632 6.7454C10.7271 6.92725 10.6378 7.0943 10.5067 7.22541C10.3756 7.35652 10.2085 7.44581 10.0267 7.48199C9.84479 7.51816 9.65629 7.49959 9.48499 7.42864C9.31368 7.35768 9.16726 7.23752 9.06425 7.08335C8.96124 6.92918 8.90625 6.74792 8.90625 6.5625C8.90625 6.31386 9.00503 6.0754 9.18084 5.89959C9.35666 5.72377 9.59511 5.625 9.84375 5.625ZM10.625 14.375H10C9.83424 14.375 9.67527 14.3092 9.55806 14.1919C9.44085 14.0747 9.375 13.9158 9.375 13.75V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75H10C10.1658 8.75 10.3247 8.81585 10.4419 8.93306C10.5592 9.05027 10.625 9.20924 10.625 9.375V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375Z" fill="#ACACAC"/></svg>                
                                                                        <span>최대 상품 선정 수는 알고리즘 총합 200개 입니다.</span>
                                                                    </div>
                                                                    // : // 필수 상품 총 개수
                                                                    // this.state.max_item_analysis != "1" && this.totalEssentialProductCnt() > this.state.max_item_analysis_value
                                                                    // ? <div class="alert_warning list_select_margin">
                                                                    // <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1229 7.84575 17.2662 5.78033 15.743 4.25704C14.2197 2.73376 12.1543 1.87707 10 1.875ZM9.84375 5.625C10.0292 5.625 10.2104 5.67998 10.3646 5.783C10.5188 5.88601 10.6389 6.03243 10.7099 6.20373C10.7808 6.37504 10.7994 6.56354 10.7632 6.7454C10.7271 6.92725 10.6378 7.0943 10.5067 7.22541C10.3756 7.35652 10.2085 7.44581 10.0267 7.48199C9.84479 7.51816 9.65629 7.49959 9.48499 7.42864C9.31368 7.35768 9.16726 7.23752 9.06425 7.08335C8.96124 6.92918 8.90625 6.74792 8.90625 6.5625C8.90625 6.31386 9.00503 6.0754 9.18084 5.89959C9.35666 5.72377 9.59511 5.625 9.84375 5.625ZM10.625 14.375H10C9.83424 14.375 9.67527 14.3092 9.55806 14.1919C9.44085 14.0747 9.375 13.9158 9.375 13.75V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75H10C10.1658 8.75 10.3247 8.81585 10.4419 8.93306C10.5592 9.05027 10.625 9.20924 10.625 9.375V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375Z" fill="#ACACAC"/></svg>                
                                                                    //     <span>최대 상품 선택 수는 필수 상품의 총 개수보다 커야 합니다.</span>
                                                                    // </div>
                                                                    : null
                                                                : ""}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{borderBottom: "1px solid rgba(0, 0, 0, 0.12)", margin: "10px 0"}}></div>
                                        {/* </div>
                                        <div class="list_admin_side_select list_expand_1" style={{overflow:"visible"}}> */}
                                            {this.state.list_self_select != null && this.state.list_self_select.map((obj, idx) => (
                                                <div class="list_select_content" id={"list_select_content_"+idx}
                                                    key={idx}
                                                    onDragOver={(e) => this.onDragOverAlgorithm(e)}
                                                    onDrop={(e) => this.onDropAlgorithm(e, idx)}>
                                                    <div className='flexBox' style={{marginBottom:"8px", alignItems:"center", gap:"5px"}}>
                                                        <label className='text_14 m-b-8' style={{color: "#0E395A", fontWeight:"500"}}>
                                                            {idx+1}순위 진열 상품 설정
                                                        </label>
                                                        <Tooltip iconWidth={16} iconHeight={16} content={"설정된 알고리즘 기준에 맞는 상품만 추출됩니다. 자동 진열 설정  기준과 다른 상품은 추출되지 않으므로, 설정된 수량보다 실제 추출되는 상품 수가 적을 수 있습니다. 미달이 발생하는 경우에는 '자동진열할 상품  부족시  상품설정'을 체크해주세요."}/>
                                                    </div>
                                                    <div class="list_select_wrap">
                                                        <div class="list_select_expand_wrap">
                                                            <label class="list_select_expand" style={{display: "flex",flexDirection: "column"}} id={"list_select_expand_"+idx} for={"list_select_arrow_"+idx} onClick={e => {this.onClickEventFolder(idx)}} 
                                                                draggable
                                                                onDragStart={(e) => this.onDragStartAlgorithm(e, idx)}>
                                                                <div class="label-content" style={{display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center"}}>
                                                                    <h3 class="text_16 txt_mint">
                                                                        {getSelectBoxSelectIdx(item_select_type_self_list_add_past_order_sort, "val1","code_cd",obj.cd)}
                                                                    </h3>
                                                                    <div class="list_self_select_number_text">{"상품 "+obj.cnt+"개"}</div>
                                                                    <input class="list_select_expand_check" type="checkbox" id={"list_select_arrow_"+idx} name="list_select_arrow"/>
                                                                    <label for={"list_select_arrow_"+idx} style={{cursor:"pointer",display: "flex", alignItems: "center", justifyContent: "center", width:"16px",height:"16px"}}>
                                                                        <svg style={{background:"none",width:"16px",height:"16px", marginBottom: "3px"}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#333" class="arrow-down" viewBox="0 0 16 16">
                                                                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                                                        </svg>
                                                                    </label>
                                                                </div>
                                                                <div class="list_select_action_set" 
                                                                style={{display: "flex", justifyContent: "center", alignItems: "center", boxSizing: "border-box", width: "50%" , marginTop: "5px"}}>
                                                                    <button class="list_select_paste" alt="알고리즘 복제" onClick={e => {this.copyPasteAlgorithm(e, idx)}} tabIndex={10}> 
                                                                        <Tooltip
                                                                        className={"algorithm_tooltip"}
                                                                        content={"복제"}
                                                                        iconWidth={30}
                                                                        iconHeight={30}
                                                                        zIndex={10}
                                                                        hoverSvg={(
                                                                            <svg class="hover" width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7475 9.4149 20.7195 6.93639 18.8916 5.10845C17.0636 3.28051 14.5851 2.25248 12 2.25ZM12 20.25C10.3683 20.25 8.77326 19.7661 7.41655 18.8596C6.05984 17.9531 5.00242 16.6646 4.378 15.1571C3.75358 13.6496 3.5902 11.9908 3.90853 10.3905C4.22685 8.79016 5.01259 7.32015 6.16637 6.16637C7.32016 5.01259 8.79017 4.22685 10.3905 3.90852C11.9909 3.59019 13.6497 3.75357 15.1571 4.37799C16.6646 5.00242 17.9531 6.05984 18.8596 7.41655C19.7661 8.77325 20.25 10.3683 20.25 12C20.2475 14.1873 19.3775 16.2843 17.8309 17.8309C16.2843 19.3775 14.1873 20.2475 12 20.25ZM16.5 12C16.5 12.1989 16.421 12.3897 16.2803 12.5303C16.1397 12.671 15.9489 12.75 15.75 12.75H12.75V15.75C12.75 15.9489 12.671 16.1397 12.5303 16.2803C12.3897 16.421 12.1989 16.5 12 16.5C11.8011 16.5 11.6103 16.421 11.4697 16.2803C11.329 16.1397 11.25 15.9489 11.25 15.75V12.75H8.25C8.05109 12.75 7.86033 12.671 7.71967 12.5303C7.57902 12.3897 7.5 12.1989 7.5 12C7.5 11.8011 7.57902 11.6103 7.71967 11.4697C7.86033 11.329 8.05109 11.25 8.25 11.25H11.25V8.25C11.25 8.05109 11.329 7.86032 11.4697 7.71967C11.6103 7.57902 11.8011 7.5 12 7.5C12.1989 7.5 12.3897 7.57902 12.5303 7.71967C12.671 7.86032 12.75 8.05109 12.75 8.25V11.25H15.75C15.9489 11.25 16.1397 11.329 16.2803 11.4697C16.421 11.6103 16.5 11.8011 16.5 12Z" fill="#333333"/>
                                                                        </svg>
                                                                        )}
                                                                        nonHoverSvg={(
                                                                            <svg class="non_hover" width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7475 9.4149 20.7195 6.93639 18.8916 5.10845C17.0636 3.28051 14.5851 2.25248 12 2.25ZM12 20.25C10.3683 20.25 8.77326 19.7661 7.41655 18.8596C6.05984 17.9531 5.00242 16.6646 4.378 15.1571C3.75358 13.6496 3.5902 11.9908 3.90853 10.3905C4.22685 8.79016 5.01259 7.32015 6.16637 6.16637C7.32016 5.01259 8.79017 4.22685 10.3905 3.90852C11.9909 3.59019 13.6497 3.75357 15.1571 4.37799C16.6646 5.00242 17.9531 6.05984 18.8596 7.41655C19.7661 8.77325 20.25 10.3683 20.25 12C20.2475 14.1873 19.3775 16.2843 17.8309 17.8309C16.2843 19.3775 14.1873 20.2475 12 20.25ZM16.5 12C16.5 12.1989 16.421 12.3897 16.2803 12.5303C16.1397 12.671 15.9489 12.75 15.75 12.75H12.75V15.75C12.75 15.9489 12.671 16.1397 12.5303 16.2803C12.3897 16.421 12.1989 16.5 12 16.5C11.8011 16.5 11.6103 16.421 11.4697 16.2803C11.329 16.1397 11.25 15.9489 11.25 15.75V12.75H8.25C8.05109 12.75 7.86033 12.671 7.71967 12.5303C7.57902 12.3897 7.5 12.1989 7.5 12C7.5 11.8011 7.57902 11.6103 7.71967 11.4697C7.86033 11.329 8.05109 11.25 8.25 11.25H11.25V8.25C11.25 8.05109 11.329 7.86032 11.4697 7.71967C11.6103 7.57902 11.8011 7.5 12 7.5C12.1989 7.5 12.3897 7.57902 12.5303 7.71967C12.671 7.86032 12.75 8.05109 12.75 8.25V11.25H15.75C15.9489 11.25 16.1397 11.329 16.2803 11.4697C16.421 11.6103 16.5 11.8011 16.5 12Z" fill="#333333"/>
                                                                        </svg>
                                                                        )}
                                                                        ></Tooltip>
                                                                    </button>
                                                                    <button class="list_select_delete" alt="알고리즘 삭제" onClick={e => {this.onDeleteAlgorithm(e, idx)}} tabIndex={-1}> 
                                                                    <Tooltip
                                                                        className={"algorithm_tooltip"}
                                                                        content={"삭제"}
                                                                        iconWidth={30}
                                                                        iconHeight={30}
                                                                        hoverSvg={(
                                                                            <svg class="hover" width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7475 9.4149 20.7195 6.93639 18.8916 5.10845C17.0636 3.28051 14.5851 2.25248 12 2.25ZM12 20.25C10.3683 20.25 8.77326 19.7661 7.41655 18.8596C6.05984 17.9531 5.00242 16.6646 4.378 15.1571C3.75358 13.6496 3.5902 11.9908 3.90853 10.3905C4.22685 8.79016 5.01259 7.32015 6.16637 6.16637C7.32016 5.01259 8.79017 4.22685 10.3905 3.90852C11.9909 3.59019 13.6497 3.75357 15.1571 4.37799C16.6646 5.00242 17.9531 6.05984 18.8596 7.41655C19.7661 8.77325 20.25 10.3683 20.25 12C20.2475 14.1873 19.3775 16.2843 17.8309 17.8309C16.2843 19.3775 14.1873 20.2475 12 20.25ZM16.5 12C16.5 12.1989 16.421 12.3897 16.2803 12.5303C16.1397 12.671 15.9489 12.75 15.75 12.75H8.25C8.05109 12.75 7.86033 12.671 7.71967 12.5303C7.57902 12.3897 7.5 12.1989 7.5 12C7.5 11.8011 7.57902 11.6103 7.71967 11.4697C7.86033 11.329 8.05109 11.25 8.25 11.25H15.75C15.9489 11.25 16.1397 11.329 16.2803 11.4697C16.421 11.6103 16.5 11.8011 16.5 12Z" fill="#333333"/>
                                                                        </svg>
                                                                        )}
                                                                        nonHoverSvg={(
                                                                            <svg class="non_hover" width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7475 9.4149 20.7195 6.93639 18.8916 5.10845C17.0636 3.28051 14.5851 2.25248 12 2.25ZM12 20.25C10.3683 20.25 8.77326 19.7661 7.41655 18.8596C6.05984 17.9531 5.00242 16.6646 4.378 15.1571C3.75358 13.6496 3.5902 11.9908 3.90853 10.3905C4.22685 8.79016 5.01259 7.32015 6.16637 6.16637C7.32016 5.01259 8.79017 4.22685 10.3905 3.90852C11.9909 3.59019 13.6497 3.75357 15.1571 4.37799C16.6646 5.00242 17.9531 6.05984 18.8596 7.41655C19.7661 8.77325 20.25 10.3683 20.25 12C20.2475 14.1873 19.3775 16.2843 17.8309 17.8309C16.2843 19.3775 14.1873 20.2475 12 20.25ZM16.5 12C16.5 12.1989 16.421 12.3897 16.2803 12.5303C16.1397 12.671 15.9489 12.75 15.75 12.75H8.25C8.05109 12.75 7.86033 12.671 7.71967 12.5303C7.57902 12.3897 7.5 12.1989 7.5 12C7.5 11.8011 7.57902 11.6103 7.71967 11.4697C7.86033 11.329 8.05109 11.25 8.25 11.25H15.75C15.9489 11.25 16.1397 11.329 16.2803 11.4697C16.421 11.6103 16.5 11.8011 16.5 12Z" fill="#333333"/>
                                                                        </svg>
                                                                        )}
                                                                        ></Tooltip>
                                                                        
                                                                    </button>
                                                                    <button class="list_select_arrow_up" alt="알고리즘 순서 맨 위로" onClick={e => {this.onChangeTopSequenceAlgorithm(e, idx)}} tabIndex={-1} style={{marginLeft:"8px"}}> 
                                                                    <Tooltip
                                                                        className={"algorithm_tooltip"}
                                                                        content={"맨위로"}
                                                                        iconWidth={30}
                                                                        iconHeight={30}
                                                                        hoverSvg={(
                                                                            <svg class="hover" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M18.8906 5.10938C17.9866 4.20287 16.9126 3.48364 15.7302 2.9929C14.5478 2.50216 13.2802 2.24956 12 2.24956C10.7197 2.24956 9.45212 2.50216 8.2697 2.9929C7.08728 3.48364 6.01332 4.20287 5.10933 5.10938C4.20283 6.01336 3.4836 7.08733 2.99286 8.26975C2.50212 9.45217 2.24951 10.7198 2.24951 12C2.24951 13.2802 2.50212 14.5478 2.99286 15.7303C3.4836 16.9127 4.20283 17.9866 5.10933 18.8906C6.01332 19.7971 7.08728 20.5164 8.2697 21.0071C9.45212 21.4978 10.7197 21.7505 12 21.7505C13.2802 21.7505 14.5478 21.4978 15.7302 21.0071C16.9126 20.5164 17.9866 19.7971 18.8906 18.8906C19.7971 17.9866 20.5163 16.9127 21.0071 15.7303C21.4978 14.5478 21.7504 13.2802 21.7504 12C21.7504 10.7198 21.4978 9.45217 21.0071 8.26975C20.5163 7.08733 19.7971 6.01336 18.8906 5.10938ZM17.8312 17.8313C16.6777 18.9857 15.2077 19.7721 13.6072 20.091C12.0066 20.4099 10.3475 20.2469 8.83962 19.6227C7.33173 18.9984 6.04286 17.941 5.13604 16.5842C4.22922 15.2273 3.7452 13.632 3.7452 12C3.7452 10.368 4.22922 8.7727 5.13604 7.41585C6.04286 6.059 7.33173 5.00158 8.83962 4.37736C10.3475 3.75313 12.0066 3.59015 13.6072 3.90902C15.2077 4.22789 16.6777 5.0143 17.8312 6.16876C19.3746 7.71695 20.2413 9.8139 20.2413 12C20.2413 14.1861 19.3746 16.2831 17.8312 17.8313ZM15.5343 15.2156C15.6752 15.3578 15.7542 15.5499 15.7542 15.75C15.7542 15.9501 15.6752 16.1422 15.5343 16.2844C15.391 16.423 15.1994 16.5005 15 16.5005C14.8005 16.5005 14.6089 16.423 14.4656 16.2844L12 13.8094L9.53433 16.2844C9.38861 16.404 9.20362 16.4651 9.01533 16.4559C8.82704 16.4466 8.64892 16.3677 8.51562 16.2343C8.38232 16.101 8.30336 15.9229 8.29412 15.7346C8.28487 15.5464 8.34599 15.3614 8.46559 15.2156L11.4656 12.2156C11.6078 12.0748 11.7998 11.9958 12 11.9958C12.2001 11.9958 12.3921 12.0748 12.5343 12.2156L15.5343 15.2156ZM15.5343 9.96563C15.6752 10.1078 15.7542 10.2999 15.7542 10.5C15.7542 10.7001 15.6752 10.8922 15.5343 11.0344C15.391 11.173 15.1994 11.2505 15 11.2505C14.8005 11.2505 14.6089 11.173 14.4656 11.0344L12 8.55938L9.53433 11.0344C9.38861 11.154 9.20362 11.2151 9.01533 11.2058C8.82704 11.1966 8.64892 11.1176 8.51562 10.9843C8.38232 10.851 8.30336 10.6729 8.29412 10.4846C8.28487 10.2964 8.34599 10.1114 8.46559 9.96563L11.4656 6.96563C11.6078 6.82479 11.7998 6.74579 12 6.74579C12.2001 6.74579 12.3921 6.82479 12.5343 6.96563L15.5343 9.96563Z" fill="#333333"/>
                                                                            </svg>

                                                                        )}
                                                                        nonHoverSvg={(
                                                                            <svg class="non_hover" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M18.8906 5.10938C17.9866 4.20287 16.9126 3.48364 15.7302 2.9929C14.5478 2.50216 13.2802 2.24956 12 2.24956C10.7197 2.24956 9.45212 2.50216 8.2697 2.9929C7.08728 3.48364 6.01332 4.20287 5.10933 5.10938C4.20283 6.01336 3.4836 7.08733 2.99286 8.26975C2.50212 9.45217 2.24951 10.7198 2.24951 12C2.24951 13.2802 2.50212 14.5478 2.99286 15.7303C3.4836 16.9127 4.20283 17.9866 5.10933 18.8906C6.01332 19.7971 7.08728 20.5164 8.2697 21.0071C9.45212 21.4978 10.7197 21.7505 12 21.7505C13.2802 21.7505 14.5478 21.4978 15.7302 21.0071C16.9126 20.5164 17.9866 19.7971 18.8906 18.8906C19.7971 17.9866 20.5163 16.9127 21.0071 15.7303C21.4978 14.5478 21.7504 13.2802 21.7504 12C21.7504 10.7198 21.4978 9.45217 21.0071 8.26975C20.5163 7.08733 19.7971 6.01336 18.8906 5.10938ZM17.8312 17.8313C16.6777 18.9857 15.2077 19.7721 13.6072 20.091C12.0066 20.4099 10.3475 20.2469 8.83962 19.6227C7.33173 18.9984 6.04286 17.941 5.13604 16.5842C4.22922 15.2273 3.7452 13.632 3.7452 12C3.7452 10.368 4.22922 8.7727 5.13604 7.41585C6.04286 6.059 7.33173 5.00158 8.83962 4.37736C10.3475 3.75313 12.0066 3.59015 13.6072 3.90902C15.2077 4.22789 16.6777 5.0143 17.8312 6.16876C19.3746 7.71695 20.2413 9.8139 20.2413 12C20.2413 14.1861 19.3746 16.2831 17.8312 17.8313ZM15.5343 15.2156C15.6752 15.3578 15.7542 15.5499 15.7542 15.75C15.7542 15.9501 15.6752 16.1422 15.5343 16.2844C15.391 16.423 15.1994 16.5005 15 16.5005C14.8005 16.5005 14.6089 16.423 14.4656 16.2844L12 13.8094L9.53433 16.2844C9.38861 16.404 9.20362 16.4651 9.01533 16.4559C8.82704 16.4466 8.64892 16.3677 8.51562 16.2343C8.38232 16.101 8.30336 15.9229 8.29412 15.7346C8.28487 15.5464 8.34599 15.3614 8.46559 15.2156L11.4656 12.2156C11.6078 12.0748 11.7998 11.9958 12 11.9958C12.2001 11.9958 12.3921 12.0748 12.5343 12.2156L15.5343 15.2156ZM15.5343 9.96563C15.6752 10.1078 15.7542 10.2999 15.7542 10.5C15.7542 10.7001 15.6752 10.8922 15.5343 11.0344C15.391 11.173 15.1994 11.2505 15 11.2505C14.8005 11.2505 14.6089 11.173 14.4656 11.0344L12 8.55938L9.53433 11.0344C9.38861 11.154 9.20362 11.2151 9.01533 11.2058C8.82704 11.1966 8.64892 11.1176 8.51562 10.9843C8.38232 10.851 8.30336 10.6729 8.29412 10.4846C8.28487 10.2964 8.34599 10.1114 8.46559 9.96563L11.4656 6.96563C11.6078 6.82479 11.7998 6.74579 12 6.74579C12.2001 6.74579 12.3921 6.82479 12.5343 6.96563L15.5343 9.96563Z" fill="#333333"/>
                                                                            </svg>

                                                                        )}
                                                                        ></Tooltip>
                                                                        
                                                                    </button>
                                                                    <button class="list_select_arrow_up" alt="알고리즘 순서 위로" onClick={e => {this.onChangeUpSequenceAlgorithm(e, idx)}} tabIndex={-1}> 
                                                                    <Tooltip
                                                                        className={"algorithm_tooltip"}
                                                                        content={"위로"}
                                                                        iconWidth={30}
                                                                        iconHeight={30}
                                                                        hoverSvg={(
                                                                            <svg class="hover" width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M18.8908 5.10938C17.0633 3.28187 14.5847 2.25519 12.0002 2.25519C9.4157 2.25519 6.93707 3.28187 5.10956 5.10938C3.28205 6.93689 2.25537 9.41552 2.25537 12C2.25537 14.5845 3.28205 17.0631 5.10956 18.8906C6.93707 20.7181 9.4157 21.7448 12.0002 21.7448C14.5847 21.7448 17.0633 20.7181 18.8908 18.8906C20.7183 17.0631 21.745 14.5845 21.745 12C21.745 9.41552 20.7183 6.93689 18.8908 5.10938ZM17.8314 17.8313C16.6779 18.9857 15.2079 19.7721 13.6074 20.091C12.0069 20.4099 10.3477 20.2469 8.83984 19.6227C7.33196 18.9984 6.04309 17.941 5.13627 16.5842C4.22945 15.2273 3.74543 13.632 3.74543 12C3.74543 10.368 4.22945 8.7727 5.13627 7.41585C6.04309 6.059 7.33196 5.00158 8.83984 4.37735C10.3477 3.75313 12.0069 3.59014 13.6074 3.90902C15.2079 4.22789 16.6779 5.0143 17.8314 6.16875C18.6024 6.93159 19.2145 7.83974 19.6322 8.84066C20.0499 9.84159 20.265 10.9154 20.265 12C20.265 13.0846 20.0499 14.1584 19.6322 15.1593C19.2145 16.1603 18.6024 17.0684 17.8314 17.8313ZM15.9283 12.9938C16.0625 13.1405 16.133 13.3345 16.1242 13.5331C16.1154 13.7318 16.0281 13.9188 15.8814 14.0531C15.7423 14.1782 15.5623 14.2482 15.3752 14.25C15.271 14.2506 15.1679 14.2291 15.0726 14.1871C14.9773 14.1451 14.8919 14.0835 14.8221 14.0063L12.0002 10.875L9.17831 14.0063C9.04281 14.148 8.85718 14.2311 8.66119 14.2376C8.4652 14.2442 8.27444 14.1737 8.12978 14.0413C7.98512 13.9089 7.89807 13.7251 7.88729 13.5293C7.8765 13.3335 7.94283 13.1412 8.07206 12.9938L11.4471 9.24375C11.5173 9.16702 11.6028 9.10575 11.698 9.06383C11.7932 9.02191 11.8961 9.00026 12.0002 9.00026C12.1042 9.00026 12.2071 9.02191 12.3024 9.06383C12.3976 9.10575 12.483 9.16702 12.5533 9.24375L15.9283 12.9938Z" fill="#333333"/>
                                                                            </svg>
                                                                        )}
                                                                        nonHoverSvg={(
                                                                            <svg class="non_hover" width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M18.8908 5.10938C17.0633 3.28187 14.5847 2.25519 12.0002 2.25519C9.4157 2.25519 6.93707 3.28187 5.10956 5.10938C3.28205 6.93689 2.25537 9.41552 2.25537 12C2.25537 14.5845 3.28205 17.0631 5.10956 18.8906C6.93707 20.7181 9.4157 21.7448 12.0002 21.7448C14.5847 21.7448 17.0633 20.7181 18.8908 18.8906C20.7183 17.0631 21.745 14.5845 21.745 12C21.745 9.41552 20.7183 6.93689 18.8908 5.10938ZM17.8314 17.8313C16.6779 18.9857 15.2079 19.7721 13.6074 20.091C12.0069 20.4099 10.3477 20.2469 8.83984 19.6227C7.33196 18.9984 6.04309 17.941 5.13627 16.5842C4.22945 15.2273 3.74543 13.632 3.74543 12C3.74543 10.368 4.22945 8.7727 5.13627 7.41585C6.04309 6.059 7.33196 5.00158 8.83984 4.37735C10.3477 3.75313 12.0069 3.59014 13.6074 3.90902C15.2079 4.22789 16.6779 5.0143 17.8314 6.16875C18.6024 6.93159 19.2145 7.83974 19.6322 8.84066C20.0499 9.84159 20.265 10.9154 20.265 12C20.265 13.0846 20.0499 14.1584 19.6322 15.1593C19.2145 16.1603 18.6024 17.0684 17.8314 17.8313ZM15.9283 12.9938C16.0625 13.1405 16.133 13.3345 16.1242 13.5331C16.1154 13.7318 16.0281 13.9188 15.8814 14.0531C15.7423 14.1782 15.5623 14.2482 15.3752 14.25C15.271 14.2506 15.1679 14.2291 15.0726 14.1871C14.9773 14.1451 14.8919 14.0835 14.8221 14.0063L12.0002 10.875L9.17831 14.0063C9.04281 14.148 8.85718 14.2311 8.66119 14.2376C8.4652 14.2442 8.27444 14.1737 8.12978 14.0413C7.98512 13.9089 7.89807 13.7251 7.88729 13.5293C7.8765 13.3335 7.94283 13.1412 8.07206 12.9938L11.4471 9.24375C11.5173 9.16702 11.6028 9.10575 11.698 9.06383C11.7932 9.02191 11.8961 9.00026 12.0002 9.00026C12.1042 9.00026 12.2071 9.02191 12.3024 9.06383C12.3976 9.10575 12.483 9.16702 12.5533 9.24375L15.9283 12.9938Z" fill="#333333"/>
                                                                            </svg>
                                                                        )}
                                                                        ></Tooltip>
                                                                        
                                                                    </button>
                                                                    <button class="list_select_arrow_down" alt="알고리즘 순서 아래로" onClick={e => {this.onChangeDownSequenceAlogorithm(e, idx)}} tabIndex={-1}> 
                                                                    <Tooltip
                                                                        className={"algorithm_tooltip"}
                                                                        content={"아래로"}
                                                                        iconWidth={30}
                                                                        iconHeight={30}
                                                                        hoverSvg={(
                                                                            <svg class="hover" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M5.10919 18.8906C6.9367 20.7181 9.41533 21.7448 11.9998 21.7448C14.5843 21.7448 17.0629 20.7181 18.8904 18.8906C20.7179 17.0631 21.7446 14.5845 21.7446 12C21.7446 9.41551 20.7179 6.93688 18.8904 5.10937C17.0629 3.28186 14.5843 2.25518 11.9998 2.25518C9.41533 2.25518 6.93669 3.28187 5.10919 5.10937C3.28168 6.93688 2.255 9.41551 2.255 12C2.255 14.5845 3.28168 17.0631 5.10919 18.8906ZM6.16856 6.16875C7.32208 5.01429 8.79207 4.22789 10.3926 3.90901C11.9931 3.59014 13.6523 3.75312 15.1602 4.37735C16.668 5.00157 17.9569 6.05899 18.8637 7.41584C19.7705 8.77269 20.2546 10.368 20.2546 12C20.2546 13.632 19.7706 15.2273 18.8637 16.5842C17.9569 17.941 16.668 18.9984 15.1602 19.6226C13.6523 20.2469 11.9931 20.4099 10.3926 20.091C8.79208 19.7721 7.32208 18.9857 6.16856 17.8312C5.39757 17.0684 4.78551 16.1603 4.36779 15.1593C3.95007 14.1584 3.73499 13.0846 3.73499 12C3.73499 10.9154 3.95007 9.84158 4.36779 8.84066C4.78551 7.83973 5.39757 6.93158 6.16856 6.16875ZM8.07169 11.0062C7.93747 10.8595 7.867 10.6655 7.87579 10.4669C7.88458 10.2682 7.97191 10.0812 8.11856 9.94687C8.25773 9.82183 8.43773 9.75183 8.62481 9.75C8.72896 9.74945 8.83206 9.77088 8.92737 9.81288C9.02268 9.85488 9.10806 9.91651 9.17794 9.99375L11.9998 13.125L14.8217 9.99375C14.9572 9.85199 15.1428 9.76894 15.3388 9.76239C15.5348 9.75585 15.7256 9.82632 15.8702 9.95872C16.0149 10.0911 16.1019 10.2749 16.1127 10.4707C16.1235 10.6665 16.0572 10.8588 15.9279 11.0062L12.5529 14.7562C12.4827 14.833 12.3972 14.8943 12.302 14.9362C12.2068 14.9781 12.1039 14.9997 11.9998 14.9997C11.8958 14.9997 11.7929 14.9781 11.6976 14.9362C11.6024 14.8943 11.517 14.833 11.4467 14.7562L8.07169 11.0062Z" fill="#333333"/>
                                                                            </svg>

                                                                        )}
                                                                        nonHoverSvg={(
                                                                            <svg class="non_hover" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M5.10919 18.8906C6.9367 20.7181 9.41533 21.7448 11.9998 21.7448C14.5843 21.7448 17.0629 20.7181 18.8904 18.8906C20.7179 17.0631 21.7446 14.5845 21.7446 12C21.7446 9.41551 20.7179 6.93688 18.8904 5.10937C17.0629 3.28186 14.5843 2.25518 11.9998 2.25518C9.41533 2.25518 6.93669 3.28187 5.10919 5.10937C3.28168 6.93688 2.255 9.41551 2.255 12C2.255 14.5845 3.28168 17.0631 5.10919 18.8906ZM6.16856 6.16875C7.32208 5.01429 8.79207 4.22789 10.3926 3.90901C11.9931 3.59014 13.6523 3.75312 15.1602 4.37735C16.668 5.00157 17.9569 6.05899 18.8637 7.41584C19.7705 8.77269 20.2546 10.368 20.2546 12C20.2546 13.632 19.7706 15.2273 18.8637 16.5842C17.9569 17.941 16.668 18.9984 15.1602 19.6226C13.6523 20.2469 11.9931 20.4099 10.3926 20.091C8.79208 19.7721 7.32208 18.9857 6.16856 17.8312C5.39757 17.0684 4.78551 16.1603 4.36779 15.1593C3.95007 14.1584 3.73499 13.0846 3.73499 12C3.73499 10.9154 3.95007 9.84158 4.36779 8.84066C4.78551 7.83973 5.39757 6.93158 6.16856 6.16875ZM8.07169 11.0062C7.93747 10.8595 7.867 10.6655 7.87579 10.4669C7.88458 10.2682 7.97191 10.0812 8.11856 9.94687C8.25773 9.82183 8.43773 9.75183 8.62481 9.75C8.72896 9.74945 8.83206 9.77088 8.92737 9.81288C9.02268 9.85488 9.10806 9.91651 9.17794 9.99375L11.9998 13.125L14.8217 9.99375C14.9572 9.85199 15.1428 9.76894 15.3388 9.76239C15.5348 9.75585 15.7256 9.82632 15.8702 9.95872C16.0149 10.0911 16.1019 10.2749 16.1127 10.4707C16.1235 10.6665 16.0572 10.8588 15.9279 11.0062L12.5529 14.7562C12.4827 14.833 12.3972 14.8943 12.302 14.9362C12.2068 14.9781 12.1039 14.9997 11.9998 14.9997C11.8958 14.9997 11.7929 14.9781 11.6976 14.9362C11.6024 14.8943 11.517 14.833 11.4467 14.7562L8.07169 11.0062Z" fill="#333333"/>
                                                                            </svg>

                                                                        )}
                                                                        ></Tooltip>
                                                                       
                                                                    </button>
                                                                    <button class="list_select_arrow_down" alt="알고리즘 순서 맨 아래로" onClick={e => {this.onChangeBottomSequenceAlogorithm(e, idx)}} tabIndex={-1}> 
                                                                    <Tooltip
                                                                        className={"algorithm_tooltip"}
                                                                        content={"맨아래로"}
                                                                        iconWidth={30}
                                                                        iconHeight={30}
                                                                        hoverSvg={(
                                                                            <svg class="hover" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M5.10941 18.8906C6.0134 19.7971 7.08736 20.5164 8.26978 21.0071C9.4522 21.4978 10.7198 21.7504 12 21.7504C13.2803 21.7504 14.5479 21.4978 15.7303 21.0071C16.9127 20.5164 17.9867 19.7971 18.8907 18.8906C19.7972 17.9866 20.5164 16.9127 21.0071 15.7303C21.4979 14.5478 21.7505 13.2802 21.7505 12C21.7505 10.7198 21.4979 9.45215 21.0071 8.26974C20.5164 7.08732 19.7972 6.01335 18.8907 5.10937C17.9867 4.20286 16.9127 3.48363 15.7303 2.99289C14.5479 2.50215 13.2802 2.24955 12 2.24955C10.7198 2.24955 9.4522 2.50215 8.26978 2.99289C7.08736 3.48363 6.01339 4.20286 5.10941 5.10937C4.20291 6.01335 3.48368 7.08732 2.99294 8.26974C2.5022 9.45216 2.24959 10.7198 2.24959 12C2.24959 13.2802 2.5022 14.5478 2.99294 15.7303C3.48368 16.9127 4.20291 17.9866 5.10941 18.8906ZM6.16879 6.16875C7.3223 5.01429 8.7923 4.22788 10.3928 3.90901C11.9934 3.59013 13.6525 3.75312 15.1604 4.37734C16.6683 5.00157 17.9571 6.05899 18.864 7.41584C19.7708 8.77269 20.2548 10.368 20.2548 12C20.2548 13.632 19.7708 15.2273 18.864 16.5841C17.9571 17.941 16.6683 18.9984 15.1604 19.6226C13.6525 20.2469 11.9934 20.4099 10.3928 20.091C8.7923 19.7721 7.3223 18.9857 6.16879 17.8312C4.62536 16.2831 3.75867 14.1861 3.75867 12C3.75867 9.81388 4.62536 7.71694 6.16879 6.16875ZM8.46566 8.78437C8.32483 8.64217 8.24582 8.45013 8.24582 8.24999C8.24582 8.04986 8.32483 7.85782 8.46566 7.71562C8.60902 7.577 8.80063 7.49952 9.00004 7.49952C9.19945 7.49952 9.39106 7.577 9.53441 7.71562L12 10.1906L14.4657 7.71562C14.6114 7.59602 14.7964 7.5349 14.9847 7.54415C15.173 7.5534 15.3511 7.63235 15.4844 7.76565C15.6177 7.89895 15.6966 8.07707 15.7059 8.26536C15.7151 8.45365 15.654 8.63865 15.5344 8.78437L12.5344 11.7844C12.3922 11.9252 12.2002 12.0042 12 12.0042C11.7999 12.0042 11.6079 11.9252 11.4657 11.7844L8.46566 8.78437ZM8.46566 14.0344C8.32483 13.8922 8.24582 13.7001 8.24582 13.5C8.24582 13.2999 8.32483 13.1078 8.46566 12.9656C8.60902 12.827 8.80063 12.7495 9.00004 12.7495C9.19945 12.7495 9.39106 12.827 9.53441 12.9656L12 15.4406L14.4657 12.9656C14.6114 12.846 14.7964 12.7849 14.9847 12.7942C15.173 12.8034 15.3511 12.8824 15.4844 13.0157C15.6177 13.149 15.6966 13.3271 15.7059 13.5154C15.7151 13.7037 15.654 13.8886 15.5344 14.0344L12.5344 17.0344C12.3922 17.1752 12.2002 17.2542 12 17.2542C11.7999 17.2542 11.6079 17.1752 11.4657 17.0344L8.46566 14.0344Z" fill="#333333"/>
                                                                            </svg>

                                                                        )}
                                                                        nonHoverSvg={(
                                                                            <svg class="non_hover" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M5.10941 18.8906C6.0134 19.7971 7.08736 20.5164 8.26978 21.0071C9.4522 21.4978 10.7198 21.7504 12 21.7504C13.2803 21.7504 14.5479 21.4978 15.7303 21.0071C16.9127 20.5164 17.9867 19.7971 18.8907 18.8906C19.7972 17.9866 20.5164 16.9127 21.0071 15.7303C21.4979 14.5478 21.7505 13.2802 21.7505 12C21.7505 10.7198 21.4979 9.45215 21.0071 8.26974C20.5164 7.08732 19.7972 6.01335 18.8907 5.10937C17.9867 4.20286 16.9127 3.48363 15.7303 2.99289C14.5479 2.50215 13.2802 2.24955 12 2.24955C10.7198 2.24955 9.4522 2.50215 8.26978 2.99289C7.08736 3.48363 6.01339 4.20286 5.10941 5.10937C4.20291 6.01335 3.48368 7.08732 2.99294 8.26974C2.5022 9.45216 2.24959 10.7198 2.24959 12C2.24959 13.2802 2.5022 14.5478 2.99294 15.7303C3.48368 16.9127 4.20291 17.9866 5.10941 18.8906ZM6.16879 6.16875C7.3223 5.01429 8.7923 4.22788 10.3928 3.90901C11.9934 3.59013 13.6525 3.75312 15.1604 4.37734C16.6683 5.00157 17.9571 6.05899 18.864 7.41584C19.7708 8.77269 20.2548 10.368 20.2548 12C20.2548 13.632 19.7708 15.2273 18.864 16.5841C17.9571 17.941 16.6683 18.9984 15.1604 19.6226C13.6525 20.2469 11.9934 20.4099 10.3928 20.091C8.7923 19.7721 7.3223 18.9857 6.16879 17.8312C4.62536 16.2831 3.75867 14.1861 3.75867 12C3.75867 9.81388 4.62536 7.71694 6.16879 6.16875ZM8.46566 8.78437C8.32483 8.64217 8.24582 8.45013 8.24582 8.24999C8.24582 8.04986 8.32483 7.85782 8.46566 7.71562C8.60902 7.577 8.80063 7.49952 9.00004 7.49952C9.19945 7.49952 9.39106 7.577 9.53441 7.71562L12 10.1906L14.4657 7.71562C14.6114 7.59602 14.7964 7.5349 14.9847 7.54415C15.173 7.5534 15.3511 7.63235 15.4844 7.76565C15.6177 7.89895 15.6966 8.07707 15.7059 8.26536C15.7151 8.45365 15.654 8.63865 15.5344 8.78437L12.5344 11.7844C12.3922 11.9252 12.2002 12.0042 12 12.0042C11.7999 12.0042 11.6079 11.9252 11.4657 11.7844L8.46566 8.78437ZM8.46566 14.0344C8.32483 13.8922 8.24582 13.7001 8.24582 13.5C8.24582 13.2999 8.32483 13.1078 8.46566 12.9656C8.60902 12.827 8.80063 12.7495 9.00004 12.7495C9.19945 12.7495 9.39106 12.827 9.53441 12.9656L12 15.4406L14.4657 12.9656C14.6114 12.846 14.7964 12.7849 14.9847 12.7942C15.173 12.8034 15.3511 12.8824 15.4844 13.0157C15.6177 13.149 15.6966 13.3271 15.7059 13.5154C15.7151 13.7037 15.654 13.8886 15.5344 14.0344L12.5344 17.0344C12.3922 17.1752 12.2002 17.2542 12 17.2542C11.7999 17.2542 11.6079 17.1752 11.4657 17.0344L8.46566 14.0344Z" fill="#333333"/>
                                                                            </svg>
                                                                            
                                                                        )}
                                                                        ></Tooltip>
                                                                       
                                                                    </button>
                                                                </div>
                                                                <div class="list_select_set" style={{paddingBottom:"5px"}}>
                                                                    <button class="selected_list_btn text_extrasmall hover_white btn_in_algorithm" tabindex="-1" onClick={() => {this.onClickEssentialProductListPopup(obj.uuid)}}>{"필수 선정 상품 설정 ("+(obj.essential_product_no_list != null ? obj.essential_product_no_list.length : 0)+"개)"}</button>
                                                                </div>
                                                                <div className="list_select_margin list_select_set" style={{width:"100%", paddingTop:"0", paddingBottom: "5px"}}>
                                                                    <button
                                                                        type="button"
                                                                        className="selected_list_btn text_extrasmall hover_white btn_in_algorithm"
                                                                        onClick={() => this.openSelfExceptSettingPopup(idx)}
                                                                        style={{width:"100%"}}
                                                                    >
                                                                        진열코너간 같은 상품 제외등록
                                                                        {
                                                                            ` (${obj.self_except_setting_list ? obj.self_except_setting_list.length : 0}개)`
                                                                        }
                                                                    </button>
                                                                </div>
                                                            </label>
                                                            <div class="list_select_expand_1 rp_algorithm">
                                                                <div class="list_select_set">
                                                                    <h4 className="txt_black text_15">1. 상품 선택 카테고리</h4>
                                                                    {/* 상품 카테고리 */}
                                                                    <div class="list_select_margin" style={{width:"100%"}}>
                                                                        <div class="list_category_select_box">
                                                                            <SelectBoxV2
                                                                                id={"product_rp_category_no_1/"+idx}
                                                                                tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                                width="100%"
                                                                                height="36px"
                                                                                padding="14px 36px 14px 16px"
                                                                                list= {
                                                                                    Array.isArray(obj.product_rp_category_list_1)
                                                                                    ? obj.product_rp_category_list_1.filter(
                                                                                        item =>
                                                                                            item?.del_yn !== "Y" ||
                                                                                            item?.category_no == (obj.product_rp_category_no_1 ?? "")
                                                                                        )
                                                                                    : []
                                                                                }
                                                                                optionTexttName = "category_name_no_format"
                                                                                optionValuetName = "category_no"
                                                                                selectedValue = {obj.product_rp_category_no_1 == "" ? "전체상품" : obj.product_rp_category_no_1}
                                                                                onClickOption={this.onChangeRpCategory.bind(this)}
                                                                            />
                                                                        </div>
                                                                        {
                                                                            obj.product_rp_category_list_2 != null && obj.product_rp_category_list_2.length > 0
                                                                            ?<div class="list_category_select_box list_category_select_box_1">
                                                                                <SelectBoxV2
                                                                                    id={"product_rp_category_no_2/"+idx}
                                                                                    tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                                    width="100%"
                                                                                    height="36px"
                                                                                    padding="14px 36px 14px 16px"
                                                                                    list= {
                                                                                        Array.isArray(obj.product_rp_category_list_2)
                                                                                        ? obj.product_rp_category_list_2.filter(
                                                                                            item =>
                                                                                                item?.del_yn !== "Y" ||
                                                                                                item?.category_no == (obj.product_rp_category_no_2 ?? "")
                                                                                            )
                                                                                        : []
                                                                                    }
                                                                                    optionTexttName = "category_name_no_format"
                                                                                    optionValuetName = "category_no"
                                                                                    selectedValue = {obj.product_rp_category_no_2 == "" ? "전체상품" : obj.product_rp_category_no_2}
                                                                                    onClickOption={this.onChangeRpCategory.bind(this)}
                                                                                />
                                                                            </div>
                                                                            :   ""
                                                                        }
                                                                        {
                                                                            obj.product_rp_category_list_3 != null && obj.product_rp_category_list_3.length > 0
                                                                            ?<div class="list_category_select_box list_category_select_box_1">
                                                                                <SelectBoxV2
                                                                                    id={"product_rp_category_no_3/"+idx}
                                                                                    tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                                    width="100%"
                                                                                    height="36px"
                                                                                    padding="14px 36px 14px 16px"
                                                                                    list= {
                                                                                        Array.isArray(obj.product_rp_category_list_3)
                                                                                        ? obj.product_rp_category_list_3.filter(
                                                                                            item =>
                                                                                                item?.del_yn !== "Y" ||
                                                                                                item?.category_no == (obj.product_rp_category_no_3 ?? "")
                                                                                            )
                                                                                        : []
                                                                                    }
                                                                                    optionTexttName = "category_name_no_format"
                                                                                    optionValuetName = "category_no"
                                                                                    selectedValue = {obj.product_rp_category_no_3 == "" ? "전체상품" : obj.product_rp_category_no_3}
                                                                                    onClickOption={this.onChangeRpCategory.bind(this)}
                                                                                />
                                                                            </div>
                                                                            :   ""
                                                                        }
                                                                        {
                                                                            obj.product_rp_category_list_4 != null && obj.product_rp_category_list_4.length > 0
                                                                            ?<div class="list_category_select_box list_category_select_box_1">
                                                                                <SelectBoxV2
                                                                                    id={"product_rp_category_no_4/"+idx}
                                                                                    tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                                    width="100%"
                                                                                    height="36px"
                                                                                    padding="14px 36px 14px 16px"
                                                                                    list= {
                                                                                        Array.isArray(obj.product_rp_category_list_4)
                                                                                        ? obj.product_rp_category_list_4.filter(
                                                                                            item =>
                                                                                                item?.del_yn !== "Y" ||
                                                                                                item?.category_no == (obj.product_rp_category_no_4 ?? "")
                                                                                            )
                                                                                        : []
                                                                                    }
                                                                                    optionTexttName = "category_name_no_format"
                                                                                    optionValuetName = "category_no"
                                                                                    selectedValue = {obj.product_rp_category_no_4 == "" ? "전체상품" : obj.product_rp_category_no_4}
                                                                                    onClickOption={this.onChangeRpCategory.bind(this)}
                                                                                />
                                                                            </div>
                                                                            :   ""
                                                                        }
                                                                    </div>
                                                                    <h4 className="txt_black text_15">2. 상품 제외 카테고리</h4>
                                                                    {/* 상품 카테고리 */}
                                                                    <div className="list_except_category_select_box_area">
                                                                    {
                                                                        obj.product_rp_except_category_no_list &&  obj.product_rp_except_category_no_list.length > 0 
                                                                        ?
                                                                            obj.product_rp_except_category_no_list.map((except_category_obj, except_category_idx) => (
                                                                                <>
                                                                                    <div class="list_select_margin" style={{width:"100%"}}>
                                                                                        <div class="list_category_select_box flexBox">
                                                                                            <div class="select_box_parent_area">
                                                                                                <SelectBoxV2
                                                                                                    id={"product_rp_except_category_no_1/"+idx+"/"+except_category_idx}
                                                                                                    tabIndex={except_category_obj.self_select_area_checked ? 0 : ""}
                                                                                                    width="100%"
                                                                                                    height="36px"
                                                                                                    padding="14px 36px 14px 16px"
                                                                                                    list= {
                                                                                                        Array.isArray(except_category_obj.product_rp_except_category_list_1)
                                                                                                        ? except_category_obj.product_rp_except_category_list_1.filter(
                                                                                                            item =>
                                                                                                                item?.del_yn !== "Y" ||
                                                                                                                item?.category_no == (except_category_obj.product_rp_except_category_no_1 ?? "")
                                                                                                            )
                                                                                                        : []
                                                                                                    }
                                                                                                    optionTexttName = "category_name_no_format"
                                                                                                    optionValuetName = "category_no"
                                                                                                    selectedValue = {except_category_obj.product_rp_except_category_no_1}
                                                                                                    // selectedValue = {alert(except_category_obj.product_rp_except_category_no_1)}
                                                                                                    onClickOption={this.onChangeRpExceptCategory.bind(this)}
                                                                                                />
                                                                                            </div>
                                                                                            <div className="plus_minus_area">
                                                                                                <img 
                                                                                                onClick={() => this.addExceptCategoryList(idx,except_category_idx)} 
                                                                                                src={default_plus_img}/>
                                                                                                <img 
                                                                                                onClick={() => this.deleteExceptCategoryList(idx,except_category_idx)} 
                                                                                                src={default_minus_img}/>
                                                                                            </div>
                                                                                        </div>
                                                                                        {
                                                                                            except_category_obj.product_rp_except_category_list_2 != null && except_category_obj.product_rp_except_category_list_2.length > 0
                                                                                            ?<div class="list_category_select_box list_category_select_box_1 flexBox">
                                                                                                <div class="select_box_parent_area">
                                                                                                    <SelectBoxV2
                                                                                                        id={"product_rp_except_category_no_2/"+idx+"/"+except_category_idx}
                                                                                                        tabIndex={except_category_obj.self_select_area_checked ? 0 : ""}
                                                                                                        width="100%"
                                                                                                        height="36px"
                                                                                                        padding="14px 36px 14px 16px"
                                                                                                        list= {
                                                                                                            Array.isArray(except_category_obj.product_rp_except_category_list_2)
                                                                                                            ? except_category_obj.product_rp_except_category_list_2.filter(
                                                                                                                item =>
                                                                                                                    item?.del_yn !== "Y" ||
                                                                                                                    item?.category_no == (except_category_obj.product_rp_except_category_no_2 ?? "")
                                                                                                                )
                                                                                                            : []
                                                                                                        }
                                                                                                        optionTexttName = "category_name_no_format"
                                                                                                        optionValuetName = "category_no"
                                                                                                        selectedValue = {!except_category_obj.product_rp_except_category_no_2 ? "전체상품" : except_category_obj.product_rp_except_category_no_2}
                                                                                                        onClickOption={this.onChangeRpExceptCategory.bind(this)}
                                                                                                    />
                                                                                                </div>
                                                                                                <div className="plus_minus_area">
                                                                                                    {/* <img 
                                                                                                    onClick={() => this.addExceptCategoryList(idx,except_category_idx)} 
                                                                                                    src={default_plus_img}/>
                                                                                                    <img 
                                                                                                    onClick={() => this.deleteExceptCategoryList(idx,except_category_idx)} 
                                                                                                    src={default_minus_img}/> */}
                                                                                                </div>
                                                                                            </div>
                                                                                            :   ""
                                                                                        }
                                                                                        {
                                                                                            except_category_obj.product_rp_except_category_list_3 != null && except_category_obj.product_rp_except_category_list_3.length > 0
                                                                                            ?<div class="list_category_select_box list_category_select_box_1 flexBox">
                                                                                                <div class="select_box_parent_area">
                                                                                                    <SelectBoxV2
                                                                                                        id={"product_rp_except_category_no_3/"+idx+"/"+except_category_idx}
                                                                                                        tabIndex={except_category_obj.self_select_area_checked ? 0 : ""}
                                                                                                        width="100%"
                                                                                                        height="36px"
                                                                                                        padding="14px 36px 14px 16px"
                                                                                                        list= {
                                                                                                            Array.isArray(except_category_obj.product_rp_except_category_list_3)
                                                                                                            ? except_category_obj.product_rp_except_category_list_3.filter(
                                                                                                                item =>
                                                                                                                    item?.del_yn !== "Y" ||
                                                                                                                    item?.category_no == (except_category_obj.product_rp_except_category_no_3 ?? "")
                                                                                                                )
                                                                                                            : []
                                                                                                        }
                                                                                                        optionTexttName = "category_name_no_format"
                                                                                                        optionValuetName = "category_no"
                                                                                                        selectedValue = {!except_category_obj.product_rp_except_category_no_3 ? "전체상품" : except_category_obj.product_rp_except_category_no_3}
                                                                                                        onClickOption={this.onChangeRpExceptCategory.bind(this)}
                                                                                                    />
                                                                                                </div>
                                                                                                <div className="plus_minus_area">
                                                                                                    {/* <img 
                                                                                                    onClick={() => this.addExceptCategoryList(idx,except_category_idx)} 
                                                                                                    src={default_plus_img}/>
                                                                                                    <img 
                                                                                                    onClick={() => this.deleteExceptCategoryList(idx,except_category_idx)} 
                                                                                                    src={default_minus_img}/> */}
                                                                                                </div>
                                                                                            </div>
                                                                                            :   ""
                                                                                        }
                                                                                        {
                                                                                            except_category_obj.product_rp_except_category_list_4 != null && except_category_obj.product_rp_except_category_list_4.length > 0
                                                                                            ?<div class="list_category_select_box list_category_select_box_1 flexBox">
                                                                                                <div class="select_box_parent_area">
                                                                                                    <SelectBoxV2
                                                                                                        id={"product_rp_except_category_no_4/"+idx+"/"+except_category_idx}
                                                                                                        tabIndex={except_category_obj.self_select_area_checked ? 0 : ""}
                                                                                                        width="100%"
                                                                                                        height="36px"
                                                                                                        padding="14px 36px 14px 16px"
                                                                                                        list= {
                                                                                                            Array.isArray(except_category_obj.product_rp_except_category_list_4)
                                                                                                            ? except_category_obj.product_rp_except_category_list_4.filter(
                                                                                                                item =>
                                                                                                                    item?.del_yn !== "Y" ||
                                                                                                                    item?.category_no == (except_category_obj.product_rp_except_category_no_4 ?? "")
                                                                                                                )
                                                                                                            : []
                                                                                                        }
                                                                                                        optionTexttName = "category_name_no_format"
                                                                                                        optionValuetName = "category_no"
                                                                                                        selectedValue = {!except_category_obj.product_rp_except_category_no_4 ? "전체상품" : except_category_obj.product_rp_except_category_no_4}
                                                                                                        onClickOption={this.onChangeRpExceptCategory.bind(this)}
                                                                                                    />
                                                                                                </div>
                                                                                                <div className="plus_minus_area">
                                                                                                    {/* <img 
                                                                                                    onClick={() => this.addExceptCategoryList(idx,except_category_idx)} 
                                                                                                    src={default_plus_img}/>
                                                                                                    <img 
                                                                                                    onClick={() => this.deleteExceptCategoryList(idx,except_category_idx)} 
                                                                                                    src={default_minus_img}/> */}
                                                                                                </div>
                                                                                            </div>
                                                                                            :   ""
                                                                                        }
                                                                                    </div>
                                                                                </>
                                                                            ))
                                                                        :   
                                                                            <>
                                                                            <div class="list_select_margin" style={{width:"100%"}}>
                                                                                <div class="list_category_select_box flexBox">
                                                                                    <div className="plus_minus_area">
                                                                                        <img 
                                                                                            onClick={() => this.addExceptCategoryList(idx,-1)} 
                                                                                            src={default_plus_img}/>
                                                                                        {/* <img 
                                                                                            // onClick={() => this.deleteExceptCategoryList(idx,-1)} 
                                                                                            src={default_minus_img}/> */}
                                                                                    </div>
                                                                                </div>
                                                                            </div>        
                                                                            </>
                                                                    }
                                                                    </div>
                                                                    <h4 className="txt_black text_15">3. 상품 선택 메인분류</h4>
                                                                    <div class="list_select_margin" style={{width:"100%"}}>
                                                                        <SelectBoxV2
                                                                            id={"event_main_display_group/"+idx}
                                                                            tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                            width="100%"
                                                                            height="36px"
                                                                            padding="14px 36px 14px 16px"
                                                                            list={this.getSelfSelectMainCategoryOptions(true)}
                                                                            optionTexttName="display_group_format"
                                                                            optionValuetName="display_group"
                                                                            selectedValue={obj.event_main_display_group == null ? "" : String(obj.event_main_display_group)}
                                                                            onClickOption={this.onChangeSelfSelectMainDisplayGroup.bind(this)}
                                                                        />
                                                                    </div>
                                                                    <h4 className="txt_black text_15">4. 상품 제외 메인분류</h4>
                                                                    <div id="event_except_main_display_group_list" class="list_select_margin" style={{width:"100%"}}>
                                                                        <MultiSelect
                                                                            key={obj.uuid + "_event_except_main_display_group_list"}
                                                                            className={["react-select"].join(' ')}
                                                                            value={this.getSelectedExceptMainCategoryOptions(obj.event_except_main_display_group_list)}
                                                                            closeMenuOnSelect={false}
                                                                            components={animatedComponents}
                                                                            isMulti
                                                                            placeholder={"제외할 메인분류를 선택할 수 있습니다."}
                                                                            noOptionsMessage={() => "선택할 메인분류가 없습니다."}
                                                                            getOptionValue={(option) => String(option.display_group)}
                                                                            getOptionLabel={(option) => option.display_group_format}
                                                                            options={this.getSelfSelectMainCategoryOptions(false)}
                                                                            onChange={(selectedOption) => this.onChangeSelfSelectExceptMainDisplayGroup(idx, selectedOption)}
                                                                            styles={reactSelectStyles()}
                                                                        />
                                                                    </div>

                                                                    <h4 className="txt_black text_15">5. 상품 등록일 기준</h4>
                                                                    <div class="list_select_margin">
                                                                        <SelectBoxV2
                                                                            id={"eventItemCreatedPeriod_"+idx}
                                                                            tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                            width="100%"
                                                                            height="36px"
                                                                            padding="14px 36px 14px 16px"
                                                                            list= {this.state.event_item_created_period_list}
                                                                            optionTexttName = "title"
                                                                            optionValuetName = "value"
                                                                            selectedValue = {
                                                                                obj.event_item_created_period_type == "S"
                                                                                ? "-999"
                                                                                : obj.self_select_created_yn == 'Y' ? '-1' : obj.event_item_created_period == 0 ? 0 : obj.event_item_created_period+'/'+obj.event_item_created_period_type
                                                                            }
                                                                            selectedText={
                                                                                obj.event_item_created_period_type == "S"
                                                                                ? '계절 등록일 기준 적용중'
                                                                                : obj.self_select_created_yn == 'Y' ? "직접 지정": null}
                                                                            onClickOption={(text, value, id) => this.onChangeEventItemCreatedPeriod(value, idx)}
                                                                            disabled = {obj.event_item_created_period_type == "S"}
                                                                        />
                                                                        {obj.self_select_created_yn == 'Y'
                                                                        ?<div class="event_item_created_period">
                                                                            <div>
                                                                                <DatePicker name="start_date" id="select_start_date"
                                                                                    selected={obj.event_item_created_start_date}
                                                                                    onChange={(date) => this.onChangeSelectStartDate(date, idx)}
                                                                                    placeholderText="시작일자"
                                                                                    dateFormat="yyyy-MM-dd"
                                                                                    maxDate={new Date()}
                                                                                    locale={ko}
                                                                                    todayButton="오늘"
                                                                                    autoComplete="off"
                                                                                    showYearDropdown
                                                                                    yearDropdownItemNumber={15}
                                                                                    scrollableYearDropdown
                                                                                    tabIndex={obj.self_select_area_checked ? 0 : -1}
                                                                                />
                                                                            </div>
                                                                            <span>~</span>
                                                                            <div class="event_item_created_end_date">
                                                                                <DatePicker name="end_date" id="select_end_date"
                                                                                    selected={obj.event_item_created_end_date}
                                                                                    onChange={(date) => this.onChangeSelectEndDate(date, idx)}
                                                                                    placeholderText="종료일자"
                                                                                    dateFormat="yyyy-MM-dd"
                                                                                    minDate={obj.event_item_created_start_date}
                                                                                    maxDate={new Date()}
                                                                                    locale={ko}
                                                                                    todayButton="오늘"
                                                                                    autoComplete="off"
                                                                                    showYearDropdown
                                                                                    yearDropdownItemNumber={15}
                                                                                    scrollableYearDropdown
                                                                                    tabIndex={obj.self_select_area_checked ? 0 : -1}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        :""}
                                                                    </div>
                                                                    <h4 className="txt_black text_15 flexBox WeatherCreatedPeriodTitle">
                                                                        <div>6. 계절 등록일 기준</div>
                                                                        <Tooltip iconWidth={16} iconHeight={16} content={
                                                                            `[계절등록일 기준안내]
                                                                            - 2년, 3년, 4년, 전체년은 각 년도의 계절등록일 합계 기준임

                                                                            (1) 각 계절 기준
                                                                            * 모든 봄등록일 : 2월 15일 ~ 4월 30일
                                                                            * 모든 초여름등록일 : 3월 1일 ~ 8월 15일
                                                                            * 모든 여름등록일 : 5월 1일 ~ 8월 15일
                                                                            * 모든 가을등록일 : 8월 15일 ~ 9월 30일
                                                                            * 모든 겨울등록일 : 9월 20일 ~ 2월 15일

                                                                            (2) 년 4계절 기준
                                                                            * 매년 4계절마다
                                                                            - 봄   : 2월 15일 ~ 5월
                                                                            - 여름 : 5월 15일 ~ 8월
                                                                            - 가을 : 8월 15일 ~ 11월
                                                                            - 겨울 : 10월 15일 ~ 2월

                                                                            (3) 복합계절 기준
                                                                            * 여름·겨울이 긴 계절마다
                                                                            - 봄   : 2월 15일 ~ 4월
                                                                            - 여름 : 3월 1일 ~ 8월 20일
                                                                            - 가을 : 8월 15일 ~ 10월 15일
                                                                            - 겨울 : 10월 1일 ~ 2월 15일

                                                                            * 봄·가을 구분 없는 모든 계절별
                                                                            - 봄   : 1월 10일 ~ 5월 30일 + 8월 10일 ~ 9월 30일
                                                                            - 여름 : 3월 1일 ~ 8월 10일
                                                                            - 가을 : 1월 10일 ~ 5월 30일 + 8월 10일 ~ 10월 30일
                                                                            - 겨울 : 10월 1일 ~ 1월 10일

                                                                            * 간절기 포함 장기판매 6계절별
                                                                            - 봄   : 1월 10일 ~ 4월 30일
                                                                            - 여름 : 3월 1일 ~ 8월 20일
                                                                            - 가을 : 1월 10일 ~ 5월 30일 + 8월 10일 ~ 10월 30일
                                                                            - 초겨울 : 8월 10일 ~ 11월 30일
                                                                            - 한겨울 : 10월 1일 ~ 1월 10일
                                                                            - 간절기 : 11월 1일 ~ 2월 15일

                                                                            * 긴여름 고려 장기판매 6계절별
                                                                            - 봄   : 1월 10일 ~ 4월 30일
                                                                            - 여름 : 3월 1일 ~ 8월 20일
                                                                            - 가을 : 1월 10일 ~ 5월 30일 + 7월 1일 ~ 10월 30일
                                                                            - 늦가을 : 1월 10일 ~ 5월 30일 + 8월 8일 ~ 11월 10일
                                                                            - 초겨울 : 8월 10일 ~ 11월 30일
                                                                            - 한겨울 : 10월 1일 ~ 1월 10일
                                                                            - 간절기 : 11월 1일 ~ 2월 15일
                                                                            
                                                                            * 전체 4계절 선등록 후 노출 기준
                                                                            - 봄 : 1월 15일  ~ 4월 15일  
                                                                            - 여름 : 4월 15일 ~ 8월 15일
                                                                            - 가을 : 8월 15일 ~ 10월 15일 
                                                                            - 겨울 : 10월 15일 ~ 1월 15일`
                                                                        }/>
                                                                    </h4>
                                                                    <div class="list_select_margin">
                                                                        <SelectBoxV2
                                                                            id={"eventItemWeatherCreatedPeriod_"+idx}
                                                                            tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                            width="100%"
                                                                            height="36px"
                                                                            padding="14px 36px 14px 16px"
                                                                            list= {this.state.event_item_created_period_season_list}
                                                                            optionTexttName = "title"
                                                                            optionValuetName = "value"
                                                                            selectedValue = {
                                                                                obj.event_item_created_period_type && obj.event_item_created_period_type == "S" 
                                                                                ? obj.event_item_created_period+'/'+obj.event_item_created_period_type
                                                                                : "-999"
                                                                            }
                                                                            onClickOption={(text, value, id) => this.onChangeEventItemCreatedPeriod(value, idx)}
                                                                        />
                                                                    </div>
                                                                    <h4 className="txt_black text_15">7. 과거 판매된 상품 선택</h4>
                                                                    <div class="list_select_margin">
                                                                        <div className='list_admin_side_row_5_radio m-b-10'>
                                                                            <RadioButton
                                                                                value={"Y"}
                                                                                text={"사용함"}
                                                                                checked={obj.past_order_date_use_yn == "Y" ? true : false}
                                                                                onChangeCheck={() => this.onChangePastOrderDateUseYn(idx, "Y")}
                                                                            />
                                                                            <RadioButton
                                                                                value={"N"}
                                                                                text={"사용 안 함"}
                                                                                checked={obj.past_order_date_use_yn == "N" ? true : !obj.past_order_date_use_yn ? true : false}
                                                                                onChangeCheck={() => this.onChangePastOrderDateUseYn(idx, "N")}
                                                                            />
                                                                        </div>
                                                                        <div>
                                                                            <h4>1년전 오늘로 부터</h4>
                                                                        </div>
                                                                        <div className='flexBox algorithm_selectbox' style={{marginBottom: "10px"}}>
                                                                            {obj.past_order_date_use_yn == "Y"
                                                                                ? <SelectBoxV2
                                                                                    id={"pastOrderStartDateType_"+idx}
                                                                                    tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                                    width="100%"
                                                                                    height="36px"
                                                                                    padding="14px 36px 14px 16px"
                                                                                    list= {this.state.past_order_start_date_type_list}
                                                                                    optionTexttName = "title"
                                                                                    optionValuetName = "value"
                                                                                    selectedValue = {
                                                                                        obj.past_order_start_date_type
                                                                                        ? obj.past_order_start_date_type
                                                                                        : ""
                                                                                    }
                                                                                    onClickOption={(text, value, id) => this.onChangePastOrderType(value, idx, "past_order_start_date_type")}
                                                                                />
                                                                                : <div class="select_list_position_disabled">
                                                                                        <SelectBoxV2
                                                                                        id={"pastOrderStartDateType_"+idx}
                                                                                        tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                                        width="100%"
                                                                                        height="36px"
                                                                                        padding="14px 36px 14px 16px"
                                                                                        list= {this.state.past_order_start_date_type_list}
                                                                                        optionTexttName = "title"
                                                                                        optionValuetName = "value"
                                                                                        disabled={true}
                                                                                        selectedValue = {
                                                                                            obj.past_order_start_date_type
                                                                                            ? obj.past_order_start_date_type
                                                                                            : ""
                                                                                        }
                                                                                        selectedText = {
                                                                                            "사용 안 함"
                                                                                        }
                                                                                        onClickOption={(text, value, id) => this.onChangePastOrderType(value, idx, "past_order_start_date_type")}
                                                                                    />
                                                                                </div>
                                                                            }
                                                                            <span class="text_14">
                                                                            에서
                                                                            </span>
                                                                        </div>
                                                                        <div className='flexBox algorithm_selectbox' style={{marginBottom: "10px"}}>
                                                                            {obj.past_order_date_use_yn == "Y"
                                                                            ?  <SelectBoxV2
                                                                                id={"pastOrderEndDateType_"+idx}
                                                                                tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                                width="100%"
                                                                                height="36px"
                                                                                padding="14px 36px 14px 16px"
                                                                                list= {this.state.past_order_end_date_type_list}
                                                                                optionTexttName = "title"
                                                                                optionValuetName = "value"
                                                                                selectedValue = {
                                                                                    obj.past_order_end_date_type
                                                                                    ? obj.past_order_end_date_type
                                                                                    : ""
                                                                                }
                                                                                onClickOption={(text, value, id) => this.onChangePastOrderType(value, idx, "past_order_end_date_type")}
                                                                            />
                                                                            : <div class="select_list_position_disabled">
                                                                                <SelectBoxV2
                                                                                    id={"pastOrderEndDateType_"+idx}
                                                                                    tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                                    width="100%"
                                                                                    height="36px"
                                                                                    padding="14px 36px 14px 16px"
                                                                                    list= {this.state.past_order_end_date_type_list}
                                                                                    optionTexttName = "title"
                                                                                    optionValuetName = "value"
                                                                                    selectedValue = {
                                                                                        obj.past_order_end_date_type
                                                                                        ? obj.past_order_end_date_type
                                                                                        : ""
                                                                                    }
                                                                                    selectedText = {
                                                                                        "사용 안 함"
                                                                                    }
                                                                                    disabled="true"
                                                                                    onClickOption={(text, value, id) => this.onChangePastOrderType(value, idx, "past_order_end_date_type")}
                                                                                />
                                                                                </div>
                                                                            }
                                                                            <span class="text_14">
                                                                            까지
                                                                            </span>
                                                                        </div>
                                                                        <div>
                                                                            <h4>과거 판매가 있는 상품 중에서</h4>
                                                                        </div>
                                                                        {/* <div className='text_14 m-b-10' style={{marginBottom:"10px", marginLeft:"14px"}}>과거 판매가 있는 상품 중에서</div> */}
                                                                        <div className='flexBox algorithm_selectbox'>
                                                                            {obj.past_order_date_use_yn == "Y"
                                                                            ? <SelectBoxV2
                                                                                id={"item_past_order_sort_type_select_"+idx}
                                                                                tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                                width="100%"
                                                                                height="36px"
                                                                                padding="14px 36px 14px 16px"
                                                                                list= {this.state.past_order_sort_type_list}
                                                                                optionTexttName = "title"
                                                                                optionValuetName = "value"
                                                                                selectedValue = {obj.past_order_sort_type}
                                                                                onClickOption={this.onChangePastOrderSortType.bind(this)}
                                                                            />
                                                                            : <div class="select_list_position_disabled">
                                                                                <SelectBoxV2
                                                                                    id={"item_past_order_sort_type_select_"+idx}
                                                                                    tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                                    width="100%"
                                                                                    height="36px"
                                                                                    padding="14px 36px 14px 16px"
                                                                                    list= {this.state.past_order_sort_type_list}
                                                                                    optionTexttName = "title"
                                                                                    optionValuetName = "value"
                                                                                    selectedValue = {obj.past_order_sort_type}
                                                                                    selectedText = {
                                                                                        "사용 안 함"
                                                                                    }
                                                                                    disabled="true"
                                                                                    onClickOption={this.onChangePastOrderSortType.bind(this)}
                                                                                />
                                                                            </div>
                                                                            }
                                                                            <div className='text_14'>&nbsp;순서대로</div>
                                                                        </div>
                                                                    </div>
                                                                    <h4 className="txt_black text_15">8. 복합알고리즘 상품 선택 기준</h4>
                                                                    <div class="list_select_margin">
                                                                        <h4>
                                                                        상품 선택 조건
                                                                        </h4>
                                                                        {
                                                                            obj["event_item_condition_list"] 
                                                                            ?   obj["event_item_condition_list"].map((condition_obj, condition_idx) => (
                                                                                    <div className='flexBox algorithm_selectbox' style={{marginBottom: "10px"}}>
                                                                                        <SelectBoxV2
                                                                                            id={"item_condition_list_"+idx+"_"+condition_idx}
                                                                                            tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                                            width="100%"
                                                                                            height="36px"
                                                                                            padding="14px 36px 14px 16px"
                                                                                            list= {this.state.item_condition_list}
                                                                                            optionTexttName = "val1"
                                                                                            optionValuetName = "code_cd"
                                                                                            selectedValue = {condition_obj}
                                                                                            onClickOption={this.onChangeItemConditionListCd.bind(this)}
                                                                                        />
                                                                                        <div className='text_14' style={{paddingRight:"1em"}}>&nbsp;중에서</div>
                                                                                    </div>
                                                                                ))
                                                                            : ""
                                                                        }
                                                                        <h4>
                                                                        통계 수치 분석 기간
                                                                        </h4>
                                                                        <div style={{marginBottom: "10px"}}>
                                                                            <SelectBoxV2
                                                                                id={"eventItemConditionPeriod_"+idx}
                                                                                tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                                width="100%"
                                                                                height="36px"
                                                                                padding="14px 36px 14px 16px"
                                                                                list= {this.state.event_item_condition_period_list}
                                                                                optionTexttName = "title"
                                                                                optionValuetName = "value"
                                                                                selectedValue = {
                                                                                    obj.event_item_condition_period === 0
                                                                                    ? (obj.event_item_condition_period = 4)
                                                                                    : (obj.event_item_condition_period ??= obj.event_item_analysis_period)
                                                                                }
                                                                                selectedText = {
                                                                                    (obj["event_item_condition_list"].every(item => item === "A2999"))
                                                                                    ? "생략"
                                                                                    : null
                                                                                }
                                                                                disabled={obj["event_item_condition_list"].every(item => item === "A2999") ? true : false}
                                                                                onClickOption={this.onChangeEventItemConditionPeried.bind(this)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <h4 className="txt_black text_15">9. 순서를 위한 통계 분석 기간</h4>
                                                                    <div class="list_select_margin">
                                                                        <h4>
                                                                            상품 순서 조건
                                                                        </h4>
                                                                        <div className='flexBox algorithm_selectbox'>
                                                                            {obj.past_order_date_use_yn == "Y"
                                                                            ? <SelectBoxV2
                                                                                key={idx}
                                                                                id={"item_select_type_select_" + idx}
                                                                                tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                                width="100%"
                                                                                height="36px"
                                                                                padding="14px 36px 14px 16px"
                                                                                list={obj.cd == "22998"
                                                                                    ? [...item_select_type_self_list_add_past_order_sort, { code_cd: "22998", val1: "직접입력" }]
                                                                                    : item_select_type_self_list_add_past_order_sort}
                                                                                optionTexttName="val1"
                                                                                optionValuetName="code_cd"
                                                                                selectedValue={obj.cd}
                                                                                onClickOption={this.onChangeSelfSelectListCd.bind(this)}
                                                                            />
                                                                            : <SelectBoxV2
                                                                                id={"item_select_type_select_"+idx}
                                                                                tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                                width="100%"
                                                                                height="36px"
                                                                                padding="14px 36px 14px 16px"
                                                                                list= {item_select_type_self_list}
                                                                                optionTexttName = "val1"
                                                                                optionValuetName = "code_cd"
                                                                                selectedValue = {obj.cd}
                                                                                onClickOption={this.onChangeSelfSelectListCd.bind(this)}
                                                                            />
                                                                             }
                                                                            <div className='text_14'>&nbsp;순서대로</div>
                                                                        </div>
                                                                        <div className='flexBox algorithm_selectbox' style={{justifyContent:"space-between", marginTop: "10px", marginBottom: "10px"}}>
                                                                            <input class="input_self_select" name={"item_select_type_start_idx"} type="text" placeholder="1" value={obj.cd == "22030" ? "" : StringUtil.numberComma(obj.item_select_type_start_idx)} onChange={e => this.onChangeEventItemSelectTypeStartIdx(e,idx)} autocomplete="off" disabled={obj.cd == "22030"} tabIndex={obj.self_select_area_checked ? 0 : -1} style={{width:"180px"}}/>
                                                                            <span class="text_14">번 상품부터 진열</span>
                                                                        </div>
                                                                        <h4>
                                                                            통계 수치 분석 기간
                                                                        </h4>
                                                                        <div style={{marginBottom: "10px"}}>
                                                                            <SelectBoxV2
                                                                                id={"eventItemAnalysisPeriod_"+idx}
                                                                                tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                                width="100%"
                                                                                height="36px"
                                                                                padding="14px 36px 14px 16px"
                                                                                list= {this.state.event_item_analysis_period_list}
                                                                                optionTexttName = "title"
                                                                                optionValuetName = "value"
                                                                                selectedValue = {
                                                                                    obj.event_item_analysis_period = obj.event_item_analysis_period === 0
                                                                                    ? (obj.event_item_analysis_period = 4)
                                                                                    : obj.event_item_analysis_period
                                                                                }
                                                                                onClickOption={this.onChangeEventItemAnalysisPeried.bind(this)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <h4 className="txt_black text_15">10. 상품 선정 수</h4>
                                                                    <div class="list_combo_box">
                                                                        <div class="list_combo_select_color">
                                                                            <SelectBoxV2
                                                                                id={"EventTotalItemSelectCntSelect_"+idx}
                                                                                tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                                width="100%"
                                                                                height="36px"
                                                                                padding="14px 36px 14px 16px"
                                                                                list= {this.state.total_item_select_cnt_range}
                                                                                onlyValue={true}
                                                                                selectedValue = {obj.cnt}
                                                                                error={
                                                                                    (this.state.total_item_select_cnt_range ? (this.state.total_item_select_cnt_range.length > 0 && this.state.event_total_item_select_cnt > (this.state.total_item_select_cnt_range.indexOf("자동") >= 0 ? this.state.total_item_select_cnt_range.length-2 : this.state.total_item_select_cnt_range.length-1)) : false)
                                                                                    || ((obj.essential_product_no_list? obj.essential_product_no_list.length : 0) > 0 && obj.cnt == '자동')
                                                                                    || ((obj.essential_product_no_list? obj.essential_product_no_list.length : 0) > obj.cnt)
                                                                                }
                                                                                onClickOption={this.onChangeEventTotalItemSelectCntSelect.bind(this)}
                                                                            />
                                                                        </div>
                                                                        <input 
                                                                            type="text" 
                                                                            class="text_14 list_input_disabled" 
                                                                            maxlength="3" 
                                                                            id={"EventTotalItemSelectCntSelectInput_"+idx} 
                                                                            value={obj.cnt} 
                                                                            onChange={e => this.onChangeEventTotalItemSelectCntInput(e,idx)
                                                                            }
                                                                        onBlur={e => this.onChangeEventTotalItemSelectCntInput(e,idx,true)} autocomplete="off" tabIndex={-1}/>
                                                                    </div>
                                                                    {this.state.event_total_item_select_cnt > (this.state.total_item_select_cnt_range ? (this.state.total_item_select_cnt_range.indexOf("자동") >= 0 ? this.state.total_item_select_cnt_range.length-2 : this.state.total_item_select_cnt_range.length-1) : 0)
                                                                    ?<div class="alert_warning list_select_margin">
                                                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1229 7.84575 17.2662 5.78033 15.743 4.25704C14.2197 2.73376 12.1543 1.87707 10 1.875ZM9.84375 5.625C10.0292 5.625 10.2104 5.67998 10.3646 5.783C10.5188 5.88601 10.6389 6.03243 10.7099 6.20373C10.7808 6.37504 10.7994 6.56354 10.7632 6.7454C10.7271 6.92725 10.6378 7.0943 10.5067 7.22541C10.3756 7.35652 10.2085 7.44581 10.0267 7.48199C9.84479 7.51816 9.65629 7.49959 9.48499 7.42864C9.31368 7.35768 9.16726 7.23752 9.06425 7.08335C8.96124 6.92918 8.90625 6.74792 8.90625 6.5625C8.90625 6.31386 9.00503 6.0754 9.18084 5.89959C9.35666 5.72377 9.59511 5.625 9.84375 5.625ZM10.625 14.375H10C9.83424 14.375 9.67527 14.3092 9.55806 14.1919C9.44085 14.0747 9.375 13.9158 9.375 13.75V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75H10C10.1658 8.75 10.3247 8.81585 10.4419 8.93306C10.5592 9.05027 10.625 9.20924 10.625 9.375V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375Z" fill="#ACACAC"/></svg>                
                                                                        <span>최대 상품 선정 수는 알고리즘 종합 {this.state.total_item_select_cnt_range ? (this.state.total_item_select_cnt_range.indexOf("자동") >= 0 ? this.state.total_item_select_cnt_range.length-2 : this.state.total_item_select_cnt_range.length-1): 0}개입니다.</span>
                                                                    </div>
                                                                    :
                                                                    obj.essential_product_no_list && (obj.essential_product_no_list.length > obj.cnt)
                                                                    ? <div class="alert_warning list_select_margin">
                                                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1229 7.84575 17.2662 5.78033 15.743 4.25704C14.2197 2.73376 12.1543 1.87707 10 1.875ZM9.84375 5.625C10.0292 5.625 10.2104 5.67998 10.3646 5.783C10.5188 5.88601 10.6389 6.03243 10.7099 6.20373C10.7808 6.37504 10.7994 6.56354 10.7632 6.7454C10.7271 6.92725 10.6378 7.0943 10.5067 7.22541C10.3756 7.35652 10.2085 7.44581 10.0267 7.48199C9.84479 7.51816 9.65629 7.49959 9.48499 7.42864C9.31368 7.35768 9.16726 7.23752 9.06425 7.08335C8.96124 6.92918 8.90625 6.74792 8.90625 6.5625C8.90625 6.31386 9.00503 6.0754 9.18084 5.89959C9.35666 5.72377 9.59511 5.625 9.84375 5.625ZM10.625 14.375H10C9.83424 14.375 9.67527 14.3092 9.55806 14.1919C9.44085 14.0747 9.375 13.9158 9.375 13.75V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75H10C10.1658 8.75 10.3247 8.81585 10.4419 8.93306C10.5592 9.05027 10.625 9.20924 10.625 9.375V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375Z" fill="#ACACAC"/></svg>                
                                                                        <span>상품 선정 수는 고정 상품의 개수보다 커야 합니다.</span>
                                                                    </div>
                                                                    : obj.essential_product_no_list && (obj.essential_product_no_list.length > 0 && obj.cnt == '자동')
                                                                    ? // 필수 상품이 설정되어 있는경우, 상품 선정 수는 ‘자동’으로 할 수 없습니다.
                                                                    <div class="alert_warning list_select_margin">
                                                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1229 7.84575 17.2662 5.78033 15.743 4.25704C14.2197 2.73376 12.1543 1.87707 10 1.875ZM9.84375 5.625C10.0292 5.625 10.2104 5.67998 10.3646 5.783C10.5188 5.88601 10.6389 6.03243 10.7099 6.20373C10.7808 6.37504 10.7994 6.56354 10.7632 6.7454C10.7271 6.92725 10.6378 7.0943 10.5067 7.22541C10.3756 7.35652 10.2085 7.44581 10.0267 7.48199C9.84479 7.51816 9.65629 7.49959 9.48499 7.42864C9.31368 7.35768 9.16726 7.23752 9.06425 7.08335C8.96124 6.92918 8.90625 6.74792 8.90625 6.5625C8.90625 6.31386 9.00503 6.0754 9.18084 5.89959C9.35666 5.72377 9.59511 5.625 9.84375 5.625ZM10.625 14.375H10C9.83424 14.375 9.67527 14.3092 9.55806 14.1919C9.44085 14.0747 9.375 13.9158 9.375 13.75V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75H10C10.1658 8.75 10.3247 8.81585 10.4419 8.93306C10.5592 9.05027 10.625 9.20924 10.625 9.375V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375Z" fill="#ACACAC"/></svg>                
                                                                        <span>고정 상품이 설정되어 있는경우, 상품 선정 수는 ‘자동’으로 할 수 없습니다.</span>
                                                                    </div>
                                                                    : <div class="alert_info list_select_margin">
                                                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1229 7.84575 17.2662 5.78033 15.743 4.25704C14.2197 2.73376 12.1543 1.87707 10 1.875ZM9.84375 5.625C10.0292 5.625 10.2104 5.67998 10.3646 5.783C10.5188 5.88601 10.6389 6.03243 10.7099 6.20373C10.7808 6.37504 10.7994 6.56354 10.7632 6.7454C10.7271 6.92725 10.6378 7.0943 10.5067 7.22541C10.3756 7.35652 10.2085 7.44581 10.0267 7.48199C9.84479 7.51816 9.65629 7.49959 9.48499 7.42864C9.31368 7.35768 9.16726 7.23752 9.06425 7.08335C8.96124 6.92918 8.90625 6.74792 8.90625 6.5625C8.90625 6.31386 9.00503 6.0754 9.18084 5.89959C9.35666 5.72377 9.59511 5.625 9.84375 5.625ZM10.625 14.375H10C9.83424 14.375 9.67527 14.3092 9.55806 14.1919C9.44085 14.0747 9.375 13.9158 9.375 13.75V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75H10C10.1658 8.75 10.3247 8.81585 10.4419 8.93306C10.5592 9.05027 10.625 9.20924 10.625 9.375V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375Z" fill="#ACACAC"/></svg>                
                                                                        <span>최대 상품 선정 수는 알고리즘 종합 {this.state.total_item_select_cnt_range ? (this.state.total_item_select_cnt_range.indexOf("자동") >= 0 ? this.state.total_item_select_cnt_range.length-2 : this.state.total_item_select_cnt_range.length-1) : 0}개입니다.</span>
                                                                    </div>}
                                                                    <div className={this.state.highlightType == "keyword" ? "rp_border_padding_highlight" : ""} ref={highlightKeyword}>
                                                                        <h4 className="txt_black text_15">11. 자동 선택 상품 키워드</h4>
                                                                        <div className={"list_self_select_title_keword_area"}>
                                                                        {obj.product_keyword_list.map((keyword, keyword_idx) => (
                                                                            <div className="list_self_select_title_keword">
                                                                                <TextInput height={38} value={keyword} onChange={e => this.onChangeEventItemProductKeyword(e, idx, keyword_idx)}/>
                                                                                <img onClick={() => this.addEventItemProductKeyword(idx,keyword_idx)} src={default_plus_img}/>
                                                                                {keyword_idx == 0
                                                                                ?<div className={"empty_area"}></div>
                                                                                :<img onClick={() => this.delEventItemProductKeyword(idx,keyword_idx)} src={default_minus_img}/>}
                                                                            </div>
                                                                        ))}
                                                                        </div>
                                                                    </div>
                                                                    <div className={this.state.highlightType == "keyword" ? "rp_border_padding_highlight" : ""} ref={highlightKeyword}>
                                                                        <h4 className="txt_black text_15">12. 자동 제외 상품 키워드</h4>
                                                                        <div className={"list_self_select_title_keword_area"}>
                                                                        {obj.product_except_keyword_list.map((keyword, keyword_idx) => (
                                                                            <div className="list_self_select_title_keword">
                                                                                <TextInput height={38} value={keyword} onChange={e => this.onChangeEventItemProductExceptKeyword(e, idx, keyword_idx)}/>
                                                                                <img onClick={() => this.addEventItemProductExceptKeyword(idx,keyword_idx)} src={default_plus_img}/>
                                                                                {keyword_idx == 0
                                                                                ?<div className={"empty_area"}></div>
                                                                                :<img onClick={() => this.delEventItemProductExceptKeyword(idx,keyword_idx)} src={default_minus_img}/>}
                                                                            </div>
                                                                        ))}
                                                                        </div>
                                                                    </div>
                                                                    <div class="list_select_margin" style={{width:"100%"}}>
                                                                        <h4 className="txt_black text_15">13. 부분품절 상품 자동 제외</h4>    
                                                                        <div className='list_admin_side_row_5_radio'>
                                                                            <RadioButton
                                                                                value={"Y"}
                                                                                text={"제외함"}
                                                                                checked={obj.is_except_option_soldout == "Y" ? true : false}
                                                                                onChangeCheck={() => this.onChangeIsExceptOptionSoldout(idx, "Y")}
                                                                            />
                                                                            <RadioButton
                                                                                value={"N"}
                                                                                text={"제외 안 함"}
                                                                                checked={obj.is_except_option_soldout == "N" ? true : obj.is_except_option_soldout == null ? true : false}
                                                                                onChangeCheck={() => this.onChangeIsExceptOptionSoldout(idx, "N")}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div class="list_select_margin" style={{width:"100%"}}>
                                                                        <h4 className="txt_black text_15">14. 품절 상품 자동 제외</h4>    
                                                                        <div className='list_admin_side_row_5_radio'>
                                                                            {/* <RadioButton
                                                                                value={"Y"}
                                                                                text={"품절상품 자동 제외함"}
                                                                                checked={true}
                                                                            /> */}
                                                                            <RadioButton
                                                                                value={"Y"}
                                                                                text={"제외함"}
                                                                                checked={obj.is_except_soldout == "Y" ? true : obj.is_except_soldout == null ? true : false}
                                                                                onChangeCheck={() => this.onChangeIsExceptSoldout(idx, "Y")}
                                                                            />
                                                                            <RadioButton
                                                                                value={"N"}
                                                                                text={"제외 안 함"}
                                                                                checked={obj.is_except_soldout == "N" ? true : false}
                                                                                onChangeCheck={() => this.onChangeIsExceptSoldout(idx, "N")}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div class="list_select_margin" style={{width:"100%"}}>
                                                                        <h4 className="txt_black text_15">15. 상품 정보에 숨긴 카테고리가 있다면</h4>    
                                                                        <div className='list_admin_side_row_5_radio'>
                                                                            <RadioButton
                                                                                value={"Y"}
                                                                                text={"제외함"}
                                                                                checked={obj.is_except_invisible_category == "Y" ? true : obj.is_except_invisible_category == null ? true : false}
                                                                                onChangeCheck={() => this.onChangeIsExceptInvisibleCategory(idx, "Y")}
                                                                            />
                                                                            <RadioButton
                                                                                value={"N"}
                                                                                text={"제외 안 함"}
                                                                                checked={obj.is_except_invisible_category == "N" ? true : false}
                                                                                onChangeCheck={() => this.onChangeIsExceptInvisibleCategory(idx, "N")}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className='detail_filter_wrapper'>
                                                                        <div className='detail_filter_header' id={'detail_filter_header_'+idx} onClick={e => {this.onClicAlgorithmDetailFilterFolder(e, idx)}}>
                                                                            <h4 className="txt_black text_15" style={{marginBottom:"0px"}}>16. 상품 선택 세부 설정</h4>
                                                                            <input class="detail_filter_expand_check" type="checkbox" id={"detail_filter_arrow_"+idx} name="detail_filter_arrow" checked={obj.detail_filter_expand_check? true : false}/>
                                                                            <label for={"detail_filter_arrow_"+idx} style={{cursor:"pointer",display: "flex", alignItems: "center", justifyContent: "center", width:"16px",height:"16px"}} onClick={e => {e.preventDefault();}}>
                                                                                <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M0.750097 1.00005C0.750217 0.967343 0.756919 0.934992 0.769804 0.904927C0.782689 0.874862 0.801494 0.847697 0.825097 0.825052C0.84782 0.801616 0.875019 0.782982 0.905081 0.770257C0.935143 0.757533 0.967454 0.750976 1.0001 0.750976C1.03274 0.750976 1.06505 0.757533 1.09511 0.770258C1.12518 0.782982 1.15237 0.801616 1.1751 0.825052L6.0001 5.6438L10.8251 0.825053C10.8732 0.788945 10.9328 0.771416 10.9928 0.775682C11.0528 0.779948 11.1093 0.805723 11.1519 0.848276C11.1944 0.890829 11.2202 0.947304 11.2245 1.00733C11.2287 1.06736 11.2112 1.12691 11.1751 1.17505L6.1751 6.17505C6.15237 6.19849 6.12517 6.21712 6.09511 6.22985C6.06505 6.24257 6.03274 6.24913 6.0001 6.24913C5.96745 6.24913 5.93514 6.24257 5.90508 6.22985C5.87502 6.21712 5.84782 6.19849 5.8251 6.17505L0.825097 1.17505C0.801494 1.15241 0.782689 1.12524 0.769804 1.09518C0.756919 1.06511 0.750217 1.03276 0.750097 1.00005Z" fill="#333333"/>
                                                                                </svg>
                                                                            </label>
                                                                        </div>
                                                                        <div className={'detail_filter_area '+(obj.detail_filter_expand_check? 'visible_algorithm' : 'hidden_algorithm')}>
                                                                            <h4>17. 자동 선택 상품 옵션</h4>
                                                                            <div className="list_self_select_product_color">
                                                                                <MultiSelect
                                                                                    key={obj.uuid+JSON.stringify(obj.color_list)+obj.detail_filter_expand_check+obj.detail_filter_expand_check}
                                                                                    className={["react-select"].join(' ')}
                                                                                    value={obj.color_list}
                                                                                    closeMenuOnSelect={false}
                                                                                    components={animatedComponents}
                                                                                    isMulti
                                                                                    placeholder={"상품 컬러를 선택할 수 있습니다."}
                                                                                    noOptionsMessage={() => "선택할 컬러가 없습니다."}
                                                                                    getOptionValue={(option) => option.color_seq}
                                                                                    getOptionLabel={(option) => option.color_name}
                                                                                    options={this.state.product_color_list}
                                                                                    onChange={(selectedOption) => this.selectProductColor(idx, selectedOption)}
                                                                                    styles={reactSelectStyles({optionColorName : "color_hex"})}
                                                                                />
                                                                            </div>
                                                                            <h4>18. 상품 조회수</h4>
                                                                            <div class="list_self_select_price">
                                                                                <div>
                                                                                    <input class="input_self_select" name={"min_hit_cnt"} type="text" placeholder="0" value={StringUtil.numberComma(obj.min_hit_cnt)} onChange={e => this.onChangeEventItemPrice(e,idx)} autocomplete="off" tabIndex={obj.self_select_area_checked ? 0 : -1}/>
                                                                                    <span class="text_14">~</span>
                                                                                </div>
                                                                                <div>
                                                                                    <input class="input_self_select" name={"max_hit_cnt"} type="text" placeholder="999,999,999" value={StringUtil.numberComma(obj.max_hit_cnt)} onChange={e => this.onChangeEventItemPrice(e,idx)} autocomplete="off" tabIndex={obj.self_select_area_checked ? 0 : -1}/>
                                                                                    <span class="text_14">개</span>
                                                                                </div>
                                                                            </div>
                                                                            <h4>19. 상품 장바구니수</h4>
                                                                            <div class="list_self_select_price">
                                                                                <div>
                                                                                    <input class="input_self_select" name={"min_cart_cnt"} type="text" placeholder="0" value={StringUtil.numberComma(obj.min_cart_cnt)} onChange={e => this.onChangeEventItemPrice(e,idx)} autocomplete="off" tabIndex={obj.self_select_area_checked ? 0 : -1}/>
                                                                                    <span class="text_14">~</span>
                                                                                </div>
                                                                                <div>
                                                                                    <input class="input_self_select" name={"max_cart_cnt"} type="text" placeholder="999,999,999" value={StringUtil.numberComma(obj.max_cart_cnt)} onChange={e => this.onChangeEventItemPrice(e,idx)} autocomplete="off" tabIndex={obj.self_select_area_checked ? 0 : -1}/>
                                                                                    <span class="text_14">개</span>
                                                                                </div>
                                                                            </div>
                                                                            <h4>20. 상품 판매가</h4>
                                                                            <div class="list_self_select_price">
                                                                                <div>
                                                                                    <input class="input_self_select" name={"min_price"} type="text" placeholder="0" value={StringUtil.numberComma(obj.min_price)} onChange={e => this.onChangeEventItemPrice(e,idx)} autocomplete="off" tabIndex={obj.self_select_area_checked ? 0 : -1}/>
                                                                                    <span class="text_14">~</span>
                                                                                </div>
                                                                                <div>
                                                                                    <input class="input_self_select" name={"max_price"} type="text" placeholder="999,999,999" value={StringUtil.numberComma(obj.max_price)} onChange={e => this.onChangeEventItemPrice(e,idx)} autocomplete="off" tabIndex={obj.self_select_area_checked ? 0 : -1}/>
                                                                                    <span class="text_14">원</span>
                                                                                </div>
                                                                            </div>
                                                                            <h4>21. 상품 할인율</h4>
                                                                            <div className='list_admin_side_row_5_radio' style={{flexDirection:"column", alignItems: "flex-start", gap: "8px", marginBottom:"8px"}}>
                                                                                <RadioButton
                                                                                    value={"1"}
                                                                                    text={"판매가 대비 할인가"}
                                                                                    checked={obj.sale_percent_type == "1" || !obj.sale_percent_type}
                                                                                    onChangeCheck={() => this.onChangeSalePercentType(idx, "1")}
                                                                                />
                                                                                <RadioButton
                                                                                    value={"2"}
                                                                                    text={"소비자가 대비 판매가"}
                                                                                    checked={obj.sale_percent_type == "2"}
                                                                                    onChangeCheck={() => this.onChangeSalePercentType(idx, "2")}
                                                                                />
                                                                            </div>
                                                                            <div class="list_self_select_price">
                                                                                <div>
                                                                                    <input class="input_self_select" name={"min_sale_percent"} type="text" placeholder="0" value={obj.min_sale_percent ? StringUtil.numberComma(obj.min_sale_percent) : ""} onChange={e => this.onChangeEventItemPrice(e,idx, "", true)} autocomplete="off" tabIndex={obj.self_select_area_checked ? 0 : -1}/>
                                                                                    <span class="text_14">~</span>
                                                                                </div>
                                                                                <div>
                                                                                    <input class="input_self_select" name={"max_sale_percent"} type="text" placeholder="100" value={obj.max_sale_percent ? StringUtil.numberComma(obj.max_sale_percent) : ""} onChange={e => this.onChangeEventItemPrice(e,idx, "", true)} autocomplete="off" tabIndex={obj.self_select_area_checked ? 0 : -1}/>
                                                                                    <span class="text_14">%</span>
                                                                                </div>
                                                                            </div>
                                                                            <h4>22. 상품 판매수</h4>
                                                                            <div class="list_self_select_price">
                                                                                <div>
                                                                                    <input class="input_self_select" name={"min_order_cnt"} type="text" placeholder="0" value={StringUtil.numberComma(obj.min_order_cnt)} onChange={e => this.onChangeEventItemPrice(e,idx)} autocomplete="off" tabIndex={obj.self_select_area_checked ? 0 : -1}/>
                                                                                    <span class="text_14">~</span>
                                                                                </div>
                                                                                <div>
                                                                                    <input class="input_self_select" name={"max_order_cnt"} type="text" placeholder="999,999,999" value={StringUtil.numberComma(obj.max_order_cnt)} onChange={e => this.onChangeEventItemPrice(e,idx)} autocomplete="off" tabIndex={obj.self_select_area_checked ? 0 : -1}/>
                                                                                    <span class="text_14">개</span>
                                                                                </div>
                                                                            </div>
                                                                            <h4>23. 상품 판매액</h4>
                                                                            <div class="list_self_select_price">
                                                                                <div>
                                                                                    <input class="input_self_select" name={"min_order_price"} type="text" placeholder="0" value={StringUtil.numberComma(obj.min_order_price)} onChange={e => this.onChangeEventItemPrice(e,idx)} autocomplete="off" tabIndex={obj.self_select_area_checked ? 0 : -1}/>
                                                                                    <span class="text_14">~</span>
                                                                                </div>
                                                                                <div>
                                                                                    <input class="input_self_select" name={"max_order_price"} type="text" placeholder="999,999,999" value={StringUtil.numberComma(obj.max_order_price)} onChange={e => this.onChangeEventItemPrice(e,idx)} autocomplete="off" tabIndex={obj.self_select_area_checked ? 0 : -1}/>
                                                                                    <span class="text_14">원</span>
                                                                                </div>
                                                                            </div>
                                                                            <h4>24. 상품 리뷰수</h4>
                                                                            <div class="list_self_select_price">
                                                                                <div>
                                                                                    <input class="input_self_select" name={"min_review_cnt"} type="text" placeholder="0" value={StringUtil.numberComma(obj.min_review_cnt)} onChange={e => this.onChangeEventItemPrice(e,idx)} autocomplete="off" tabIndex={obj.self_select_area_checked ? 0 : -1}/>
                                                                                    <span class="text_14">~</span>
                                                                                </div>
                                                                                <div>
                                                                                    <input class="input_self_select" name={"max_review_cnt"} type="text" placeholder="999,999,999" value={StringUtil.numberComma(obj.max_review_cnt)} onChange={e => this.onChangeEventItemPrice(e,idx)} autocomplete="off" tabIndex={obj.self_select_area_checked ? 0 : -1}/>
                                                                                    <span class="text_14">개</span>
                                                                                </div>
                                                                            </div>
                                                                            <h4>25. 상품 리뷰평점</h4>
                                                                            <div class="list_self_select_price">
                                                                                <div>
                                                                                    <input class="input_self_select" name={"min_review_point"} type="text" placeholder="0" value={StringUtil.numberComma(obj.min_review_point)} onChange={e => this.onChangeEventItemPrice(e,idx, 5)} autocomplete="off" tabIndex={obj.self_select_area_checked ? 0 : -1}/>
                                                                                    <span class="text_14">~</span>
                                                                                </div>
                                                                                <div>
                                                                                    <input class="input_self_select" name={"max_review_point"} type="text" placeholder="5" value={StringUtil.numberComma(obj.max_review_point)} onChange={e => this.onChangeEventItemPrice(e,idx, 5)} autocomplete="off" tabIndex={obj.self_select_area_checked ? 0 : -1}/>
                                                                                    <span class="text_14">점</span>
                                                                                </div>
                                                                            </div>
                                                                            <h4>26. 상품 재고수</h4>
                                                                            <div class="list_self_select_price">
                                                                                <div>
                                                                                    <input class="input_self_select" name={"min_quantity"} type="text" placeholder="0" value={StringUtil.numberComma(obj.min_quantity)} onChange={e => this.onChangeEventItemPrice(e,idx)} autocomplete="off" tabIndex={obj.self_select_area_checked ? 0 : -1}/>
                                                                                    <span class="text_14">~</span>
                                                                                </div>
                                                                                <div>
                                                                                    <input class="input_self_select" name={"max_quantity"} type="text" placeholder="999,999,999" value={StringUtil.numberComma(obj.max_quantity)} onChange={e => this.onChangeEventItemPrice(e,idx)} autocomplete="off" tabIndex={obj.self_select_area_checked ? 0 : -1}/>
                                                                                    <span class="text_14">개</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='detail_filter_summary' style={{display:(obj.detail_filter_expand_check? 'none' : 'flex')}}>
                                                                        {/* 옵션 */}
                                                                        {obj.color_list && obj.color_list.length > 0
                                                                            ? <div className='detail_filter_summary_content'>
                                                                                <div>자동 선택 상품옵션&nbsp;&nbsp;&nbsp;{obj.color_list.map(color_obj => "#" + color_obj.color_name).join(', ')}</div>
                                                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveListFilter("color_list", idx)}>
                                                                                    <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                                </svg>
                                                                            </div>
                                                                            : ""
                                                                        }
                                                                        {/* 조회수 */}
                                                                        {obj.min_hit_cnt && !obj.max_hit_cnt
                                                                        ? <div className='detail_filter_summary_content'>
                                                                            상품 조회수 {StringUtil.numberComma(obj.min_hit_cnt)}개 이상
                                                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_hit_cnt", "max_hit_cnt", idx)}>
                                                                                <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                            </svg>
                                                                        </div>
                                                                        : !obj.min_hit_cnt && obj.max_hit_cnt
                                                                            ? <div className='detail_filter_summary_content'>
                                                                                상품 조회수 {StringUtil.numberComma(obj.max_hit_cnt)}개 이하
                                                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_hit_cnt", "max_hit_cnt", idx)}>
                                                                                    <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                                </svg>
                                                                            </div>
                                                                            : obj.min_hit_cnt && obj.max_hit_cnt
                                                                            ? <div className='detail_filter_summary_content'>
                                                                                상품 조회수 {StringUtil.numberComma(obj.min_hit_cnt)} ~ {StringUtil.numberComma(obj.max_hit_cnt)} 개
                                                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_hit_cnt", "max_hit_cnt", idx)}>
                                                                                    <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                                </svg>
                                                                            </div>
                                                                            : ""
                                                                        }
                                                                        {/* 장바구니수 */}
                                                                        {obj.min_cart_cnt && !obj.max_cart_cnt
                                                                        ? <div className='detail_filter_summary_content'>
                                                                            상품 장바구니수 {StringUtil.numberComma(obj.min_cart_cnt)}개 이상
                                                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_cart_cnt", "max_cart_cnt", idx)}>
                                                                                <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                            </svg>
                                                                        </div>
                                                                        : !obj.min_cart_cnt && obj.max_cart_cnt
                                                                            ? <div className='detail_filter_summary_content'>
                                                                                상품 장바구니수 {StringUtil.numberComma(obj.max_cart_cnt)}개 이하
                                                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_cart_cnt", "max_cart_cnt", idx)}>
                                                                                    <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                                </svg>
                                                                            </div>
                                                                            : obj.min_cart_cnt && obj.max_cart_cnt
                                                                            ? <div className='detail_filter_summary_content'>
                                                                                상품 장바구니수 {StringUtil.numberComma(obj.min_cart_cnt)} ~ {StringUtil.numberComma(obj.max_cart_cnt)} 개
                                                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_cart_cnt", "max_cart_cnt", idx)}>
                                                                                    <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                                </svg>    
                                                                            </div>
                                                                            : ""
                                                                        }
                                                                        {/* 판매가 */}
                                                                        {obj.min_price && !obj.max_price
                                                                        ? <div className='detail_filter_summary_content'>
                                                                            상품 판매가 {StringUtil.numberComma(obj.min_price)}원 이상
                                                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_price", "max_price", idx)}>
                                                                                <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                            </svg>
                                                                        </div>
                                                                        : !obj.min_price && obj.max_price
                                                                            ? <div className='detail_filter_summary_content'>
                                                                                상품 판매가 {StringUtil.numberComma(obj.max_price)}원 이하
                                                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_price", "max_price", idx)}>
                                                                                    <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                                </svg>
                                                                            </div>
                                                                            : obj.min_price && obj.max_price
                                                                            ? <div className='detail_filter_summary_content'>
                                                                                상품 판매가 {StringUtil.numberComma(obj.min_price)} ~ {StringUtil.numberComma(obj.max_price)} 원
                                                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_price", "max_price", idx)}>
                                                                                    <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                                </svg>
                                                                            </div>
                                                                            : ""
                                                                        }
                                                                        {/* 판매수 */}
                                                                        {obj.min_order_cnt && !obj.max_order_cnt
                                                                        ? <div className='detail_filter_summary_content'>
                                                                            상품 판매수 {StringUtil.numberComma(obj.min_order_cnt)}개 이상
                                                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_order_cnt", "max_order_cnt", idx)}>
                                                                                <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                            </svg>
                                                                        </div>
                                                                        : !obj.min_order_cnt && obj.max_order_cnt
                                                                            ? <div className='detail_filter_summary_content'>
                                                                                상품 판매수 {StringUtil.numberComma(obj.max_order_cnt)}개 이하
                                                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_order_cnt", "max_order_cnt", idx)}>
                                                                                    <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                                </svg>
                                                                            </div>
                                                                            : obj.min_order_cnt && obj.max_order_cnt
                                                                            ? <div className='detail_filter_summary_content'>
                                                                                상품 판매수 {StringUtil.numberComma(obj.min_order_cnt)} ~ {StringUtil.numberComma(obj.max_order_cnt)} 개
                                                                                 <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_order_cnt", "max_order_cnt", idx)}>
                                                                                    <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                                </svg>
                                                                            </div>
                                                                            : ""
                                                                        }
                                                                        {/* 할인율 */}
                                                                        {obj.min_sale_percent && !obj.max_sale_percent
                                                                        ? <div className='detail_filter_summary_content'>
                                                                            상품 할인율 {StringUtil.numberComma(obj.min_sale_percent)}% 이상
                                                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_sale_percent", "max_sale_percent", idx)}>
                                                                                <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                            </svg>
                                                                        </div>
                                                                        : !obj.min_sale_percent && obj.max_sale_percent
                                                                            ? <div className='detail_filter_summary_content'>
                                                                                상품 할인율 {StringUtil.numberComma(obj.max_sale_percent)}% 이하
                                                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_sale_percentt", "max_sale_percent", idx)}>
                                                                                    <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                                </svg>
                                                                            </div>
                                                                            : obj.min_sale_percent && obj.max_sale_percent
                                                                            ? <div className='detail_filter_summary_content'>
                                                                                상품 할인율 {StringUtil.numberComma(obj.min_sale_percent)} ~ {StringUtil.numberComma(obj.max_sale_percent)} %
                                                                                 <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_sale_percent", "max_sale_percent", idx)}>
                                                                                    <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                                </svg>
                                                                            </div>
                                                                            : ""
                                                                        }
                                                                        {/* 판매액 */}
                                                                        {obj.min_order_price && !obj.max_order_price
                                                                        ? <div className='detail_filter_summary_content'>
                                                                            상품 판매액 {StringUtil.numberComma(obj.min_order_price)}원 이상
                                                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_order_price", "max_order_price", idx)}>
                                                                                <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                            </svg>
                                                                        </div>
                                                                        : !obj.min_order_price && obj.max_order_price
                                                                            ? <div className='detail_filter_summary_content'>
                                                                                상품 판매액 {StringUtil.numberComma(obj.max_order_price)}원 이하
                                                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_order_price", "max_order_price", idx)}>
                                                                                    <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                                </svg>
                                                                            </div>
                                                                            : obj.min_order_price && obj.max_order_price
                                                                            ? <div className='detail_filter_summary_content'>
                                                                                상품 판매액 {StringUtil.numberComma(obj.min_order_price)} ~ {StringUtil.numberComma(obj.max_order_price)} 원
                                                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_order_price", "max_order_price", idx)}>
                                                                                    <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                                </svg>
                                                                            </div>
                                                                            : ""
                                                                        }
                                                                        {/* 리뷰수 */}
                                                                        {obj.min_review_cnt && !obj.max_review_cnt
                                                                        ? <div className='detail_filter_summary_content'>
                                                                            상품 리뷰수 {StringUtil.numberComma(obj.min_review_cnt)}개 이상
                                                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_review_cnt", "max_review_cnt", idx)}>
                                                                                <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                            </svg>
                                                                        </div>
                                                                        : !obj.min_review_cnt && obj.max_review_cnt
                                                                            ? <div className='detail_filter_summary_content'>
                                                                                상품 리뷰수 {StringUtil.numberComma(obj.max_review_cnt)}개 이하
                                                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_review_cnt", "max_review_cnt", idx)}>
                                                                                    <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                                </svg>
                                                                            </div>
                                                                            : obj.min_review_cnt && obj.max_review_cnt
                                                                            ? <div className='detail_filter_summary_content'>
                                                                                상품 리뷰수 {StringUtil.numberComma(obj.min_review_cnt)} ~ {StringUtil.numberComma(obj.max_review_cnt)} 개
                                                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_review_cnt", "max_review_cnt", idx)}>
                                                                                    <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                                </svg>
                                                                            </div>
                                                                            : ""
                                                                        }
                                                                        {/* 리뷰평점 */}
                                                                        {obj.min_review_point && !obj.max_review_point
                                                                        ? <div className='detail_filter_summary_content'>
                                                                            상품 리뷰평점 {StringUtil.numberComma(obj.min_review_point)}점 이상
                                                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_review_point", "max_review_point", idx)}>
                                                                                <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                            </svg>
                                                                        </div>
                                                                        : !obj.min_review_point && obj.max_review_point
                                                                            ? <div className='detail_filter_summary_content'>
                                                                                상품 리뷰평점 {StringUtil.numberComma(obj.max_review_point)}점 이하
                                                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_review_point", "max_review_point", idx)}>
                                                                                    <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                                </svg>
                                                                            </div>
                                                                            : obj.min_review_point && obj.max_review_point
                                                                            ? <div className='detail_filter_summary_content'>
                                                                                상품 리뷰평점 {StringUtil.numberComma(obj.min_review_point)} ~ {StringUtil.numberComma(obj.max_review_point)} 점
                                                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_review_point", 'max_review_point', idx)}>
                                                                                    <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                                </svg>
                                                                            </div>
                                                                            : ""
                                                                        }
                                                                        {/* 재고수 */}
                                                                        {obj.min_quantity && !obj.max_quantity
                                                                        ? <div className='detail_filter_summary_content'>
                                                                            상품 재고수 {StringUtil.numberComma(obj.min_quantity)}개 이상
                                                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_quantity", "max_quantity", idx)}>
                                                                                <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                            </svg>
                                                                        </div>
                                                                        : !obj.min_quantity && obj.max_quantity
                                                                            ? <div className='detail_filter_summary_content'>
                                                                                상품 재고수 {StringUtil.numberComma(obj.max_quantity)}개 이하
                                                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter('min_quantity', "max_quantity", idx)}>
                                                                                    <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                                </svg>
                                                                            </div>
                                                                            : obj.min_quantity && obj.max_quantity
                                                                            ? <div className='detail_filter_summary_content'>
                                                                                상품 재고수 {StringUtil.numberComma(obj.min_quantity)} ~ {StringUtil.numberComma(obj.max_quantity)} 개
                                                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => this.onClicRemoveMinMaxFilter("min_quantity", "max_quantity", idx)}>
                                                                                    <path d="M9.67506 9.32501C9.69849 9.34773 9.71712 9.37493 9.72985 9.40499C9.74257 9.43505 9.74913 9.46736 9.74913 9.50001C9.74913 9.53265 9.74257 9.56496 9.72985 9.59502C9.71712 9.62508 9.69849 9.65228 9.67506 9.67501C9.65233 9.69844 9.62513 9.71708 9.59507 9.7298C9.56501 9.74253 9.5327 9.74908 9.50006 9.74908C9.46741 9.74908 9.4351 9.74253 9.40504 9.7298C9.37498 9.71708 9.34778 9.69844 9.32506 9.67501L5.00005 5.35626L0.675053 9.67501C0.65233 9.69844 0.625131 9.71708 0.595069 9.7298C0.565008 9.74253 0.532697 9.74908 0.500053 9.74908C0.46741 9.74908 0.435098 9.74253 0.405037 9.7298C0.374976 9.71708 0.347776 9.69844 0.325053 9.67501C0.301617 9.65228 0.282983 9.62508 0.270258 9.59502C0.257534 9.56496 0.250977 9.53265 0.250977 9.50001C0.250977 9.46736 0.257534 9.43505 0.270258 9.40499C0.282983 9.37493 0.301617 9.34773 0.325053 9.32501L4.6438 5.00001L0.325053 0.675006C0.288946 0.626863 0.271416 0.567311 0.275682 0.507284C0.279948 0.447257 0.305724 0.390782 0.348276 0.348229C0.390829 0.305677 0.447304 0.279901 0.507331 0.275635C0.567358 0.271369 0.62691 0.288899 0.675053 0.325006L5.00005 4.64376L9.32506 0.325006C9.34655 0.296352 9.37394 0.27265 9.40539 0.255505C9.43684 0.238361 9.47161 0.228174 9.50733 0.225635C9.54306 0.223096 9.57892 0.228264 9.61247 0.240788C9.64603 0.253313 9.67651 0.272902 9.70183 0.298229C9.72716 0.323557 9.74675 0.35403 9.75927 0.387587C9.7718 0.421144 9.77697 0.457001 9.77443 0.492729C9.77189 0.528456 9.7617 0.563222 9.74456 0.59467C9.72741 0.626118 9.70371 0.653515 9.67506 0.675006L5.3563 5.00001L9.67506 9.32501Z" fill="#333333"/>
                                                                                </svg>
                                                                            </div>
                                                                            : ""
                                                                        }
                                                                    </div>    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                            <button class="list_select_content_add_btn" onClick={() => {this.addListSelfSelect()}}>
                                                <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M2.5 10C2.5 9.83424 2.56585 9.67527 2.68306 9.55806C2.80027 9.44085 2.95924 9.375 3.125 9.375L9.375 9.375L9.375 3.125C9.375 2.95924 9.44085 2.80027 9.55806 2.68306C9.67527 2.56585 9.83424 2.5 10 2.5C10.1658 2.5 10.3247 2.56585 10.4419 2.68306C10.5592 2.80027 10.625 2.95924 10.625 3.125L10.625 9.375L16.875 9.375C17.0408 9.375 17.1997 9.44085 17.3169 9.55806C17.4342 9.67527 17.5 9.83424 17.5 10C17.5 10.1658 17.4342 10.3247 17.3169 10.4419C17.1997 10.5592 17.0408 10.625 16.875 10.625L10.625 10.625L10.625 16.875C10.625 17.0408 10.5592 17.1997 10.4419 17.3169C10.3247 17.4342 10.1658 17.5 10 17.5C9.83424 17.5 9.67527 17.4342 9.55806 17.3169C9.44085 17.1997 9.375 17.0408 9.375 16.875L9.375 10.625L3.125 10.625C2.95924 10.625 2.80027 10.5592 2.68306 10.4419C2.56585 10.3247 2.5 10.1658 2.5 10Z" fill="#333333"/>
                                                </svg>
                                                <h4>추가</h4>
                                            </button>
                                            <div style={{borderBottom: "1px solid rgba(0, 0, 0, 0.12)", margin:"16px 0px 24px 0px"}}></div>
                                            <div class="list_select_product_btn_wrap">
                                                <button class="text_extrasmall hover_white" onClick={() => this.onClickExcludeProductListPopup()} tabIndex={-1}>제외 상품등록</button>
                                                <button class="text_extrasmall hover_white" onClick={() => this.onClickExceptSettingPopup()} tabIndex={-1}>진열코너간의 같은 상품 제외등록</button>
                                            </div>
                                            <div style={{borderBottom: "1px solid rgba(0, 0, 0, 0.12)", margin: "0 0 16px"}}></div>
                                            {/* </div>
                                            <div class="list_admin_side_select list_expand_1" style={{overflow:"visible"}}> */}
                                            <div class="list_select_content" style={{paddingBottom: "18px"}}>
                                                <div class="list_select_wrap">
                                                    <div class="list_select_expand_wrap" style={{overflow:'visible'}}>
                                                        <label class="list_select_expand" id="list_select_expand_force" for="list_select_arrow_force" onClick={e => {this.onClickEventFolderForce()}}>
                                                            <h3 class="text_16">백업용 | 자동진열할 상품  부족시  상품설정</h3>
                                                            <input class="list_select_expand_check" type="checkbox" id="list_select_arrow_force" name="list_select_arrow"/>
                                                            <label for="list_select_arrow_force" style={{cursor:"pointer",width:"16px",height:"16px"}}>
                                                                <svg style={{background:"none",width:"16px",height:"16px", marginBottom: "3px"}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#333" class="arrow-down" viewBox="0 0 16 16">
                                                                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                                                </svg>
                                                            </label>
                                                        </label>
                                                        <div class="list_select_expand_1 rp_algorithm">
                                                            <div class="list_select_set">
                                                                <h4>자동 진열 수량 부족 시 강제 선택</h4>
                                                                <div class="list_admin_side_row_5_radio">
                                                                    {this.state.force_use_yn_list.map((obj, idx) => (
                                                                        <RadioButton
                                                                            id={"force_use_" + obj.value}
                                                                            name={"list_side_force_radio"}
                                                                            value={obj.value}
                                                                            text={obj.text}
                                                                            checked={this.state.force_use_yn===obj.value}
                                                                            onChangeCheck={this.onChangeForceUseYn.bind(this)}
                                                                        />
                                                                    ))}
                                                                </div>
                                                            </div>
                                                            <div class="list_select_set">
                                                                <h4>상품 선택 카테고리</h4>
                                                                {/* 상품 카테고리 */}
                                                                <div class="list_select_margin" style={{width:"100%"}}>
                                                                    <div class="list_category_select_box">
                                                                        <SelectBoxV2
                                                                            id={"product_rp_category_no_force/1"}
                                                                            width="100%"
                                                                            height="36px"
                                                                            padding="14px 36px 14px 16px"
                                                                            list={this.state.force_category_list_1}
                                                                            optionTexttName = "category_name_no_format"
                                                                            optionValuetName = "category_no"
                                                                            selectedValue = {this.state.force_category.product_rp_category_no_1 === "" ? "전체상품" : this.state.force_category.product_rp_category_no_1}
                                                                            onClickOption={this.onChangeForceCategory.bind(this)}
                                                                        />
                                                                    </div>
                                                                    {
                                                                        this.state.force_category_list_2 != null && this.state.force_category_list_2.length > 0
                                                                        ?<div class="list_category_select_box list_category_select_box_1">
                                                                            <SelectBoxV2
                                                                                id={"product_rp_category_no_force/2"}
                                                                                // tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                                width="100%"
                                                                                height="36px"
                                                                                padding="14px 36px 14px 16px"
                                                                                list= {this.state.force_category_list_2}
                                                                                optionTexttName = "category_name_no_format"
                                                                                optionValuetName = "category_no"
                                                                                selectedValue = {this.state.force_category.product_rp_category_no_2 === "" ? "전체상품" : this.state.force_category.product_rp_category_no_2}
                                                                                onClickOption={this.onChangeForceCategory.bind(this)}
                                                                            />
                                                                        </div>
                                                                        :   ""
                                                                    }
                                                                    {
                                                                        this.state.force_category_list_3 != null && this.state.force_category_list_3.length > 0
                                                                        ?<div class="list_category_select_box list_category_select_box_1">
                                                                            <SelectBoxV2
                                                                                id={"product_rp_category_no_force/3"}
                                                                                tabIndex={this.state.force_category.self_select_area_checked ? 0 : ""}
                                                                                width="100%"
                                                                                height="36px"
                                                                                padding="14px 36px 14px 16px"
                                                                                list= {this.state.force_category_list_3}
                                                                                optionTexttName = "category_name_no_format"
                                                                                optionValuetName = "category_no"
                                                                                selectedValue = {this.state.force_category.product_rp_category_no_3 === "" ? "전체상품" : this.state.force_category.product_rp_category_no_3}
                                                                                onClickOption={this.onChangeForceCategory.bind(this)}
                                                                            />
                                                                        </div>
                                                                        :   ""
                                                                    }
                                                                    {
                                                                        this.state.force_category_list_4 != null && this.state.force_category_list_4.length > 0
                                                                        ?<div class="list_category_select_box list_category_select_box_1">
                                                                            <SelectBoxV2
                                                                                id={"product_rp_category_no_force/4"}
                                                                                tabIndex={this.state.force_category.self_select_area_checked ? 0 : ""}
                                                                                width="100%"
                                                                                height="36px"
                                                                                padding="14px 36px 14px 16px"
                                                                                list= {this.state.force_category_list_4}
                                                                                optionTexttName = "category_name_no_format"
                                                                                optionValuetName = "category_no"
                                                                                selectedValue = {this.state.force_category.product_rp_category_no_4 === "" ? "전체상품" : this.state.force_category.product_rp_category_no_4}
                                                                                onClickOption={this.onChangeForceCategory.bind(this)}
                                                                            />
                                                                        </div>
                                                                        :   ""
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div class="list_select_set">
                                                                <div class="list_select_margin" style={{width:"100%"}}>
                                                                    <h4>상품 등록일 기준</h4>
                                                                    <div class="list_select_margin">
                                                                        {/* <SelectBoxV2
                                                                            id={"eventItemCreatedPeriod_force"}
                                                                            width="100%"
                                                                            height="36px"
                                                                            padding="14px 36px 14px 16px"
                                                                            list= {this.state.event_item_created_period_list}
                                                                            optionTexttName = "title"
                                                                            optionValuetName = "value"
                                                                            selectedValue = {this.state.force_select_created_yn === 'Y' ? '-1' : this.state.force_created_period === 0 ? 0 : this.state.force_created_period+'/'+this.state.force_created_period_type}
                                                                            selectedText={this.state.force_select_created_yn === 'Y' ? "직접 지정": null}
                                                                            onClickOption={(text, value, id) => this.onChangeEventItemCreatedPeriodForce(value)}
                                                                        /> */}
                                                                        <SelectBoxV2
                                                                            id={"eventItemCreatedPeriod_force"}
                                                                            width="100%"
                                                                            height="36px"
                                                                            padding="14px 36px 14px 16px"
                                                                            list= {this.state.event_item_created_period_list}
                                                                            optionTexttName = "title"
                                                                            optionValuetName = "value"
                                                                            selectedValue = {
                                                                                this.state.force_created_period_type == "S"
                                                                                ? "-999"
                                                                                : this.state.force_select_created_yn == 'Y' ? '-1' : this.state.force_created_period == 0 ? 0 : this.state.force_created_period+'/'+this.state.force_created_period_type
                                                                            }
                                                                            selectedText={
                                                                                this.state.force_created_period_type == "S"
                                                                                ? '계절 등록일 기준 적용중'
                                                                                : this.state.force_select_created_yn == 'Y' ? "직접 지정": null}
                                                                            onClickOption={(text, value, id) => this.onChangeEventItemCreatedPeriodForce(value)}
                                                                            disabled = {this.state.force_created_period_type == "S"}
                                                                        />
                                                                        {this.state.force_select_created_yn === 'Y'
                                                                        ?<div class="event_item_created_period">
                                                                            <div>
                                                                                <DatePicker name="start_date" id="select_start_date"
                                                                                    selected={this.state.force_created_start_date}
                                                                                    onChange={(date) => this.onChangeSelectStartDateForce(date)}
                                                                                    placeholderText="시작일자"
                                                                                    dateFormat="yyyy-MM-dd"
                                                                                    maxDate={new Date()}
                                                                                    locale={ko}
                                                                                    todayButton="오늘"
                                                                                    autoComplete="off"
                                                                                    showYearDropdown
                                                                                    yearDropdownItemNumber={15}
                                                                                    scrollableYearDropdown
                                                                                />
                                                                            </div>
                                                                            <span>~</span>
                                                                            <div class="event_item_created_end_date">
                                                                                <DatePicker name="end_date" id="select_end_date"
                                                                                    selected={this.state.force_created_end_date}
                                                                                    onChange={(date) => this.onChangeSelectEndDateForce(date)}
                                                                                    placeholderText="종료일자"
                                                                                    dateFormat="yyyy-MM-dd"
                                                                                    minDate={this.state.force_created_start_date}
                                                                                    maxDate={new Date()}
                                                                                    locale={ko}
                                                                                    todayButton="오늘"
                                                                                    autoComplete="off"
                                                                                    showYearDropdown
                                                                                    yearDropdownItemNumber={15}
                                                                                    scrollableYearDropdown
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        :""}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="list_select_set">
                                                                <div class="list_select_margin" style={{width:"100%"}}>
                                                                <h4>계절 등록일 기준</h4>
                                                                <div class="list_select_margin">
                                                                    <SelectBoxV2
                                                                        id={"eventItemCreatedPeriod_force"}
                                                                        width="100%"
                                                                        height="36px"
                                                                        padding="14px 36px 14px 16px"
                                                                        list= {this.state.event_item_created_period_season_list}
                                                                        optionTexttName = "title"
                                                                        optionValuetName = "value"
                                                                        selectedValue = { 
                                                                            this.state.force_created_period_type && this.state.force_created_period_type == "S" 
                                                                            ? this.state.force_created_period+'/'+this.state.force_created_period_type
                                                                            : "-999"
                                                                        }
                                                                        onClickOption={(text, value, id) => this.onChangeEventItemCreatedPeriodForce(value)}
                                                                    />
                                                                </div>
                                                                </div>
                                                            </div>
                                                            <div class="list_select_set">
                                                                <div class="list_select_margin" style={{width:"100%"}}>
                                                                <h4>강제 알고리즘 선택</h4>
                                                                    <SelectBoxV2
                                                                        id={"item_select_type_force"}
                                                                        // tabIndex={obj.self_select_area_checked ? 0 : ""}
                                                                        width="100%"
                                                                        height="36px"
                                                                        padding="14px 36px 14px 16px"
                                                                        list= {item_select_type_self_list}
                                                                        optionTexttName = "val1"
                                                                        optionValuetName = "code_cd"
                                                                        selectedValue = {this.state.force_logic}
                                                                        onClickOption={this.onChangeSelfSelectListCdForce.bind(this)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="list_select_set">
                                                                <div class="list_select_margin" style={{width:"100%"}}>
                                                                    <h4>상품 정보에 숨긴 카테고리가 있다면</h4>    
                                                                    <div className='list_admin_side_row_5_radio'>
                                                                        <RadioButton
                                                                            value={"Y"}
                                                                            text={"제외함"}
                                                                            checked={this.state.force_is_except_invisible_category === "Y" ? true : this.state.force_is_except_invisible_category == null ? true : false}
                                                                            onChangeCheck={() => this.onChangeIsExceptInvisibleCategoryForce("Y")}

                                                                        />
                                                                        <RadioButton
                                                                            value={"N"}
                                                                            text={"제외 안 함"}
                                                                            checked={this.state.force_is_except_invisible_category === "N" ? true : false}
                                                                            onChangeCheck={() => this.onChangeIsExceptInvisibleCategoryForce("N")}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div class="list_select_margin" style={{width:"100%"}}>
                                                                    <h4>통계 수치 분석 기간</h4>
                                                                    <div class="list_select_margin">
                                                                        <SelectBoxV2
                                                                            id={"eventItemAnalysisPeriod_force"}
                                                                            width="100%"
                                                                            height="36px"
                                                                            padding="14px 36px 14px 16px"
                                                                            list= {this.state.event_item_analysis_period_list}
                                                                            optionTexttName = "title"
                                                                            optionValuetName = "value"
                                                                            selectedValue = {
                                                                                this.state.force_analysis_period = this.state.force_analysis_period === 0
                                                                                    ? (this.state.force_analysis_period = 4)
                                                                                    : this.state.force_analysis_period
                                                                            }
                                                                            onClickOption={this.onChangeEventItemAnalysisPeriedForce.bind(this)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="list_side_select_btn_wrap" >
                                            <h3 class="text_16" style={{marginBottom: "10px", fontSize: "14px"}}>자동 진열 설정 적용 상품 미리보기</h3>
                                            <div style={{display:"flex", flexDirection:"column"}}>
                                                {this.state.mirroring_type_list.map((obj,idx) => (
                                                    <div style={{marginBottom: "8px"}}>
                                                        <RadioButton
                                                        value={obj.value}
                                                        text={obj.text}
                                                        checked={this.state.mirroring_type === obj.value}
                                                        onChangeCheck={() => this.onChangeMirroringType(obj.value)}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                            <button class="selected_list_btn text_extrasmall hover_dark" 
                                            style={{marginTop:"2px"}}
                                            onClick={e => {
                                                this.state.mirroring_type == 1
                                                ? this.onClickOverWritePreview()
                                                : this.onClickAddPlusAtCurrentProducts()
                                            }} tabIndex={-1}>미리보기</button>
                                            <div class="list_admin_row_4_1a">
                                                <span class="i_notice">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                                                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                                                    </svg>
                                                </span>
                                                <span class="text_12">현재 데이터 기준이며 반복일정으로 데이터가 변경 시 상품이 변경될 수 있습니다.</span>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div class="list_save" id="left_setting_save_button_div">
                                        {(this.state.left_is_modified || this.props.excludeProductModified || this.state.except_setting_is_modified) &&
                                            <button class="text_small hover_white" onClick={e => this.titleContentDialogResetLeftSetting()} tabIndex={-1}>취소</button>
                                        }
                                        <button id="left_save_btn" class="text_small hover_mint list_save_btn" onClick={e => {
                                                this.onClickSaveLeftSetting()
                                            }} tabIndex={-1}>저장</button>
                                    </div> */}
                                </div>
                            </div>
                            <div class="list_admin_main_menu">
                                <div class="list_admin_main_menu_wrap">
                                    <div class="list_admin_main_menu_row_1" style={{rowGap: "12px", flexWrap: "wrap"}}>
                                        <div class="list_admin_main_menu_row_1_left">
                                            <div className="list_admin_main_menu_row_1_left_sync" style={{flexWrap: "nowrap"}}>
                                                {<h2 class="text_16">미리보기 &nbsp;&nbsp;</h2>}
                                                {   
                                                    this.state.event_rp_product_list_created ?
                                                        <>
                                                            <div style={{color: "#878B90", minWidth:"73px"}}>총 <span style={{color: "#00ACB2"}}>{event_rp_product_list.length}</span>개 &nbsp;&nbsp;</div>
                                                            <div className='sync_data_format'> 
                                                                {`${this.state.event_rp_product_list_created} 에 ${this.state.event_rp_product_list_yn == 'Y' ? '자동 ':'수동 '}진열 설정에 따라 선택된 상품 목록입니다`}
                                                            </div>
                                                        </>
                                                    : ''
                                                }
                                            </div>
                                        </div>
                                        {
                                        // (this.state.iframe_page_id == "robomd_cafe24_main_page" && this.state.cafe24_main_page_over_product)
                                        // || 
                                        (this.state.del_cafe24_main_display_group)
                                        // || this.state.is_main_auto_display_use || this.state.is_category_auto_display_use
                                        ? ""
                                        : <div class="list_admin_main_menu_row_1_right">
                                                {/* {this.state.right_is_modified && 
                                                    <button class="text_small hover_white" onClick={e => this.titleContentDialogResetRightSetting()} tabIndex={-1}>변경사항 미적용</button>
                                                } */}
                                                <button id="left_save_btn" class="text_small hover_mint list_save_btn" style={{marginRight: "8px"}} onClick={e => {this.onClickSaveLeftSetting()}} tabIndex={-1}>저장</button>                                            
                                                <button class="text_small hover_dark" 
                                                style={{marginRight: "8px"}}
                                                onClick={e => {
                                                    this.state.mirroring_type == 1
                                                    ? this.onClickOverWritePreview()
                                                    : this.onClickAddPlusAtCurrentProducts()
                                                }} tabIndex={-1}>미리보기</button>
                                                <button class="text_small hover_white" onClick={e => {this.onClickSaveRightSetting()}} tabIndex={-1}>쇼핑몰 바로 진열</button>
                                            </div>
                                        }
                                        </div>
                                    {
                                        // this.state.iframe_page_id == "robomd_cafe24_main_page" && this.state.cafe24_main_page_over_product
                                        // ? <div className={"list_admin_text_notce"}>
                                        //     진열 되어있는 상품 수가 {cafe24_main_page_max_product_num}개를 넘겼습니다.<br/>cafe24 관리자에서 상품 수를 {cafe24_main_page_max_product_num}개 이하로 수정 후 사용해 주세요.
                                        // </div>
                                        // : 
                                        // this.state.iframe_page_id == "robomd_cafe24_main_page" && this.state.is_main_auto_display_use 
                                        //     || this.state.iframe_page_id == "robomd_cafe24_category_page" && this.state.is_category_auto_display_use
                                        // ?   <div className={"list_admin_text_notce"}>
                                        //         해당 분류는 현재 카페24 자동진열을 이용중입니다.
                                        //         <br/>카페24 자동진열을 이용중인 분류는 카페24 어드민의 <a href="https://support.cafe24.com/hc/ko/articles/7739021669529-%EC%9E%90%EB%8F%99-%EC%A7%84%EC%97%B4" target="_blank">[상품 자동 진열]</a>에서 관리하실 수 있습니다.
                                        //         {
                                        //             this.state.iframe_page_id == "robomd_cafe24_main_page"
                                        //             ?   <>
                                        //                 <br/><br/>로보MD를 이용하시려면 카페24 자동진열을 해제후 사용해주세요.
                                        //                 </>
                                        //             :   this.state.iframe_page_id == "robomd_cafe24_category_page"
                                        //                 ?    <>
                                        //                     <br/><br/>로보MD를 이용하시려면 추천상품/신상품의 카페24 자동진열을 모두 해제후 사용해주세요.
                                        //                     </>
                                        //                 :   null    
                                        //         }
                                        //     </div>
                                        // : 
                                        this.state.del_cafe24_main_display_group
                                        ?<div className={"list_admin_text_notce"} >
                                            cafe24에서 삭제된 메인분류 페이지 입니다.
                                        </div>
                                        : this.state.del_cafe24_category_no
                                        ?<div className={"list_admin_text_notce"} >
                                            cafe24에서 삭제된 카테고리 페이지 입니다.
                                        </div>
                                        :
                                        <div class="list_admin_main_board" style={{
                                            width: this.getPageStatus() === "init" ? maxRightTableWidth : null,
                                            maxWidth: this.getPageStatus() === "init" ? "100%" : null
                                        }}>
                                            <div class="list_admin_main_board_notice">
                                                <span>※ 미노출 · 미판매 상태인 상품은 선정 대상에서 자동 제외됩니다.</span>
                                                <Tooltip
                                                    content=                            
                                                    {   
                                                        `<ul class="disc-inside-ul"><li>고정 상품도 미노출 · 미판매 상태라면 동일하게 선정 대상에서 자동 제외됩니다.</li>
                                                            <li>고정 번호가 선정 개수보다 크면, 선정 개수에 맞춰 자동 조정됩니다.</li>
                                                            <div class="example">예: 18번에 고정된 상품이더라도 선정 개수가 10개라면, 해당 상품은 10번으로 선정됩니다.</div>
                                                            <li>고정 상품 개수가 선정 상품 개수보다 많을 경우, 모든 고정 상품이 우선적으로 포함되며 결과 개수는 선정 개수를 초과할 수 있습니다.</li>
                                                            <div class="example">예: 고정 상품이 12개이고 선정 개수가 10개라면, 최종 12개 상품이 선정됩니다.</div>
                                                            <li>카페24 관리자에서 고정 상품을 설정하면, 로보MD 고정보다 카페24 고정 순서가 우선 적용됩니다. 따라서 로보MD에서 고정으로 선정되더라도 카페24 고정 순서에 따라 배치됩니다.</li>
                                                            <li>핀으로 고정한 상품은 <b>저장</b> 또는 <b>쇼핑몰 바로 진열</b> 시 적용됩니다.</li>
                                                            <li>고정으로 적용된 상품은 이후 선정 시 항상 포함됩니다.</li></ul>`
                                                    }>
                                                </Tooltip>
                                            </div>
                                            {
                                                this.state.is_cafe24_show_exception_category || this.state.is_cafe24_show_exception_auto
                                                ?
                                                (
                                                    (this.state.cafe24_sub_category_product_display == "T" && this.state.iframe_page_id == "robomd_cafe24_category_page")
                                                    || (this.state.is_main_auto_display_use && this.state.iframe_page_id == "robomd_cafe24_main_page")
                                                    || (this.state.is_category_auto_display_use && this.state.iframe_page_id == "robomd_cafe24_category_page")
                                                    || (this.state.iframe_page_id=='robomd_cafe24_main_page' && this.state.cafe24_main_page_over_product)
                                                    ? 
                                                        <div class="list_admin_main_board_notice" style={{display:"flex", flexDirection:"column", justifyContent:"left", alignItems:"flex-start"}}>
                                                            {
                                                                (this.state.cafe24_sub_category_product_display == "T" && this.state.iframe_page_id == "robomd_cafe24_category_page")
                                                                &&
                                                                <>
                                                                <span style={{display:"flex", alignItems:"center", gap:"3px", color:"rgb(175 133 16)", fontWeight:"500"}}>
                                                                    <svg width="16" height="16" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                                                                        <circle cx="24" cy="24" r="22" fill="#FFCA28"/>
                                                                        <rect x="22" y="12" width="4" height="14" rx="2" fill="#37474F"/>
                                                                        <circle cx="24" cy="36" r="3" fill="#37474F"/>
                                                                    </svg>
                                                                    <div style={{flex:1}}>
                                                                    현재 상품분류는 카페24 관리자에서 ‘하위 분류 상품 진열’이 '진열함'으로 설정되어 있으므로, 하위 분류 상품도 함께 노출되어 쇼핑몰의 실제 진열 순서가 다르게 보일 수 있습니다.
                                                                    </div>
                                                                </span>
                                                                카페24 관리자에서 상품분류 메뉴의 ‘하위 분류 상품 진열' 설정을 진열안함으로 변경한 후 이용하시기 바랍니다.
                                                                </>
                                                            }
                                                            {
                                                                ((this.state.is_main_auto_display_use && this.state.iframe_page_id == "robomd_cafe24_main_page")
                                                                    || (this.state.is_category_auto_display_use && this.state.iframe_page_id == "robomd_cafe24_category_page"))
                                                                    && 
                                                                <>
                                                                <span style={{display:"flex", alignItems:"center", gap:"3px", color:"#F44336", fontWeight:"500"}}>
                                                                    <svg width="16" height="16" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                                                                        <circle cx="24" cy="24" r="22" fill="#F44336"/>
                                                                        <rect x="22" y="12" width="4" height="14" rx="2" fill="#FFFFFF"/>
                                                                        <circle cx="24" cy="36" r="3" fill="#FFFFFF"/>
                                                                    </svg>
                                                                    <div style={{flex:1}}>
                                                                    현재 {this.state.iframe_page_id == "robomd_cafe24_main_page" ? "메인분류" : "상품분류"}는 카페24 관리자의 ‘자동진열’ 기능을 사용 중이므로, 로보MD 자동진열을 사용할 수 없습니다.
                                                                    </div>
                                                                </span>
                                                                카페24 관리자에서 {this.state.iframe_page_id == "robomd_cafe24_main_page" ? "메인분류" : "상품분류"}의 '자동진열'을 OFF로 변경한 후 이용하시기 바랍니다.
                                                                </>
                                                            }
                                                            {
                                                                (this.state.iframe_page_id=='robomd_cafe24_main_page' && this.state.cafe24_main_page_over_product)
                                                                && 
                                                                <>
                                                                <span style={{display:"flex", alignItems:"center", gap:"3px", color:"#F44336", fontWeight:"500"}}>
                                                                    <svg width="16" height="16" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                                                                        <circle cx="24" cy="24" r="22" fill="#F44336"/>
                                                                        <rect x="22" y="12" width="4" height="14" rx="2" fill="#FFFFFF"/>
                                                                        <circle cx="24" cy="36" r="3" fill="#FFFFFF"/>
                                                                    </svg>
                                                                    <div style={{flex:1}}>
                                                                    현재 메인분류는 상품 개수가 200개 이상이므로, 로보MD 자동진열을 사용할 수 없습니다.
                                                                    </div>
                                                                </span>
                                                                카페24 관리자에서 메인분류의 상품 개수를 200개 이하로 수정 후 이용하시기 바랍니다.
                                                                </>
                                                            }
                                                        </div>
                                                    : null
                                                )
                                                : null
                                            }
                                            <>
                                                <div class="list_main_board_row_1" style={{overflow: "visible", flexWrap:"wrap"}}>
                                                    <div className='flexBox product_preview_type pc_display_none' style={{borderTop: "0px"}}>
                                                        {
                                                            this.state.product_preview_type == "1"
                                                            ? <img src="https://s3.ap-northeast-2.amazonaws.com/otdeal.file/svg/ph_list-numbers+active.svg" onClick={e=>this.onChangeProductPreviewType()}/>
                                                            : <img src="https://s3.ap-northeast-2.amazonaws.com/otdeal.file/svg/ph_list-numbers.svg" onClick={e=>this.onChangeProductPreviewType()}/>
                                                        }
                                                        {    
                                                            this.state.product_preview_type == "2"
                                                            ? <img src="https://s3.ap-northeast-2.amazonaws.com/otdeal.file/svg/img+list+active.svg" onClick={e=>this.onChangeProductPreviewType()}/>
                                                            : <img src="https://s3.ap-northeast-2.amazonaws.com/otdeal.file/svg/img+list.svg" onClick={e=>this.onChangeProductPreviewType()}/>
                                                        }
                                                    </div>
                                                    {this.state.product_preview_type == "1" &&
                                                        <div style={{borderTop: "0px"}}>
                                                            <button class="delete_btn text_extrasmall"
                                                            onClick={() => { if (this.state.event_product_checked_list.length !== 0) this.titleContentDialogAlertExceptProduct() }} 
                                                            tabIndex={-1}>
                                                                {"미진열"}
                                                            </button>
                                                                <ListOrderChangeBtnBundle
                                                                    list={this.state.event_rp_product_list}
                                                                    changeList={this.state.event_product_checked_list}
                                                                    listKeyName={'product_no'}
                                                                    fixKeyName={'fixed_sort'}
                                                                    changeOrder={(list) => this.setState({event_rp_product_list:list})}
                                                                />
                                                        </div>
                                                    }
                                                    
                                                    <div id={this.state.iframe_page_id == "robomd_cafe24_category_page" ? "eventItemAnalysisStandardAreaForCategoryPage" : "eventItemAnalysisStandardArea"}>
                                                        통계 수치 조회 기간
                                                        <div style={{flex: 1, marginLeft:"10px"}}>
                                                            <SelectBoxV2
                                                                style={{width:"100%"}}
                                                                id={"eventItemAnalysisStandard"}
                                                                tabIndex={0}
                                                                width="100%"
                                                                height="36px"
                                                                padding="14px 36px 14px 16px"
                                                                list= {this.state.event_item_analysis_standard_list}
                                                                optionTexttName = "title"
                                                                optionValuetName = "value"
                                                                selectedValue = {this.state.analysis_standard_value}
                                                                onClickOption={this.onChangeEventItemAnalysisStandard.bind(this)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <button class="add_btn text_extrasmall hover_mint_b" onClick={() => this.onClickAddProductPopup()} tabIndex={-1}>
                                                        <img src={plus_img} alt="플러스 아이콘"/>
                                                        <div style={{alignSelf:'center'}}>
                                                            상품추가
                                                        </div>
                                                    </button>
                                                    <div className='flexBox product_preview_type mobile_display_none' style={{marginLeft:"10px"}}>
                                                        {
                                                            this.state.product_preview_type == "1"
                                                            ? <img src="https://s3.ap-northeast-2.amazonaws.com/otdeal.file/svg/ph_list-numbers+active.svg" onClick={e=>this.onChangeProductPreviewType()}/>
                                                            : <img src="https://s3.ap-northeast-2.amazonaws.com/otdeal.file/svg/ph_list-numbers.svg" onClick={e=>this.onChangeProductPreviewType()}/>
                                                        }
                                                        {    
                                                            this.state.product_preview_type == "2"
                                                            ? <img src="https://s3.ap-northeast-2.amazonaws.com/otdeal.file/svg/img+list+active.svg" onClick={e=>this.onChangeProductPreviewType()}/>
                                                            : <img src="https://s3.ap-northeast-2.amazonaws.com/otdeal.file/svg/img+list.svg" onClick={e=>this.onChangeProductPreviewType()}/>
                                                        }
                                                    </div>
                                                </div>
                                                {
                                                    this.state.product_preview_type == "2"
                                                    &&  <div className='flexBox mobile_display_none' style={{display: "flex", justifyContent: "right", width:"auto", marginBottom:"10px", margin:"-10px 0 10px 0"}}>
                                                            <div style={{fontSize:"14px", marginRight:"10px", alignSelf:"center"}}>
                                                                미리보기 가로 줄 상품 개수
                                                            </div>
                                                            <SelectBoxV2
                                                                style={{width:"100%"}}
                                                                id={"gridColumnCount"}
                                                                tabIndex={0}
                                                                width="100%"
                                                                height="36px"
                                                                padding="14px 36px 14px 16px"
                                                                list= {[
                                                                    {value: "4", title: "4개"},
                                                                    {value: "5", title: "5개"},
                                                                ]}
                                                                optionTexttName = "title"
                                                                optionValuetName = "value"
                                                                selectedValue = {this.state.grid_column_count}
                                                                onClickOption={(name, value, id) => this.setGridColumnCount(value)}
                                                            />
                                                        </div>
                                                }
                                                {/* 상품 목록 테이블 시작 */}
                                                <div className={"list_main_board_table_wrap"} id={"list_main_board_table_wrap"} ref={this.list_main_board_table_wrap}>
                                                {this.getPageStatus() === "init"
                                                  ? <div style={{height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", padding: "20px 0px 10px"}}><h4>저장하신 이후 상품 진열이 보입니다</h4></div> 
                                                  : 
                                                    this.state.product_preview_type == "1" 
                                                    ?   <table 
                                                        className={"list_main_board_table rp_list_main_table"} 
                                                        style={{visibility: this.getPageStatus() != "init" ? "visible" : "hidden"}} 
                                                        onLoad={e => this.onLoadMainTable()}>
                                                            <thead>
                                                                <tr>
                                                                    <td class="list_main_td check_box">
                                                                        <CheckBox
                                                                            id={"list_main_board_checkbox_all"}
                                                                            checked={event_rp_product_list != null && event_rp_product_list.length > 0 && this.state.event_product_checked_list != null && event_rp_product_list.length == this.state.event_product_checked_list.length}
                                                                            onChangeCheck={this.onChangeEventProductListCheckAll.bind(this)}
                                                                        />
                                                                    </td>
                                                                    <td class="list_main_td input_table_idx">순서</td>
                                                                    <td class="list_main_td table_algorithm">선택기준</td>
                                                                    <td class="list_main_td table_image">사진</td>
                                                                    <td class="list_main_td product_name">상품명</td>
                                                                    <td class="list_main_td reg_date">상품등록일</td>
                                                                    <td class="list_main_td hit_cnt">조회수</td>
                                                                    <td class="list_main_td cart_cnt">장바구니수</td>
                                                                    {/* <td class="list_main_td wish_cnt">찜</td> */}
                                                                    <td class="list_main_td price">판매가</td>
                                                                    <td class="list_main_td pc_discount_price">할인가</td>
                                                                    <td class="list_main_td order_cnt">판매수</td>
                                                                    <td class="list_main_td order_price">판매액</td>
                                                                    <td class="list_main_td order_rate">판매 전환율</td>
                                                                    <td class="list_main_td click_value">클릭가치</td>
                                                                    <td class="list_main_td review_cnt">리뷰수</td>
                                                                    <td class="list_main_td review_point">리뷰 평점</td>
                                                                    <td class="list_main_td quantity">재고수</td>
                                                                </tr>
                                                            </thead>
                                                            {
                                                            !this.state.show_rp_product_list_table_loading_bar
                                                            ?<tbody id="main_table_tbody">
                                                                    {
                                                                        event_rp_product_list && event_rp_product_list.map((value, index) => 
                                                                            {
                                                                            console.log(typeof value.created_date === 'number' && value.created_date > 0 && value.created_date < 2147483647)
                                                                            return (
                                                                            <tr
                                                                            style={{
                                                                                height: "600 !important",
                                                                                overflowY: 'scroll !important',
                                                                                overflowX: 'hidden !important',
                                                                            }}
                                                                            key={value.product_no}
                                                                            tabIndex={-1} >
                                                                                <LazyLoad 
                                                                                offset="300"
                                                                                once="true"
                                                                                scrollContainer="#main_table_tbody"
                                                                                throttle={100}
                                                                                placeholder={<td style={{height:"60px"}}></td>}
                                                                                style={{ width: '100%' }}>
                                                                                <td className={"check_box"}>
                                                                                    <CheckBox
                                                                                        id={"list_main_board_checkbox_"+index}
                                                                                        value={index}
                                                                                        checked={this.state.event_product_checked_list.find(product => product.product_no == value.product_no) != null}
                                                                                        onChangeCheck={this.onChangeEventProductListCheck.bind(this)}
                                                                                    />
                                                                                </td>
                                                                                <td className={"input_table_idx"}>
                                                                                    {!value.fixed_sort
                                                                                    ? 
                                                                                    <>
                                                                                        <input 
                                                                                            class="list_table_number" type="text" 
                                                                                            value={this.state.main_order_idx[index] || ''} 
                                                                                            name={index}
                                                                                            id={"main_order_input_"+index} 
                                                                                            onChange={e => this.onChangeInput(e)} 
                                                                                            onKeyPress={e =>this.onChangeOrderIdx(index,false, e)}
                                                                                            onBlur={e => this.onChangeOrderIdx(index,true, e)} 
                                                                                            style={{padding:'0px', height: "24px"}} 
                                                                                            autocomplete="off" 
                                                                                        />
                                                                                        {
                                                                                            value.is_fixed 
                                                                                            ? <div className='btn_fixed active' 
                                                                                                onClick={() => this.toggleFixed(value.product_no)}
                                                                                                onPointerDown={(e) => {
                                                                                                    e.preventDefault();
                                                                                                    e.stopPropagation();
                                                                                                }} 
                                                                                            >
                                                                                                <svg viewBox="0 0 24 24">
                                                                                                    <path d="M16 9V4l1 0c.55 0 1-.45 1-1v0c0-.55-.45-1-1-1H7C6.45 2 6 2.45 6 3v0 C6 3.55 6.45 4 7 4l1 0v5c0 1.66-1.34 3-3 3h0v2h5.97v7l1 1l1-1v-7H19v-2h0C17.34 12 16 10.66 16 9z"></path>
                                                                                                </svg>
                                                                                            </div>
                                                                                            : <div className='btn_fixed' 
                                                                                                onClick={() => this.toggleFixed(value.product_no)}
                                                                                                onPointerDown={(e) => {
                                                                                                    e.preventDefault();
                                                                                                    e.stopPropagation();
                                                                                                }} 
                                                                                            >
                                                                                                <svg viewBox="0 0 24 24">
                                                                                                    <path d="M16 9V4l1 0c.55 0 1-.45 1-1v0c0-.55-.45-1-1-1H7C6.45 2 6 2.45 6 3v0 C6 3.55 6.45 4 7 4l1 0v5c0 1.66-1.34 3-3 3h0v2h5.97v7l1 1l1-1v-7H19v-2h0C17.34 12 16 10.66 16 9z"></path>
                                                                                                </svg>
                                                                                            </div>
                                                                                        }
                                                                                    </>
                                                                                    : 
                                                                                    <div>
                                                                                        {this.state.main_order_idx[index]}
                                                                                    </div>
                                                                                    }
                                                                                    {/* { this.state.iframe_page_id != "robomd_cafe24_category_page"
                                                                                        ?   value.fixed_sort
                                                                                            ? 
                                                                                            <img 
                                                                                                alt='fixed_sort'
                                                                                                onClick={() => this.changeProductFix(value.product_no)} 
                                                                                                src={fix_icon} 
                                                                                                />
                                                                                            : 
                                                                                            <img 
                                                                                                alt='non_fixed_sort'
                                                                                                className={"non_fix_icon"} 
                                                                                                onClick={() => this.changeProductFix(value.product_no)} 
                                                                                                src={non_fix_icon} 
                                                                                                />
                                                                                        :   null
                                                                                    } */}
                                                                                </td>
                                                                                <td className={"table_algorithm"}>
                                                                                {
                                                                                    this.getWhichAlgorithm(item_select_type_self_list_add_past_order_sort, value.uuid)
                                                                                }
                                                                                </td>
                                                                                <td className={"table_image"}>
                                                                                    <img src={
                                                                                        this.state.image_type_cd == "45002"
                                                                                        ? value.detail_image_url ? value.detail_image_url : value.detail_image
                                                                                        : value.image_url ? value.image_url : value.list_image
                                                                                    }/>
                                                                                </td>
                                                                                <td className={"product_name"}>
                                                                                    <h4 class="text_extrasmall">
                                                                                        {value.product_name}
                                                                                    </h4>
                                                                                </td>
                                                                                <td className={"reg_date"}>{typeof value.created_date === 'number' && value.created_date > 0 && value.created_date < 2147483647000
                                                                                ? moment.unix(Math.floor(value.created_date / 1000)).format("YYYY-MM-DD") 
                                                                                : value.created_date}</td>
                                                                                <td className={"hit_cnt"}>{value.hit_cnt}</td>
                                                                                <td className={"cart_cnt"}>{value.cart_cnt}</td>
                                                                                {/* <td className={"wish_cnt"}>{value.wish_cnt}</td> */}
                                                                                <td className={"price"}>{value.price}</td>
                                                                                <td className={"pc_discount_price"}>{value.pc_discount_price}</td>
                                                                                <td className={"order_cnt"}>{value.order_cnt}</td>
                                                                                <td className={"order_price"}>{value.order_price}</td>
                                                                                <td className={"order_rate"}>{value.order_rate+"%"}</td>
                                                                                <td className={"click_value"}>{value.click_value}</td>
                                                                                <td className={"review_cnt"}>{value.review_cnt}</td>
                                                                                <td className={"review_point"}>{value.review_point}</td>
                                                                                <td className={"quantity"}>{value.quantity}</td>
                                                                                </LazyLoad>  
                                                                            </tr>
                                                                        )
                                                                            }
                                                                        
                                                                        )
                                                                    }
                                                                </tbody>
                                                            : 
                                                            <tbody style={{position: "relative", height:"auto"}}>  
                                                                <div style={{width:$(".list_main_board_table_wrap").width(), height:"auto",display:"flex",flexDirection:"column",justifyContent:"center"}}>
                                                                    <img src={round_loading_bar} style={{width:"200px", margin:"0 auto"}}></img>
                                                                    {
                                                                        this.state.is_loading_overwrite_product
                                                                        ?   <font style={{textAlign:"center", fontWeight:"500", fontSize:"18px"}}>
                                                                                미리보기에 상품을 덮어쓰고 있습니다.
                                                                            </font>
                                                                        :   this.state.is_loading_add_below_product
                                                                        ?
                                                                            <font style={{textAlign:"center", fontWeight:"500", fontSize:"18px"}}>
                                                                                미리보기 하단에 상품을 추가하고 있습니다.
                                                                            </font>
                                                                        :   null
                                                                    }
                                                                </div>
                                                            </tbody>
                                                            }
                                                        </table>
                                                    :   
                                                        !this.state.show_rp_product_list_table_loading_bar
                                                        ? <DndContext
                                                            sensors={sensors}
                                                            collisionDetection={closestCenter}
                                                            onDragEnd={this.handleDragEnd}
                                                        >
                                                            <SortableContext
                                                            items={event_rp_product_list.map(item => item.product_no)}
                                                            strategy={rectSortingStrategy}
                                                            >
                                                            <div className="rp-grid-container" id="rp-grid-container" style={{ width: "1325px", maxWidth: "100%", gridTemplateColumns: `repeat(${this.state.grid_column_count}, 1fr)`,}}>
                                                                {event_rp_product_list.map((obj, idx) => (
                                                                <SortableItem key={obj.product_no} obj={obj} idx={idx} product_list={event_rp_product_list}/>
                                                                ))}
                                                            </div>
                                                            </SortableContext>
                                                        </DndContext>
                                                        :   <div style={{position: "relative", height:"auto"}}>  
                                                                <div style={{width: "1325px", maxWidth: "100%", height:"auto",display:"flex",flexDirection:"column",justifyContent:"center"}}>
                                                                    <img src={round_loading_bar} style={{width:"200px", margin:"0 auto"}}></img>
                                                                    {
                                                                        this.state.is_loading_overwrite_product
                                                                        ?   <font style={{textAlign:"center", fontWeight:"500", fontSize:"18px"}}>
                                                                                미리보기에 상품을 덮어쓰고 있습니다.
                                                                            </font>
                                                                        :   this.state.is_loading_add_below_product
                                                                        ?
                                                                            <font style={{textAlign:"center", fontWeight:"500", fontSize:"18px"}}>
                                                                                미리보기 하단에 상품을 추가하고 있습니다.
                                                                            </font>
                                                                        :   null
                                                                    }
                                                                </div>
                                                            </div>
                                                }                     
                                                </div>
                                            </>
                                        </div>
                                    }
                                    {/* 모바일 화면일때 가장 아래에 있는 변경사항 미적용 / 즉시 적용 버튼 */}
                                    {
                                    // (this.state.iframe_page_id == "robomd_cafe24_main_page" && this.state.cafe24_main_page_over_product)
                                    // || 
                                    (this.state.del_cafe24_main_display_group)
                                    ? ""
                                    : <div class="list_admin_main_menu_row_1_right mobile">
                                            {/* {this.state.right_is_modified && 
                                                <button class="text_small hover_white" onClick={e => this.titleContentDialogResetRightSetting()} tabIndex={-1}>변경사항 미적용</button>
                                            } */}
                                            <button id="left_save_btn" class="text_small hover_mint list_save_btn" style={{marginRight: "5px"}} onClick={e => {this.onClickSaveLeftSetting()}} tabIndex={-1}>저장</button>                                            
                                            <button class="text_small hover_white" onClick={e => this.onClickSaveRightSetting()} tabIndex={-1}>쇼핑몰 바로 진열</button>
                                        </div>
                                    }

                                    {/* 제외 상품 목록 팝업 */}
                                    {this.state.show_exclude_product_list_popup && 
                                        <ExcludeProductTableMgmt
                                            iframePageId={this.state.iframe_page_id}
                                            iframeHtmlId={this.state.iframe_html_id}
                                            imageTypeCd={this.state.image_type_cd}
                                            onClose={() => this.setState({
                                                show_exclude_product_list_popup : false,
                                            })}
                                        />
                                    }
                                    {/* 필수 상품 목록 팝업 */}
                                    {this.state.show_essential_product_list_popup && 
                                        <EssentialProductTableMgmt
                                            list_self_select={this.state.list_self_select}
                                            item_select_type_self_list={item_select_type_self_list_add_past_order_sort}
                                            list_self_select_uuid={this.state.essential_list_self_select_uuid}
                                            iframePageId={this.state.iframe_page_id}
                                            iframeHtmlId={this.state.iframe_html_id}
                                            imageTypeCd={this.state.image_type_cd}
                                            onClose={() => this.setState({
                                                show_essential_product_list_popup : false,
                                            })}
                                            onAddProduct={this.addEssentialProduct.bind(this)}
                                        />
                                    }
                                    {/* 상품 추가 팝업 */}
                                    {this.state.show_add_product_popup
                                    ? <SearchProductPopup
                                        title = {"상품 추가"}
                                        selected_product_list = {event_rp_product_list}
                                        image_type_cd = {this.state.image_type_cd}
                                        onClose = {() => this.closeAddProductPopup()}
                                        onSubmit = {this.onClickAddProductbtn.bind(this)}
                                        submit_btn_name = {"선택 상품 추가"}
                                    />
                                    : ""}
                                    {this.state.show_self_except_setting_popup
                                    ?<PopupFrame 
                                        title={"진열코너간의 같은 상품 제외등록"}
                                        content={"현재 순위의 상품 선정 시, 선택한 진열 속 상품들이 알고리즘 선택에서 제외됩니다.<br/>진열 순번을 입력하면 해당 순번 범위의 상품만 제외됩니다."}
                                        maxWidth={"868px"}
                                        onClose={this.closeSelfExceptSettingPopup.bind(this)}
                                    >
                                        <div class="except_setting_table_control ">
                                            <div id="self_except_setting_popup_header" style={{width:"100%"}}>
                                                <div className='self_except_setting_popup_header_item'>
                                                    <SelectBoxV2
                                                        id={"self_except_event_setting_select"}
                                                        tabIndex={0}
                                                        width="100%"
                                                        height="34px"
                                                        padding="10px 36px 10px 16px"
                                                        list={this.getCurrentSelfExceptSelectableList()}
                                                        optionTexttName="name"
                                                        optionValuetName="id"
                                                        selectedValue={
                                                            this.state.select_self_except_rp_setting
                                                            || (this.getCurrentSelfExceptSelectableList().length > 0 ? this.getCurrentSelfExceptSelectableList()[0].id : "")
                                                        }
                                                        onClickOption={this.onChangeSelectSelfExceptRpSetting.bind(this)}
                                                    />

                                                    {
                                                        this.state.self_except_event_category_list != null
                                                        && this.state.self_except_event_category_list.length > 0
                                                        ? <div>
                                                            <SelectBoxV2
                                                                id={"self_except_event_category_select"}
                                                                tabIndex={0}
                                                                width="200px"
                                                                height="34px"
                                                                padding="10px 36px 10px 16px"
                                                                list={this.state.self_except_event_category_list}
                                                                optionTexttName="category_name_no_format"
                                                                optionValuetName="category_no"
                                                                selectedValue={this.state.select_self_except_event_category}
                                                                onClickOption={(text, value) => {
                                                                    this.setState({
                                                                        select_self_except_event_category: value
                                                                    });
                                                                }}
                                                            />
                                                        </div>
                                                        : ""
                                                    }
                                                </div>
                                                <div className='self_except_setting_popup_header_item'>
                                                    <button
                                                        class="list_exclude_btn text_extrasmall hover_white"
                                                        // style={{marginRight:"10px"}}
                                                        onClick={() => {
                                                            const selectedObj = this.getCurrentSelectedSelfExceptRpSetting();

                                                            if (!selectedObj) {
                                                                alert("조회할 진열코너를 선택해주세요.");
                                                                return;
                                                            }

                                                            this.showExceptSettingProductList(selectedObj, this.state.select_self_except_event_category);
                                                        }}
                                                    >
                                                        상품보기
                                                    </button>

                                                    <button
                                                        class="list_exclude_btn text_extrasmall hover_white"
                                                        onClick={this.addCurrentSelfExceptSetting.bind(this)}
                                                    >
                                                        추가
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="selected_list_table_wrap self_except_setting_table_wrap">
                                            <table class="except_setting_table list_main_board_table self_except_setting_table" style={{width:"820px"}}>
                                                <thead>
                                                    <tr>
                                                        <td class="list_main_td self_except_title_td">진열 제목</td>
                                                        {/* <td class="list_main_td self_except_page_td">페이지</td> */}
                                                        <td class="list_main_td self_except_order_td">제외 순번</td>
                                                        <td class="list_main_td self_except_btn_td">상품 보기</td>
                                                        <td class="list_main_td self_except_btn_td">삭제</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.getCurrentSelfExceptSettingList().length > 0
                                                        ? this.getCurrentSelfExceptSettingList().map((obj, exceptIdx) => {
                                                            return (
                                                                <tr key={obj.id + "_" + exceptIdx}>
                                                                    <td>
                                                                        {obj.name}
                                                                        {
                                                                            obj.iframe_page_id == "robomd_product_detail_page"
                                                                            && obj.event_category_select_type == "34001"
                                                                            && obj.except_event_category_name_no_format
                                                                            ? <div style={{fontSize:"12px", color:"#878B90", marginTop:"4px"}}>
                                                                                {obj.except_event_category_name_no_format}
                                                                            </div>
                                                                            : ""
                                                                        }
                                                                    </td>

                                                                    <td>
                                                                        <div style={{display:"flex", alignItems:"center"}}>
                                                                            <input
                                                                                type="text"
                                                                                value={obj.except_order_start_no || ""}
                                                                                placeholder="시작"
                                                                                style={{width:"58px"}}
                                                                                onChange={(e) => this.onChangeCurrentSelfExceptOrderNo(
                                                                                    exceptIdx,
                                                                                    "except_order_start_no",
                                                                                    e.target.value
                                                                                )}
                                                                            />
                                                                            <span className="span_bun" style={{margin:"0 3px"}}>번</span>
                                                                            <span className="span_bun" style={{margin:"0 6px 0 3px"}}>~</span>
                                                                            <input
                                                                                type="text"
                                                                                value={obj.except_order_end_no || ""}
                                                                                placeholder="종료"
                                                                                style={{width:"58px"}}
                                                                                onChange={(e) => this.onChangeCurrentSelfExceptOrderNo(
                                                                                    exceptIdx,
                                                                                    "except_order_end_no",
                                                                                    e.target.value
                                                                                )}
                                                                            />
                                                                            <span className="span_bun" style={{marginLeft:"3px"}}>번 상품까지</span>
                                                                        </div>
                                                                    </td>

                                                                    <td>
                                                                        <button
                                                                            class="list_exclude_btn text_extrasmall hover_white"
                                                                            onClick={() => this.showExceptSettingProductList(obj, obj.except_event_category_no)}
                                                                        >
                                                                            상품보기
                                                                        </button>
                                                                    </td>

                                                                    <td>
                                                                        <button
                                                                            class="list_exclude_btn text_extrasmall hover_white"
                                                                            onClick={() => this.deleteCurrentSelfExceptSetting(exceptIdx)}
                                                                        >
                                                                            삭제
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                        : <tr>
                                                            <td colSpan="4" style={{textAlign:"center"}}>
                                                                등록된 진열코너가 없습니다.
                                                            </td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>

                                        <div class="list_admin_side_row_3_1a">
                                            <span class="i_notice">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path></svg>
                                            </span>
                                            <span class="text_12">
                                                순번을 비워두면 해당 진열코너의 전체 상품을 제외합니다.
                                            </span>
                                        </div>
                                    </PopupFrame>
                                    :""}
                                    {/* 진열목록별 중복상품제외 팝업 */}
                                    {this.state.show_except_setting_popup
                                    ?<PopupFrame 
                                        title={"진열코너간의 같은 상품 제외등록"}
                                        content={"진열끼리 상품이 중복되지 않도록 하는 기능입니다.<br/>아래에 진열을 추가하면 추가된 진열 속 상품들이 알고리즘 선택에서 제외됩니다."}
                                        maxWidth={"850px"}
                                        onClose={this.closeExceptSettingPopup.bind(this)}
                                    >
                                        <div class="except_setting_table_control">
                                            <div style={{width:"100%"}}>
                                            {/* {this.state.iframe_html_id == null || this.state.iframe_html_id == ""
                                            ?<>
                                                <SelectBoxV2
                                                    id={"except_event_setting_select"}
                                                    tabIndex={0}
                                                    width="100%"
                                                    height="34px"
                                                    padding="10px 36px 10px 16px"
                                                    list= {this.state.rp_event_setting_list}
                                                    optionTexttName = "name"
                                                    optionValuetName = "id"
                                                    selectedValue = {this.state.select_except_rp_setting}
                                                    disabled = {true}
                                                />
                                                <button class="list_exclude_btn text_extrasmall hover_white disabled" style={{marginRight:"10px"}}>상품보기</button>
                                                <button class="list_exclude_btn text_extrasmall hover_white disabled">추가</button>
                                            </>
                                            : */}
                                            <>
                                                <SelectBoxV2
                                                    id={"except_event_setting_select"}
                                                    tabIndex={0}
                                                    width="100%"
                                                    height="34px"
                                                    padding="10px 36px 10px 16px"
                                                    list= {this.state.rp_event_setting_list}
                                                    optionTexttName = "name"
                                                    optionValuetName = "id"
                                                    selectedValue = {this.state.select_except_rp_setting}
                                                    onClickOption={this.onChangeSelectExceptRpSetting.bind(this)}
                                                    disableOptions = {this.state.except_setting_list.map(obj => obj.id)}
                                                />
                                                <button class="list_exclude_btn text_extrasmall hover_grey" style={{marginRight:"10px"}}
                                                    onClick={() => {
                                                        const iframe_page_id = this.state.select_except_rp_setting.split("/")[0];
                                                        const iframe_html_id = this.state.select_except_rp_setting.split("/")[1];
                                                        this.showExceptSettingProductList(this.state.rp_event_setting_list.filter((obj) => {return obj.iframe_page_id == iframe_page_id && obj.iframe_html_id == iframe_html_id})[0])
                                                    }
                                                }>상품보기</button>
                                                <button class="list_exclude_btn text_extrasmall hover_mint_b" onClick={() => this.addExceptSettingList()}>추가</button>
                                            </>
                                            {/* } */}
                                            </div>
                                        </div>
                                        <div class="selected_list_table_wrap">
                                            <table class="except_setting_table list_main_board_table" style={{width:"800px"}}>
                                                <thead>
                                                    <tr>
                                                        <td class="list_main_td">진열 제목</td>
                                                        <td class="list_main_td">페이지</td>
                                                        <td class="list_main_td">상품 보기</td>
                                                        <td class="list_main_td">삭제</td>
                                                    </tr>
                                                </thead>
                                                
                                                {this.state.except_setting_list !=null && this.state.except_setting_list != ""
                                                ? <tbody>
                                                    {this.state.except_setting_list.map((obj, idx) => (
                                                        <tr>
                                                            <td>{obj.display_name}</td>
                                                            <td>{obj.iframe_page_name}</td>
                                                            <td>
                                                                <button class="list_exclude_btn text_extrasmall hover_white" style={{width:"90%"}} onClick={() => this.showExceptSettingProductList(obj)}>상품보기</button>
                                                            </td>
                                                            <td>
                                                                <button class="close_btn" onClick={e => this.delExceptSetting(idx)}>
                                                                    <img style={{display:"inline", width:"16px", margin:"0px", backgroundColor: "initial"}} src={x_img}/>
                                                                </button></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                : ""
                                                }
                                            </table>
                                        </div>
                                        {this.state.except_setting_is_modified
                                        ?<div class="selected_list_btn_wrap exclude_list_btn_wrap">
                                            <button class="text_extrasmall hover_white" style={{border:"1px solid #ACACAC"}} onClick={() => this.titleContentDialogExceptSettingList()}>취소</button>
                                            <button class="text_extrasmall hover_mint" onClick={() => this.saveExceptSettingList()}>저장</button>
                                        </div>
                                        :""}
                                        {/* {this.state.iframe_html_id == null || this.state.iframe_html_id == ""
                                        ?<div style={{textAlign:"center", padding:"50px", width:"100%"}}>진열 관리 먼저 저장해주세요.</div>
                                        :""} */}
                                    </PopupFrame>
                                    : ""}
                                    {/* 진열 간 상품 중복 제외 설정 상품 목록 팝업 */}
                                    {this.state.show_except_product_popup
                                    ?<PopupFrame 
                                        title={"진열 상품 목록"}
                                        maxWidth={"1150px"}
                                        onClose={this.closeExceptSettingProductList.bind(this)}
                                    >
                                        {this.state.except_select_category != null && this.state.except_select_category != ""
                                        ?   <div style={{marginBottom:"24px"}}>
                                                <SelectBoxV2
                                                    id={"except_event_product_category_select"}
                                                    tabIndex={0}
                                                    width="200px"
                                                    height="34px"
                                                    padding="10px 36px 10px 16px"
                                                    list= {this.state.except_event_category_list}
                                                    optionTexttName = "category_name_no_format"
                                                    optionValuetName = "category_no"
                                                    selectedValue = {this.state.except_select_category}
                                                    selectedText={this.state.except_products[this.state.except_select_category].category_name_no_format}
                                                    onClickOption={this.onChangeSelectExceptProductCategory.bind(this)}
                                                />
                                            </div>
                                        : ""}
                                        <div class="selected_list_table_wrap" id="except_product_table_wrap">
                                            <table class="selected_list_table list_main_board_table">
                                                <thead>
                                                    <tr>
                                                        <td class="list_main_td" style={{display: "none"}}>
                                                        </td>
                                                        <td class="list_main_td">순서</td>
                                                        <td class="list_main_td">사진</td>
                                                        <td class="list_main_td">상품명</td>
                                                        <td class="list_main_td">상품등록일</td>
                                                        <td class="list_main_td">조회수</td>
                                                        <td class="list_main_td">장바구니수</td>
                                                        {/* <td class="list_main_td">찜</td> */}
                                                        <td class="list_main_td">판매가</td>
                                                        <td class="list_main_td">할인가</td>
                                                        <td class="list_main_td">판매수</td>
                                                        <td class="list_main_td">판매액</td>
                                                        <td class="list_main_td">판매 전활율</td>
                                                        <td class="list_main_td">리뷰수</td>
                                                        <td class="list_main_td">리뷰 평점</td>
                                                        <td class="list_main_td">재고수</td>
                                                    </tr>
                                                </thead>
                                                
                                                {this.state.except_product_list !=null && this.state.except_product_list != ""
                                                ? <tbody id="selected_list_table_tbody">
                                                    {this.state.except_product_list.map((obj, idx) => (
                                                        <tr>
                                                            <td style={{display: "none"}}>
                                                            </td>
                                                            <td>{idx+1}</td>
                                                            <td>
                                                                <img src={
                                                                    this.state.image_type_cd == "45002"
                                                                    ? obj.detail_image_url
                                                                    : obj.image_url
                                                                }/>
                                                            </td>
                                                            <td>
                                                                <h4 class="text_extrasmall">
                                                                    {obj.product_name}
                                                                </h4>
                                                            </td>
                                                            <td>{obj.created_date}</td>
                                                            <td>{StringUtil.numberComma(obj.hit_cnt)}</td>
                                                            <td>{StringUtil.numberComma(obj.cart_cnt)}</td>
                                                            {/* <td>{StringUtil.numberComma(obj.wish_cnt)}</td> */}
                                                            <td>{obj.price}</td>
                                                            <td>{obj.pc_discount_price}</td>
                                                            <td>{StringUtil.numberComma(obj.order_cnt)}</td>
                                                            <td>{StringUtil.numberComma(obj.order_price)}</td>
                                                            <td>{StringUtil.numberComma(obj.order_rate)+"%"}</td>
                                                            <td>{StringUtil.numberComma(obj.review_cnt)}</td>
                                                            <td>{obj.review_point}</td>
                                                            <td>{obj.quantity}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                : this.state.show_except_product_list_table_loading_bar
                                                    ?<tbody style={{position: "relative", height:"200px"}}>
                                                        <div style={{width:$("#except_product_table_wrap").width(), height:"200px",position: "absolute",display:"flex",justifyContent:"center"}}>
                                                            <img src={round_loading_bar} style={{width:"200px"}}></img>
                                                        </div>
                                                    </tbody>
                                                    : ""
                                                }
                                            </table>
                                        </div>
                                    </PopupFrame>
                                    : ""}
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
                {/* 왼쪽 또는 오른쪽 영역 저장시 나오는 다이얼로그 */
					(this.state.save_dialog_show_state === true)
					? <SaveDialogV2
						content={this.state.save_dialog_content}
						button_list={this.state.save_dialog_button_list}
					/>
					: ''
				}
                {/* 기본 안내 다이얼로그 */
					(this.state.basic_dialog_show_state === true)
					? <BasicDialogV2
						content={this.state.basic_dialog_content}
						button_list={this.state.basic_dialog_button_list}
                        width= {this.state.basic_dialog_width}
					/>
					: ''
				}
                {/* 오른쪽 영역 초기화 다이얼로그*/
					(this.state.title_content_dialog_show_state === true)
					? <TitleContentDialogV2
                        title={this.state.title_content_dialog_title}
						content={this.state.title_content_dialog_content}
						button_list={this.state.title_content_dialog_button_list}
                        check_box_text={this.state.title_content_dialog_check_box_text}
                        check_box_checked={this.state.title_content_dialog_check_box_checked}
                        onChangeCheckBox={this.onChangeTitleContentCheckBox}
						popup_close={() => {
                            this.setState({title_content_dialog_show_state: false});
                        }}
					/>
					: ''
				}
                {/* 확인 취소 다이얼로그 */
					(this.state.confirm_dialog_show_state === true)
					? <ConfirmDialogV2
						content={this.state.confirm_dialog_content}
						content2={this.state.confirm_dialog_content2}
						button_list={this.state.confirm_dialog_button_list}
						popup_close={() => {
                            this.setState({
                                confirm_dialog_show_state: false,
                                confirm_dialog_content2 : null,
                            });
                        }}
					/>
					: ''
				}
                {/* 선택된 상품목록 적용하기 : 뒷 스크롤 계속 막아야함 */
					(this.state.paste_confirm_dialog_show_state === true)
					? <ConfirmDialogV2
						content={this.state.confirm_dialog_content}
						button_list={this.state.confirm_dialog_button_list}
						popup_close={() => {
                            this.setState({paste_confirm_dialog_show_state: false});
                        }}
					/>
					: ''
				}
                {/* 상품 연동 다이얼로그 */
					(this.state.refresh_data_show_state === true)
					? <TitleContentDialogV2
                        title={"상품 목록을 새로 불러오시겠습니까?"}
						content={'<p style="word-break:keep-all;">상품 수에 따라 짧게는 몇 분에서 길게는 몇 시간이 걸릴 수 있습니다.</br>' +
                        "그 동안 다른 기능들은 모두 정상적으로 이용하실 수 있습니다.</p>"}
						button_list={[
                            {
                                title:"네",
                                event_method: () => {
                                    this.fn_refreshDataSync();
                                    this.setState({refresh_data_show_state : false});
                                }
                            },
                            {
                                title: "아니요",
                                event_method: () => {
                                    //팝업 닫기
                                    this.setState({refresh_data_show_state : false});
                                }
                            },
                        ]}
						popup_close={() => {
                            this.setState({refresh_data_show_state: false});
                        }}
					/>
					: ''
				}
                {
                    /* Warning Dialog */
                    this.state.warning_state &&
                    <WarningDialog
                        content={this.state.warning_message}
                        button_list={[{
                                    title : "확인",
                                    event_method : () => { this.handleToggle("warning_state") }
                            }]}
                        popup_close={() => this.handleToggle("warning_state")}
                        width="auto"
                    />
                }
                {/* 실시간 관리 신청 다이얼로그 */
					(this.state.real_time_service_regist_show_state == true)
					? <TitleContentDialogV2
                        title={"<img src='https://s3.ap-northeast-2.amazonaws.com/otdeal.file/icn_robomd.png' style='width:100px;height:auto;'/>"}
						content={'<p style="word-break:keep-all;">실시간관리는 실시간 유료서비스를</br>등록하셔야 사용이 가능합니다.</br>실시간 상세 기능 설명을 보러 가시겠습니까?</p>'}
						button_list={[
                            {
                                title:"네",
                                event_method: () => {
                                    window.open("/shop/rp/realTimeService");
                                    this.setState({real_time_service_regist_show_state : false});
                                }
                            },
                            {
                                title: "아니요",
                                event_method: () => {
                                    //팝업 닫기
                                    this.setState({real_time_service_regist_show_state : false});
                                }
                            },
                        ]}
						popup_close={() => {
                            this.setState({real_time_service_regist_show_state: false});
                        }}
					/>
					: ''
				}
                {/* 입력 다이얼로그 */
                    (this.state.input_dialog_show_state === true)
                    ? <InputDialogV2
                        title={this.state.input_dialog_title}
                        content={this.state.input_dialog_content}
                        input_value={this.state.input_dialog_input_value}
                        input_placeholder={this.state.input_dialog_input_placeholder}
                        button_list={this.state.input_dialog_button_list}
                        popup_close={() => {
                            this.setState({input_dialog_show_state: false});
                        }}
                    />
                    : ''
                }
            </>
        )
    };
}

// 스토어의 상태를 컴포넌트의 props로 매핑 : useSelector
const mapStateToProps = state => ({
    excludeProductList: state.excludeProductsSlice.list,
    excludeProductModified: state.excludeProductsSlice.modified,
});

// 스토어의 상태를 컴포넌트의 프로퍼티로 매핑 : useDispatch
const mapDispatchToProps = dispatch => ({
    excludeProductLoad : (pageID, htmlID) => dispatch(loadList({pageID : pageID, htmlID : htmlID})),
    excludeProductSave : (data) => dispatch(saveList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RpProductList_nonInstall);